export const area_list = [
  {
    "city": [
      {
        "regionName": "北京市",
        "pid": "1",
        "status": "deleted",
        "regionType": "市",
        "county": [
          {
            "regionName": "东城区",
            "pid": "35",
            "status": "deleted",
            "regionType": "县",
            "id": "425"
          },
          {
            "regionName": "西城区",
            "pid": "35",
            "status": "deleted",
            "regionType": "县",
            "id": "426"
          },
          {
            "regionName": "崇文区",
            "pid": "35",
            "status": "new",
            "regionType": "县",
            "id": "427"
          },
          {
            "regionName": "宣武区",
            "pid": "35",
            "status": "active",
            "regionType": "县",
            "id": "428"
          },
          {
            "regionName": "朝阳区",
            "pid": "35",
            "status": "active",
            "regionType": "县",
            "id": "429"
          },
          {
            "regionName": "丰台区",
            "pid": "35",
            "status": "active",
            "regionType": "县",
            "id": "430"
          },
          {
            "regionName": "石景山区",
            "pid": "35",
            "status": "deleted",
            "regionType": "县",
            "id": "431"
          },
          {
            "regionName": "海淀区",
            "pid": "35",
            "status": "deleted",
            "regionType": "县",
            "id": "432"
          },
          {
            "regionName": "门头沟区",
            "pid": "35",
            "status": "deleted",
            "regionType": "县",
            "id": "433"
          },
          {
            "regionName": "房山区",
            "pid": "35",
            "status": "deleted",
            "regionType": "县",
            "id": "434"
          },
          {
            "regionName": "通州区",
            "pid": "35",
            "status": "deleted",
            "regionType": "县",
            "id": "435"
          },
          {
            "regionName": "顺义区",
            "pid": "35",
            "status": "deleted",
            "regionType": "县",
            "id": "436"
          },
          {
            "regionName": "昌平区",
            "pid": "35",
            "status": "active",
            "regionType": "县",
            "id": "437"
          },
          {
            "regionName": "大兴区",
            "pid": "35",
            "status": "active",
            "regionType": "县",
            "id": "438"
          },
          {
            "regionName": "怀柔区",
            "pid": "35",
            "status": "active",
            "regionType": "县",
            "id": "439"
          },
          {
            "regionName": "平谷区",
            "pid": "35",
            "status": "deleted",
            "regionType": "县",
            "id": "440"
          },
          {
            "regionName": "密云县",
            "pid": "35",
            "status": "deleted",
            "regionType": "县",
            "id": "441"
          },
          {
            "regionName": "延庆县",
            "pid": "35",
            "status": "deleted",
            "regionType": "县",
            "id": "442"
          }
        ],
        "id": "35"
      }
    ],
    "regionName": "北京",
    "pid": "0",
    "status": "active",
    "regionType": "省",
    "id": "1"
  },
  {
    "city": [
      {
        "regionName": "天津市",
        "pid": "2",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "和平区",
            "pid": "36",
            "status": "active",
            "regionType": "县",
            "id": "443"
          },
          {
            "regionName": "河东区",
            "pid": "36",
            "status": "active",
            "regionType": "县",
            "id": "444"
          },
          {
            "regionName": "河西区",
            "pid": "36",
            "status": "active",
            "regionType": "县",
            "id": "445"
          },
          {
            "regionName": "南开区",
            "pid": "36",
            "status": "active",
            "regionType": "县",
            "id": "446"
          },
          {
            "regionName": "河北区",
            "pid": "36",
            "status": "active",
            "regionType": "县",
            "id": "447"
          },
          {
            "regionName": "红桥区",
            "pid": "36",
            "status": "active",
            "regionType": "县",
            "id": "448"
          },
          {
            "regionName": "塘沽区",
            "pid": "36",
            "status": "active",
            "regionType": "县",
            "id": "449"
          },
          {
            "regionName": "汉沽区",
            "pid": "36",
            "status": "active",
            "regionType": "县",
            "id": "450"
          },
          {
            "regionName": "大港区",
            "pid": "36",
            "status": "active",
            "regionType": "县",
            "id": "451"
          },
          {
            "regionName": "东丽区",
            "pid": "36",
            "status": "active",
            "regionType": "县",
            "id": "452"
          },
          {
            "regionName": "西青区",
            "pid": "36",
            "status": "active",
            "regionType": "县",
            "id": "453"
          },
          {
            "regionName": "津南区",
            "pid": "36",
            "status": "active",
            "regionType": "县",
            "id": "454"
          },
          {
            "regionName": "北辰区",
            "pid": "36",
            "status": "active",
            "regionType": "县",
            "id": "455"
          },
          {
            "regionName": "武清区",
            "pid": "36",
            "status": "active",
            "regionType": "县",
            "id": "456"
          },
          {
            "regionName": "宝坻区",
            "pid": "36",
            "status": "active",
            "regionType": "县",
            "id": "457"
          },
          {
            "regionName": "宁河县",
            "pid": "36",
            "status": "active",
            "regionType": "县",
            "id": "458"
          },
          {
            "regionName": "静海县",
            "pid": "36",
            "status": "active",
            "regionType": "县",
            "id": "459"
          },
          {
            "regionName": "蓟县",
            "pid": "36",
            "status": "active",
            "regionType": "县",
            "id": "460"
          }
        ],
        "id": "36"
      }
    ],
    "regionName": "天津",
    "pid": "0",
    "status": "active",
    "regionType": "省",
    "id": "2"
  },
  {
    "city": [
      {
        "regionName": "邯郸市",
        "pid": "3",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "邯山区",
            "pid": "39",
            "status": "active",
            "regionType": "县",
            "id": "520"
          },
          {
            "regionName": "丛台区",
            "pid": "39",
            "status": "active",
            "regionType": "县",
            "id": "521"
          },
          {
            "regionName": "复兴区",
            "pid": "39",
            "status": "active",
            "regionType": "县",
            "id": "522"
          },
          {
            "regionName": "峰峰矿区",
            "pid": "39",
            "status": "active",
            "regionType": "县",
            "id": "523"
          },
          {
            "regionName": "邯郸县",
            "pid": "39",
            "status": "active",
            "regionType": "县",
            "id": "524"
          },
          {
            "regionName": "临漳县",
            "pid": "39",
            "status": "active",
            "regionType": "县",
            "id": "525"
          },
          {
            "regionName": "成安县",
            "pid": "39",
            "status": "active",
            "regionType": "县",
            "id": "526"
          },
          {
            "regionName": "大名县",
            "pid": "39",
            "status": "active",
            "regionType": "县",
            "id": "527"
          },
          {
            "regionName": "涉县",
            "pid": "39",
            "status": "active",
            "regionType": "县",
            "id": "528"
          },
          {
            "regionName": "磁县",
            "pid": "39",
            "status": "active",
            "regionType": "县",
            "id": "529"
          },
          {
            "regionName": "肥乡县",
            "pid": "39",
            "status": "active",
            "regionType": "县",
            "id": "530"
          },
          {
            "regionName": "永年县",
            "pid": "39",
            "status": "active",
            "regionType": "县",
            "id": "531"
          },
          {
            "regionName": "邱县",
            "pid": "39",
            "status": "active",
            "regionType": "县",
            "id": "532"
          },
          {
            "regionName": "鸡泽县",
            "pid": "39",
            "status": "active",
            "regionType": "县",
            "id": "533"
          },
          {
            "regionName": "广平县",
            "pid": "39",
            "status": "active",
            "regionType": "县",
            "id": "534"
          },
          {
            "regionName": "馆陶县",
            "pid": "39",
            "status": "active",
            "regionType": "县",
            "id": "535"
          },
          {
            "regionName": "魏县",
            "pid": "39",
            "status": "active",
            "regionType": "县",
            "id": "536"
          },
          {
            "regionName": "曲周县",
            "pid": "39",
            "status": "active",
            "regionType": "县",
            "id": "537"
          },
          {
            "regionName": "武安市",
            "pid": "39",
            "status": "active",
            "regionType": "县",
            "id": "538"
          },
          {
            "regionName": "从台区",
            "pid": "39",
            "status": "active",
            "regionType": "县",
            "id": "3717"
          }
        ],
        "id": "39"
      },
      {
        "regionName": "石家庄市",
        "pid": "3",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "长安区",
            "pid": "40",
            "status": "active",
            "regionType": "县",
            "id": "539"
          },
          {
            "regionName": "桥东区",
            "pid": "40",
            "status": "active",
            "regionType": "县",
            "id": "540"
          },
          {
            "regionName": "桥西区",
            "pid": "40",
            "status": "active",
            "regionType": "县",
            "id": "541"
          },
          {
            "regionName": "新华区",
            "pid": "40",
            "status": "active",
            "regionType": "县",
            "id": "542"
          },
          {
            "regionName": "井陉矿区",
            "pid": "40",
            "status": "active",
            "regionType": "县",
            "id": "543"
          },
          {
            "regionName": "裕华区",
            "pid": "40",
            "status": "active",
            "regionType": "县",
            "id": "544"
          },
          {
            "regionName": "井陉县",
            "pid": "40",
            "status": "active",
            "regionType": "县",
            "id": "545"
          },
          {
            "regionName": "正定县",
            "pid": "40",
            "status": "active",
            "regionType": "县",
            "id": "546"
          },
          {
            "regionName": "栾城县",
            "pid": "40",
            "status": "active",
            "regionType": "县",
            "id": "547"
          },
          {
            "regionName": "行唐县",
            "pid": "40",
            "status": "active",
            "regionType": "县",
            "id": "548"
          },
          {
            "regionName": "灵寿县",
            "pid": "40",
            "status": "active",
            "regionType": "县",
            "id": "549"
          },
          {
            "regionName": "高邑县",
            "pid": "40",
            "status": "active",
            "regionType": "县",
            "id": "550"
          },
          {
            "regionName": "深泽县",
            "pid": "40",
            "status": "active",
            "regionType": "县",
            "id": "551"
          },
          {
            "regionName": "赞皇县",
            "pid": "40",
            "status": "active",
            "regionType": "县",
            "id": "552"
          },
          {
            "regionName": "无极县",
            "pid": "40",
            "status": "active",
            "regionType": "县",
            "id": "553"
          },
          {
            "regionName": "平山县",
            "pid": "40",
            "status": "active",
            "regionType": "县",
            "id": "554"
          },
          {
            "regionName": "元氏县",
            "pid": "40",
            "status": "active",
            "regionType": "县",
            "id": "555"
          },
          {
            "regionName": "赵县",
            "pid": "40",
            "status": "active",
            "regionType": "县",
            "id": "556"
          },
          {
            "regionName": "辛集市",
            "pid": "40",
            "status": "active",
            "regionType": "县",
            "id": "557"
          },
          {
            "regionName": "藁城市",
            "pid": "40",
            "status": "active",
            "regionType": "县",
            "id": "558"
          },
          {
            "regionName": "晋州市",
            "pid": "40",
            "status": "active",
            "regionType": "县",
            "id": "559"
          },
          {
            "regionName": "新乐市",
            "pid": "40",
            "status": "active",
            "regionType": "县",
            "id": "560"
          },
          {
            "regionName": "鹿泉市",
            "pid": "40",
            "status": "active",
            "regionType": "县",
            "id": "561"
          },
          {
            "regionName": "高新区",
            "pid": "40",
            "status": "active",
            "regionType": "县",
            "id": "3716"
          }
        ],
        "id": "40"
      },
      {
        "regionName": "保定市",
        "pid": "3",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "新市区",
            "pid": "41",
            "status": "active",
            "regionType": "县",
            "id": "562"
          },
          {
            "regionName": "北市区",
            "pid": "41",
            "status": "active",
            "regionType": "县",
            "id": "563"
          },
          {
            "regionName": "南市区",
            "pid": "41",
            "status": "active",
            "regionType": "县",
            "id": "564"
          },
          {
            "regionName": "满城县",
            "pid": "41",
            "status": "active",
            "regionType": "县",
            "id": "565"
          },
          {
            "regionName": "清苑县",
            "pid": "41",
            "status": "active",
            "regionType": "县",
            "id": "566"
          },
          {
            "regionName": "涞水县",
            "pid": "41",
            "status": "active",
            "regionType": "县",
            "id": "567"
          },
          {
            "regionName": "阜平县",
            "pid": "41",
            "status": "active",
            "regionType": "县",
            "id": "568"
          },
          {
            "regionName": "徐水县",
            "pid": "41",
            "status": "active",
            "regionType": "县",
            "id": "569"
          },
          {
            "regionName": "定兴县",
            "pid": "41",
            "status": "active",
            "regionType": "县",
            "id": "570"
          },
          {
            "regionName": "唐县",
            "pid": "41",
            "status": "active",
            "regionType": "县",
            "id": "571"
          },
          {
            "regionName": "高阳县",
            "pid": "41",
            "status": "active",
            "regionType": "县",
            "id": "572"
          },
          {
            "regionName": "容城县",
            "pid": "41",
            "status": "active",
            "regionType": "县",
            "id": "573"
          },
          {
            "regionName": "涞源县",
            "pid": "41",
            "status": "active",
            "regionType": "县",
            "id": "574"
          },
          {
            "regionName": "望都县",
            "pid": "41",
            "status": "active",
            "regionType": "县",
            "id": "575"
          },
          {
            "regionName": "安新县",
            "pid": "41",
            "status": "active",
            "regionType": "县",
            "id": "576"
          },
          {
            "regionName": "易县",
            "pid": "41",
            "status": "active",
            "regionType": "县",
            "id": "577"
          },
          {
            "regionName": "曲阳县",
            "pid": "41",
            "status": "active",
            "regionType": "县",
            "id": "578"
          },
          {
            "regionName": "蠡县",
            "pid": "41",
            "status": "active",
            "regionType": "县",
            "id": "579"
          },
          {
            "regionName": "顺平县",
            "pid": "41",
            "status": "active",
            "regionType": "县",
            "id": "580"
          },
          {
            "regionName": "博野县",
            "pid": "41",
            "status": "active",
            "regionType": "县",
            "id": "581"
          },
          {
            "regionName": "雄县",
            "pid": "41",
            "status": "active",
            "regionType": "县",
            "id": "582"
          },
          {
            "regionName": "涿州市",
            "pid": "41",
            "status": "active",
            "regionType": "县",
            "id": "583"
          },
          {
            "regionName": "定州市",
            "pid": "41",
            "status": "active",
            "regionType": "县",
            "id": "584"
          },
          {
            "regionName": "安国市",
            "pid": "41",
            "status": "active",
            "regionType": "县",
            "id": "585"
          },
          {
            "regionName": "高碑店市",
            "pid": "41",
            "status": "active",
            "regionType": "县",
            "id": "586"
          }
        ],
        "id": "41"
      },
      {
        "regionName": "张家口市",
        "pid": "3",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "桥东区",
            "pid": "42",
            "status": "active",
            "regionType": "县",
            "id": "587"
          },
          {
            "regionName": "桥西区",
            "pid": "42",
            "status": "active",
            "regionType": "县",
            "id": "588"
          },
          {
            "regionName": "宣化区",
            "pid": "42",
            "status": "active",
            "regionType": "县",
            "id": "589"
          },
          {
            "regionName": "下花园区",
            "pid": "42",
            "status": "active",
            "regionType": "县",
            "id": "590"
          },
          {
            "regionName": "宣化县",
            "pid": "42",
            "status": "active",
            "regionType": "县",
            "id": "591"
          },
          {
            "regionName": "张北县",
            "pid": "42",
            "status": "active",
            "regionType": "县",
            "id": "592"
          },
          {
            "regionName": "康保县",
            "pid": "42",
            "status": "active",
            "regionType": "县",
            "id": "593"
          },
          {
            "regionName": "沽源县",
            "pid": "42",
            "status": "active",
            "regionType": "县",
            "id": "594"
          },
          {
            "regionName": "尚义县",
            "pid": "42",
            "status": "active",
            "regionType": "县",
            "id": "595"
          },
          {
            "regionName": "蔚县",
            "pid": "42",
            "status": "active",
            "regionType": "县",
            "id": "596"
          },
          {
            "regionName": "阳原县",
            "pid": "42",
            "status": "active",
            "regionType": "县",
            "id": "597"
          },
          {
            "regionName": "怀安县",
            "pid": "42",
            "status": "active",
            "regionType": "县",
            "id": "598"
          },
          {
            "regionName": "万全县",
            "pid": "42",
            "status": "active",
            "regionType": "县",
            "id": "599"
          },
          {
            "regionName": "怀来县",
            "pid": "42",
            "status": "active",
            "regionType": "县",
            "id": "600"
          },
          {
            "regionName": "涿鹿县",
            "pid": "42",
            "status": "active",
            "regionType": "县",
            "id": "601"
          },
          {
            "regionName": "赤城县",
            "pid": "42",
            "status": "active",
            "regionType": "县",
            "id": "602"
          },
          {
            "regionName": "崇礼县",
            "pid": "42",
            "status": "active",
            "regionType": "县",
            "id": "603"
          }
        ],
        "id": "42"
      },
      {
        "regionName": "承德市",
        "pid": "3",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "双桥区",
            "pid": "43",
            "status": "active",
            "regionType": "县",
            "id": "604"
          },
          {
            "regionName": "双滦区",
            "pid": "43",
            "status": "active",
            "regionType": "县",
            "id": "605"
          },
          {
            "regionName": "鹰手营子矿区",
            "pid": "43",
            "status": "active",
            "regionType": "县",
            "id": "606"
          },
          {
            "regionName": "承德县",
            "pid": "43",
            "status": "active",
            "regionType": "县",
            "id": "607"
          },
          {
            "regionName": "兴隆县",
            "pid": "43",
            "status": "active",
            "regionType": "县",
            "id": "608"
          },
          {
            "regionName": "平泉县",
            "pid": "43",
            "status": "active",
            "regionType": "县",
            "id": "609"
          },
          {
            "regionName": "滦平县",
            "pid": "43",
            "status": "active",
            "regionType": "县",
            "id": "610"
          },
          {
            "regionName": "隆化县",
            "pid": "43",
            "status": "active",
            "regionType": "县",
            "id": "611"
          },
          {
            "regionName": "丰宁满族自治县",
            "pid": "43",
            "status": "active",
            "regionType": "县",
            "id": "612"
          },
          {
            "regionName": "宽城满族自治县",
            "pid": "43",
            "status": "active",
            "regionType": "县",
            "id": "613"
          },
          {
            "regionName": "围场满族蒙古族自治县",
            "pid": "43",
            "status": "active",
            "regionType": "县",
            "id": "614"
          }
        ],
        "id": "43"
      },
      {
        "regionName": "唐山市",
        "pid": "3",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "路南区",
            "pid": "44",
            "status": "active",
            "regionType": "县",
            "id": "615"
          },
          {
            "regionName": "路北区",
            "pid": "44",
            "status": "active",
            "regionType": "县",
            "id": "616"
          },
          {
            "regionName": "古冶区",
            "pid": "44",
            "status": "active",
            "regionType": "县",
            "id": "617"
          },
          {
            "regionName": "开平区",
            "pid": "44",
            "status": "active",
            "regionType": "县",
            "id": "618"
          },
          {
            "regionName": "丰南区",
            "pid": "44",
            "status": "active",
            "regionType": "县",
            "id": "619"
          },
          {
            "regionName": "丰润区",
            "pid": "44",
            "status": "active",
            "regionType": "县",
            "id": "620"
          },
          {
            "regionName": "滦县",
            "pid": "44",
            "status": "active",
            "regionType": "县",
            "id": "621"
          },
          {
            "regionName": "滦南县",
            "pid": "44",
            "status": "active",
            "regionType": "县",
            "id": "622"
          },
          {
            "regionName": "乐亭县",
            "pid": "44",
            "status": "active",
            "regionType": "县",
            "id": "623"
          },
          {
            "regionName": "迁西县",
            "pid": "44",
            "status": "active",
            "regionType": "县",
            "id": "624"
          },
          {
            "regionName": "玉田县",
            "pid": "44",
            "status": "active",
            "regionType": "县",
            "id": "625"
          },
          {
            "regionName": "唐海县",
            "pid": "44",
            "status": "active",
            "regionType": "县",
            "id": "626"
          },
          {
            "regionName": "遵化市",
            "pid": "44",
            "status": "active",
            "regionType": "县",
            "id": "627"
          },
          {
            "regionName": "迁安市",
            "pid": "44",
            "status": "active",
            "regionType": "县",
            "id": "628"
          }
        ],
        "id": "44"
      },
      {
        "regionName": "廊坊市",
        "pid": "3",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "安次区",
            "pid": "45",
            "status": "active",
            "regionType": "县",
            "id": "629"
          },
          {
            "regionName": "广阳区",
            "pid": "45",
            "status": "active",
            "regionType": "县",
            "id": "630"
          },
          {
            "regionName": "固安县",
            "pid": "45",
            "status": "active",
            "regionType": "县",
            "id": "631"
          },
          {
            "regionName": "永清县",
            "pid": "45",
            "status": "active",
            "regionType": "县",
            "id": "632"
          },
          {
            "regionName": "香河县",
            "pid": "45",
            "status": "active",
            "regionType": "县",
            "id": "633"
          },
          {
            "regionName": "大城县",
            "pid": "45",
            "status": "active",
            "regionType": "县",
            "id": "634"
          },
          {
            "regionName": "文安县",
            "pid": "45",
            "status": "active",
            "regionType": "县",
            "id": "635"
          },
          {
            "regionName": "大厂回族自治县",
            "pid": "45",
            "status": "active",
            "regionType": "县",
            "id": "636"
          },
          {
            "regionName": "霸州市",
            "pid": "45",
            "status": "active",
            "regionType": "县",
            "id": "637"
          },
          {
            "regionName": "三河市",
            "pid": "45",
            "status": "active",
            "regionType": "县",
            "id": "638"
          }
        ],
        "id": "45"
      },
      {
        "regionName": "沧州市",
        "pid": "3",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "新华区",
            "pid": "46",
            "status": "active",
            "regionType": "县",
            "id": "639"
          },
          {
            "regionName": "运河区",
            "pid": "46",
            "status": "active",
            "regionType": "县",
            "id": "640"
          },
          {
            "regionName": "沧县",
            "pid": "46",
            "status": "active",
            "regionType": "县",
            "id": "641"
          },
          {
            "regionName": "青县",
            "pid": "46",
            "status": "active",
            "regionType": "县",
            "id": "642"
          },
          {
            "regionName": "东光县",
            "pid": "46",
            "status": "active",
            "regionType": "县",
            "id": "643"
          },
          {
            "regionName": "海兴县",
            "pid": "46",
            "status": "active",
            "regionType": "县",
            "id": "644"
          },
          {
            "regionName": "盐山县",
            "pid": "46",
            "status": "active",
            "regionType": "县",
            "id": "645"
          },
          {
            "regionName": "肃宁县",
            "pid": "46",
            "status": "active",
            "regionType": "县",
            "id": "646"
          },
          {
            "regionName": "南皮县",
            "pid": "46",
            "status": "active",
            "regionType": "县",
            "id": "647"
          },
          {
            "regionName": "吴桥县",
            "pid": "46",
            "status": "active",
            "regionType": "县",
            "id": "648"
          },
          {
            "regionName": "献县",
            "pid": "46",
            "status": "active",
            "regionType": "县",
            "id": "649"
          },
          {
            "regionName": "孟村回族自治县",
            "pid": "46",
            "status": "active",
            "regionType": "县",
            "id": "650"
          },
          {
            "regionName": "泊头市",
            "pid": "46",
            "status": "active",
            "regionType": "县",
            "id": "651"
          },
          {
            "regionName": "任丘市",
            "pid": "46",
            "status": "active",
            "regionType": "县",
            "id": "652"
          },
          {
            "regionName": "黄骅市",
            "pid": "46",
            "status": "active",
            "regionType": "县",
            "id": "653"
          },
          {
            "regionName": "河间市",
            "pid": "46",
            "status": "active",
            "regionType": "县",
            "id": "654"
          }
        ],
        "id": "46"
      },
      {
        "regionName": "衡水市",
        "pid": "3",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "桃城区",
            "pid": "47",
            "status": "active",
            "regionType": "县",
            "id": "655"
          },
          {
            "regionName": "枣强县",
            "pid": "47",
            "status": "active",
            "regionType": "县",
            "id": "656"
          },
          {
            "regionName": "武邑县",
            "pid": "47",
            "status": "active",
            "regionType": "县",
            "id": "657"
          },
          {
            "regionName": "武强县",
            "pid": "47",
            "status": "active",
            "regionType": "县",
            "id": "658"
          },
          {
            "regionName": "饶阳县",
            "pid": "47",
            "status": "active",
            "regionType": "县",
            "id": "659"
          },
          {
            "regionName": "安平县",
            "pid": "47",
            "status": "active",
            "regionType": "县",
            "id": "660"
          },
          {
            "regionName": "故城县",
            "pid": "47",
            "status": "active",
            "regionType": "县",
            "id": "661"
          },
          {
            "regionName": "景县",
            "pid": "47",
            "status": "active",
            "regionType": "县",
            "id": "662"
          },
          {
            "regionName": "阜城县",
            "pid": "47",
            "status": "active",
            "regionType": "县",
            "id": "663"
          },
          {
            "regionName": "冀州市",
            "pid": "47",
            "status": "active",
            "regionType": "县",
            "id": "664"
          },
          {
            "regionName": "深州市",
            "pid": "47",
            "status": "active",
            "regionType": "县",
            "id": "665"
          }
        ],
        "id": "47"
      },
      {
        "regionName": "邢台市",
        "pid": "3",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "桥东区",
            "pid": "48",
            "status": "active",
            "regionType": "县",
            "id": "666"
          },
          {
            "regionName": "桥西区",
            "pid": "48",
            "status": "active",
            "regionType": "县",
            "id": "667"
          },
          {
            "regionName": "邢台县",
            "pid": "48",
            "status": "active",
            "regionType": "县",
            "id": "668"
          },
          {
            "regionName": "临城县",
            "pid": "48",
            "status": "active",
            "regionType": "县",
            "id": "669"
          },
          {
            "regionName": "内丘县",
            "pid": "48",
            "status": "active",
            "regionType": "县",
            "id": "670"
          },
          {
            "regionName": "柏乡县",
            "pid": "48",
            "status": "active",
            "regionType": "县",
            "id": "671"
          },
          {
            "regionName": "隆尧县",
            "pid": "48",
            "status": "active",
            "regionType": "县",
            "id": "672"
          },
          {
            "regionName": "任县",
            "pid": "48",
            "status": "active",
            "regionType": "县",
            "id": "673"
          },
          {
            "regionName": "南和县",
            "pid": "48",
            "status": "active",
            "regionType": "县",
            "id": "674"
          },
          {
            "regionName": "宁晋县",
            "pid": "48",
            "status": "active",
            "regionType": "县",
            "id": "675"
          },
          {
            "regionName": "巨鹿县",
            "pid": "48",
            "status": "active",
            "regionType": "县",
            "id": "676"
          },
          {
            "regionName": "新河县",
            "pid": "48",
            "status": "active",
            "regionType": "县",
            "id": "677"
          },
          {
            "regionName": "广宗县",
            "pid": "48",
            "status": "active",
            "regionType": "县",
            "id": "678"
          },
          {
            "regionName": "平乡县",
            "pid": "48",
            "status": "active",
            "regionType": "县",
            "id": "679"
          },
          {
            "regionName": "威县",
            "pid": "48",
            "status": "active",
            "regionType": "县",
            "id": "680"
          },
          {
            "regionName": "清河县",
            "pid": "48",
            "status": "active",
            "regionType": "县",
            "id": "681"
          },
          {
            "regionName": "临西县",
            "pid": "48",
            "status": "active",
            "regionType": "县",
            "id": "682"
          },
          {
            "regionName": "南宫市",
            "pid": "48",
            "status": "active",
            "regionType": "县",
            "id": "683"
          },
          {
            "regionName": "沙河市",
            "pid": "48",
            "status": "active",
            "regionType": "县",
            "id": "684"
          }
        ],
        "id": "48"
      },
      {
        "regionName": "秦皇岛市",
        "pid": "3",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "海港区",
            "pid": "49",
            "status": "active",
            "regionType": "县",
            "id": "685"
          },
          {
            "regionName": "山海关区",
            "pid": "49",
            "status": "active",
            "regionType": "县",
            "id": "686"
          },
          {
            "regionName": "北戴河区",
            "pid": "49",
            "status": "active",
            "regionType": "县",
            "id": "687"
          },
          {
            "regionName": "青龙满族自治县",
            "pid": "49",
            "status": "active",
            "regionType": "县",
            "id": "688"
          },
          {
            "regionName": "昌黎县",
            "pid": "49",
            "status": "active",
            "regionType": "县",
            "id": "689"
          },
          {
            "regionName": "抚宁县",
            "pid": "49",
            "status": "active",
            "regionType": "县",
            "id": "690"
          },
          {
            "regionName": "卢龙县",
            "pid": "49",
            "status": "active",
            "regionType": "县",
            "id": "691"
          }
        ],
        "id": "49"
      }
    ],
    "regionName": "河北省",
    "pid": "0",
    "status": "active",
    "regionType": "省",
    "id": "3"
  },
  {
    "city": [
      {
        "regionName": "朔州市",
        "pid": "4",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "朔城区",
            "pid": "50",
            "status": "active",
            "regionType": "县",
            "id": "692"
          },
          {
            "regionName": "平鲁区",
            "pid": "50",
            "status": "active",
            "regionType": "县",
            "id": "693"
          },
          {
            "regionName": "山阴县",
            "pid": "50",
            "status": "active",
            "regionType": "县",
            "id": "694"
          },
          {
            "regionName": "应县",
            "pid": "50",
            "status": "active",
            "regionType": "县",
            "id": "695"
          },
          {
            "regionName": "右玉县",
            "pid": "50",
            "status": "active",
            "regionType": "县",
            "id": "696"
          },
          {
            "regionName": "怀仁县",
            "pid": "50",
            "status": "active",
            "regionType": "县",
            "id": "697"
          }
        ],
        "id": "50"
      },
      {
        "regionName": "忻州市",
        "pid": "4",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "忻府区",
            "pid": "51",
            "status": "active",
            "regionType": "县",
            "id": "698"
          },
          {
            "regionName": "定襄县",
            "pid": "51",
            "status": "active",
            "regionType": "县",
            "id": "699"
          },
          {
            "regionName": "五台县",
            "pid": "51",
            "status": "active",
            "regionType": "县",
            "id": "700"
          },
          {
            "regionName": "代县",
            "pid": "51",
            "status": "active",
            "regionType": "县",
            "id": "701"
          },
          {
            "regionName": "繁峙县",
            "pid": "51",
            "status": "active",
            "regionType": "县",
            "id": "702"
          },
          {
            "regionName": "宁武县",
            "pid": "51",
            "status": "active",
            "regionType": "县",
            "id": "703"
          },
          {
            "regionName": "静乐县",
            "pid": "51",
            "status": "active",
            "regionType": "县",
            "id": "704"
          },
          {
            "regionName": "神池县",
            "pid": "51",
            "status": "active",
            "regionType": "县",
            "id": "705"
          },
          {
            "regionName": "五寨县",
            "pid": "51",
            "status": "active",
            "regionType": "县",
            "id": "706"
          },
          {
            "regionName": "岢岚县",
            "pid": "51",
            "status": "active",
            "regionType": "县",
            "id": "707"
          },
          {
            "regionName": "河曲县",
            "pid": "51",
            "status": "active",
            "regionType": "县",
            "id": "708"
          },
          {
            "regionName": "保德县",
            "pid": "51",
            "status": "active",
            "regionType": "县",
            "id": "709"
          },
          {
            "regionName": "偏关县",
            "pid": "51",
            "status": "active",
            "regionType": "县",
            "id": "710"
          },
          {
            "regionName": "原平市",
            "pid": "51",
            "status": "active",
            "regionType": "县",
            "id": "711"
          }
        ],
        "id": "51"
      },
      {
        "regionName": "太原市",
        "pid": "4",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "小店区",
            "pid": "52",
            "status": "active",
            "regionType": "县",
            "id": "712"
          },
          {
            "regionName": "迎泽区",
            "pid": "52",
            "status": "active",
            "regionType": "县",
            "id": "713"
          },
          {
            "regionName": "杏花岭区",
            "pid": "52",
            "status": "active",
            "regionType": "县",
            "id": "714"
          },
          {
            "regionName": "尖草坪区",
            "pid": "52",
            "status": "active",
            "regionType": "县",
            "id": "715"
          },
          {
            "regionName": "万柏林区",
            "pid": "52",
            "status": "active",
            "regionType": "县",
            "id": "716"
          },
          {
            "regionName": "晋源区",
            "pid": "52",
            "status": "active",
            "regionType": "县",
            "id": "717"
          },
          {
            "regionName": "清徐县",
            "pid": "52",
            "status": "active",
            "regionType": "县",
            "id": "718"
          },
          {
            "regionName": "阳曲县",
            "pid": "52",
            "status": "active",
            "regionType": "县",
            "id": "719"
          },
          {
            "regionName": "娄烦县",
            "pid": "52",
            "status": "active",
            "regionType": "县",
            "id": "720"
          },
          {
            "regionName": "古交市",
            "pid": "52",
            "status": "active",
            "regionType": "县",
            "id": "721"
          },
          {
            "regionName": "民营经济开发区",
            "pid": "52",
            "status": "active",
            "regionType": "县",
            "id": "3760"
          }
        ],
        "id": "52"
      },
      {
        "regionName": "大同市",
        "pid": "4",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "矿区",
            "pid": "53",
            "status": "active",
            "regionType": "县",
            "id": "722"
          },
          {
            "regionName": "南郊区",
            "pid": "53",
            "status": "active",
            "regionType": "县",
            "id": "723"
          },
          {
            "regionName": "新荣区",
            "pid": "53",
            "status": "active",
            "regionType": "县",
            "id": "724"
          },
          {
            "regionName": "阳高县",
            "pid": "53",
            "status": "active",
            "regionType": "县",
            "id": "725"
          },
          {
            "regionName": "天镇县",
            "pid": "53",
            "status": "active",
            "regionType": "县",
            "id": "726"
          },
          {
            "regionName": "广灵县",
            "pid": "53",
            "status": "active",
            "regionType": "县",
            "id": "727"
          },
          {
            "regionName": "灵丘县",
            "pid": "53",
            "status": "active",
            "regionType": "县",
            "id": "728"
          },
          {
            "regionName": "浑源县",
            "pid": "53",
            "status": "active",
            "regionType": "县",
            "id": "729"
          },
          {
            "regionName": "左云县",
            "pid": "53",
            "status": "active",
            "regionType": "县",
            "id": "730"
          },
          {
            "regionName": "大同县",
            "pid": "53",
            "status": "active",
            "regionType": "县",
            "id": "731"
          }
        ],
        "id": "53"
      },
      {
        "regionName": "阳泉市",
        "pid": "4",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "矿区",
            "pid": "54",
            "status": "active",
            "regionType": "县",
            "id": "732"
          },
          {
            "regionName": "平定县",
            "pid": "54",
            "status": "active",
            "regionType": "县",
            "id": "733"
          },
          {
            "regionName": "盂县",
            "pid": "54",
            "status": "active",
            "regionType": "县",
            "id": "734"
          }
        ],
        "id": "54"
      },
      {
        "regionName": "晋中市",
        "pid": "4",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "榆次区",
            "pid": "55",
            "status": "active",
            "regionType": "县",
            "id": "735"
          },
          {
            "regionName": "榆社县",
            "pid": "55",
            "status": "active",
            "regionType": "县",
            "id": "736"
          },
          {
            "regionName": "左权县",
            "pid": "55",
            "status": "active",
            "regionType": "县",
            "id": "737"
          },
          {
            "regionName": "和顺县",
            "pid": "55",
            "status": "active",
            "regionType": "县",
            "id": "738"
          },
          {
            "regionName": "昔阳县",
            "pid": "55",
            "status": "active",
            "regionType": "县",
            "id": "739"
          },
          {
            "regionName": "寿阳县",
            "pid": "55",
            "status": "active",
            "regionType": "县",
            "id": "740"
          },
          {
            "regionName": "太谷县",
            "pid": "55",
            "status": "active",
            "regionType": "县",
            "id": "741"
          },
          {
            "regionName": "祁县",
            "pid": "55",
            "status": "active",
            "regionType": "县",
            "id": "742"
          },
          {
            "regionName": "平遥县",
            "pid": "55",
            "status": "active",
            "regionType": "县",
            "id": "743"
          },
          {
            "regionName": "灵石县",
            "pid": "55",
            "status": "active",
            "regionType": "县",
            "id": "744"
          },
          {
            "regionName": "介休市",
            "pid": "55",
            "status": "active",
            "regionType": "县",
            "id": "745"
          }
        ],
        "id": "55"
      },
      {
        "regionName": "长治市",
        "pid": "4",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "长治县",
            "pid": "56",
            "status": "active",
            "regionType": "县",
            "id": "746"
          },
          {
            "regionName": "襄垣县",
            "pid": "56",
            "status": "active",
            "regionType": "县",
            "id": "747"
          },
          {
            "regionName": "屯留县",
            "pid": "56",
            "status": "active",
            "regionType": "县",
            "id": "748"
          },
          {
            "regionName": "平顺县",
            "pid": "56",
            "status": "active",
            "regionType": "县",
            "id": "749"
          },
          {
            "regionName": "黎城县",
            "pid": "56",
            "status": "active",
            "regionType": "县",
            "id": "750"
          },
          {
            "regionName": "壶关县",
            "pid": "56",
            "status": "active",
            "regionType": "县",
            "id": "751"
          },
          {
            "regionName": "长子县",
            "pid": "56",
            "status": "active",
            "regionType": "县",
            "id": "752"
          },
          {
            "regionName": "武乡县",
            "pid": "56",
            "status": "active",
            "regionType": "县",
            "id": "753"
          },
          {
            "regionName": "沁县",
            "pid": "56",
            "status": "active",
            "regionType": "县",
            "id": "754"
          },
          {
            "regionName": "沁源县",
            "pid": "56",
            "status": "active",
            "regionType": "县",
            "id": "755"
          },
          {
            "regionName": "潞城市",
            "pid": "56",
            "status": "active",
            "regionType": "县",
            "id": "756"
          }
        ],
        "id": "56"
      },
      {
        "regionName": "晋城市",
        "pid": "4",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "沁水县",
            "pid": "57",
            "status": "active",
            "regionType": "县",
            "id": "757"
          },
          {
            "regionName": "阳城县",
            "pid": "57",
            "status": "active",
            "regionType": "县",
            "id": "758"
          },
          {
            "regionName": "陵川县",
            "pid": "57",
            "status": "active",
            "regionType": "县",
            "id": "759"
          },
          {
            "regionName": "泽州县",
            "pid": "57",
            "status": "active",
            "regionType": "县",
            "id": "760"
          },
          {
            "regionName": "高平市",
            "pid": "57",
            "status": "active",
            "regionType": "县",
            "id": "761"
          }
        ],
        "id": "57"
      },
      {
        "regionName": "临汾市",
        "pid": "4",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "尧都区",
            "pid": "58",
            "status": "active",
            "regionType": "县",
            "id": "762"
          },
          {
            "regionName": "曲沃县",
            "pid": "58",
            "status": "active",
            "regionType": "县",
            "id": "763"
          },
          {
            "regionName": "翼城县",
            "pid": "58",
            "status": "active",
            "regionType": "县",
            "id": "764"
          },
          {
            "regionName": "襄汾县",
            "pid": "58",
            "status": "active",
            "regionType": "县",
            "id": "765"
          },
          {
            "regionName": "洪洞县",
            "pid": "58",
            "status": "active",
            "regionType": "县",
            "id": "766"
          },
          {
            "regionName": "古县",
            "pid": "58",
            "status": "active",
            "regionType": "县",
            "id": "767"
          },
          {
            "regionName": "安泽县",
            "pid": "58",
            "status": "active",
            "regionType": "县",
            "id": "768"
          },
          {
            "regionName": "浮山县",
            "pid": "58",
            "status": "active",
            "regionType": "县",
            "id": "769"
          },
          {
            "regionName": "吉县",
            "pid": "58",
            "status": "active",
            "regionType": "县",
            "id": "770"
          },
          {
            "regionName": "乡宁县",
            "pid": "58",
            "status": "active",
            "regionType": "县",
            "id": "771"
          },
          {
            "regionName": "大宁县",
            "pid": "58",
            "status": "active",
            "regionType": "县",
            "id": "772"
          },
          {
            "regionName": "隰县",
            "pid": "58",
            "status": "active",
            "regionType": "县",
            "id": "773"
          },
          {
            "regionName": "永和县",
            "pid": "58",
            "status": "active",
            "regionType": "县",
            "id": "774"
          },
          {
            "regionName": "蒲县",
            "pid": "58",
            "status": "active",
            "regionType": "县",
            "id": "775"
          },
          {
            "regionName": "汾西县",
            "pid": "58",
            "status": "active",
            "regionType": "县",
            "id": "776"
          },
          {
            "regionName": "侯马市",
            "pid": "58",
            "status": "active",
            "regionType": "县",
            "id": "777"
          },
          {
            "regionName": "霍州市",
            "pid": "58",
            "status": "active",
            "regionType": "县",
            "id": "778"
          }
        ],
        "id": "58"
      },
      {
        "regionName": "吕梁市",
        "pid": "4",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "离石区",
            "pid": "59",
            "status": "active",
            "regionType": "县",
            "id": "779"
          },
          {
            "regionName": "文水县",
            "pid": "59",
            "status": "active",
            "regionType": "县",
            "id": "780"
          },
          {
            "regionName": "交城县",
            "pid": "59",
            "status": "active",
            "regionType": "县",
            "id": "781"
          },
          {
            "regionName": "兴县",
            "pid": "59",
            "status": "active",
            "regionType": "县",
            "id": "782"
          },
          {
            "regionName": "临县",
            "pid": "59",
            "status": "active",
            "regionType": "县",
            "id": "783"
          },
          {
            "regionName": "柳林县",
            "pid": "59",
            "status": "active",
            "regionType": "县",
            "id": "784"
          },
          {
            "regionName": "石楼县",
            "pid": "59",
            "status": "active",
            "regionType": "县",
            "id": "785"
          },
          {
            "regionName": "岚县",
            "pid": "59",
            "status": "active",
            "regionType": "县",
            "id": "786"
          },
          {
            "regionName": "方山县",
            "pid": "59",
            "status": "active",
            "regionType": "县",
            "id": "787"
          },
          {
            "regionName": "中阳县",
            "pid": "59",
            "status": "active",
            "regionType": "县",
            "id": "788"
          },
          {
            "regionName": "交口县",
            "pid": "59",
            "status": "active",
            "regionType": "县",
            "id": "789"
          },
          {
            "regionName": "孝义市",
            "pid": "59",
            "status": "active",
            "regionType": "县",
            "id": "790"
          },
          {
            "regionName": "汾阳市",
            "pid": "59",
            "status": "active",
            "regionType": "县",
            "id": "791"
          },
          {
            "regionName": "离石市",
            "pid": "59",
            "status": "active",
            "regionType": "县",
            "id": "3761"
          }
        ],
        "id": "59"
      },
      {
        "regionName": "运城市",
        "pid": "4",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "盐湖区",
            "pid": "60",
            "status": "active",
            "regionType": "县",
            "id": "792"
          },
          {
            "regionName": "临猗县",
            "pid": "60",
            "status": "active",
            "regionType": "县",
            "id": "793"
          },
          {
            "regionName": "万荣县",
            "pid": "60",
            "status": "active",
            "regionType": "县",
            "id": "794"
          },
          {
            "regionName": "闻喜县",
            "pid": "60",
            "status": "active",
            "regionType": "县",
            "id": "795"
          },
          {
            "regionName": "稷山县",
            "pid": "60",
            "status": "active",
            "regionType": "县",
            "id": "796"
          },
          {
            "regionName": "新绛县",
            "pid": "60",
            "status": "active",
            "regionType": "县",
            "id": "797"
          },
          {
            "regionName": "绛县",
            "pid": "60",
            "status": "active",
            "regionType": "县",
            "id": "798"
          },
          {
            "regionName": "垣曲县",
            "pid": "60",
            "status": "active",
            "regionType": "县",
            "id": "799"
          },
          {
            "regionName": "夏县",
            "pid": "60",
            "status": "active",
            "regionType": "县",
            "id": "800"
          },
          {
            "regionName": "平陆县",
            "pid": "60",
            "status": "active",
            "regionType": "县",
            "id": "801"
          },
          {
            "regionName": "芮城县",
            "pid": "60",
            "status": "active",
            "regionType": "县",
            "id": "802"
          },
          {
            "regionName": "永济市",
            "pid": "60",
            "status": "active",
            "regionType": "县",
            "id": "803"
          },
          {
            "regionName": "河津市",
            "pid": "60",
            "status": "active",
            "regionType": "县",
            "id": "804"
          }
        ],
        "id": "60"
      }
    ],
    "regionName": "山西省",
    "pid": "0",
    "status": "active",
    "regionType": "省",
    "id": "4"
  },
  {
    "city": [
      {
        "regionName": "呼伦贝尔市",
        "pid": "5",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "海拉尔区",
            "pid": "385",
            "status": "active",
            "regionType": "县",
            "id": "3148"
          },
          {
            "regionName": "阿荣旗",
            "pid": "385",
            "status": "active",
            "regionType": "县",
            "id": "3149"
          },
          {
            "regionName": "莫力达瓦达斡尔族自治旗",
            "pid": "385",
            "status": "active",
            "regionType": "县",
            "id": "3150"
          },
          {
            "regionName": "鄂伦春自治旗",
            "pid": "385",
            "status": "active",
            "regionType": "县",
            "id": "3151"
          },
          {
            "regionName": "鄂温克族自治旗",
            "pid": "385",
            "status": "active",
            "regionType": "县",
            "id": "3152"
          },
          {
            "regionName": "陈巴尔虎旗",
            "pid": "385",
            "status": "active",
            "regionType": "县",
            "id": "3153"
          },
          {
            "regionName": "新巴尔虎左旗",
            "pid": "385",
            "status": "active",
            "regionType": "县",
            "id": "3154"
          },
          {
            "regionName": "新巴尔虎右旗",
            "pid": "385",
            "status": "active",
            "regionType": "县",
            "id": "3155"
          },
          {
            "regionName": "满洲里市",
            "pid": "385",
            "status": "active",
            "regionType": "县",
            "id": "3156"
          },
          {
            "regionName": "牙克石市",
            "pid": "385",
            "status": "active",
            "regionType": "县",
            "id": "3157"
          },
          {
            "regionName": "扎兰屯市",
            "pid": "385",
            "status": "active",
            "regionType": "县",
            "id": "3158"
          },
          {
            "regionName": "额尔古纳市",
            "pid": "385",
            "status": "active",
            "regionType": "县",
            "id": "3159"
          },
          {
            "regionName": "根河市",
            "pid": "385",
            "status": "active",
            "regionType": "县",
            "id": "3160"
          }
        ],
        "id": "385"
      },
      {
        "regionName": "呼和浩特市",
        "pid": "5",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "新城区",
            "pid": "386",
            "status": "active",
            "regionType": "县",
            "id": "3161"
          },
          {
            "regionName": "回民区",
            "pid": "386",
            "status": "active",
            "regionType": "县",
            "id": "3162"
          },
          {
            "regionName": "玉泉区",
            "pid": "386",
            "status": "active",
            "regionType": "县",
            "id": "3163"
          },
          {
            "regionName": "赛罕区",
            "pid": "386",
            "status": "active",
            "regionType": "县",
            "id": "3164"
          },
          {
            "regionName": "土默特左旗",
            "pid": "386",
            "status": "active",
            "regionType": "县",
            "id": "3165"
          },
          {
            "regionName": "托克托县",
            "pid": "386",
            "status": "active",
            "regionType": "县",
            "id": "3166"
          },
          {
            "regionName": "和林格尔县",
            "pid": "386",
            "status": "active",
            "regionType": "县",
            "id": "3167"
          },
          {
            "regionName": "清水河县",
            "pid": "386",
            "status": "active",
            "regionType": "县",
            "id": "3168"
          },
          {
            "regionName": "武川县",
            "pid": "386",
            "status": "active",
            "regionType": "县",
            "id": "3169"
          }
        ],
        "id": "386"
      },
      {
        "regionName": "包头市",
        "pid": "5",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "东河区",
            "pid": "387",
            "status": "active",
            "regionType": "县",
            "id": "3170"
          },
          {
            "regionName": "昆都仑区",
            "pid": "387",
            "status": "active",
            "regionType": "县",
            "id": "3171"
          },
          {
            "regionName": "青山区",
            "pid": "387",
            "status": "active",
            "regionType": "县",
            "id": "3172"
          },
          {
            "regionName": "石拐区",
            "pid": "387",
            "status": "active",
            "regionType": "县",
            "id": "3173"
          },
          {
            "regionName": "白云鄂博矿区",
            "pid": "387",
            "status": "active",
            "regionType": "县",
            "id": "3174"
          },
          {
            "regionName": "九原区",
            "pid": "387",
            "status": "active",
            "regionType": "县",
            "id": "3175"
          },
          {
            "regionName": "土默特右旗",
            "pid": "387",
            "status": "active",
            "regionType": "县",
            "id": "3176"
          },
          {
            "regionName": "固阳县",
            "pid": "387",
            "status": "active",
            "regionType": "县",
            "id": "3177"
          },
          {
            "regionName": "达尔罕茂明安联合旗",
            "pid": "387",
            "status": "active",
            "regionType": "县",
            "id": "3178"
          },
          {
            "regionName": "白云矿区",
            "pid": "387",
            "status": "active",
            "regionType": "县",
            "id": "3756"
          }
        ],
        "id": "387"
      },
      {
        "regionName": "乌海市",
        "pid": "5",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "海勃湾区",
            "pid": "388",
            "status": "active",
            "regionType": "县",
            "id": "3179"
          },
          {
            "regionName": "海南区",
            "pid": "388",
            "status": "active",
            "regionType": "县",
            "id": "3180"
          },
          {
            "regionName": "乌达区",
            "pid": "388",
            "status": "active",
            "regionType": "县",
            "id": "3181"
          }
        ],
        "id": "388"
      },
      {
        "regionName": "乌兰察布市",
        "pid": "5",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "集宁区",
            "pid": "389",
            "status": "active",
            "regionType": "县",
            "id": "3182"
          },
          {
            "regionName": "卓资县",
            "pid": "389",
            "status": "active",
            "regionType": "县",
            "id": "3183"
          },
          {
            "regionName": "化德县",
            "pid": "389",
            "status": "active",
            "regionType": "县",
            "id": "3184"
          },
          {
            "regionName": "商都县",
            "pid": "389",
            "status": "active",
            "regionType": "县",
            "id": "3185"
          },
          {
            "regionName": "兴和县",
            "pid": "389",
            "status": "active",
            "regionType": "县",
            "id": "3186"
          },
          {
            "regionName": "凉城县",
            "pid": "389",
            "status": "active",
            "regionType": "县",
            "id": "3187"
          },
          {
            "regionName": "察哈尔右翼前旗",
            "pid": "389",
            "status": "active",
            "regionType": "县",
            "id": "3188"
          },
          {
            "regionName": "察哈尔右翼中旗",
            "pid": "389",
            "status": "active",
            "regionType": "县",
            "id": "3189"
          },
          {
            "regionName": "察哈尔右翼后旗",
            "pid": "389",
            "status": "active",
            "regionType": "县",
            "id": "3190"
          },
          {
            "regionName": "四子王旗",
            "pid": "389",
            "status": "active",
            "regionType": "县",
            "id": "3191"
          },
          {
            "regionName": "丰镇市",
            "pid": "389",
            "status": "active",
            "regionType": "县",
            "id": "3192"
          }
        ],
        "id": "389"
      },
      {
        "regionName": "通辽市",
        "pid": "5",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "科尔沁区",
            "pid": "390",
            "status": "active",
            "regionType": "县",
            "id": "3193"
          },
          {
            "regionName": "科尔沁左翼中旗",
            "pid": "390",
            "status": "active",
            "regionType": "县",
            "id": "3194"
          },
          {
            "regionName": "科尔沁左翼后旗",
            "pid": "390",
            "status": "active",
            "regionType": "县",
            "id": "3195"
          },
          {
            "regionName": "开鲁县",
            "pid": "390",
            "status": "active",
            "regionType": "县",
            "id": "3196"
          },
          {
            "regionName": "库伦旗",
            "pid": "390",
            "status": "active",
            "regionType": "县",
            "id": "3197"
          },
          {
            "regionName": "奈曼旗",
            "pid": "390",
            "status": "active",
            "regionType": "县",
            "id": "3198"
          },
          {
            "regionName": "扎鲁特旗",
            "pid": "390",
            "status": "active",
            "regionType": "县",
            "id": "3199"
          },
          {
            "regionName": "霍林郭勒市",
            "pid": "390",
            "status": "active",
            "regionType": "县",
            "id": "3200"
          }
        ],
        "id": "390"
      },
      {
        "regionName": "赤峰市",
        "pid": "5",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "红山区",
            "pid": "391",
            "status": "active",
            "regionType": "县",
            "id": "3201"
          },
          {
            "regionName": "元宝山区",
            "pid": "391",
            "status": "active",
            "regionType": "县",
            "id": "3202"
          },
          {
            "regionName": "松山区",
            "pid": "391",
            "status": "active",
            "regionType": "县",
            "id": "3203"
          },
          {
            "regionName": "阿鲁科尔沁旗",
            "pid": "391",
            "status": "active",
            "regionType": "县",
            "id": "3204"
          },
          {
            "regionName": "巴林左旗",
            "pid": "391",
            "status": "active",
            "regionType": "县",
            "id": "3205"
          },
          {
            "regionName": "巴林右旗",
            "pid": "391",
            "status": "active",
            "regionType": "县",
            "id": "3206"
          },
          {
            "regionName": "林西县",
            "pid": "391",
            "status": "active",
            "regionType": "县",
            "id": "3207"
          },
          {
            "regionName": "克什克腾旗",
            "pid": "391",
            "status": "active",
            "regionType": "县",
            "id": "3208"
          },
          {
            "regionName": "翁牛特旗",
            "pid": "391",
            "status": "active",
            "regionType": "县",
            "id": "3209"
          },
          {
            "regionName": "喀喇沁旗",
            "pid": "391",
            "status": "active",
            "regionType": "县",
            "id": "3210"
          },
          {
            "regionName": "宁城县",
            "pid": "391",
            "status": "active",
            "regionType": "县",
            "id": "3211"
          },
          {
            "regionName": "敖汉旗",
            "pid": "391",
            "status": "active",
            "regionType": "县",
            "id": "3212"
          }
        ],
        "id": "391"
      },
      {
        "regionName": "鄂尔多斯市",
        "pid": "5",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "东胜区",
            "pid": "392",
            "status": "active",
            "regionType": "县",
            "id": "3213"
          },
          {
            "regionName": "达拉特旗",
            "pid": "392",
            "status": "active",
            "regionType": "县",
            "id": "3214"
          },
          {
            "regionName": "准格尔旗",
            "pid": "392",
            "status": "active",
            "regionType": "县",
            "id": "3215"
          },
          {
            "regionName": "鄂托克前旗",
            "pid": "392",
            "status": "active",
            "regionType": "县",
            "id": "3216"
          },
          {
            "regionName": "鄂托克旗",
            "pid": "392",
            "status": "active",
            "regionType": "县",
            "id": "3217"
          },
          {
            "regionName": "杭锦旗",
            "pid": "392",
            "status": "active",
            "regionType": "县",
            "id": "3218"
          },
          {
            "regionName": "乌审旗",
            "pid": "392",
            "status": "active",
            "regionType": "县",
            "id": "3219"
          },
          {
            "regionName": "伊金霍洛旗",
            "pid": "392",
            "status": "active",
            "regionType": "县",
            "id": "3220"
          }
        ],
        "id": "392"
      },
      {
        "regionName": "巴彦淖尔市",
        "pid": "5",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "临河区",
            "pid": "393",
            "status": "active",
            "regionType": "县",
            "id": "3221"
          },
          {
            "regionName": "五原县",
            "pid": "393",
            "status": "active",
            "regionType": "县",
            "id": "3222"
          },
          {
            "regionName": "磴口县",
            "pid": "393",
            "status": "active",
            "regionType": "县",
            "id": "3223"
          },
          {
            "regionName": "乌拉特前旗",
            "pid": "393",
            "status": "active",
            "regionType": "县",
            "id": "3224"
          },
          {
            "regionName": "乌拉特中旗",
            "pid": "393",
            "status": "active",
            "regionType": "县",
            "id": "3225"
          },
          {
            "regionName": "乌拉特后旗",
            "pid": "393",
            "status": "active",
            "regionType": "县",
            "id": "3226"
          },
          {
            "regionName": "杭锦后旗",
            "pid": "393",
            "status": "active",
            "regionType": "县",
            "id": "3227"
          }
        ],
        "id": "393"
      },
      {
        "regionName": "锡林郭勒盟",
        "pid": "5",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "二连浩特市",
            "pid": "394",
            "status": "active",
            "regionType": "县",
            "id": "3228"
          },
          {
            "regionName": "锡林浩特市",
            "pid": "394",
            "status": "active",
            "regionType": "县",
            "id": "3229"
          },
          {
            "regionName": "阿巴嘎旗",
            "pid": "394",
            "status": "active",
            "regionType": "县",
            "id": "3230"
          },
          {
            "regionName": "苏尼特左旗",
            "pid": "394",
            "status": "active",
            "regionType": "县",
            "id": "3231"
          },
          {
            "regionName": "苏尼特右旗",
            "pid": "394",
            "status": "active",
            "regionType": "县",
            "id": "3232"
          },
          {
            "regionName": "东乌珠穆沁旗",
            "pid": "394",
            "status": "active",
            "regionType": "县",
            "id": "3233"
          },
          {
            "regionName": "西乌珠穆沁旗",
            "pid": "394",
            "status": "active",
            "regionType": "县",
            "id": "3234"
          },
          {
            "regionName": "太仆寺旗",
            "pid": "394",
            "status": "active",
            "regionType": "县",
            "id": "3235"
          },
          {
            "regionName": "镶黄旗",
            "pid": "394",
            "status": "active",
            "regionType": "县",
            "id": "3236"
          },
          {
            "regionName": "正镶白旗",
            "pid": "394",
            "status": "active",
            "regionType": "县",
            "id": "3237"
          },
          {
            "regionName": "正蓝旗",
            "pid": "394",
            "status": "active",
            "regionType": "县",
            "id": "3238"
          },
          {
            "regionName": "多伦县",
            "pid": "394",
            "status": "active",
            "regionType": "县",
            "id": "3239"
          }
        ],
        "id": "394"
      },
      {
        "regionName": "兴安盟",
        "pid": "5",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "乌兰浩特市",
            "pid": "395",
            "status": "active",
            "regionType": "县",
            "id": "3240"
          },
          {
            "regionName": "阿尔山市",
            "pid": "395",
            "status": "active",
            "regionType": "县",
            "id": "3241"
          },
          {
            "regionName": "科尔沁右翼前旗",
            "pid": "395",
            "status": "active",
            "regionType": "县",
            "id": "3242"
          },
          {
            "regionName": "科尔沁右翼中旗",
            "pid": "395",
            "status": "active",
            "regionType": "县",
            "id": "3243"
          },
          {
            "regionName": "扎赉特旗",
            "pid": "395",
            "status": "active",
            "regionType": "县",
            "id": "3244"
          },
          {
            "regionName": "突泉县",
            "pid": "395",
            "status": "active",
            "regionType": "县",
            "id": "3245"
          }
        ],
        "id": "395"
      },
      {
        "regionName": "阿拉善盟",
        "pid": "5",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "阿拉善左旗",
            "pid": "396",
            "status": "active",
            "regionType": "县",
            "id": "3246"
          },
          {
            "regionName": "阿拉善右旗",
            "pid": "396",
            "status": "active",
            "regionType": "县",
            "id": "3247"
          },
          {
            "regionName": "额济纳旗",
            "pid": "396",
            "status": "active",
            "regionType": "县",
            "id": "3248"
          }
        ],
        "id": "396"
      },
      {
        "regionName": "巴彦淖尔盟",
        "pid": "5",
        "status": "active",
        "regionType": "市",
        "id": "423"
      }
    ],
    "regionName": "内蒙古自治区",
    "pid": "0",
    "status": "active",
    "regionType": "省",
    "id": "5"
  },
  {
    "city": [
      {
        "regionName": "沈阳市",
        "pid": "6",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "和平区",
            "pid": "61",
            "status": "active",
            "regionType": "县",
            "id": "805"
          },
          {
            "regionName": "沈河区",
            "pid": "61",
            "status": "active",
            "regionType": "县",
            "id": "806"
          },
          {
            "regionName": "大东区",
            "pid": "61",
            "status": "active",
            "regionType": "县",
            "id": "807"
          },
          {
            "regionName": "皇姑区",
            "pid": "61",
            "status": "active",
            "regionType": "县",
            "id": "808"
          },
          {
            "regionName": "铁西区",
            "pid": "61",
            "status": "active",
            "regionType": "县",
            "id": "809"
          },
          {
            "regionName": "苏家屯区",
            "pid": "61",
            "status": "active",
            "regionType": "县",
            "id": "810"
          },
          {
            "regionName": "东陵区",
            "pid": "61",
            "status": "active",
            "regionType": "县",
            "id": "811"
          },
          {
            "regionName": "沈北新区",
            "pid": "61",
            "status": "active",
            "regionType": "县",
            "id": "812"
          },
          {
            "regionName": "于洪区",
            "pid": "61",
            "status": "active",
            "regionType": "县",
            "id": "813"
          },
          {
            "regionName": "辽中县",
            "pid": "61",
            "status": "active",
            "regionType": "县",
            "id": "814"
          },
          {
            "regionName": "康平县",
            "pid": "61",
            "status": "active",
            "regionType": "县",
            "id": "815"
          },
          {
            "regionName": "法库县",
            "pid": "61",
            "status": "active",
            "regionType": "县",
            "id": "816"
          },
          {
            "regionName": "新民市",
            "pid": "61",
            "status": "active",
            "regionType": "县",
            "id": "817"
          },
          {
            "regionName": "浑南新区",
            "pid": "61",
            "status": "active",
            "regionType": "县",
            "id": "3754"
          }
        ],
        "id": "61"
      },
      {
        "regionName": "铁岭市",
        "pid": "6",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "银州区",
            "pid": "62",
            "status": "active",
            "regionType": "县",
            "id": "818"
          },
          {
            "regionName": "清河区",
            "pid": "62",
            "status": "active",
            "regionType": "县",
            "id": "819"
          },
          {
            "regionName": "铁岭县",
            "pid": "62",
            "status": "active",
            "regionType": "县",
            "id": "820"
          },
          {
            "regionName": "西丰县",
            "pid": "62",
            "status": "active",
            "regionType": "县",
            "id": "821"
          },
          {
            "regionName": "昌图县",
            "pid": "62",
            "status": "active",
            "regionType": "县",
            "id": "822"
          },
          {
            "regionName": "调兵山市",
            "pid": "62",
            "status": "active",
            "regionType": "县",
            "id": "823"
          },
          {
            "regionName": "开原市",
            "pid": "62",
            "status": "active",
            "regionType": "县",
            "id": "824"
          }
        ],
        "id": "62"
      },
      {
        "regionName": "大连市",
        "pid": "6",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "长海县",
            "pid": "63",
            "status": "active",
            "regionType": "县",
            "id": "825"
          },
          {
            "regionName": "旅顺口区",
            "pid": "63",
            "status": "active",
            "regionType": "县",
            "id": "826"
          },
          {
            "regionName": "中山区",
            "pid": "63",
            "status": "active",
            "regionType": "县",
            "id": "827"
          },
          {
            "regionName": "西岗区",
            "pid": "63",
            "status": "active",
            "regionType": "县",
            "id": "828"
          },
          {
            "regionName": "沙河口区",
            "pid": "63",
            "status": "active",
            "regionType": "县",
            "id": "829"
          },
          {
            "regionName": "甘井子区",
            "pid": "63",
            "status": "active",
            "regionType": "县",
            "id": "830"
          },
          {
            "regionName": "金州区",
            "pid": "63",
            "status": "active",
            "regionType": "县",
            "id": "831"
          },
          {
            "regionName": "普兰店市",
            "pid": "63",
            "status": "active",
            "regionType": "县",
            "id": "832"
          },
          {
            "regionName": "瓦房店市",
            "pid": "63",
            "status": "active",
            "regionType": "县",
            "id": "833"
          },
          {
            "regionName": "庄河市",
            "pid": "63",
            "status": "active",
            "regionType": "县",
            "id": "834"
          }
        ],
        "id": "63"
      },
      {
        "regionName": "鞍山市",
        "pid": "6",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "铁东区",
            "pid": "64",
            "status": "active",
            "regionType": "县",
            "id": "835"
          },
          {
            "regionName": "铁西区",
            "pid": "64",
            "status": "active",
            "regionType": "县",
            "id": "836"
          },
          {
            "regionName": "立山区",
            "pid": "64",
            "status": "active",
            "regionType": "县",
            "id": "837"
          },
          {
            "regionName": "千山区",
            "pid": "64",
            "status": "active",
            "regionType": "县",
            "id": "838"
          },
          {
            "regionName": "台安县",
            "pid": "64",
            "status": "active",
            "regionType": "县",
            "id": "839"
          },
          {
            "regionName": "岫岩满族自治县",
            "pid": "64",
            "status": "active",
            "regionType": "县",
            "id": "840"
          },
          {
            "regionName": "海城市",
            "pid": "64",
            "status": "active",
            "regionType": "县",
            "id": "841"
          }
        ],
        "id": "64"
      },
      {
        "regionName": "抚顺市",
        "pid": "6",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "新抚区",
            "pid": "65",
            "status": "active",
            "regionType": "县",
            "id": "842"
          },
          {
            "regionName": "东洲区",
            "pid": "65",
            "status": "active",
            "regionType": "县",
            "id": "843"
          },
          {
            "regionName": "望花区",
            "pid": "65",
            "status": "active",
            "regionType": "县",
            "id": "844"
          },
          {
            "regionName": "顺城区",
            "pid": "65",
            "status": "active",
            "regionType": "县",
            "id": "845"
          },
          {
            "regionName": "抚顺县",
            "pid": "65",
            "status": "active",
            "regionType": "县",
            "id": "846"
          },
          {
            "regionName": "新宾满族自治县",
            "pid": "65",
            "status": "active",
            "regionType": "县",
            "id": "847"
          },
          {
            "regionName": "清原满族自治县",
            "pid": "65",
            "status": "active",
            "regionType": "县",
            "id": "848"
          }
        ],
        "id": "65"
      },
      {
        "regionName": "本溪市",
        "pid": "6",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "平山区",
            "pid": "66",
            "status": "active",
            "regionType": "县",
            "id": "849"
          },
          {
            "regionName": "溪湖区",
            "pid": "66",
            "status": "active",
            "regionType": "县",
            "id": "850"
          },
          {
            "regionName": "明山区",
            "pid": "66",
            "status": "active",
            "regionType": "县",
            "id": "851"
          },
          {
            "regionName": "南芬区",
            "pid": "66",
            "status": "active",
            "regionType": "县",
            "id": "852"
          },
          {
            "regionName": "本溪满族自治县",
            "pid": "66",
            "status": "active",
            "regionType": "县",
            "id": "853"
          },
          {
            "regionName": "桓仁满族自治县",
            "pid": "66",
            "status": "active",
            "regionType": "县",
            "id": "854"
          }
        ],
        "id": "66"
      },
      {
        "regionName": "丹东市",
        "pid": "6",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "元宝区",
            "pid": "67",
            "status": "active",
            "regionType": "县",
            "id": "855"
          },
          {
            "regionName": "振兴区",
            "pid": "67",
            "status": "active",
            "regionType": "县",
            "id": "856"
          },
          {
            "regionName": "振安区",
            "pid": "67",
            "status": "active",
            "regionType": "县",
            "id": "857"
          },
          {
            "regionName": "宽甸满族自治县",
            "pid": "67",
            "status": "active",
            "regionType": "县",
            "id": "858"
          },
          {
            "regionName": "东港市",
            "pid": "67",
            "status": "active",
            "regionType": "县",
            "id": "859"
          },
          {
            "regionName": "凤城市",
            "pid": "67",
            "status": "active",
            "regionType": "县",
            "id": "860"
          }
        ],
        "id": "67"
      },
      {
        "regionName": "锦州市",
        "pid": "6",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "古塔区",
            "pid": "68",
            "status": "active",
            "regionType": "县",
            "id": "861"
          },
          {
            "regionName": "凌河区",
            "pid": "68",
            "status": "active",
            "regionType": "县",
            "id": "862"
          },
          {
            "regionName": "太和区",
            "pid": "68",
            "status": "active",
            "regionType": "县",
            "id": "863"
          },
          {
            "regionName": "黑山县",
            "pid": "68",
            "status": "active",
            "regionType": "县",
            "id": "864"
          },
          {
            "regionName": "义县",
            "pid": "68",
            "status": "active",
            "regionType": "县",
            "id": "865"
          },
          {
            "regionName": "凌海市",
            "pid": "68",
            "status": "active",
            "regionType": "县",
            "id": "866"
          },
          {
            "regionName": "北镇市",
            "pid": "68",
            "status": "active",
            "regionType": "县",
            "id": "867"
          }
        ],
        "id": "68"
      },
      {
        "regionName": "营口市",
        "pid": "6",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "站前区",
            "pid": "69",
            "status": "active",
            "regionType": "县",
            "id": "868"
          },
          {
            "regionName": "西市区",
            "pid": "69",
            "status": "active",
            "regionType": "县",
            "id": "869"
          },
          {
            "regionName": "鮁鱼圈区",
            "pid": "69",
            "status": "active",
            "regionType": "县",
            "id": "870"
          },
          {
            "regionName": "老边区",
            "pid": "69",
            "status": "active",
            "regionType": "县",
            "id": "871"
          },
          {
            "regionName": "盖州市",
            "pid": "69",
            "status": "active",
            "regionType": "县",
            "id": "872"
          },
          {
            "regionName": "大石桥市",
            "pid": "69",
            "status": "active",
            "regionType": "县",
            "id": "873"
          },
          {
            "regionName": "鲅鱼圈区",
            "pid": "69",
            "status": "active",
            "regionType": "县",
            "id": "3755"
          }
        ],
        "id": "69"
      },
      {
        "regionName": "阜新市",
        "pid": "6",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "海州区",
            "pid": "70",
            "status": "active",
            "regionType": "县",
            "id": "874"
          },
          {
            "regionName": "新邱区",
            "pid": "70",
            "status": "active",
            "regionType": "县",
            "id": "875"
          },
          {
            "regionName": "太平区",
            "pid": "70",
            "status": "active",
            "regionType": "县",
            "id": "876"
          },
          {
            "regionName": "清河门区",
            "pid": "70",
            "status": "active",
            "regionType": "县",
            "id": "877"
          },
          {
            "regionName": "细河区",
            "pid": "70",
            "status": "active",
            "regionType": "县",
            "id": "878"
          },
          {
            "regionName": "阜新蒙古族自治县",
            "pid": "70",
            "status": "active",
            "regionType": "县",
            "id": "879"
          },
          {
            "regionName": "彰武县",
            "pid": "70",
            "status": "active",
            "regionType": "县",
            "id": "880"
          }
        ],
        "id": "70"
      },
      {
        "regionName": "辽阳市",
        "pid": "6",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "白塔区",
            "pid": "71",
            "status": "active",
            "regionType": "县",
            "id": "881"
          },
          {
            "regionName": "文圣区",
            "pid": "71",
            "status": "active",
            "regionType": "县",
            "id": "882"
          },
          {
            "regionName": "宏伟区",
            "pid": "71",
            "status": "active",
            "regionType": "县",
            "id": "883"
          },
          {
            "regionName": "弓长岭区",
            "pid": "71",
            "status": "active",
            "regionType": "县",
            "id": "884"
          },
          {
            "regionName": "太子河区",
            "pid": "71",
            "status": "active",
            "regionType": "县",
            "id": "885"
          },
          {
            "regionName": "辽阳县",
            "pid": "71",
            "status": "active",
            "regionType": "县",
            "id": "886"
          },
          {
            "regionName": "灯塔市",
            "pid": "71",
            "status": "active",
            "regionType": "县",
            "id": "887"
          }
        ],
        "id": "71"
      },
      {
        "regionName": "朝阳市",
        "pid": "6",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "双塔区",
            "pid": "72",
            "status": "active",
            "regionType": "县",
            "id": "888"
          },
          {
            "regionName": "龙城区",
            "pid": "72",
            "status": "active",
            "regionType": "县",
            "id": "889"
          },
          {
            "regionName": "朝阳县",
            "pid": "72",
            "status": "active",
            "regionType": "县",
            "id": "890"
          },
          {
            "regionName": "建平县",
            "pid": "72",
            "status": "active",
            "regionType": "县",
            "id": "891"
          },
          {
            "regionName": "喀喇沁左翼蒙古族自治县",
            "pid": "72",
            "status": "active",
            "regionType": "县",
            "id": "892"
          },
          {
            "regionName": "北票市",
            "pid": "72",
            "status": "active",
            "regionType": "县",
            "id": "893"
          },
          {
            "regionName": "凌源市",
            "pid": "72",
            "status": "active",
            "regionType": "县",
            "id": "894"
          }
        ],
        "id": "72"
      },
      {
        "regionName": "盘锦市",
        "pid": "6",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "双台子区",
            "pid": "73",
            "status": "active",
            "regionType": "县",
            "id": "895"
          },
          {
            "regionName": "兴隆台区",
            "pid": "73",
            "status": "active",
            "regionType": "县",
            "id": "896"
          },
          {
            "regionName": "大洼县",
            "pid": "73",
            "status": "active",
            "regionType": "县",
            "id": "897"
          },
          {
            "regionName": "盘山县",
            "pid": "73",
            "status": "active",
            "regionType": "县",
            "id": "898"
          }
        ],
        "id": "73"
      },
      {
        "regionName": "葫芦岛市",
        "pid": "6",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "连山区",
            "pid": "74",
            "status": "active",
            "regionType": "县",
            "id": "899"
          },
          {
            "regionName": "龙港区",
            "pid": "74",
            "status": "active",
            "regionType": "县",
            "id": "900"
          },
          {
            "regionName": "南票区",
            "pid": "74",
            "status": "active",
            "regionType": "县",
            "id": "901"
          },
          {
            "regionName": "绥中县",
            "pid": "74",
            "status": "active",
            "regionType": "县",
            "id": "902"
          },
          {
            "regionName": "建昌县",
            "pid": "74",
            "status": "active",
            "regionType": "县",
            "id": "903"
          },
          {
            "regionName": "兴城市",
            "pid": "74",
            "status": "active",
            "regionType": "县",
            "id": "904"
          }
        ],
        "id": "74"
      }
    ],
    "regionName": "辽宁省",
    "pid": "0",
    "status": "active",
    "regionType": "省",
    "id": "6"
  },
  {
    "city": [
      {
        "regionName": "长春市",
        "pid": "7",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "南关区",
            "pid": "75",
            "status": "active",
            "regionType": "县",
            "id": "905"
          },
          {
            "regionName": "宽城区",
            "pid": "75",
            "status": "active",
            "regionType": "县",
            "id": "906"
          },
          {
            "regionName": "朝阳区",
            "pid": "75",
            "status": "active",
            "regionType": "县",
            "id": "907"
          },
          {
            "regionName": "二道区",
            "pid": "75",
            "status": "active",
            "regionType": "县",
            "id": "908"
          },
          {
            "regionName": "绿园区",
            "pid": "75",
            "status": "active",
            "regionType": "县",
            "id": "909"
          },
          {
            "regionName": "双阳区",
            "pid": "75",
            "status": "active",
            "regionType": "县",
            "id": "910"
          },
          {
            "regionName": "农安县",
            "pid": "75",
            "status": "active",
            "regionType": "县",
            "id": "911"
          },
          {
            "regionName": "九台市",
            "pid": "75",
            "status": "active",
            "regionType": "县",
            "id": "912"
          },
          {
            "regionName": "榆树市",
            "pid": "75",
            "status": "active",
            "regionType": "县",
            "id": "913"
          },
          {
            "regionName": "德惠市",
            "pid": "75",
            "status": "active",
            "regionType": "县",
            "id": "914"
          },
          {
            "regionName": "净月潭开发区",
            "pid": "75",
            "status": "active",
            "regionType": "县",
            "id": "3734"
          },
          {
            "regionName": "高新技术开发区",
            "pid": "75",
            "status": "active",
            "regionType": "县",
            "id": "3735"
          },
          {
            "regionName": "汽车产业开发区",
            "pid": "75",
            "status": "active",
            "regionType": "县",
            "id": "3736"
          }
        ],
        "id": "75"
      },
      {
        "regionName": "吉林市",
        "pid": "7",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "昌邑区",
            "pid": "76",
            "status": "active",
            "regionType": "县",
            "id": "915"
          },
          {
            "regionName": "龙潭区",
            "pid": "76",
            "status": "active",
            "regionType": "县",
            "id": "916"
          },
          {
            "regionName": "船营区",
            "pid": "76",
            "status": "active",
            "regionType": "县",
            "id": "917"
          },
          {
            "regionName": "丰满区",
            "pid": "76",
            "status": "active",
            "regionType": "县",
            "id": "918"
          },
          {
            "regionName": "永吉县",
            "pid": "76",
            "status": "active",
            "regionType": "县",
            "id": "919"
          },
          {
            "regionName": "蛟河市",
            "pid": "76",
            "status": "active",
            "regionType": "县",
            "id": "920"
          },
          {
            "regionName": "桦甸市",
            "pid": "76",
            "status": "active",
            "regionType": "县",
            "id": "921"
          },
          {
            "regionName": "舒兰市",
            "pid": "76",
            "status": "active",
            "regionType": "县",
            "id": "922"
          },
          {
            "regionName": "磐石市",
            "pid": "76",
            "status": "active",
            "regionType": "县",
            "id": "923"
          }
        ],
        "id": "76"
      },
      {
        "regionName": "延边朝鲜族自治州",
        "pid": "7",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "延吉市",
            "pid": "77",
            "status": "active",
            "regionType": "县",
            "id": "924"
          },
          {
            "regionName": "图们市",
            "pid": "77",
            "status": "active",
            "regionType": "县",
            "id": "925"
          },
          {
            "regionName": "敦化市",
            "pid": "77",
            "status": "active",
            "regionType": "县",
            "id": "926"
          },
          {
            "regionName": "珲春市",
            "pid": "77",
            "status": "active",
            "regionType": "县",
            "id": "927"
          },
          {
            "regionName": "龙井市",
            "pid": "77",
            "status": "active",
            "regionType": "县",
            "id": "928"
          },
          {
            "regionName": "和龙市",
            "pid": "77",
            "status": "active",
            "regionType": "县",
            "id": "929"
          },
          {
            "regionName": "汪清县",
            "pid": "77",
            "status": "active",
            "regionType": "县",
            "id": "930"
          },
          {
            "regionName": "安图县",
            "pid": "77",
            "status": "active",
            "regionType": "县",
            "id": "931"
          }
        ],
        "id": "77"
      },
      {
        "regionName": "四平市",
        "pid": "7",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "铁西区",
            "pid": "78",
            "status": "active",
            "regionType": "县",
            "id": "932"
          },
          {
            "regionName": "铁东区",
            "pid": "78",
            "status": "active",
            "regionType": "县",
            "id": "933"
          },
          {
            "regionName": "梨树县",
            "pid": "78",
            "status": "active",
            "regionType": "县",
            "id": "934"
          },
          {
            "regionName": "伊通满族自治县",
            "pid": "78",
            "status": "active",
            "regionType": "县",
            "id": "935"
          },
          {
            "regionName": "公主岭市",
            "pid": "78",
            "status": "active",
            "regionType": "县",
            "id": "936"
          },
          {
            "regionName": "双辽市",
            "pid": "78",
            "status": "active",
            "regionType": "县",
            "id": "937"
          }
        ],
        "id": "78"
      },
      {
        "regionName": "通化市",
        "pid": "7",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "东昌区",
            "pid": "79",
            "status": "active",
            "regionType": "县",
            "id": "938"
          },
          {
            "regionName": "二道江区",
            "pid": "79",
            "status": "active",
            "regionType": "县",
            "id": "939"
          },
          {
            "regionName": "通化县",
            "pid": "79",
            "status": "active",
            "regionType": "县",
            "id": "940"
          },
          {
            "regionName": "辉南县",
            "pid": "79",
            "status": "active",
            "regionType": "县",
            "id": "941"
          },
          {
            "regionName": "柳河县",
            "pid": "79",
            "status": "active",
            "regionType": "县",
            "id": "942"
          },
          {
            "regionName": "梅河口市",
            "pid": "79",
            "status": "active",
            "regionType": "县",
            "id": "943"
          },
          {
            "regionName": "集安市",
            "pid": "79",
            "status": "active",
            "regionType": "县",
            "id": "944"
          }
        ],
        "id": "79"
      },
      {
        "regionName": "白城市",
        "pid": "7",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "洮北区",
            "pid": "80",
            "status": "active",
            "regionType": "县",
            "id": "945"
          },
          {
            "regionName": "镇赉县",
            "pid": "80",
            "status": "active",
            "regionType": "县",
            "id": "946"
          },
          {
            "regionName": "通榆县",
            "pid": "80",
            "status": "active",
            "regionType": "县",
            "id": "947"
          },
          {
            "regionName": "洮南市",
            "pid": "80",
            "status": "active",
            "regionType": "县",
            "id": "948"
          },
          {
            "regionName": "大安市",
            "pid": "80",
            "status": "active",
            "regionType": "县",
            "id": "949"
          }
        ],
        "id": "80"
      },
      {
        "regionName": "辽源市",
        "pid": "7",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "龙山区",
            "pid": "81",
            "status": "active",
            "regionType": "县",
            "id": "950"
          },
          {
            "regionName": "西安区",
            "pid": "81",
            "status": "active",
            "regionType": "县",
            "id": "951"
          },
          {
            "regionName": "东丰县",
            "pid": "81",
            "status": "active",
            "regionType": "县",
            "id": "952"
          },
          {
            "regionName": "东辽县",
            "pid": "81",
            "status": "active",
            "regionType": "县",
            "id": "953"
          }
        ],
        "id": "81"
      },
      {
        "regionName": "松原市",
        "pid": "7",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "宁江区",
            "pid": "82",
            "status": "active",
            "regionType": "县",
            "id": "954"
          },
          {
            "regionName": "前郭尔罗斯蒙古族自治县",
            "pid": "82",
            "status": "active",
            "regionType": "县",
            "id": "955"
          },
          {
            "regionName": "长岭县",
            "pid": "82",
            "status": "active",
            "regionType": "县",
            "id": "956"
          },
          {
            "regionName": "乾安县",
            "pid": "82",
            "status": "active",
            "regionType": "县",
            "id": "957"
          },
          {
            "regionName": "扶余县",
            "pid": "82",
            "status": "active",
            "regionType": "县",
            "id": "958"
          }
        ],
        "id": "82"
      },
      {
        "regionName": "白山市",
        "pid": "7",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "八道江区",
            "pid": "83",
            "status": "active",
            "regionType": "县",
            "id": "959"
          },
          {
            "regionName": "江源区",
            "pid": "83",
            "status": "active",
            "regionType": "县",
            "id": "960"
          },
          {
            "regionName": "抚松县",
            "pid": "83",
            "status": "active",
            "regionType": "县",
            "id": "961"
          },
          {
            "regionName": "靖宇县",
            "pid": "83",
            "status": "active",
            "regionType": "县",
            "id": "962"
          },
          {
            "regionName": "长白朝鲜族自治县",
            "pid": "83",
            "status": "active",
            "regionType": "县",
            "id": "963"
          },
          {
            "regionName": "临江市",
            "pid": "83",
            "status": "active",
            "regionType": "县",
            "id": "964"
          }
        ],
        "id": "83"
      }
    ],
    "regionName": "吉林省",
    "pid": "0",
    "status": "active",
    "regionType": "省",
    "id": "7"
  },
  {
    "city": [
      {
        "regionName": "哈尔滨市",
        "pid": "8",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "道里区",
            "pid": "84",
            "status": "active",
            "regionType": "县",
            "id": "965"
          },
          {
            "regionName": "南岗区",
            "pid": "84",
            "status": "active",
            "regionType": "县",
            "id": "966"
          },
          {
            "regionName": "道外区",
            "pid": "84",
            "status": "active",
            "regionType": "县",
            "id": "967"
          },
          {
            "regionName": "平房区",
            "pid": "84",
            "status": "active",
            "regionType": "县",
            "id": "968"
          },
          {
            "regionName": "松北区",
            "pid": "84",
            "status": "active",
            "regionType": "县",
            "id": "969"
          },
          {
            "regionName": "香坊区",
            "pid": "84",
            "status": "active",
            "regionType": "县",
            "id": "970"
          },
          {
            "regionName": "呼兰区",
            "pid": "84",
            "status": "active",
            "regionType": "县",
            "id": "971"
          },
          {
            "regionName": "阿城区",
            "pid": "84",
            "status": "active",
            "regionType": "县",
            "id": "972"
          },
          {
            "regionName": "依兰县",
            "pid": "84",
            "status": "active",
            "regionType": "县",
            "id": "973"
          },
          {
            "regionName": "方正县",
            "pid": "84",
            "status": "active",
            "regionType": "县",
            "id": "974"
          },
          {
            "regionName": "宾县",
            "pid": "84",
            "status": "active",
            "regionType": "县",
            "id": "975"
          },
          {
            "regionName": "巴彦县",
            "pid": "84",
            "status": "active",
            "regionType": "县",
            "id": "976"
          },
          {
            "regionName": "木兰县",
            "pid": "84",
            "status": "active",
            "regionType": "县",
            "id": "977"
          },
          {
            "regionName": "通河县",
            "pid": "84",
            "status": "active",
            "regionType": "县",
            "id": "978"
          },
          {
            "regionName": "延寿县",
            "pid": "84",
            "status": "active",
            "regionType": "县",
            "id": "979"
          },
          {
            "regionName": "双城市",
            "pid": "84",
            "status": "active",
            "regionType": "县",
            "id": "980"
          },
          {
            "regionName": "尚志市",
            "pid": "84",
            "status": "active",
            "regionType": "县",
            "id": "981"
          },
          {
            "regionName": "五常市",
            "pid": "84",
            "status": "active",
            "regionType": "县",
            "id": "982"
          },
          {
            "regionName": "动力区",
            "pid": "84",
            "status": "active",
            "regionType": "县",
            "id": "3725"
          }
        ],
        "id": "84"
      },
      {
        "regionName": "齐齐哈尔市",
        "pid": "8",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "龙沙区",
            "pid": "85",
            "status": "active",
            "regionType": "县",
            "id": "983"
          },
          {
            "regionName": "建华区",
            "pid": "85",
            "status": "active",
            "regionType": "县",
            "id": "984"
          },
          {
            "regionName": "铁锋区",
            "pid": "85",
            "status": "active",
            "regionType": "县",
            "id": "985"
          },
          {
            "regionName": "昂昂溪区",
            "pid": "85",
            "status": "active",
            "regionType": "县",
            "id": "986"
          },
          {
            "regionName": "富拉尔基区",
            "pid": "85",
            "status": "active",
            "regionType": "县",
            "id": "987"
          },
          {
            "regionName": "碾子山区",
            "pid": "85",
            "status": "active",
            "regionType": "县",
            "id": "988"
          },
          {
            "regionName": "梅里斯达翰尔族区",
            "pid": "85",
            "status": "active",
            "regionType": "县",
            "id": "989"
          },
          {
            "regionName": "龙江县",
            "pid": "85",
            "status": "active",
            "regionType": "县",
            "id": "990"
          },
          {
            "regionName": "依安县",
            "pid": "85",
            "status": "active",
            "regionType": "县",
            "id": "991"
          },
          {
            "regionName": "泰来县",
            "pid": "85",
            "status": "active",
            "regionType": "县",
            "id": "992"
          },
          {
            "regionName": "甘南县",
            "pid": "85",
            "status": "active",
            "regionType": "县",
            "id": "993"
          },
          {
            "regionName": "富裕县",
            "pid": "85",
            "status": "active",
            "regionType": "县",
            "id": "994"
          },
          {
            "regionName": "克山县",
            "pid": "85",
            "status": "active",
            "regionType": "县",
            "id": "995"
          },
          {
            "regionName": "克东县",
            "pid": "85",
            "status": "active",
            "regionType": "县",
            "id": "996"
          },
          {
            "regionName": "拜泉县",
            "pid": "85",
            "status": "active",
            "regionType": "县",
            "id": "997"
          },
          {
            "regionName": "讷河市",
            "pid": "85",
            "status": "active",
            "regionType": "县",
            "id": "998"
          },
          {
            "regionName": "铁峰区",
            "pid": "85",
            "status": "active",
            "regionType": "县",
            "id": "3726"
          },
          {
            "regionName": "梅里斯达斡尔区",
            "pid": "85",
            "status": "active",
            "regionType": "县",
            "id": "3727"
          }
        ],
        "id": "85"
      },
      {
        "regionName": "鸡西市",
        "pid": "8",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "鸡冠区",
            "pid": "86",
            "status": "active",
            "regionType": "县",
            "id": "999"
          },
          {
            "regionName": "恒山区",
            "pid": "86",
            "status": "active",
            "regionType": "县",
            "id": "1000"
          },
          {
            "regionName": "滴道区",
            "pid": "86",
            "status": "active",
            "regionType": "县",
            "id": "1001"
          },
          {
            "regionName": "梨树区",
            "pid": "86",
            "status": "active",
            "regionType": "县",
            "id": "1002"
          },
          {
            "regionName": "城子河区",
            "pid": "86",
            "status": "active",
            "regionType": "县",
            "id": "1003"
          },
          {
            "regionName": "麻山区",
            "pid": "86",
            "status": "active",
            "regionType": "县",
            "id": "1004"
          },
          {
            "regionName": "鸡东县",
            "pid": "86",
            "status": "active",
            "regionType": "县",
            "id": "1005"
          },
          {
            "regionName": "虎林市",
            "pid": "86",
            "status": "active",
            "regionType": "县",
            "id": "1006"
          },
          {
            "regionName": "密山市",
            "pid": "86",
            "status": "active",
            "regionType": "县",
            "id": "1007"
          }
        ],
        "id": "86"
      },
      {
        "regionName": "牡丹江市",
        "pid": "8",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "东安区",
            "pid": "87",
            "status": "active",
            "regionType": "县",
            "id": "1008"
          },
          {
            "regionName": "阳明区",
            "pid": "87",
            "status": "active",
            "regionType": "县",
            "id": "1009"
          },
          {
            "regionName": "爱民区",
            "pid": "87",
            "status": "active",
            "regionType": "县",
            "id": "1010"
          },
          {
            "regionName": "西安区",
            "pid": "87",
            "status": "active",
            "regionType": "县",
            "id": "1011"
          },
          {
            "regionName": "东宁县",
            "pid": "87",
            "status": "active",
            "regionType": "县",
            "id": "1012"
          },
          {
            "regionName": "林口县",
            "pid": "87",
            "status": "active",
            "regionType": "县",
            "id": "1013"
          },
          {
            "regionName": "绥芬河市",
            "pid": "87",
            "status": "active",
            "regionType": "县",
            "id": "1014"
          },
          {
            "regionName": "海林市",
            "pid": "87",
            "status": "active",
            "regionType": "县",
            "id": "1015"
          },
          {
            "regionName": "宁安市",
            "pid": "87",
            "status": "active",
            "regionType": "县",
            "id": "1016"
          },
          {
            "regionName": "穆棱市",
            "pid": "87",
            "status": "active",
            "regionType": "县",
            "id": "1017"
          }
        ],
        "id": "87"
      },
      {
        "regionName": "七台河市",
        "pid": "8",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "新兴区",
            "pid": "88",
            "status": "active",
            "regionType": "县",
            "id": "1018"
          },
          {
            "regionName": "桃山区",
            "pid": "88",
            "status": "active",
            "regionType": "县",
            "id": "1019"
          },
          {
            "regionName": "茄子河区",
            "pid": "88",
            "status": "active",
            "regionType": "县",
            "id": "1020"
          },
          {
            "regionName": "勃利县",
            "pid": "88",
            "status": "active",
            "regionType": "县",
            "id": "1021"
          }
        ],
        "id": "88"
      },
      {
        "regionName": "佳木斯市",
        "pid": "8",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "向阳区",
            "pid": "89",
            "status": "active",
            "regionType": "县",
            "id": "1022"
          },
          {
            "regionName": "前进区",
            "pid": "89",
            "status": "active",
            "regionType": "县",
            "id": "1023"
          },
          {
            "regionName": "东风区",
            "pid": "89",
            "status": "active",
            "regionType": "县",
            "id": "1024"
          },
          {
            "regionName": "桦南县",
            "pid": "89",
            "status": "active",
            "regionType": "县",
            "id": "1025"
          },
          {
            "regionName": "桦川县",
            "pid": "89",
            "status": "active",
            "regionType": "县",
            "id": "1026"
          },
          {
            "regionName": "汤原县",
            "pid": "89",
            "status": "active",
            "regionType": "县",
            "id": "1027"
          },
          {
            "regionName": "抚远县",
            "pid": "89",
            "status": "active",
            "regionType": "县",
            "id": "1028"
          },
          {
            "regionName": "同江市",
            "pid": "89",
            "status": "active",
            "regionType": "县",
            "id": "1029"
          },
          {
            "regionName": "富锦市",
            "pid": "89",
            "status": "active",
            "regionType": "县",
            "id": "1030"
          }
        ],
        "id": "89"
      },
      {
        "regionName": "鹤岗市",
        "pid": "8",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "向阳区",
            "pid": "90",
            "status": "active",
            "regionType": "县",
            "id": "1031"
          },
          {
            "regionName": "工农区",
            "pid": "90",
            "status": "active",
            "regionType": "县",
            "id": "1032"
          },
          {
            "regionName": "南山区",
            "pid": "90",
            "status": "active",
            "regionType": "县",
            "id": "1033"
          },
          {
            "regionName": "兴安区",
            "pid": "90",
            "status": "active",
            "regionType": "县",
            "id": "1034"
          },
          {
            "regionName": "东山区",
            "pid": "90",
            "status": "active",
            "regionType": "县",
            "id": "1035"
          },
          {
            "regionName": "兴山区",
            "pid": "90",
            "status": "active",
            "regionType": "县",
            "id": "1036"
          },
          {
            "regionName": "萝北县",
            "pid": "90",
            "status": "active",
            "regionType": "县",
            "id": "1037"
          },
          {
            "regionName": "绥滨县",
            "pid": "90",
            "status": "active",
            "regionType": "县",
            "id": "1038"
          }
        ],
        "id": "90"
      },
      {
        "regionName": "双鸭山市",
        "pid": "8",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "尖山区",
            "pid": "91",
            "status": "active",
            "regionType": "县",
            "id": "1039"
          },
          {
            "regionName": "岭东区",
            "pid": "91",
            "status": "active",
            "regionType": "县",
            "id": "1040"
          },
          {
            "regionName": "四方台区",
            "pid": "91",
            "status": "active",
            "regionType": "县",
            "id": "1041"
          },
          {
            "regionName": "宝山区",
            "pid": "91",
            "status": "active",
            "regionType": "县",
            "id": "1042"
          },
          {
            "regionName": "集贤县",
            "pid": "91",
            "status": "active",
            "regionType": "县",
            "id": "1043"
          },
          {
            "regionName": "友谊县",
            "pid": "91",
            "status": "active",
            "regionType": "县",
            "id": "1044"
          },
          {
            "regionName": "宝清县",
            "pid": "91",
            "status": "active",
            "regionType": "县",
            "id": "1045"
          },
          {
            "regionName": "饶河县",
            "pid": "91",
            "status": "active",
            "regionType": "县",
            "id": "1046"
          }
        ],
        "id": "91"
      },
      {
        "regionName": "绥化市",
        "pid": "8",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "北林区",
            "pid": "92",
            "status": "active",
            "regionType": "县",
            "id": "1047"
          },
          {
            "regionName": "望奎县",
            "pid": "92",
            "status": "active",
            "regionType": "县",
            "id": "1048"
          },
          {
            "regionName": "兰西县",
            "pid": "92",
            "status": "active",
            "regionType": "县",
            "id": "1049"
          },
          {
            "regionName": "青冈县",
            "pid": "92",
            "status": "active",
            "regionType": "县",
            "id": "1050"
          },
          {
            "regionName": "庆安县",
            "pid": "92",
            "status": "active",
            "regionType": "县",
            "id": "1051"
          },
          {
            "regionName": "明水县",
            "pid": "92",
            "status": "active",
            "regionType": "县",
            "id": "1052"
          },
          {
            "regionName": "绥棱县",
            "pid": "92",
            "status": "active",
            "regionType": "县",
            "id": "1053"
          },
          {
            "regionName": "安达市",
            "pid": "92",
            "status": "active",
            "regionType": "县",
            "id": "1054"
          },
          {
            "regionName": "肇东市",
            "pid": "92",
            "status": "active",
            "regionType": "县",
            "id": "1055"
          },
          {
            "regionName": "海伦市",
            "pid": "92",
            "status": "active",
            "regionType": "县",
            "id": "1056"
          }
        ],
        "id": "92"
      },
      {
        "regionName": "黑河市",
        "pid": "8",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "爱辉区",
            "pid": "93",
            "status": "active",
            "regionType": "县",
            "id": "1057"
          },
          {
            "regionName": "嫩江县",
            "pid": "93",
            "status": "active",
            "regionType": "县",
            "id": "1058"
          },
          {
            "regionName": "逊克县",
            "pid": "93",
            "status": "active",
            "regionType": "县",
            "id": "1059"
          },
          {
            "regionName": "孙吴县",
            "pid": "93",
            "status": "active",
            "regionType": "县",
            "id": "1060"
          },
          {
            "regionName": "北安市",
            "pid": "93",
            "status": "active",
            "regionType": "县",
            "id": "1061"
          },
          {
            "regionName": "五大连池市",
            "pid": "93",
            "status": "active",
            "regionType": "县",
            "id": "1062"
          }
        ],
        "id": "93"
      },
      {
        "regionName": "大兴安岭地区",
        "pid": "8",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "呼玛县",
            "pid": "94",
            "status": "active",
            "regionType": "县",
            "id": "1063"
          },
          {
            "regionName": "塔河县",
            "pid": "94",
            "status": "active",
            "regionType": "县",
            "id": "1064"
          },
          {
            "regionName": "漠河县",
            "pid": "94",
            "status": "active",
            "regionType": "县",
            "id": "1065"
          }
        ],
        "id": "94"
      },
      {
        "regionName": "伊春市",
        "pid": "8",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "伊春区",
            "pid": "95",
            "status": "active",
            "regionType": "县",
            "id": "1066"
          },
          {
            "regionName": "南岔区",
            "pid": "95",
            "status": "active",
            "regionType": "县",
            "id": "1067"
          },
          {
            "regionName": "友好区",
            "pid": "95",
            "status": "active",
            "regionType": "县",
            "id": "1068"
          },
          {
            "regionName": "西林区",
            "pid": "95",
            "status": "active",
            "regionType": "县",
            "id": "1069"
          },
          {
            "regionName": "翠峦区",
            "pid": "95",
            "status": "active",
            "regionType": "县",
            "id": "1070"
          },
          {
            "regionName": "新青区",
            "pid": "95",
            "status": "active",
            "regionType": "县",
            "id": "1071"
          },
          {
            "regionName": "美溪区",
            "pid": "95",
            "status": "active",
            "regionType": "县",
            "id": "1072"
          },
          {
            "regionName": "金山屯区",
            "pid": "95",
            "status": "active",
            "regionType": "县",
            "id": "1073"
          },
          {
            "regionName": "五营区",
            "pid": "95",
            "status": "active",
            "regionType": "县",
            "id": "1074"
          },
          {
            "regionName": "乌马河区",
            "pid": "95",
            "status": "active",
            "regionType": "县",
            "id": "1075"
          },
          {
            "regionName": "汤旺河区",
            "pid": "95",
            "status": "active",
            "regionType": "县",
            "id": "1076"
          },
          {
            "regionName": "带岭区",
            "pid": "95",
            "status": "active",
            "regionType": "县",
            "id": "1077"
          },
          {
            "regionName": "乌伊岭区",
            "pid": "95",
            "status": "active",
            "regionType": "县",
            "id": "1078"
          },
          {
            "regionName": "红星区",
            "pid": "95",
            "status": "active",
            "regionType": "县",
            "id": "1079"
          },
          {
            "regionName": "上甘岭区",
            "pid": "95",
            "status": "active",
            "regionType": "县",
            "id": "1080"
          },
          {
            "regionName": "嘉荫县",
            "pid": "95",
            "status": "active",
            "regionType": "县",
            "id": "1081"
          },
          {
            "regionName": "铁力市",
            "pid": "95",
            "status": "active",
            "regionType": "县",
            "id": "1082"
          }
        ],
        "id": "95"
      },
      {
        "regionName": "大庆市",
        "pid": "8",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "萨尔图区",
            "pid": "96",
            "status": "active",
            "regionType": "县",
            "id": "1083"
          },
          {
            "regionName": "龙凤区",
            "pid": "96",
            "status": "active",
            "regionType": "县",
            "id": "1084"
          },
          {
            "regionName": "让胡路区",
            "pid": "96",
            "status": "active",
            "regionType": "县",
            "id": "1085"
          },
          {
            "regionName": "红岗区",
            "pid": "96",
            "status": "active",
            "regionType": "县",
            "id": "1086"
          },
          {
            "regionName": "大同区",
            "pid": "96",
            "status": "active",
            "regionType": "县",
            "id": "1087"
          },
          {
            "regionName": "肇州县",
            "pid": "96",
            "status": "active",
            "regionType": "县",
            "id": "1088"
          },
          {
            "regionName": "肇源县",
            "pid": "96",
            "status": "active",
            "regionType": "县",
            "id": "1089"
          },
          {
            "regionName": "林甸县",
            "pid": "96",
            "status": "active",
            "regionType": "县",
            "id": "1090"
          },
          {
            "regionName": "杜尔伯特蒙古族自治县",
            "pid": "96",
            "status": "active",
            "regionType": "县",
            "id": "1091"
          }
        ],
        "id": "96"
      }
    ],
    "regionName": "黑龙江省",
    "pid": "0",
    "status": "active",
    "regionType": "省",
    "id": "8"
  },
  {
    "city": [
      {
        "regionName": "上海市",
        "pid": "9",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "黄浦区",
            "pid": "37",
            "status": "active",
            "regionType": "县",
            "id": "461"
          },
          {
            "regionName": "卢湾区",
            "pid": "37",
            "status": "active",
            "regionType": "县",
            "id": "462"
          },
          {
            "regionName": "徐汇区",
            "pid": "37",
            "status": "active",
            "regionType": "县",
            "id": "463"
          },
          {
            "regionName": "长宁区",
            "pid": "37",
            "status": "active",
            "regionType": "县",
            "id": "464"
          },
          {
            "regionName": "静安区",
            "pid": "37",
            "status": "active",
            "regionType": "县",
            "id": "465"
          },
          {
            "regionName": "普陀区",
            "pid": "37",
            "status": "active",
            "regionType": "县",
            "id": "466"
          },
          {
            "regionName": "闸北区",
            "pid": "37",
            "status": "active",
            "regionType": "县",
            "id": "467"
          },
          {
            "regionName": "虹口区",
            "pid": "37",
            "status": "active",
            "regionType": "县",
            "id": "468"
          },
          {
            "regionName": "杨浦区",
            "pid": "37",
            "status": "active",
            "regionType": "县",
            "id": "469"
          },
          {
            "regionName": "闵行区",
            "pid": "37",
            "status": "active",
            "regionType": "县",
            "id": "470"
          },
          {
            "regionName": "宝山区",
            "pid": "37",
            "status": "active",
            "regionType": "县",
            "id": "471"
          },
          {
            "regionName": "嘉定区",
            "pid": "37",
            "status": "active",
            "regionType": "县",
            "id": "472"
          },
          {
            "regionName": "浦东新区",
            "pid": "37",
            "status": "active",
            "regionType": "县",
            "id": "473"
          },
          {
            "regionName": "金山区",
            "pid": "37",
            "status": "active",
            "regionType": "县",
            "id": "474"
          },
          {
            "regionName": "松江区",
            "pid": "37",
            "status": "active",
            "regionType": "县",
            "id": "475"
          },
          {
            "regionName": "青浦区",
            "pid": "37",
            "status": "active",
            "regionType": "县",
            "id": "476"
          },
          {
            "regionName": "南汇区",
            "pid": "37",
            "status": "active",
            "regionType": "县",
            "id": "477"
          },
          {
            "regionName": "奉贤区",
            "pid": "37",
            "status": "active",
            "regionType": "县",
            "id": "478"
          },
          {
            "regionName": "崇明县",
            "pid": "37",
            "status": "active",
            "regionType": "县",
            "id": "479"
          }
        ],
        "id": "37"
      }
    ],
    "regionName": "上海",
    "pid": "0",
    "status": "active",
    "regionType": "省",
    "id": "9"
  },
  {
    "city": [
      {
        "regionName": "南京市",
        "pid": "10",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "江宁区",
            "pid": "97",
            "status": "active",
            "regionType": "县",
            "id": "1092"
          },
          {
            "regionName": "浦口区",
            "pid": "97",
            "status": "active",
            "regionType": "县",
            "id": "1093"
          },
          {
            "regionName": "玄武区",
            "pid": "97",
            "status": "active",
            "regionType": "县",
            "id": "1094"
          },
          {
            "regionName": "白下区",
            "pid": "97",
            "status": "active",
            "regionType": "县",
            "id": "1095"
          },
          {
            "regionName": "秦淮区",
            "pid": "97",
            "status": "active",
            "regionType": "县",
            "id": "1096"
          },
          {
            "regionName": "建邺区",
            "pid": "97",
            "status": "active",
            "regionType": "县",
            "id": "1097"
          },
          {
            "regionName": "鼓楼区",
            "pid": "97",
            "status": "active",
            "regionType": "县",
            "id": "1098"
          },
          {
            "regionName": "下关区",
            "pid": "97",
            "status": "active",
            "regionType": "县",
            "id": "1099"
          },
          {
            "regionName": "栖霞区",
            "pid": "97",
            "status": "active",
            "regionType": "县",
            "id": "1100"
          },
          {
            "regionName": "雨花台区",
            "pid": "97",
            "status": "active",
            "regionType": "县",
            "id": "1101"
          },
          {
            "regionName": "六合区",
            "pid": "97",
            "status": "active",
            "regionType": "县",
            "id": "1102"
          },
          {
            "regionName": "溧水县",
            "pid": "97",
            "status": "active",
            "regionType": "县",
            "id": "1103"
          },
          {
            "regionName": "高淳县",
            "pid": "97",
            "status": "active",
            "regionType": "县",
            "id": "1104"
          }
        ],
        "id": "97"
      },
      {
        "regionName": "无锡市",
        "pid": "10",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "崇安区",
            "pid": "98",
            "status": "active",
            "regionType": "县",
            "id": "1105"
          },
          {
            "regionName": "南长区",
            "pid": "98",
            "status": "active",
            "regionType": "县",
            "id": "1106"
          },
          {
            "regionName": "北塘区",
            "pid": "98",
            "status": "active",
            "regionType": "县",
            "id": "1107"
          },
          {
            "regionName": "锡山区",
            "pid": "98",
            "status": "active",
            "regionType": "县",
            "id": "1108"
          },
          {
            "regionName": "惠山区",
            "pid": "98",
            "status": "active",
            "regionType": "县",
            "id": "1109"
          },
          {
            "regionName": "滨湖区",
            "pid": "98",
            "status": "active",
            "regionType": "县",
            "id": "1110"
          },
          {
            "regionName": "江阴市",
            "pid": "98",
            "status": "active",
            "regionType": "县",
            "id": "1111"
          },
          {
            "regionName": "宜兴市",
            "pid": "98",
            "status": "active",
            "regionType": "县",
            "id": "1112"
          }
        ],
        "id": "98"
      },
      {
        "regionName": "镇江市",
        "pid": "10",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "京口区",
            "pid": "99",
            "status": "active",
            "regionType": "县",
            "id": "1113"
          },
          {
            "regionName": "润州区",
            "pid": "99",
            "status": "active",
            "regionType": "县",
            "id": "1114"
          },
          {
            "regionName": "丹徒区",
            "pid": "99",
            "status": "active",
            "regionType": "县",
            "id": "1115"
          },
          {
            "regionName": "丹阳市",
            "pid": "99",
            "status": "active",
            "regionType": "县",
            "id": "1116"
          },
          {
            "regionName": "扬中市",
            "pid": "99",
            "status": "active",
            "regionType": "县",
            "id": "1117"
          },
          {
            "regionName": "句容市",
            "pid": "99",
            "status": "active",
            "regionType": "县",
            "id": "1118"
          }
        ],
        "id": "99"
      },
      {
        "regionName": "苏州市",
        "pid": "10",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "沧浪区",
            "pid": "100",
            "status": "active",
            "regionType": "县",
            "id": "1119"
          },
          {
            "regionName": "常熟市",
            "pid": "100",
            "status": "active",
            "regionType": "县",
            "id": "1120"
          },
          {
            "regionName": "平江区",
            "pid": "100",
            "status": "active",
            "regionType": "县",
            "id": "1121"
          },
          {
            "regionName": "金阊区",
            "pid": "100",
            "status": "active",
            "regionType": "县",
            "id": "1122"
          },
          {
            "regionName": "虎丘区",
            "pid": "100",
            "status": "active",
            "regionType": "县",
            "id": "1123"
          },
          {
            "regionName": "昆山市",
            "pid": "100",
            "status": "active",
            "regionType": "县",
            "id": "1124"
          },
          {
            "regionName": "太仓市",
            "pid": "100",
            "status": "active",
            "regionType": "县",
            "id": "1125"
          },
          {
            "regionName": "吴江市",
            "pid": "100",
            "status": "active",
            "regionType": "县",
            "id": "1126"
          },
          {
            "regionName": "吴中区",
            "pid": "100",
            "status": "active",
            "regionType": "县",
            "id": "1127"
          },
          {
            "regionName": "相城区",
            "pid": "100",
            "status": "active",
            "regionType": "县",
            "id": "1128"
          },
          {
            "regionName": "张家港市",
            "pid": "100",
            "status": "active",
            "regionType": "县",
            "id": "1129"
          },
          {
            "regionName": "园区",
            "pid": "100",
            "status": "active",
            "regionType": "县",
            "id": "3737"
          },
          {
            "regionName": "新区",
            "pid": "100",
            "status": "active",
            "regionType": "县",
            "id": "3738"
          },
          {
            "regionName": "玉山镇",
            "pid": "100",
            "status": "active",
            "regionType": "县",
            "id": "3739"
          },
          {
            "regionName": "巴城镇",
            "pid": "100",
            "status": "active",
            "regionType": "县",
            "id": "3740"
          },
          {
            "regionName": "周市镇",
            "pid": "100",
            "status": "active",
            "regionType": "县",
            "id": "3741"
          },
          {
            "regionName": "陆家镇",
            "pid": "100",
            "status": "active",
            "regionType": "县",
            "id": "3742"
          },
          {
            "regionName": "花桥镇",
            "pid": "100",
            "status": "active",
            "regionType": "县",
            "id": "3743"
          },
          {
            "regionName": "淀山湖镇",
            "pid": "100",
            "status": "active",
            "regionType": "县",
            "id": "3744"
          },
          {
            "regionName": "张浦镇",
            "pid": "100",
            "status": "active",
            "regionType": "县",
            "id": "3745"
          },
          {
            "regionName": "周庄镇",
            "pid": "100",
            "status": "active",
            "regionType": "县",
            "id": "3746"
          },
          {
            "regionName": "千灯镇",
            "pid": "100",
            "status": "active",
            "regionType": "县",
            "id": "3747"
          },
          {
            "regionName": "锦溪镇",
            "pid": "100",
            "status": "active",
            "regionType": "县",
            "id": "3748"
          }
        ],
        "id": "100"
      },
      {
        "regionName": "南通市",
        "pid": "10",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "崇川区",
            "pid": "101",
            "status": "active",
            "regionType": "县",
            "id": "1130"
          },
          {
            "regionName": "港闸区",
            "pid": "101",
            "status": "active",
            "regionType": "县",
            "id": "1131"
          },
          {
            "regionName": "海安县",
            "pid": "101",
            "status": "active",
            "regionType": "县",
            "id": "1132"
          },
          {
            "regionName": "如东县",
            "pid": "101",
            "status": "active",
            "regionType": "县",
            "id": "1133"
          },
          {
            "regionName": "启东市",
            "pid": "101",
            "status": "active",
            "regionType": "县",
            "id": "1134"
          },
          {
            "regionName": "如皋市",
            "pid": "101",
            "status": "active",
            "regionType": "县",
            "id": "1135"
          },
          {
            "regionName": "通州市",
            "pid": "101",
            "status": "active",
            "regionType": "县",
            "id": "1136"
          },
          {
            "regionName": "海门市",
            "pid": "101",
            "status": "active",
            "regionType": "县",
            "id": "1137"
          }
        ],
        "id": "101"
      },
      {
        "regionName": "扬州市",
        "pid": "10",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "高邮市",
            "pid": "102",
            "status": "active",
            "regionType": "县",
            "id": "1138"
          },
          {
            "regionName": "广陵区",
            "pid": "102",
            "status": "active",
            "regionType": "县",
            "id": "1139"
          },
          {
            "regionName": "邗江区",
            "pid": "102",
            "status": "active",
            "regionType": "县",
            "id": "1140"
          },
          {
            "regionName": "维扬区",
            "pid": "102",
            "status": "active",
            "regionType": "县",
            "id": "1141"
          },
          {
            "regionName": "宝应县",
            "pid": "102",
            "status": "active",
            "regionType": "县",
            "id": "1142"
          },
          {
            "regionName": "江都市",
            "pid": "102",
            "status": "active",
            "regionType": "县",
            "id": "1143"
          },
          {
            "regionName": "仪征市",
            "pid": "102",
            "status": "active",
            "regionType": "县",
            "id": "1144"
          }
        ],
        "id": "102"
      },
      {
        "regionName": "盐城市",
        "pid": "10",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "亭湖区",
            "pid": "103",
            "status": "active",
            "regionType": "县",
            "id": "1145"
          },
          {
            "regionName": "盐都区",
            "pid": "103",
            "status": "active",
            "regionType": "县",
            "id": "1146"
          },
          {
            "regionName": "响水县",
            "pid": "103",
            "status": "active",
            "regionType": "县",
            "id": "1147"
          },
          {
            "regionName": "滨海县",
            "pid": "103",
            "status": "active",
            "regionType": "县",
            "id": "1148"
          },
          {
            "regionName": "阜宁县",
            "pid": "103",
            "status": "active",
            "regionType": "县",
            "id": "1149"
          },
          {
            "regionName": "射阳县",
            "pid": "103",
            "status": "active",
            "regionType": "县",
            "id": "1150"
          },
          {
            "regionName": "建湖县",
            "pid": "103",
            "status": "active",
            "regionType": "县",
            "id": "1151"
          },
          {
            "regionName": "东台市",
            "pid": "103",
            "status": "active",
            "regionType": "县",
            "id": "1152"
          },
          {
            "regionName": "大丰市",
            "pid": "103",
            "status": "active",
            "regionType": "县",
            "id": "1153"
          },
          {
            "regionName": "盐都县",
            "pid": "103",
            "status": "active",
            "regionType": "县",
            "id": "3750"
          }
        ],
        "id": "103"
      },
      {
        "regionName": "徐州市",
        "pid": "10",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "鼓楼区",
            "pid": "104",
            "status": "active",
            "regionType": "县",
            "id": "1154"
          },
          {
            "regionName": "云龙区",
            "pid": "104",
            "status": "active",
            "regionType": "县",
            "id": "1155"
          },
          {
            "regionName": "九里区",
            "pid": "104",
            "status": "active",
            "regionType": "县",
            "id": "1156"
          },
          {
            "regionName": "贾汪区",
            "pid": "104",
            "status": "active",
            "regionType": "县",
            "id": "1157"
          },
          {
            "regionName": "泉山区",
            "pid": "104",
            "status": "active",
            "regionType": "县",
            "id": "1158"
          },
          {
            "regionName": "丰县",
            "pid": "104",
            "status": "active",
            "regionType": "县",
            "id": "1159"
          },
          {
            "regionName": "沛县",
            "pid": "104",
            "status": "active",
            "regionType": "县",
            "id": "1160"
          },
          {
            "regionName": "铜山县",
            "pid": "104",
            "status": "active",
            "regionType": "县",
            "id": "1161"
          },
          {
            "regionName": "睢宁县",
            "pid": "104",
            "status": "active",
            "regionType": "县",
            "id": "1162"
          },
          {
            "regionName": "新沂市",
            "pid": "104",
            "status": "active",
            "regionType": "县",
            "id": "1163"
          },
          {
            "regionName": "邳州市",
            "pid": "104",
            "status": "active",
            "regionType": "县",
            "id": "1164"
          }
        ],
        "id": "104"
      },
      {
        "regionName": "淮安市",
        "pid": "10",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "清河区",
            "pid": "105",
            "status": "active",
            "regionType": "县",
            "id": "1165"
          },
          {
            "regionName": "楚州区",
            "pid": "105",
            "status": "active",
            "regionType": "县",
            "id": "1166"
          },
          {
            "regionName": "淮阴区",
            "pid": "105",
            "status": "active",
            "regionType": "县",
            "id": "1167"
          },
          {
            "regionName": "清浦区",
            "pid": "105",
            "status": "active",
            "regionType": "县",
            "id": "1168"
          },
          {
            "regionName": "涟水县",
            "pid": "105",
            "status": "active",
            "regionType": "县",
            "id": "1169"
          },
          {
            "regionName": "洪泽县",
            "pid": "105",
            "status": "active",
            "regionType": "县",
            "id": "1170"
          },
          {
            "regionName": "盱眙县",
            "pid": "105",
            "status": "active",
            "regionType": "县",
            "id": "1171"
          },
          {
            "regionName": "金湖县",
            "pid": "105",
            "status": "active",
            "regionType": "县",
            "id": "1172"
          }
        ],
        "id": "105"
      },
      {
        "regionName": "连云港市",
        "pid": "10",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "连云区",
            "pid": "106",
            "status": "active",
            "regionType": "县",
            "id": "1173"
          },
          {
            "regionName": "新浦区",
            "pid": "106",
            "status": "active",
            "regionType": "县",
            "id": "1174"
          },
          {
            "regionName": "海州区",
            "pid": "106",
            "status": "active",
            "regionType": "县",
            "id": "1175"
          },
          {
            "regionName": "赣榆县",
            "pid": "106",
            "status": "active",
            "regionType": "县",
            "id": "1176"
          },
          {
            "regionName": "东海县",
            "pid": "106",
            "status": "active",
            "regionType": "县",
            "id": "1177"
          },
          {
            "regionName": "灌云县",
            "pid": "106",
            "status": "active",
            "regionType": "县",
            "id": "1178"
          },
          {
            "regionName": "灌南县",
            "pid": "106",
            "status": "active",
            "regionType": "县",
            "id": "1179"
          }
        ],
        "id": "106"
      },
      {
        "regionName": "常州市",
        "pid": "10",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "天宁区",
            "pid": "107",
            "status": "active",
            "regionType": "县",
            "id": "1180"
          },
          {
            "regionName": "钟楼区",
            "pid": "107",
            "status": "active",
            "regionType": "县",
            "id": "1181"
          },
          {
            "regionName": "戚墅堰区",
            "pid": "107",
            "status": "active",
            "regionType": "县",
            "id": "1182"
          },
          {
            "regionName": "新北区",
            "pid": "107",
            "status": "active",
            "regionType": "县",
            "id": "1183"
          },
          {
            "regionName": "武进区",
            "pid": "107",
            "status": "active",
            "regionType": "县",
            "id": "1184"
          },
          {
            "regionName": "溧阳市",
            "pid": "107",
            "status": "active",
            "regionType": "县",
            "id": "1185"
          },
          {
            "regionName": "金坛市",
            "pid": "107",
            "status": "active",
            "regionType": "县",
            "id": "1186"
          }
        ],
        "id": "107"
      },
      {
        "regionName": "泰州市",
        "pid": "10",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "海陵区",
            "pid": "108",
            "status": "active",
            "regionType": "县",
            "id": "1187"
          },
          {
            "regionName": "高港区",
            "pid": "108",
            "status": "active",
            "regionType": "县",
            "id": "1188"
          },
          {
            "regionName": "兴化市",
            "pid": "108",
            "status": "active",
            "regionType": "县",
            "id": "1189"
          },
          {
            "regionName": "靖江市",
            "pid": "108",
            "status": "active",
            "regionType": "县",
            "id": "1190"
          },
          {
            "regionName": "泰兴市",
            "pid": "108",
            "status": "active",
            "regionType": "县",
            "id": "1191"
          },
          {
            "regionName": "姜堰市",
            "pid": "108",
            "status": "active",
            "regionType": "县",
            "id": "1192"
          }
        ],
        "id": "108"
      },
      {
        "regionName": "宿迁市",
        "pid": "10",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "宿城区",
            "pid": "109",
            "status": "active",
            "regionType": "县",
            "id": "1193"
          },
          {
            "regionName": "宿豫区",
            "pid": "109",
            "status": "active",
            "regionType": "县",
            "id": "1194"
          },
          {
            "regionName": "沭阳县",
            "pid": "109",
            "status": "active",
            "regionType": "县",
            "id": "1195"
          },
          {
            "regionName": "泗阳县",
            "pid": "109",
            "status": "active",
            "regionType": "县",
            "id": "1196"
          },
          {
            "regionName": "泗洪县",
            "pid": "109",
            "status": "active",
            "regionType": "县",
            "id": "1197"
          },
          {
            "regionName": "宿豫县",
            "pid": "109",
            "status": "active",
            "regionType": "县",
            "id": "3749"
          }
        ],
        "id": "109"
      }
    ],
    "regionName": "江苏省",
    "pid": "0",
    "status": "active",
    "regionType": "省",
    "id": "10"
  },
  {
    "city": [
      {
        "regionName": "舟山市",
        "pid": "11",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "定海区",
            "pid": "110",
            "status": "active",
            "regionType": "县",
            "id": "1198"
          },
          {
            "regionName": "普陀区",
            "pid": "110",
            "status": "active",
            "regionType": "县",
            "id": "1199"
          },
          {
            "regionName": "岱山县",
            "pid": "110",
            "status": "active",
            "regionType": "县",
            "id": "1200"
          },
          {
            "regionName": "嵊泗县",
            "pid": "110",
            "status": "active",
            "regionType": "县",
            "id": "1201"
          }
        ],
        "id": "110"
      },
      {
        "regionName": "衢州市",
        "pid": "11",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "柯城区",
            "pid": "111",
            "status": "active",
            "regionType": "县",
            "id": "1202"
          },
          {
            "regionName": "衢江区",
            "pid": "111",
            "status": "active",
            "regionType": "县",
            "id": "1203"
          },
          {
            "regionName": "常山县",
            "pid": "111",
            "status": "active",
            "regionType": "县",
            "id": "1204"
          },
          {
            "regionName": "开化县",
            "pid": "111",
            "status": "active",
            "regionType": "县",
            "id": "1205"
          },
          {
            "regionName": "龙游县",
            "pid": "111",
            "status": "active",
            "regionType": "县",
            "id": "1206"
          },
          {
            "regionName": "江山市",
            "pid": "111",
            "status": "active",
            "regionType": "县",
            "id": "1207"
          },
          {
            "regionName": "衢州市",
            "pid": "111",
            "status": "active",
            "regionType": "县",
            "id": "3789"
          }
        ],
        "id": "111"
      },
      {
        "regionName": "杭州市",
        "pid": "11",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "上城区",
            "pid": "112",
            "status": "active",
            "regionType": "县",
            "id": "1208"
          },
          {
            "regionName": "下城区",
            "pid": "112",
            "status": "active",
            "regionType": "县",
            "id": "1209"
          },
          {
            "regionName": "江干区",
            "pid": "112",
            "status": "active",
            "regionType": "县",
            "id": "1210"
          },
          {
            "regionName": "拱墅区",
            "pid": "112",
            "status": "active",
            "regionType": "县",
            "id": "1211"
          },
          {
            "regionName": "西湖区",
            "pid": "112",
            "status": "active",
            "regionType": "县",
            "id": "1212"
          },
          {
            "regionName": "滨江区",
            "pid": "112",
            "status": "active",
            "regionType": "县",
            "id": "1213"
          },
          {
            "regionName": "余杭区",
            "pid": "112",
            "status": "active",
            "regionType": "县",
            "id": "1214"
          },
          {
            "regionName": "桐庐县",
            "pid": "112",
            "status": "active",
            "regionType": "县",
            "id": "1215"
          },
          {
            "regionName": "淳安县",
            "pid": "112",
            "status": "active",
            "regionType": "县",
            "id": "1216"
          },
          {
            "regionName": "建德市",
            "pid": "112",
            "status": "active",
            "regionType": "县",
            "id": "1217"
          },
          {
            "regionName": "富阳市",
            "pid": "112",
            "status": "active",
            "regionType": "县",
            "id": "1218"
          },
          {
            "regionName": "临安市",
            "pid": "112",
            "status": "active",
            "regionType": "县",
            "id": "1219"
          },
          {
            "regionName": "萧山区",
            "pid": "112",
            "status": "active",
            "regionType": "县",
            "id": "1220"
          }
        ],
        "id": "112"
      },
      {
        "regionName": "湖州市",
        "pid": "11",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "吴兴区",
            "pid": "113",
            "status": "active",
            "regionType": "县",
            "id": "1221"
          },
          {
            "regionName": "南浔区",
            "pid": "113",
            "status": "active",
            "regionType": "县",
            "id": "1222"
          },
          {
            "regionName": "德清县",
            "pid": "113",
            "status": "active",
            "regionType": "县",
            "id": "1223"
          },
          {
            "regionName": "长兴县",
            "pid": "113",
            "status": "active",
            "regionType": "县",
            "id": "1224"
          },
          {
            "regionName": "安吉县",
            "pid": "113",
            "status": "active",
            "regionType": "县",
            "id": "1225"
          }
        ],
        "id": "113"
      },
      {
        "regionName": "嘉兴市",
        "pid": "11",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": " 南湖区",
            "pid": "114",
            "status": "active",
            "regionType": "县",
            "id": "1226"
          },
          {
            "regionName": " 秀洲区",
            "pid": "114",
            "status": "active",
            "regionType": "县",
            "id": "1227"
          },
          {
            "regionName": " 嘉善县",
            "pid": "114",
            "status": "active",
            "regionType": "县",
            "id": "1228"
          },
          {
            "regionName": " 海盐县",
            "pid": "114",
            "status": "active",
            "regionType": "县",
            "id": "1229"
          },
          {
            "regionName": " 海宁市",
            "pid": "114",
            "status": "active",
            "regionType": "县",
            "id": "1230"
          },
          {
            "regionName": " 平湖市",
            "pid": "114",
            "status": "active",
            "regionType": "县",
            "id": "1231"
          },
          {
            "regionName": " 桐乡市 ",
            "pid": "114",
            "status": "active",
            "regionType": "县",
            "id": "1232"
          },
          {
            "regionName": "南湖区",
            "pid": "114",
            "status": "active",
            "regionType": "县",
            "id": "3776"
          },
          {
            "regionName": "秀洲区",
            "pid": "114",
            "status": "active",
            "regionType": "县",
            "id": "3777"
          },
          {
            "regionName": "海宁市",
            "pid": "114",
            "status": "active",
            "regionType": "县",
            "id": "3778"
          },
          {
            "regionName": "嘉善县",
            "pid": "114",
            "status": "active",
            "regionType": "县",
            "id": "3779"
          },
          {
            "regionName": "平湖市",
            "pid": "114",
            "status": "active",
            "regionType": "县",
            "id": "3780"
          },
          {
            "regionName": "桐乡市",
            "pid": "114",
            "status": "active",
            "regionType": "县",
            "id": "3781"
          },
          {
            "regionName": "海盐县",
            "pid": "114",
            "status": "active",
            "regionType": "县",
            "id": "3782"
          }
        ],
        "id": "114"
      },
      {
        "regionName": "宁波市",
        "pid": "11",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "海曙区",
            "pid": "115",
            "status": "active",
            "regionType": "县",
            "id": "1233"
          },
          {
            "regionName": "江东区",
            "pid": "115",
            "status": "active",
            "regionType": "县",
            "id": "1234"
          },
          {
            "regionName": "江北区",
            "pid": "115",
            "status": "active",
            "regionType": "县",
            "id": "1235"
          },
          {
            "regionName": "北仑区",
            "pid": "115",
            "status": "active",
            "regionType": "县",
            "id": "1236"
          },
          {
            "regionName": "镇海区",
            "pid": "115",
            "status": "active",
            "regionType": "县",
            "id": "1237"
          },
          {
            "regionName": "鄞州区",
            "pid": "115",
            "status": "active",
            "regionType": "县",
            "id": "1238"
          },
          {
            "regionName": "象山县",
            "pid": "115",
            "status": "active",
            "regionType": "县",
            "id": "1239"
          },
          {
            "regionName": "宁海县",
            "pid": "115",
            "status": "active",
            "regionType": "县",
            "id": "1240"
          },
          {
            "regionName": "余姚市",
            "pid": "115",
            "status": "active",
            "regionType": "县",
            "id": "1241"
          },
          {
            "regionName": "慈溪市",
            "pid": "115",
            "status": "active",
            "regionType": "县",
            "id": "1242"
          },
          {
            "regionName": "奉化市",
            "pid": "115",
            "status": "active",
            "regionType": "县",
            "id": "1243"
          }
        ],
        "id": "115"
      },
      {
        "regionName": "绍兴市",
        "pid": "11",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "越城区",
            "pid": "116",
            "status": "active",
            "regionType": "县",
            "id": "1244"
          },
          {
            "regionName": "绍兴县",
            "pid": "116",
            "status": "active",
            "regionType": "县",
            "id": "1245"
          },
          {
            "regionName": "新昌县",
            "pid": "116",
            "status": "active",
            "regionType": "县",
            "id": "1246"
          },
          {
            "regionName": "诸暨市",
            "pid": "116",
            "status": "active",
            "regionType": "县",
            "id": "1247"
          },
          {
            "regionName": "上虞市",
            "pid": "116",
            "status": "active",
            "regionType": "县",
            "id": "1248"
          },
          {
            "regionName": "嵊州市",
            "pid": "116",
            "status": "active",
            "regionType": "县",
            "id": "1249"
          }
        ],
        "id": "116"
      },
      {
        "regionName": "温州市",
        "pid": "11",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "鹿城区",
            "pid": "117",
            "status": "active",
            "regionType": "县",
            "id": "1250"
          },
          {
            "regionName": "龙湾区",
            "pid": "117",
            "status": "active",
            "regionType": "县",
            "id": "1251"
          },
          {
            "regionName": "瓯海区",
            "pid": "117",
            "status": "active",
            "regionType": "县",
            "id": "1252"
          },
          {
            "regionName": "洞头县",
            "pid": "117",
            "status": "active",
            "regionType": "县",
            "id": "1253"
          },
          {
            "regionName": "永嘉县",
            "pid": "117",
            "status": "active",
            "regionType": "县",
            "id": "1254"
          },
          {
            "regionName": "平阳县",
            "pid": "117",
            "status": "active",
            "regionType": "县",
            "id": "1255"
          },
          {
            "regionName": "苍南县",
            "pid": "117",
            "status": "active",
            "regionType": "县",
            "id": "1256"
          },
          {
            "regionName": "文成县",
            "pid": "117",
            "status": "active",
            "regionType": "县",
            "id": "1257"
          },
          {
            "regionName": "泰顺县",
            "pid": "117",
            "status": "active",
            "regionType": "县",
            "id": "1258"
          },
          {
            "regionName": "瑞安市",
            "pid": "117",
            "status": "active",
            "regionType": "县",
            "id": "1259"
          },
          {
            "regionName": "乐清市",
            "pid": "117",
            "status": "active",
            "regionType": "县",
            "id": "1260"
          }
        ],
        "id": "117"
      },
      {
        "regionName": "丽水市",
        "pid": "11",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "莲都区",
            "pid": "118",
            "status": "active",
            "regionType": "县",
            "id": "1261"
          },
          {
            "regionName": "青田县",
            "pid": "118",
            "status": "active",
            "regionType": "县",
            "id": "1262"
          },
          {
            "regionName": "缙云县",
            "pid": "118",
            "status": "active",
            "regionType": "县",
            "id": "1263"
          },
          {
            "regionName": "遂昌县",
            "pid": "118",
            "status": "active",
            "regionType": "县",
            "id": "1264"
          },
          {
            "regionName": "松阳县",
            "pid": "118",
            "status": "active",
            "regionType": "县",
            "id": "1265"
          },
          {
            "regionName": "云和县",
            "pid": "118",
            "status": "active",
            "regionType": "县",
            "id": "1266"
          },
          {
            "regionName": "庆元县",
            "pid": "118",
            "status": "active",
            "regionType": "县",
            "id": "1267"
          },
          {
            "regionName": "景宁畲族自治县",
            "pid": "118",
            "status": "active",
            "regionType": "县",
            "id": "1268"
          },
          {
            "regionName": "龙泉市",
            "pid": "118",
            "status": "active",
            "regionType": "县",
            "id": "1269"
          }
        ],
        "id": "118"
      },
      {
        "regionName": "金华市",
        "pid": "11",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "婺城区",
            "pid": "119",
            "status": "active",
            "regionType": "县",
            "id": "1270"
          },
          {
            "regionName": "金东区",
            "pid": "119",
            "status": "active",
            "regionType": "县",
            "id": "1271"
          },
          {
            "regionName": "武义县",
            "pid": "119",
            "status": "active",
            "regionType": "县",
            "id": "1272"
          },
          {
            "regionName": "浦江县",
            "pid": "119",
            "status": "active",
            "regionType": "县",
            "id": "1273"
          },
          {
            "regionName": "磐安县",
            "pid": "119",
            "status": "active",
            "regionType": "县",
            "id": "1274"
          },
          {
            "regionName": "兰溪市",
            "pid": "119",
            "status": "active",
            "regionType": "县",
            "id": "1275"
          },
          {
            "regionName": "义乌市",
            "pid": "119",
            "status": "active",
            "regionType": "县",
            "id": "1276"
          },
          {
            "regionName": "东阳市",
            "pid": "119",
            "status": "active",
            "regionType": "县",
            "id": "1277"
          },
          {
            "regionName": "永康市",
            "pid": "119",
            "status": "active",
            "regionType": "县",
            "id": "1278"
          },
          {
            "regionName": "佛堂镇",
            "pid": "119",
            "status": "active",
            "regionType": "县",
            "id": "3783"
          },
          {
            "regionName": "上溪镇",
            "pid": "119",
            "status": "active",
            "regionType": "县",
            "id": "3784"
          },
          {
            "regionName": "义亭镇",
            "pid": "119",
            "status": "active",
            "regionType": "县",
            "id": "3785"
          },
          {
            "regionName": "大陈镇",
            "pid": "119",
            "status": "active",
            "regionType": "县",
            "id": "3786"
          },
          {
            "regionName": "苏溪镇",
            "pid": "119",
            "status": "active",
            "regionType": "县",
            "id": "3787"
          },
          {
            "regionName": "赤岸镇",
            "pid": "119",
            "status": "active",
            "regionType": "县",
            "id": "3788"
          }
        ],
        "id": "119"
      },
      {
        "regionName": "台州市",
        "pid": "11",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "椒江区",
            "pid": "120",
            "status": "active",
            "regionType": "县",
            "id": "1279"
          },
          {
            "regionName": "黄岩区",
            "pid": "120",
            "status": "active",
            "regionType": "县",
            "id": "1280"
          },
          {
            "regionName": "路桥区",
            "pid": "120",
            "status": "active",
            "regionType": "县",
            "id": "1281"
          },
          {
            "regionName": "玉环县",
            "pid": "120",
            "status": "active",
            "regionType": "县",
            "id": "1282"
          },
          {
            "regionName": "三门县",
            "pid": "120",
            "status": "active",
            "regionType": "县",
            "id": "1283"
          },
          {
            "regionName": "天台县",
            "pid": "120",
            "status": "active",
            "regionType": "县",
            "id": "1284"
          },
          {
            "regionName": "仙居县",
            "pid": "120",
            "status": "active",
            "regionType": "县",
            "id": "1285"
          },
          {
            "regionName": "温岭市",
            "pid": "120",
            "status": "active",
            "regionType": "县",
            "id": "1286"
          },
          {
            "regionName": "临海市",
            "pid": "120",
            "status": "active",
            "regionType": "县",
            "id": "1287"
          }
        ],
        "id": "120"
      }
    ],
    "regionName": "浙江省",
    "pid": "0",
    "status": "active",
    "regionType": "省",
    "id": "11"
  },
  {
    "city": [
      {
        "regionName": "合肥市",
        "pid": "12",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "瑶海区",
            "pid": "121",
            "status": "active",
            "regionType": "县",
            "id": "1288"
          },
          {
            "regionName": "庐阳区",
            "pid": "121",
            "status": "active",
            "regionType": "县",
            "id": "1289"
          },
          {
            "regionName": "蜀山区",
            "pid": "121",
            "status": "active",
            "regionType": "县",
            "id": "1290"
          },
          {
            "regionName": "包河区",
            "pid": "121",
            "status": "active",
            "regionType": "县",
            "id": "1291"
          },
          {
            "regionName": "长丰县",
            "pid": "121",
            "status": "active",
            "regionType": "县",
            "id": "1292"
          },
          {
            "regionName": "肥东县",
            "pid": "121",
            "status": "active",
            "regionType": "县",
            "id": "1293"
          },
          {
            "regionName": "肥西县",
            "pid": "121",
            "status": "active",
            "regionType": "县",
            "id": "1294"
          }
        ],
        "id": "121"
      },
      {
        "regionName": "芜湖市",
        "pid": "12",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "镜湖区",
            "pid": "122",
            "status": "active",
            "regionType": "县",
            "id": "1295"
          },
          {
            "regionName": "弋江区",
            "pid": "122",
            "status": "active",
            "regionType": "县",
            "id": "1296"
          },
          {
            "regionName": "鸠江区",
            "pid": "122",
            "status": "active",
            "regionType": "县",
            "id": "1297"
          },
          {
            "regionName": "三山区",
            "pid": "122",
            "status": "active",
            "regionType": "县",
            "id": "1298"
          },
          {
            "regionName": "芜湖县",
            "pid": "122",
            "status": "active",
            "regionType": "县",
            "id": "1299"
          },
          {
            "regionName": "繁昌县",
            "pid": "122",
            "status": "active",
            "regionType": "县",
            "id": "1300"
          },
          {
            "regionName": "南陵县",
            "pid": "122",
            "status": "active",
            "regionType": "县",
            "id": "1301"
          }
        ],
        "id": "122"
      },
      {
        "regionName": "蚌埠市",
        "pid": "12",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "龙子湖区",
            "pid": "123",
            "status": "active",
            "regionType": "县",
            "id": "1302"
          },
          {
            "regionName": "蚌山区",
            "pid": "123",
            "status": "active",
            "regionType": "县",
            "id": "1303"
          },
          {
            "regionName": "禹会区",
            "pid": "123",
            "status": "active",
            "regionType": "县",
            "id": "1304"
          },
          {
            "regionName": "淮上区",
            "pid": "123",
            "status": "active",
            "regionType": "县",
            "id": "1305"
          },
          {
            "regionName": "怀远县",
            "pid": "123",
            "status": "active",
            "regionType": "县",
            "id": "1306"
          },
          {
            "regionName": "五河县",
            "pid": "123",
            "status": "active",
            "regionType": "县",
            "id": "1307"
          },
          {
            "regionName": "固镇县",
            "pid": "123",
            "status": "active",
            "regionType": "县",
            "id": "1308"
          },
          {
            "regionName": "中市区",
            "pid": "123",
            "status": "active",
            "regionType": "县",
            "id": "3639"
          },
          {
            "regionName": "东市区",
            "pid": "123",
            "status": "active",
            "regionType": "县",
            "id": "3640"
          },
          {
            "regionName": "郊区",
            "pid": "123",
            "status": "active",
            "regionType": "县",
            "id": "3641"
          }
        ],
        "id": "123"
      },
      {
        "regionName": "淮南市",
        "pid": "12",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "大通区",
            "pid": "124",
            "status": "active",
            "regionType": "县",
            "id": "1309"
          },
          {
            "regionName": "田家庵区",
            "pid": "124",
            "status": "active",
            "regionType": "县",
            "id": "1310"
          },
          {
            "regionName": "谢家集区",
            "pid": "124",
            "status": "active",
            "regionType": "县",
            "id": "1311"
          },
          {
            "regionName": "八公山区",
            "pid": "124",
            "status": "active",
            "regionType": "县",
            "id": "1312"
          },
          {
            "regionName": "潘集区",
            "pid": "124",
            "status": "active",
            "regionType": "县",
            "id": "1313"
          },
          {
            "regionName": "凤台县",
            "pid": "124",
            "status": "active",
            "regionType": "县",
            "id": "1314"
          }
        ],
        "id": "124"
      },
      {
        "regionName": "马鞍山市",
        "pid": "12",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "金家庄区",
            "pid": "125",
            "status": "active",
            "regionType": "县",
            "id": "1315"
          },
          {
            "regionName": "花山区",
            "pid": "125",
            "status": "active",
            "regionType": "县",
            "id": "1316"
          },
          {
            "regionName": "雨山区",
            "pid": "125",
            "status": "active",
            "regionType": "县",
            "id": "1317"
          },
          {
            "regionName": "当涂县",
            "pid": "125",
            "status": "active",
            "regionType": "县",
            "id": "1318"
          }
        ],
        "id": "125"
      },
      {
        "regionName": "淮北市",
        "pid": "12",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "杜集区",
            "pid": "126",
            "status": "active",
            "regionType": "县",
            "id": "1319"
          },
          {
            "regionName": "相山区",
            "pid": "126",
            "status": "active",
            "regionType": "县",
            "id": "1320"
          },
          {
            "regionName": "烈山区",
            "pid": "126",
            "status": "active",
            "regionType": "县",
            "id": "1321"
          },
          {
            "regionName": "濉溪县 ",
            "pid": "126",
            "status": "active",
            "regionType": "县",
            "id": "1322"
          }
        ],
        "id": "126"
      },
      {
        "regionName": "铜陵市",
        "pid": "12",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "铜官山区",
            "pid": "127",
            "status": "active",
            "regionType": "县",
            "id": "1323"
          },
          {
            "regionName": "狮子山区",
            "pid": "127",
            "status": "active",
            "regionType": "县",
            "id": "1324"
          },
          {
            "regionName": "铜陵县",
            "pid": "127",
            "status": "active",
            "regionType": "县",
            "id": "1325"
          }
        ],
        "id": "127"
      },
      {
        "regionName": "安庆市",
        "pid": "12",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "迎江区",
            "pid": "128",
            "status": "active",
            "regionType": "县",
            "id": "1326"
          },
          {
            "regionName": "大观区",
            "pid": "128",
            "status": "active",
            "regionType": "县",
            "id": "1327"
          },
          {
            "regionName": "宜秀区",
            "pid": "128",
            "status": "active",
            "regionType": "县",
            "id": "1328"
          },
          {
            "regionName": "怀宁县",
            "pid": "128",
            "status": "active",
            "regionType": "县",
            "id": "1329"
          },
          {
            "regionName": "枞阳县",
            "pid": "128",
            "status": "active",
            "regionType": "县",
            "id": "1330"
          },
          {
            "regionName": "潜山县",
            "pid": "128",
            "status": "active",
            "regionType": "县",
            "id": "1331"
          },
          {
            "regionName": "太湖县",
            "pid": "128",
            "status": "active",
            "regionType": "县",
            "id": "1332"
          },
          {
            "regionName": "宿松县",
            "pid": "128",
            "status": "active",
            "regionType": "县",
            "id": "1333"
          },
          {
            "regionName": "望江县",
            "pid": "128",
            "status": "active",
            "regionType": "县",
            "id": "1334"
          },
          {
            "regionName": "岳西县",
            "pid": "128",
            "status": "active",
            "regionType": "县",
            "id": "1335"
          },
          {
            "regionName": "桐城市",
            "pid": "128",
            "status": "active",
            "regionType": "县",
            "id": "1336"
          }
        ],
        "id": "128"
      },
      {
        "regionName": "黄山市",
        "pid": "12",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "屯溪区",
            "pid": "129",
            "status": "active",
            "regionType": "县",
            "id": "1337"
          },
          {
            "regionName": "黄山区",
            "pid": "129",
            "status": "active",
            "regionType": "县",
            "id": "1338"
          },
          {
            "regionName": "徽州区",
            "pid": "129",
            "status": "active",
            "regionType": "县",
            "id": "1339"
          },
          {
            "regionName": "歙县",
            "pid": "129",
            "status": "active",
            "regionType": "县",
            "id": "1340"
          },
          {
            "regionName": "休宁县",
            "pid": "129",
            "status": "active",
            "regionType": "县",
            "id": "1341"
          },
          {
            "regionName": "黟县",
            "pid": "129",
            "status": "active",
            "regionType": "县",
            "id": "1342"
          },
          {
            "regionName": "祁门县",
            "pid": "129",
            "status": "active",
            "regionType": "县",
            "id": "1343"
          }
        ],
        "id": "129"
      },
      {
        "regionName": "滁州市",
        "pid": "12",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "琅琊区",
            "pid": "130",
            "status": "active",
            "regionType": "县",
            "id": "1344"
          },
          {
            "regionName": "南谯区",
            "pid": "130",
            "status": "active",
            "regionType": "县",
            "id": "1345"
          },
          {
            "regionName": "来安县",
            "pid": "130",
            "status": "active",
            "regionType": "县",
            "id": "1346"
          },
          {
            "regionName": "全椒县",
            "pid": "130",
            "status": "active",
            "regionType": "县",
            "id": "1347"
          },
          {
            "regionName": "定远县",
            "pid": "130",
            "status": "active",
            "regionType": "县",
            "id": "1348"
          },
          {
            "regionName": "凤阳县",
            "pid": "130",
            "status": "active",
            "regionType": "县",
            "id": "1349"
          },
          {
            "regionName": "天长市",
            "pid": "130",
            "status": "active",
            "regionType": "县",
            "id": "1350"
          },
          {
            "regionName": "明光市",
            "pid": "130",
            "status": "active",
            "regionType": "县",
            "id": "1351"
          }
        ],
        "id": "130"
      },
      {
        "regionName": "阜阳市",
        "pid": "12",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "颍州区",
            "pid": "131",
            "status": "active",
            "regionType": "县",
            "id": "1352"
          },
          {
            "regionName": "颍东区",
            "pid": "131",
            "status": "active",
            "regionType": "县",
            "id": "1353"
          },
          {
            "regionName": "颍泉区",
            "pid": "131",
            "status": "active",
            "regionType": "县",
            "id": "1354"
          },
          {
            "regionName": "临泉县",
            "pid": "131",
            "status": "active",
            "regionType": "县",
            "id": "1355"
          },
          {
            "regionName": "太和县",
            "pid": "131",
            "status": "active",
            "regionType": "县",
            "id": "1356"
          },
          {
            "regionName": "阜南县",
            "pid": "131",
            "status": "active",
            "regionType": "县",
            "id": "1357"
          },
          {
            "regionName": "颍上县",
            "pid": "131",
            "status": "active",
            "regionType": "县",
            "id": "1358"
          },
          {
            "regionName": "界首市",
            "pid": "131",
            "status": "active",
            "regionType": "县",
            "id": "1359"
          },
          {
            "regionName": "颖上县",
            "pid": "131",
            "status": "active",
            "regionType": "县",
            "id": "3642"
          }
        ],
        "id": "131"
      },
      {
        "regionName": "宿州市",
        "pid": "12",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "埇桥区",
            "pid": "132",
            "status": "active",
            "regionType": "县",
            "id": "1360"
          },
          {
            "regionName": "砀山县",
            "pid": "132",
            "status": "active",
            "regionType": "县",
            "id": "1361"
          },
          {
            "regionName": "萧县",
            "pid": "132",
            "status": "active",
            "regionType": "县",
            "id": "1362"
          },
          {
            "regionName": "灵璧县",
            "pid": "132",
            "status": "active",
            "regionType": "县",
            "id": "1363"
          },
          {
            "regionName": "泗县 ",
            "pid": "132",
            "status": "active",
            "regionType": "县",
            "id": "1364"
          }
        ],
        "id": "132"
      },
      {
        "regionName": "巢湖市",
        "pid": "12",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "居巢区",
            "pid": "133",
            "status": "active",
            "regionType": "县",
            "id": "1365"
          },
          {
            "regionName": "庐江县",
            "pid": "133",
            "status": "active",
            "regionType": "县",
            "id": "1366"
          },
          {
            "regionName": "无为县",
            "pid": "133",
            "status": "active",
            "regionType": "县",
            "id": "1367"
          },
          {
            "regionName": "含山县",
            "pid": "133",
            "status": "active",
            "regionType": "县",
            "id": "1368"
          },
          {
            "regionName": "和县 ",
            "pid": "133",
            "status": "active",
            "regionType": "县",
            "id": "1369"
          }
        ],
        "id": "133"
      },
      {
        "regionName": "六安市",
        "pid": "12",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "金安区",
            "pid": "134",
            "status": "active",
            "regionType": "县",
            "id": "1370"
          },
          {
            "regionName": "裕安区",
            "pid": "134",
            "status": "active",
            "regionType": "县",
            "id": "1371"
          },
          {
            "regionName": "寿县",
            "pid": "134",
            "status": "active",
            "regionType": "县",
            "id": "1372"
          },
          {
            "regionName": "霍邱县",
            "pid": "134",
            "status": "active",
            "regionType": "县",
            "id": "1373"
          },
          {
            "regionName": "舒城县",
            "pid": "134",
            "status": "active",
            "regionType": "县",
            "id": "1374"
          },
          {
            "regionName": "金寨县",
            "pid": "134",
            "status": "active",
            "regionType": "县",
            "id": "1375"
          },
          {
            "regionName": "霍山县",
            "pid": "134",
            "status": "active",
            "regionType": "县",
            "id": "1376"
          }
        ],
        "id": "134"
      },
      {
        "regionName": "亳州市",
        "pid": "12",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "谯城区",
            "pid": "135",
            "status": "active",
            "regionType": "县",
            "id": "1377"
          },
          {
            "regionName": "涡阳县",
            "pid": "135",
            "status": "active",
            "regionType": "县",
            "id": "1378"
          },
          {
            "regionName": "蒙城县",
            "pid": "135",
            "status": "active",
            "regionType": "县",
            "id": "1379"
          },
          {
            "regionName": "利辛县",
            "pid": "135",
            "status": "active",
            "regionType": "县",
            "id": "1380"
          }
        ],
        "id": "135"
      },
      {
        "regionName": "池州市",
        "pid": "12",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "贵池区",
            "pid": "136",
            "status": "active",
            "regionType": "县",
            "id": "1381"
          },
          {
            "regionName": "东至县",
            "pid": "136",
            "status": "active",
            "regionType": "县",
            "id": "1382"
          },
          {
            "regionName": "石台县",
            "pid": "136",
            "status": "active",
            "regionType": "县",
            "id": "1383"
          },
          {
            "regionName": "青阳县",
            "pid": "136",
            "status": "active",
            "regionType": "县",
            "id": "1384"
          }
        ],
        "id": "136"
      },
      {
        "regionName": "宣城市",
        "pid": "12",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "宣州区",
            "pid": "137",
            "status": "active",
            "regionType": "县",
            "id": "1385"
          },
          {
            "regionName": "郎溪县",
            "pid": "137",
            "status": "active",
            "regionType": "县",
            "id": "1386"
          },
          {
            "regionName": "广德县",
            "pid": "137",
            "status": "active",
            "regionType": "县",
            "id": "1387"
          },
          {
            "regionName": "泾县",
            "pid": "137",
            "status": "active",
            "regionType": "县",
            "id": "1388"
          },
          {
            "regionName": "绩溪县",
            "pid": "137",
            "status": "active",
            "regionType": "县",
            "id": "1389"
          },
          {
            "regionName": "旌德县",
            "pid": "137",
            "status": "active",
            "regionType": "县",
            "id": "1390"
          },
          {
            "regionName": "宁国市",
            "pid": "137",
            "status": "active",
            "regionType": "县",
            "id": "1391"
          }
        ],
        "id": "137"
      }
    ],
    "regionName": "安徽省",
    "pid": "0",
    "status": "active",
    "regionType": "省",
    "id": "12"
  },
  {
    "city": [
      {
        "regionName": "福州市",
        "pid": "13",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "鼓楼区",
            "pid": "138",
            "status": "active",
            "regionType": "县",
            "id": "1392"
          },
          {
            "regionName": "台江区",
            "pid": "138",
            "status": "active",
            "regionType": "县",
            "id": "1393"
          },
          {
            "regionName": "仓山区",
            "pid": "138",
            "status": "active",
            "regionType": "县",
            "id": "1394"
          },
          {
            "regionName": "马尾区",
            "pid": "138",
            "status": "active",
            "regionType": "县",
            "id": "1395"
          },
          {
            "regionName": "晋安区",
            "pid": "138",
            "status": "active",
            "regionType": "县",
            "id": "1396"
          },
          {
            "regionName": "闽侯县",
            "pid": "138",
            "status": "active",
            "regionType": "县",
            "id": "1397"
          },
          {
            "regionName": "连江县",
            "pid": "138",
            "status": "active",
            "regionType": "县",
            "id": "1398"
          },
          {
            "regionName": "罗源县",
            "pid": "138",
            "status": "active",
            "regionType": "县",
            "id": "1399"
          },
          {
            "regionName": "闽清县",
            "pid": "138",
            "status": "active",
            "regionType": "县",
            "id": "1400"
          },
          {
            "regionName": "永泰县",
            "pid": "138",
            "status": "active",
            "regionType": "县",
            "id": "1401"
          },
          {
            "regionName": "平潭县",
            "pid": "138",
            "status": "active",
            "regionType": "县",
            "id": "1402"
          },
          {
            "regionName": "福清市",
            "pid": "138",
            "status": "active",
            "regionType": "县",
            "id": "1403"
          },
          {
            "regionName": "长乐市",
            "pid": "138",
            "status": "active",
            "regionType": "县",
            "id": "1404"
          }
        ],
        "id": "138"
      },
      {
        "regionName": "厦门市",
        "pid": "13",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "思明区",
            "pid": "139",
            "status": "active",
            "regionType": "县",
            "id": "1405"
          },
          {
            "regionName": "海沧区",
            "pid": "139",
            "status": "active",
            "regionType": "县",
            "id": "1406"
          },
          {
            "regionName": "湖里区",
            "pid": "139",
            "status": "active",
            "regionType": "县",
            "id": "1407"
          },
          {
            "regionName": "集美区",
            "pid": "139",
            "status": "active",
            "regionType": "县",
            "id": "1408"
          },
          {
            "regionName": "同安区",
            "pid": "139",
            "status": "active",
            "regionType": "县",
            "id": "1409"
          },
          {
            "regionName": "翔安区",
            "pid": "139",
            "status": "active",
            "regionType": "县",
            "id": "1410"
          }
        ],
        "id": "139"
      },
      {
        "regionName": "宁德市",
        "pid": "13",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "蕉城区",
            "pid": "140",
            "status": "active",
            "regionType": "县",
            "id": "1411"
          },
          {
            "regionName": "霞浦县",
            "pid": "140",
            "status": "active",
            "regionType": "县",
            "id": "1412"
          },
          {
            "regionName": "古田县",
            "pid": "140",
            "status": "active",
            "regionType": "县",
            "id": "1413"
          },
          {
            "regionName": "屏南县",
            "pid": "140",
            "status": "active",
            "regionType": "县",
            "id": "1414"
          },
          {
            "regionName": "寿宁县",
            "pid": "140",
            "status": "active",
            "regionType": "县",
            "id": "1415"
          },
          {
            "regionName": "周宁县",
            "pid": "140",
            "status": "active",
            "regionType": "县",
            "id": "1416"
          },
          {
            "regionName": "柘荣县",
            "pid": "140",
            "status": "active",
            "regionType": "县",
            "id": "1417"
          },
          {
            "regionName": "福安市",
            "pid": "140",
            "status": "active",
            "regionType": "县",
            "id": "1418"
          },
          {
            "regionName": "福鼎市",
            "pid": "140",
            "status": "active",
            "regionType": "县",
            "id": "1419"
          }
        ],
        "id": "140"
      },
      {
        "regionName": "莆田市",
        "pid": "13",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "城厢区",
            "pid": "141",
            "status": "active",
            "regionType": "县",
            "id": "1420"
          },
          {
            "regionName": "涵江区",
            "pid": "141",
            "status": "active",
            "regionType": "县",
            "id": "1421"
          },
          {
            "regionName": "荔城区",
            "pid": "141",
            "status": "active",
            "regionType": "县",
            "id": "1422"
          },
          {
            "regionName": "秀屿区",
            "pid": "141",
            "status": "active",
            "regionType": "县",
            "id": "1423"
          },
          {
            "regionName": "仙游县",
            "pid": "141",
            "status": "active",
            "regionType": "县",
            "id": "1424"
          }
        ],
        "id": "141"
      },
      {
        "regionName": "泉州市",
        "pid": "13",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "鲤城区",
            "pid": "142",
            "status": "active",
            "regionType": "县",
            "id": "1425"
          },
          {
            "regionName": "丰泽区",
            "pid": "142",
            "status": "active",
            "regionType": "县",
            "id": "1426"
          },
          {
            "regionName": "洛江区",
            "pid": "142",
            "status": "active",
            "regionType": "县",
            "id": "1427"
          },
          {
            "regionName": "泉港区",
            "pid": "142",
            "status": "active",
            "regionType": "县",
            "id": "1428"
          },
          {
            "regionName": "惠安县",
            "pid": "142",
            "status": "active",
            "regionType": "县",
            "id": "1429"
          },
          {
            "regionName": "安溪县",
            "pid": "142",
            "status": "active",
            "regionType": "县",
            "id": "1430"
          },
          {
            "regionName": "永春县",
            "pid": "142",
            "status": "active",
            "regionType": "县",
            "id": "1431"
          },
          {
            "regionName": "德化县",
            "pid": "142",
            "status": "active",
            "regionType": "县",
            "id": "1432"
          },
          {
            "regionName": "石狮市",
            "pid": "142",
            "status": "active",
            "regionType": "县",
            "id": "1433"
          },
          {
            "regionName": "晋江市",
            "pid": "142",
            "status": "active",
            "regionType": "县",
            "id": "1434"
          },
          {
            "regionName": "南安市",
            "pid": "142",
            "status": "active",
            "regionType": "县",
            "id": "1435"
          },
          {
            "regionName": "清濛开发区",
            "pid": "142",
            "status": "active",
            "regionType": "县",
            "id": "3643"
          },
          {
            "regionName": "金门县",
            "pid": "142",
            "status": "active",
            "regionType": "县",
            "id": "3644"
          }
        ],
        "id": "142"
      },
      {
        "regionName": "漳州市",
        "pid": "13",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "芗城区",
            "pid": "143",
            "status": "active",
            "regionType": "县",
            "id": "1436"
          },
          {
            "regionName": "龙文区",
            "pid": "143",
            "status": "active",
            "regionType": "县",
            "id": "1437"
          },
          {
            "regionName": "云霄县",
            "pid": "143",
            "status": "active",
            "regionType": "县",
            "id": "1438"
          },
          {
            "regionName": "漳浦县",
            "pid": "143",
            "status": "active",
            "regionType": "县",
            "id": "1439"
          },
          {
            "regionName": "诏安县",
            "pid": "143",
            "status": "active",
            "regionType": "县",
            "id": "1440"
          },
          {
            "regionName": "长泰县",
            "pid": "143",
            "status": "active",
            "regionType": "县",
            "id": "1441"
          },
          {
            "regionName": "东山县",
            "pid": "143",
            "status": "active",
            "regionType": "县",
            "id": "1442"
          },
          {
            "regionName": "南靖县",
            "pid": "143",
            "status": "active",
            "regionType": "县",
            "id": "1443"
          },
          {
            "regionName": "平和县",
            "pid": "143",
            "status": "active",
            "regionType": "县",
            "id": "1444"
          },
          {
            "regionName": "华安县",
            "pid": "143",
            "status": "active",
            "regionType": "县",
            "id": "1445"
          },
          {
            "regionName": "龙海市",
            "pid": "143",
            "status": "active",
            "regionType": "县",
            "id": "1446"
          }
        ],
        "id": "143"
      },
      {
        "regionName": "龙岩市",
        "pid": "13",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "新罗区",
            "pid": "144",
            "status": "active",
            "regionType": "县",
            "id": "1447"
          },
          {
            "regionName": "长汀县",
            "pid": "144",
            "status": "active",
            "regionType": "县",
            "id": "1448"
          },
          {
            "regionName": "永定县",
            "pid": "144",
            "status": "active",
            "regionType": "县",
            "id": "1449"
          },
          {
            "regionName": "上杭县",
            "pid": "144",
            "status": "active",
            "regionType": "县",
            "id": "1450"
          },
          {
            "regionName": "武平县",
            "pid": "144",
            "status": "active",
            "regionType": "县",
            "id": "1451"
          },
          {
            "regionName": "连城县",
            "pid": "144",
            "status": "active",
            "regionType": "县",
            "id": "1452"
          },
          {
            "regionName": "漳平市",
            "pid": "144",
            "status": "active",
            "regionType": "县",
            "id": "1453"
          }
        ],
        "id": "144"
      },
      {
        "regionName": "三明市",
        "pid": "13",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "梅列区",
            "pid": "145",
            "status": "active",
            "regionType": "县",
            "id": "1454"
          },
          {
            "regionName": "三元区",
            "pid": "145",
            "status": "active",
            "regionType": "县",
            "id": "1455"
          },
          {
            "regionName": "明溪县",
            "pid": "145",
            "status": "active",
            "regionType": "县",
            "id": "1456"
          },
          {
            "regionName": "清流县",
            "pid": "145",
            "status": "active",
            "regionType": "县",
            "id": "1457"
          },
          {
            "regionName": "宁化县",
            "pid": "145",
            "status": "active",
            "regionType": "县",
            "id": "1458"
          },
          {
            "regionName": "大田县",
            "pid": "145",
            "status": "active",
            "regionType": "县",
            "id": "1459"
          },
          {
            "regionName": "尤溪县",
            "pid": "145",
            "status": "active",
            "regionType": "县",
            "id": "1460"
          },
          {
            "regionName": "沙县",
            "pid": "145",
            "status": "active",
            "regionType": "县",
            "id": "1461"
          },
          {
            "regionName": "将乐县",
            "pid": "145",
            "status": "active",
            "regionType": "县",
            "id": "1462"
          },
          {
            "regionName": "泰宁县",
            "pid": "145",
            "status": "active",
            "regionType": "县",
            "id": "1463"
          },
          {
            "regionName": "建宁县",
            "pid": "145",
            "status": "active",
            "regionType": "县",
            "id": "1464"
          },
          {
            "regionName": "永安市",
            "pid": "145",
            "status": "active",
            "regionType": "县",
            "id": "1465"
          }
        ],
        "id": "145"
      },
      {
        "regionName": "南平市",
        "pid": "13",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "延平区",
            "pid": "146",
            "status": "active",
            "regionType": "县",
            "id": "1466"
          },
          {
            "regionName": "顺昌县",
            "pid": "146",
            "status": "active",
            "regionType": "县",
            "id": "1467"
          },
          {
            "regionName": "浦城县",
            "pid": "146",
            "status": "active",
            "regionType": "县",
            "id": "1468"
          },
          {
            "regionName": "光泽县",
            "pid": "146",
            "status": "active",
            "regionType": "县",
            "id": "1469"
          },
          {
            "regionName": "松溪县",
            "pid": "146",
            "status": "active",
            "regionType": "县",
            "id": "1470"
          },
          {
            "regionName": "政和县",
            "pid": "146",
            "status": "active",
            "regionType": "县",
            "id": "1471"
          },
          {
            "regionName": "邵武市",
            "pid": "146",
            "status": "active",
            "regionType": "县",
            "id": "1472"
          },
          {
            "regionName": "武夷山市",
            "pid": "146",
            "status": "active",
            "regionType": "县",
            "id": "1473"
          },
          {
            "regionName": "建瓯市",
            "pid": "146",
            "status": "active",
            "regionType": "县",
            "id": "1474"
          },
          {
            "regionName": "建阳市",
            "pid": "146",
            "status": "active",
            "regionType": "县",
            "id": "1475"
          }
        ],
        "id": "146"
      }
    ],
    "regionName": "福建省",
    "pid": "0",
    "status": "active",
    "regionType": "省",
    "id": "13"
  },
  {
    "city": [
      {
        "regionName": "鹰潭市",
        "pid": "14",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "月湖区",
            "pid": "147",
            "status": "active",
            "regionType": "县",
            "id": "1476"
          },
          {
            "regionName": "余江县",
            "pid": "147",
            "status": "active",
            "regionType": "县",
            "id": "1477"
          },
          {
            "regionName": "贵溪市",
            "pid": "147",
            "status": "active",
            "regionType": "县",
            "id": "1478"
          }
        ],
        "id": "147"
      },
      {
        "regionName": "新余市",
        "pid": "14",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "渝水区",
            "pid": "148",
            "status": "active",
            "regionType": "县",
            "id": "1479"
          },
          {
            "regionName": "分宜县",
            "pid": "148",
            "status": "active",
            "regionType": "县",
            "id": "1480"
          }
        ],
        "id": "148"
      },
      {
        "regionName": "南昌市",
        "pid": "14",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "东湖区",
            "pid": "149",
            "status": "active",
            "regionType": "县",
            "id": "1481"
          },
          {
            "regionName": "西湖区",
            "pid": "149",
            "status": "active",
            "regionType": "县",
            "id": "1482"
          },
          {
            "regionName": "青云谱区",
            "pid": "149",
            "status": "active",
            "regionType": "县",
            "id": "1483"
          },
          {
            "regionName": "湾里区",
            "pid": "149",
            "status": "active",
            "regionType": "县",
            "id": "1484"
          },
          {
            "regionName": "青山湖区",
            "pid": "149",
            "status": "active",
            "regionType": "县",
            "id": "1485"
          },
          {
            "regionName": "南昌县",
            "pid": "149",
            "status": "active",
            "regionType": "县",
            "id": "1486"
          },
          {
            "regionName": "新建县",
            "pid": "149",
            "status": "active",
            "regionType": "县",
            "id": "1487"
          },
          {
            "regionName": "安义县",
            "pid": "149",
            "status": "active",
            "regionType": "县",
            "id": "1488"
          },
          {
            "regionName": "进贤县",
            "pid": "149",
            "status": "active",
            "regionType": "县",
            "id": "1489"
          },
          {
            "regionName": "红谷滩新区",
            "pid": "149",
            "status": "active",
            "regionType": "县",
            "id": "3751"
          },
          {
            "regionName": "昌北区",
            "pid": "149",
            "status": "active",
            "regionType": "县",
            "id": "3752"
          }
        ],
        "id": "149"
      },
      {
        "regionName": "九江市",
        "pid": "14",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "庐山区",
            "pid": "150",
            "status": "active",
            "regionType": "县",
            "id": "1490"
          },
          {
            "regionName": "浔阳区",
            "pid": "150",
            "status": "active",
            "regionType": "县",
            "id": "1491"
          },
          {
            "regionName": "九江县",
            "pid": "150",
            "status": "active",
            "regionType": "县",
            "id": "1492"
          },
          {
            "regionName": "武宁县",
            "pid": "150",
            "status": "active",
            "regionType": "县",
            "id": "1493"
          },
          {
            "regionName": "修水县",
            "pid": "150",
            "status": "active",
            "regionType": "县",
            "id": "1494"
          },
          {
            "regionName": "永修县",
            "pid": "150",
            "status": "active",
            "regionType": "县",
            "id": "1495"
          },
          {
            "regionName": "德安县",
            "pid": "150",
            "status": "active",
            "regionType": "县",
            "id": "1496"
          },
          {
            "regionName": "星子县",
            "pid": "150",
            "status": "active",
            "regionType": "县",
            "id": "1497"
          },
          {
            "regionName": "都昌县",
            "pid": "150",
            "status": "active",
            "regionType": "县",
            "id": "1498"
          },
          {
            "regionName": "湖口县",
            "pid": "150",
            "status": "active",
            "regionType": "县",
            "id": "1499"
          },
          {
            "regionName": "彭泽县",
            "pid": "150",
            "status": "active",
            "regionType": "县",
            "id": "1500"
          },
          {
            "regionName": "瑞昌市",
            "pid": "150",
            "status": "active",
            "regionType": "县",
            "id": "1501"
          }
        ],
        "id": "150"
      },
      {
        "regionName": "上饶市",
        "pid": "14",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "信州区",
            "pid": "151",
            "status": "active",
            "regionType": "县",
            "id": "1502"
          },
          {
            "regionName": "上饶县",
            "pid": "151",
            "status": "active",
            "regionType": "县",
            "id": "1503"
          },
          {
            "regionName": "广丰县",
            "pid": "151",
            "status": "active",
            "regionType": "县",
            "id": "1504"
          },
          {
            "regionName": "玉山县",
            "pid": "151",
            "status": "active",
            "regionType": "县",
            "id": "1505"
          },
          {
            "regionName": "铅山县",
            "pid": "151",
            "status": "active",
            "regionType": "县",
            "id": "1506"
          },
          {
            "regionName": "横峰县",
            "pid": "151",
            "status": "active",
            "regionType": "县",
            "id": "1507"
          },
          {
            "regionName": "弋阳县",
            "pid": "151",
            "status": "active",
            "regionType": "县",
            "id": "1508"
          },
          {
            "regionName": "余干县",
            "pid": "151",
            "status": "active",
            "regionType": "县",
            "id": "1509"
          },
          {
            "regionName": "鄱阳县",
            "pid": "151",
            "status": "active",
            "regionType": "县",
            "id": "1510"
          },
          {
            "regionName": "万年县",
            "pid": "151",
            "status": "active",
            "regionType": "县",
            "id": "1511"
          },
          {
            "regionName": "婺源县",
            "pid": "151",
            "status": "active",
            "regionType": "县",
            "id": "1512"
          },
          {
            "regionName": "德兴市",
            "pid": "151",
            "status": "active",
            "regionType": "县",
            "id": "1513"
          },
          {
            "regionName": "波阳县",
            "pid": "151",
            "status": "active",
            "regionType": "县",
            "id": "3753"
          }
        ],
        "id": "151"
      },
      {
        "regionName": "抚州市",
        "pid": "14",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "临川区",
            "pid": "152",
            "status": "active",
            "regionType": "县",
            "id": "1514"
          },
          {
            "regionName": "南城县",
            "pid": "152",
            "status": "active",
            "regionType": "县",
            "id": "1515"
          },
          {
            "regionName": "黎川县",
            "pid": "152",
            "status": "active",
            "regionType": "县",
            "id": "1516"
          },
          {
            "regionName": "南丰县",
            "pid": "152",
            "status": "active",
            "regionType": "县",
            "id": "1517"
          },
          {
            "regionName": "崇仁县",
            "pid": "152",
            "status": "active",
            "regionType": "县",
            "id": "1518"
          },
          {
            "regionName": "乐安县",
            "pid": "152",
            "status": "active",
            "regionType": "县",
            "id": "1519"
          },
          {
            "regionName": "宜黄县",
            "pid": "152",
            "status": "active",
            "regionType": "县",
            "id": "1520"
          },
          {
            "regionName": "金溪县",
            "pid": "152",
            "status": "active",
            "regionType": "县",
            "id": "1521"
          },
          {
            "regionName": "资溪县",
            "pid": "152",
            "status": "active",
            "regionType": "县",
            "id": "1522"
          },
          {
            "regionName": "东乡县",
            "pid": "152",
            "status": "active",
            "regionType": "县",
            "id": "1523"
          },
          {
            "regionName": "广昌县",
            "pid": "152",
            "status": "active",
            "regionType": "县",
            "id": "1524"
          }
        ],
        "id": "152"
      },
      {
        "regionName": "宜春市",
        "pid": "14",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "袁州区",
            "pid": "153",
            "status": "active",
            "regionType": "县",
            "id": "1525"
          },
          {
            "regionName": "奉新县",
            "pid": "153",
            "status": "active",
            "regionType": "县",
            "id": "1526"
          },
          {
            "regionName": "万载县",
            "pid": "153",
            "status": "active",
            "regionType": "县",
            "id": "1527"
          },
          {
            "regionName": "上高县",
            "pid": "153",
            "status": "active",
            "regionType": "县",
            "id": "1528"
          },
          {
            "regionName": "宜丰县",
            "pid": "153",
            "status": "active",
            "regionType": "县",
            "id": "1529"
          },
          {
            "regionName": "靖安县",
            "pid": "153",
            "status": "active",
            "regionType": "县",
            "id": "1530"
          },
          {
            "regionName": "铜鼓县",
            "pid": "153",
            "status": "active",
            "regionType": "县",
            "id": "1531"
          },
          {
            "regionName": "丰城市",
            "pid": "153",
            "status": "active",
            "regionType": "县",
            "id": "1532"
          },
          {
            "regionName": "樟树市",
            "pid": "153",
            "status": "active",
            "regionType": "县",
            "id": "1533"
          },
          {
            "regionName": "高安市",
            "pid": "153",
            "status": "active",
            "regionType": "县",
            "id": "1534"
          }
        ],
        "id": "153"
      },
      {
        "regionName": "吉安市",
        "pid": "14",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "吉州区",
            "pid": "154",
            "status": "active",
            "regionType": "县",
            "id": "1535"
          },
          {
            "regionName": "青原区",
            "pid": "154",
            "status": "active",
            "regionType": "县",
            "id": "1536"
          },
          {
            "regionName": "吉安县",
            "pid": "154",
            "status": "active",
            "regionType": "县",
            "id": "1537"
          },
          {
            "regionName": "吉水县",
            "pid": "154",
            "status": "active",
            "regionType": "县",
            "id": "1538"
          },
          {
            "regionName": "峡江县",
            "pid": "154",
            "status": "active",
            "regionType": "县",
            "id": "1539"
          },
          {
            "regionName": "新干县",
            "pid": "154",
            "status": "active",
            "regionType": "县",
            "id": "1540"
          },
          {
            "regionName": "永丰县",
            "pid": "154",
            "status": "active",
            "regionType": "县",
            "id": "1541"
          },
          {
            "regionName": "泰和县",
            "pid": "154",
            "status": "active",
            "regionType": "县",
            "id": "1542"
          },
          {
            "regionName": "遂川县",
            "pid": "154",
            "status": "active",
            "regionType": "县",
            "id": "1543"
          },
          {
            "regionName": "万安县",
            "pid": "154",
            "status": "active",
            "regionType": "县",
            "id": "1544"
          },
          {
            "regionName": "安福县",
            "pid": "154",
            "status": "active",
            "regionType": "县",
            "id": "1545"
          },
          {
            "regionName": "永新县",
            "pid": "154",
            "status": "active",
            "regionType": "县",
            "id": "1546"
          },
          {
            "regionName": "井冈山市",
            "pid": "154",
            "status": "active",
            "regionType": "县",
            "id": "1547"
          }
        ],
        "id": "154"
      },
      {
        "regionName": "赣州市",
        "pid": "14",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "章贡区",
            "pid": "155",
            "status": "active",
            "regionType": "县",
            "id": "1548"
          },
          {
            "regionName": "赣县",
            "pid": "155",
            "status": "active",
            "regionType": "县",
            "id": "1549"
          },
          {
            "regionName": "信丰县",
            "pid": "155",
            "status": "active",
            "regionType": "县",
            "id": "1550"
          },
          {
            "regionName": "大余县",
            "pid": "155",
            "status": "active",
            "regionType": "县",
            "id": "1551"
          },
          {
            "regionName": "上犹县",
            "pid": "155",
            "status": "active",
            "regionType": "县",
            "id": "1552"
          },
          {
            "regionName": "崇义县",
            "pid": "155",
            "status": "active",
            "regionType": "县",
            "id": "1553"
          },
          {
            "regionName": "安远县",
            "pid": "155",
            "status": "active",
            "regionType": "县",
            "id": "1554"
          },
          {
            "regionName": "龙南县",
            "pid": "155",
            "status": "active",
            "regionType": "县",
            "id": "1555"
          },
          {
            "regionName": "定南县",
            "pid": "155",
            "status": "active",
            "regionType": "县",
            "id": "1556"
          },
          {
            "regionName": "全南县",
            "pid": "155",
            "status": "active",
            "regionType": "县",
            "id": "1557"
          },
          {
            "regionName": "宁都县",
            "pid": "155",
            "status": "active",
            "regionType": "县",
            "id": "1558"
          },
          {
            "regionName": "于都县",
            "pid": "155",
            "status": "active",
            "regionType": "县",
            "id": "1559"
          },
          {
            "regionName": "兴国县",
            "pid": "155",
            "status": "active",
            "regionType": "县",
            "id": "1560"
          },
          {
            "regionName": "会昌县",
            "pid": "155",
            "status": "active",
            "regionType": "县",
            "id": "1561"
          },
          {
            "regionName": "寻乌县",
            "pid": "155",
            "status": "active",
            "regionType": "县",
            "id": "1562"
          },
          {
            "regionName": "石城县",
            "pid": "155",
            "status": "active",
            "regionType": "县",
            "id": "1563"
          },
          {
            "regionName": "瑞金市",
            "pid": "155",
            "status": "active",
            "regionType": "县",
            "id": "1564"
          },
          {
            "regionName": "南康市",
            "pid": "155",
            "status": "active",
            "regionType": "县",
            "id": "1565"
          }
        ],
        "id": "155"
      },
      {
        "regionName": "景德镇市",
        "pid": "14",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "昌江区",
            "pid": "156",
            "status": "active",
            "regionType": "县",
            "id": "1566"
          },
          {
            "regionName": "珠山区",
            "pid": "156",
            "status": "active",
            "regionType": "县",
            "id": "1567"
          },
          {
            "regionName": "浮梁县",
            "pid": "156",
            "status": "active",
            "regionType": "县",
            "id": "1568"
          },
          {
            "regionName": "乐平市",
            "pid": "156",
            "status": "active",
            "regionType": "县",
            "id": "1569"
          }
        ],
        "id": "156"
      },
      {
        "regionName": "萍乡市",
        "pid": "14",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "安源区",
            "pid": "157",
            "status": "active",
            "regionType": "县",
            "id": "1570"
          },
          {
            "regionName": "湘东区",
            "pid": "157",
            "status": "active",
            "regionType": "县",
            "id": "1571"
          },
          {
            "regionName": "莲花县",
            "pid": "157",
            "status": "active",
            "regionType": "县",
            "id": "1572"
          },
          {
            "regionName": "上栗县",
            "pid": "157",
            "status": "active",
            "regionType": "县",
            "id": "1573"
          },
          {
            "regionName": "芦溪县",
            "pid": "157",
            "status": "active",
            "regionType": "县",
            "id": "1574"
          }
        ],
        "id": "157"
      }
    ],
    "regionName": "江西省",
    "pid": "0",
    "status": "active",
    "regionType": "省",
    "id": "14"
  },
  {
    "city": [
      {
        "regionName": "菏泽市",
        "pid": "15",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "牡丹区",
            "pid": "158",
            "status": "active",
            "regionType": "县",
            "id": "1575"
          },
          {
            "regionName": "曹县",
            "pid": "158",
            "status": "active",
            "regionType": "县",
            "id": "1576"
          },
          {
            "regionName": "单县",
            "pid": "158",
            "status": "active",
            "regionType": "县",
            "id": "1577"
          },
          {
            "regionName": "成武县",
            "pid": "158",
            "status": "active",
            "regionType": "县",
            "id": "1578"
          },
          {
            "regionName": "巨野县",
            "pid": "158",
            "status": "active",
            "regionType": "县",
            "id": "1579"
          },
          {
            "regionName": "郓城县",
            "pid": "158",
            "status": "active",
            "regionType": "县",
            "id": "1580"
          },
          {
            "regionName": "鄄城县",
            "pid": "158",
            "status": "active",
            "regionType": "县",
            "id": "1581"
          },
          {
            "regionName": "定陶县",
            "pid": "158",
            "status": "active",
            "regionType": "县",
            "id": "1582"
          },
          {
            "regionName": "东明县",
            "pid": "158",
            "status": "active",
            "regionType": "县",
            "id": "1583"
          }
        ],
        "id": "158"
      },
      {
        "regionName": "济南市",
        "pid": "15",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "历下区",
            "pid": "159",
            "status": "active",
            "regionType": "县",
            "id": "1584"
          },
          {
            "regionName": "市中区",
            "pid": "159",
            "status": "active",
            "regionType": "县",
            "id": "1585"
          },
          {
            "regionName": "槐荫区",
            "pid": "159",
            "status": "active",
            "regionType": "县",
            "id": "1586"
          },
          {
            "regionName": "天桥区",
            "pid": "159",
            "status": "active",
            "regionType": "县",
            "id": "1587"
          },
          {
            "regionName": "历城区",
            "pid": "159",
            "status": "active",
            "regionType": "县",
            "id": "1588"
          },
          {
            "regionName": "长清区",
            "pid": "159",
            "status": "active",
            "regionType": "县",
            "id": "1589"
          },
          {
            "regionName": "平阴县",
            "pid": "159",
            "status": "active",
            "regionType": "县",
            "id": "1590"
          },
          {
            "regionName": "济阳县",
            "pid": "159",
            "status": "active",
            "regionType": "县",
            "id": "1591"
          },
          {
            "regionName": "商河县",
            "pid": "159",
            "status": "active",
            "regionType": "县",
            "id": "1592"
          },
          {
            "regionName": "章丘市",
            "pid": "159",
            "status": "active",
            "regionType": "县",
            "id": "1593"
          }
        ],
        "id": "159"
      },
      {
        "regionName": "青岛市",
        "pid": "15",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "市南区",
            "pid": "160",
            "status": "active",
            "regionType": "县",
            "id": "1594"
          },
          {
            "regionName": "市北区",
            "pid": "160",
            "status": "active",
            "regionType": "县",
            "id": "1595"
          },
          {
            "regionName": "四方区",
            "pid": "160",
            "status": "active",
            "regionType": "县",
            "id": "1596"
          },
          {
            "regionName": "黄岛区",
            "pid": "160",
            "status": "active",
            "regionType": "县",
            "id": "1597"
          },
          {
            "regionName": "崂山区",
            "pid": "160",
            "status": "active",
            "regionType": "县",
            "id": "1598"
          },
          {
            "regionName": "李沧区",
            "pid": "160",
            "status": "active",
            "regionType": "县",
            "id": "1599"
          },
          {
            "regionName": "城阳区",
            "pid": "160",
            "status": "active",
            "regionType": "县",
            "id": "1600"
          },
          {
            "regionName": "胶州市",
            "pid": "160",
            "status": "active",
            "regionType": "县",
            "id": "1601"
          },
          {
            "regionName": "即墨市",
            "pid": "160",
            "status": "active",
            "regionType": "县",
            "id": "1602"
          },
          {
            "regionName": "平度市",
            "pid": "160",
            "status": "active",
            "regionType": "县",
            "id": "1603"
          },
          {
            "regionName": "胶南市",
            "pid": "160",
            "status": "active",
            "regionType": "县",
            "id": "1604"
          },
          {
            "regionName": "莱西市",
            "pid": "160",
            "status": "active",
            "regionType": "县",
            "id": "1605"
          }
        ],
        "id": "160"
      },
      {
        "regionName": "淄博市",
        "pid": "15",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "淄川区",
            "pid": "161",
            "status": "active",
            "regionType": "县",
            "id": "1606"
          },
          {
            "regionName": "张店区",
            "pid": "161",
            "status": "active",
            "regionType": "县",
            "id": "1607"
          },
          {
            "regionName": "博山区",
            "pid": "161",
            "status": "active",
            "regionType": "县",
            "id": "1608"
          },
          {
            "regionName": "临淄区",
            "pid": "161",
            "status": "active",
            "regionType": "县",
            "id": "1609"
          },
          {
            "regionName": "周村区",
            "pid": "161",
            "status": "active",
            "regionType": "县",
            "id": "1610"
          },
          {
            "regionName": "桓台县",
            "pid": "161",
            "status": "active",
            "regionType": "县",
            "id": "1611"
          },
          {
            "regionName": "高青县",
            "pid": "161",
            "status": "active",
            "regionType": "县",
            "id": "1612"
          },
          {
            "regionName": "沂源县",
            "pid": "161",
            "status": "active",
            "regionType": "县",
            "id": "1613"
          }
        ],
        "id": "161"
      },
      {
        "regionName": "德州市",
        "pid": "15",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "德城区",
            "pid": "162",
            "status": "active",
            "regionType": "县",
            "id": "1614"
          },
          {
            "regionName": "陵县",
            "pid": "162",
            "status": "active",
            "regionType": "县",
            "id": "1615"
          },
          {
            "regionName": "宁津县",
            "pid": "162",
            "status": "active",
            "regionType": "县",
            "id": "1616"
          },
          {
            "regionName": "庆云县",
            "pid": "162",
            "status": "active",
            "regionType": "县",
            "id": "1617"
          },
          {
            "regionName": "临邑县",
            "pid": "162",
            "status": "active",
            "regionType": "县",
            "id": "1618"
          },
          {
            "regionName": "齐河县",
            "pid": "162",
            "status": "active",
            "regionType": "县",
            "id": "1619"
          },
          {
            "regionName": "平原县",
            "pid": "162",
            "status": "active",
            "regionType": "县",
            "id": "1620"
          },
          {
            "regionName": "夏津县",
            "pid": "162",
            "status": "active",
            "regionType": "县",
            "id": "1621"
          },
          {
            "regionName": "武城县",
            "pid": "162",
            "status": "active",
            "regionType": "县",
            "id": "1622"
          },
          {
            "regionName": "乐陵市",
            "pid": "162",
            "status": "active",
            "regionType": "县",
            "id": "1623"
          },
          {
            "regionName": "禹城市",
            "pid": "162",
            "status": "active",
            "regionType": "县",
            "id": "1624"
          }
        ],
        "id": "162"
      },
      {
        "regionName": "烟台市",
        "pid": "15",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "芝罘区",
            "pid": "163",
            "status": "active",
            "regionType": "县",
            "id": "1625"
          },
          {
            "regionName": "福山区",
            "pid": "163",
            "status": "active",
            "regionType": "县",
            "id": "1626"
          },
          {
            "regionName": "牟平区",
            "pid": "163",
            "status": "active",
            "regionType": "县",
            "id": "1627"
          },
          {
            "regionName": "莱山区",
            "pid": "163",
            "status": "active",
            "regionType": "县",
            "id": "1628"
          },
          {
            "regionName": "长岛县",
            "pid": "163",
            "status": "active",
            "regionType": "县",
            "id": "1629"
          },
          {
            "regionName": "龙口市",
            "pid": "163",
            "status": "active",
            "regionType": "县",
            "id": "1630"
          },
          {
            "regionName": "莱阳市",
            "pid": "163",
            "status": "active",
            "regionType": "县",
            "id": "1631"
          },
          {
            "regionName": "莱州市",
            "pid": "163",
            "status": "active",
            "regionType": "县",
            "id": "1632"
          },
          {
            "regionName": "蓬莱市",
            "pid": "163",
            "status": "active",
            "regionType": "县",
            "id": "1633"
          },
          {
            "regionName": "招远市",
            "pid": "163",
            "status": "active",
            "regionType": "县",
            "id": "1634"
          },
          {
            "regionName": "栖霞市",
            "pid": "163",
            "status": "active",
            "regionType": "县",
            "id": "1635"
          },
          {
            "regionName": "海阳市",
            "pid": "163",
            "status": "active",
            "regionType": "县",
            "id": "1636"
          }
        ],
        "id": "163"
      },
      {
        "regionName": "潍坊市",
        "pid": "15",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "潍城区",
            "pid": "164",
            "status": "active",
            "regionType": "县",
            "id": "1637"
          },
          {
            "regionName": "寒亭区",
            "pid": "164",
            "status": "active",
            "regionType": "县",
            "id": "1638"
          },
          {
            "regionName": "坊子区",
            "pid": "164",
            "status": "active",
            "regionType": "县",
            "id": "1639"
          },
          {
            "regionName": "奎文区",
            "pid": "164",
            "status": "active",
            "regionType": "县",
            "id": "1640"
          },
          {
            "regionName": "临朐县",
            "pid": "164",
            "status": "active",
            "regionType": "县",
            "id": "1641"
          },
          {
            "regionName": "昌乐县",
            "pid": "164",
            "status": "active",
            "regionType": "县",
            "id": "1642"
          },
          {
            "regionName": "青州市",
            "pid": "164",
            "status": "active",
            "regionType": "县",
            "id": "1643"
          },
          {
            "regionName": "诸城市",
            "pid": "164",
            "status": "active",
            "regionType": "县",
            "id": "1644"
          },
          {
            "regionName": "寿光市",
            "pid": "164",
            "status": "active",
            "regionType": "县",
            "id": "1645"
          },
          {
            "regionName": "安丘市",
            "pid": "164",
            "status": "active",
            "regionType": "县",
            "id": "1646"
          },
          {
            "regionName": "高密市",
            "pid": "164",
            "status": "active",
            "regionType": "县",
            "id": "1647"
          },
          {
            "regionName": "昌邑市",
            "pid": "164",
            "status": "active",
            "regionType": "县",
            "id": "1648"
          }
        ],
        "id": "164"
      },
      {
        "regionName": "济宁市",
        "pid": "15",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "市中区",
            "pid": "165",
            "status": "active",
            "regionType": "县",
            "id": "1649"
          },
          {
            "regionName": "任城区",
            "pid": "165",
            "status": "active",
            "regionType": "县",
            "id": "1650"
          },
          {
            "regionName": "微山县",
            "pid": "165",
            "status": "active",
            "regionType": "县",
            "id": "1651"
          },
          {
            "regionName": "鱼台县",
            "pid": "165",
            "status": "active",
            "regionType": "县",
            "id": "1652"
          },
          {
            "regionName": "金乡县",
            "pid": "165",
            "status": "active",
            "regionType": "县",
            "id": "1653"
          },
          {
            "regionName": "嘉祥县",
            "pid": "165",
            "status": "active",
            "regionType": "县",
            "id": "1654"
          },
          {
            "regionName": "汶上县",
            "pid": "165",
            "status": "active",
            "regionType": "县",
            "id": "1655"
          },
          {
            "regionName": "泗水县",
            "pid": "165",
            "status": "active",
            "regionType": "县",
            "id": "1656"
          },
          {
            "regionName": "梁山县",
            "pid": "165",
            "status": "active",
            "regionType": "县",
            "id": "1657"
          },
          {
            "regionName": "曲阜市",
            "pid": "165",
            "status": "active",
            "regionType": "县",
            "id": "1658"
          },
          {
            "regionName": "兖州市",
            "pid": "165",
            "status": "active",
            "regionType": "县",
            "id": "1659"
          },
          {
            "regionName": "邹城市",
            "pid": "165",
            "status": "active",
            "regionType": "县",
            "id": "1660"
          }
        ],
        "id": "165"
      },
      {
        "regionName": "泰安市",
        "pid": "15",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "泰山区",
            "pid": "166",
            "status": "active",
            "regionType": "县",
            "id": "1661"
          },
          {
            "regionName": "岱岳区",
            "pid": "166",
            "status": "active",
            "regionType": "县",
            "id": "1662"
          },
          {
            "regionName": "宁阳县",
            "pid": "166",
            "status": "active",
            "regionType": "县",
            "id": "1663"
          },
          {
            "regionName": "东平县",
            "pid": "166",
            "status": "active",
            "regionType": "县",
            "id": "1664"
          },
          {
            "regionName": "新泰市",
            "pid": "166",
            "status": "active",
            "regionType": "县",
            "id": "1665"
          },
          {
            "regionName": "肥城市",
            "pid": "166",
            "status": "active",
            "regionType": "县",
            "id": "1666"
          }
        ],
        "id": "166"
      },
      {
        "regionName": "临沂市",
        "pid": "15",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "兰山区",
            "pid": "167",
            "status": "active",
            "regionType": "县",
            "id": "1667"
          },
          {
            "regionName": "罗庄区",
            "pid": "167",
            "status": "active",
            "regionType": "县",
            "id": "1668"
          },
          {
            "regionName": "河东区",
            "pid": "167",
            "status": "active",
            "regionType": "县",
            "id": "1669"
          },
          {
            "regionName": "沂南县",
            "pid": "167",
            "status": "active",
            "regionType": "县",
            "id": "1670"
          },
          {
            "regionName": "郯城县",
            "pid": "167",
            "status": "active",
            "regionType": "县",
            "id": "1671"
          },
          {
            "regionName": "沂水县",
            "pid": "167",
            "status": "active",
            "regionType": "县",
            "id": "1672"
          },
          {
            "regionName": "苍山县",
            "pid": "167",
            "status": "active",
            "regionType": "县",
            "id": "1673"
          },
          {
            "regionName": "费县",
            "pid": "167",
            "status": "active",
            "regionType": "县",
            "id": "1674"
          },
          {
            "regionName": "平邑县",
            "pid": "167",
            "status": "active",
            "regionType": "县",
            "id": "1675"
          },
          {
            "regionName": "莒南县",
            "pid": "167",
            "status": "active",
            "regionType": "县",
            "id": "1676"
          },
          {
            "regionName": "蒙阴县",
            "pid": "167",
            "status": "active",
            "regionType": "县",
            "id": "1677"
          },
          {
            "regionName": "临沭县",
            "pid": "167",
            "status": "active",
            "regionType": "县",
            "id": "1678"
          }
        ],
        "id": "167"
      },
      {
        "regionName": "滨州市",
        "pid": "15",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "滨城区",
            "pid": "168",
            "status": "active",
            "regionType": "县",
            "id": "1679"
          },
          {
            "regionName": "惠民县",
            "pid": "168",
            "status": "active",
            "regionType": "县",
            "id": "1680"
          },
          {
            "regionName": "阳信县",
            "pid": "168",
            "status": "active",
            "regionType": "县",
            "id": "1681"
          },
          {
            "regionName": "无棣县",
            "pid": "168",
            "status": "active",
            "regionType": "县",
            "id": "1682"
          },
          {
            "regionName": "沾化县",
            "pid": "168",
            "status": "active",
            "regionType": "县",
            "id": "1683"
          },
          {
            "regionName": "博兴县",
            "pid": "168",
            "status": "active",
            "regionType": "县",
            "id": "1684"
          },
          {
            "regionName": "邹平县",
            "pid": "168",
            "status": "active",
            "regionType": "县",
            "id": "1685"
          }
        ],
        "id": "168"
      },
      {
        "regionName": "东营市",
        "pid": "15",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "东营区",
            "pid": "169",
            "status": "active",
            "regionType": "县",
            "id": "1686"
          },
          {
            "regionName": "河口区",
            "pid": "169",
            "status": "active",
            "regionType": "县",
            "id": "1687"
          },
          {
            "regionName": "垦利县",
            "pid": "169",
            "status": "active",
            "regionType": "县",
            "id": "1688"
          },
          {
            "regionName": "利津县",
            "pid": "169",
            "status": "active",
            "regionType": "县",
            "id": "1689"
          },
          {
            "regionName": "广饶县",
            "pid": "169",
            "status": "active",
            "regionType": "县",
            "id": "1690"
          }
        ],
        "id": "169"
      },
      {
        "regionName": "威海市",
        "pid": "15",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "环翠区",
            "pid": "170",
            "status": "active",
            "regionType": "县",
            "id": "1691"
          },
          {
            "regionName": "文登市",
            "pid": "170",
            "status": "active",
            "regionType": "县",
            "id": "1692"
          },
          {
            "regionName": "荣成市",
            "pid": "170",
            "status": "active",
            "regionType": "县",
            "id": "1693"
          },
          {
            "regionName": "乳山市",
            "pid": "170",
            "status": "active",
            "regionType": "县",
            "id": "1694"
          }
        ],
        "id": "170"
      },
      {
        "regionName": "枣庄市",
        "pid": "15",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "市中区",
            "pid": "171",
            "status": "active",
            "regionType": "县",
            "id": "1695"
          },
          {
            "regionName": "薛城区",
            "pid": "171",
            "status": "active",
            "regionType": "县",
            "id": "1696"
          },
          {
            "regionName": "峄城区",
            "pid": "171",
            "status": "active",
            "regionType": "县",
            "id": "1697"
          },
          {
            "regionName": "台儿庄区",
            "pid": "171",
            "status": "active",
            "regionType": "县",
            "id": "1698"
          },
          {
            "regionName": "山亭区",
            "pid": "171",
            "status": "active",
            "regionType": "县",
            "id": "1699"
          },
          {
            "regionName": "滕州市",
            "pid": "171",
            "status": "active",
            "regionType": "县",
            "id": "1700"
          }
        ],
        "id": "171"
      },
      {
        "regionName": "日照市",
        "pid": "15",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "东港区",
            "pid": "172",
            "status": "active",
            "regionType": "县",
            "id": "1701"
          },
          {
            "regionName": "岚山区",
            "pid": "172",
            "status": "active",
            "regionType": "县",
            "id": "1702"
          },
          {
            "regionName": "五莲县",
            "pid": "172",
            "status": "active",
            "regionType": "县",
            "id": "1703"
          },
          {
            "regionName": "莒县",
            "pid": "172",
            "status": "active",
            "regionType": "县",
            "id": "1704"
          }
        ],
        "id": "172"
      },
      {
        "regionName": "莱芜市",
        "pid": "15",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "莱城区",
            "pid": "173",
            "status": "active",
            "regionType": "县",
            "id": "1705"
          },
          {
            "regionName": "钢城区",
            "pid": "173",
            "status": "active",
            "regionType": "县",
            "id": "1706"
          }
        ],
        "id": "173"
      },
      {
        "regionName": "聊城市",
        "pid": "15",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "东昌府区",
            "pid": "174",
            "status": "active",
            "regionType": "县",
            "id": "1707"
          },
          {
            "regionName": "阳谷县",
            "pid": "174",
            "status": "active",
            "regionType": "县",
            "id": "1708"
          },
          {
            "regionName": "莘县",
            "pid": "174",
            "status": "active",
            "regionType": "县",
            "id": "1709"
          },
          {
            "regionName": "茌平县",
            "pid": "174",
            "status": "active",
            "regionType": "县",
            "id": "1710"
          },
          {
            "regionName": "东阿县",
            "pid": "174",
            "status": "active",
            "regionType": "县",
            "id": "1711"
          },
          {
            "regionName": "冠县",
            "pid": "174",
            "status": "active",
            "regionType": "县",
            "id": "1712"
          },
          {
            "regionName": "高唐县",
            "pid": "174",
            "status": "active",
            "regionType": "县",
            "id": "1713"
          },
          {
            "regionName": "临清市",
            "pid": "174",
            "status": "active",
            "regionType": "县",
            "id": "1714"
          }
        ],
        "id": "174"
      }
    ],
    "regionName": "山东省",
    "pid": "0",
    "status": "active",
    "regionType": "省",
    "id": "15"
  },
  {
    "city": [
      {
        "regionName": "商丘市",
        "pid": "16",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "梁园区",
            "pid": "175",
            "status": "active",
            "regionType": "县",
            "id": "1715"
          },
          {
            "regionName": "睢阳区",
            "pid": "175",
            "status": "active",
            "regionType": "县",
            "id": "1716"
          },
          {
            "regionName": "民权县",
            "pid": "175",
            "status": "active",
            "regionType": "县",
            "id": "1717"
          },
          {
            "regionName": "睢县",
            "pid": "175",
            "status": "active",
            "regionType": "县",
            "id": "1718"
          },
          {
            "regionName": "宁陵县",
            "pid": "175",
            "status": "active",
            "regionType": "县",
            "id": "1719"
          },
          {
            "regionName": "柘城县",
            "pid": "175",
            "status": "active",
            "regionType": "县",
            "id": "1720"
          },
          {
            "regionName": "虞城县",
            "pid": "175",
            "status": "active",
            "regionType": "县",
            "id": "1721"
          },
          {
            "regionName": "夏邑县",
            "pid": "175",
            "status": "active",
            "regionType": "县",
            "id": "1722"
          },
          {
            "regionName": "永城市",
            "pid": "175",
            "status": "active",
            "regionType": "县",
            "id": "1723"
          }
        ],
        "id": "175"
      },
      {
        "regionName": "郑州市",
        "pid": "16",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "中原区",
            "pid": "176",
            "status": "active",
            "regionType": "县",
            "id": "1724"
          },
          {
            "regionName": "二七区",
            "pid": "176",
            "status": "active",
            "regionType": "县",
            "id": "1725"
          },
          {
            "regionName": "管城回族区",
            "pid": "176",
            "status": "active",
            "regionType": "县",
            "id": "1726"
          },
          {
            "regionName": "金水区",
            "pid": "176",
            "status": "active",
            "regionType": "县",
            "id": "1727"
          },
          {
            "regionName": "上街区",
            "pid": "176",
            "status": "active",
            "regionType": "县",
            "id": "1728"
          },
          {
            "regionName": "惠济区",
            "pid": "176",
            "status": "active",
            "regionType": "县",
            "id": "1729"
          },
          {
            "regionName": "中牟县",
            "pid": "176",
            "status": "active",
            "regionType": "县",
            "id": "1730"
          },
          {
            "regionName": "巩义市",
            "pid": "176",
            "status": "active",
            "regionType": "县",
            "id": "1731"
          },
          {
            "regionName": "荥阳市",
            "pid": "176",
            "status": "active",
            "regionType": "县",
            "id": "1732"
          },
          {
            "regionName": "新密市",
            "pid": "176",
            "status": "active",
            "regionType": "县",
            "id": "1733"
          },
          {
            "regionName": "新郑市",
            "pid": "176",
            "status": "active",
            "regionType": "县",
            "id": "1734"
          },
          {
            "regionName": "登封市",
            "pid": "176",
            "status": "active",
            "regionType": "县",
            "id": "1735"
          },
          {
            "regionName": "邙山区",
            "pid": "176",
            "status": "active",
            "regionType": "县",
            "id": "3718"
          },
          {
            "regionName": "管城区",
            "pid": "176",
            "status": "active",
            "regionType": "县",
            "id": "3719"
          },
          {
            "regionName": "郑东新区",
            "pid": "176",
            "status": "active",
            "regionType": "县",
            "id": "3720"
          },
          {
            "regionName": "经济技术开发区",
            "pid": "176",
            "status": "active",
            "regionType": "县",
            "id": "3721"
          },
          {
            "regionName": "高新开发区",
            "pid": "176",
            "status": "active",
            "regionType": "县",
            "id": "3722"
          },
          {
            "regionName": "出口加工区",
            "pid": "176",
            "status": "active",
            "regionType": "县",
            "id": "3723"
          }
        ],
        "id": "176"
      },
      {
        "regionName": "安阳市",
        "pid": "16",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "文峰区",
            "pid": "177",
            "status": "active",
            "regionType": "县",
            "id": "1736"
          },
          {
            "regionName": "北关区",
            "pid": "177",
            "status": "active",
            "regionType": "县",
            "id": "1737"
          },
          {
            "regionName": "殷都区",
            "pid": "177",
            "status": "active",
            "regionType": "县",
            "id": "1738"
          },
          {
            "regionName": "龙安区",
            "pid": "177",
            "status": "active",
            "regionType": "县",
            "id": "1739"
          },
          {
            "regionName": "安阳县",
            "pid": "177",
            "status": "active",
            "regionType": "县",
            "id": "1740"
          },
          {
            "regionName": "汤阴县",
            "pid": "177",
            "status": "active",
            "regionType": "县",
            "id": "1741"
          },
          {
            "regionName": "滑县",
            "pid": "177",
            "status": "active",
            "regionType": "县",
            "id": "1742"
          },
          {
            "regionName": "内黄县",
            "pid": "177",
            "status": "active",
            "regionType": "县",
            "id": "1743"
          },
          {
            "regionName": "林州市",
            "pid": "177",
            "status": "active",
            "regionType": "县",
            "id": "1744"
          }
        ],
        "id": "177"
      },
      {
        "regionName": "新乡市",
        "pid": "16",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "红旗区",
            "pid": "178",
            "status": "active",
            "regionType": "县",
            "id": "1745"
          },
          {
            "regionName": "卫滨区",
            "pid": "178",
            "status": "active",
            "regionType": "县",
            "id": "1746"
          },
          {
            "regionName": "凤泉区",
            "pid": "178",
            "status": "active",
            "regionType": "县",
            "id": "1747"
          },
          {
            "regionName": "牧野区",
            "pid": "178",
            "status": "active",
            "regionType": "县",
            "id": "1748"
          },
          {
            "regionName": "新乡县",
            "pid": "178",
            "status": "active",
            "regionType": "县",
            "id": "1749"
          },
          {
            "regionName": "获嘉县",
            "pid": "178",
            "status": "active",
            "regionType": "县",
            "id": "1750"
          },
          {
            "regionName": "原阳县",
            "pid": "178",
            "status": "active",
            "regionType": "县",
            "id": "1751"
          },
          {
            "regionName": "延津县",
            "pid": "178",
            "status": "active",
            "regionType": "县",
            "id": "1752"
          },
          {
            "regionName": "封丘县",
            "pid": "178",
            "status": "active",
            "regionType": "县",
            "id": "1753"
          },
          {
            "regionName": "长垣县",
            "pid": "178",
            "status": "active",
            "regionType": "县",
            "id": "1754"
          },
          {
            "regionName": "卫辉市",
            "pid": "178",
            "status": "active",
            "regionType": "县",
            "id": "1755"
          },
          {
            "regionName": "辉县市",
            "pid": "178",
            "status": "active",
            "regionType": "县",
            "id": "1756"
          }
        ],
        "id": "178"
      },
      {
        "regionName": "许昌市",
        "pid": "16",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "魏都区",
            "pid": "179",
            "status": "active",
            "regionType": "县",
            "id": "1757"
          },
          {
            "regionName": "许昌县",
            "pid": "179",
            "status": "active",
            "regionType": "县",
            "id": "1758"
          },
          {
            "regionName": "鄢陵县",
            "pid": "179",
            "status": "active",
            "regionType": "县",
            "id": "1759"
          },
          {
            "regionName": "襄城县",
            "pid": "179",
            "status": "active",
            "regionType": "县",
            "id": "1760"
          },
          {
            "regionName": "禹州市",
            "pid": "179",
            "status": "active",
            "regionType": "县",
            "id": "1761"
          },
          {
            "regionName": "长葛市",
            "pid": "179",
            "status": "active",
            "regionType": "县",
            "id": "1762"
          }
        ],
        "id": "179"
      },
      {
        "regionName": "平顶山市",
        "pid": "16",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "新华区",
            "pid": "180",
            "status": "active",
            "regionType": "县",
            "id": "1763"
          },
          {
            "regionName": "卫东区",
            "pid": "180",
            "status": "active",
            "regionType": "县",
            "id": "1764"
          },
          {
            "regionName": "石龙区",
            "pid": "180",
            "status": "active",
            "regionType": "县",
            "id": "1765"
          },
          {
            "regionName": "湛河区",
            "pid": "180",
            "status": "active",
            "regionType": "县",
            "id": "1766"
          },
          {
            "regionName": "宝丰县",
            "pid": "180",
            "status": "active",
            "regionType": "县",
            "id": "1767"
          },
          {
            "regionName": "叶县",
            "pid": "180",
            "status": "active",
            "regionType": "县",
            "id": "1768"
          },
          {
            "regionName": "鲁山县",
            "pid": "180",
            "status": "active",
            "regionType": "县",
            "id": "1769"
          },
          {
            "regionName": "郏县",
            "pid": "180",
            "status": "active",
            "regionType": "县",
            "id": "1770"
          },
          {
            "regionName": "舞钢市",
            "pid": "180",
            "status": "active",
            "regionType": "县",
            "id": "1771"
          },
          {
            "regionName": "汝州市",
            "pid": "180",
            "status": "active",
            "regionType": "县",
            "id": "1772"
          }
        ],
        "id": "180"
      },
      {
        "regionName": "信阳市",
        "pid": "16",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "浉河区",
            "pid": "181",
            "status": "active",
            "regionType": "县",
            "id": "1773"
          },
          {
            "regionName": "平桥区",
            "pid": "181",
            "status": "active",
            "regionType": "县",
            "id": "1774"
          },
          {
            "regionName": "罗山县",
            "pid": "181",
            "status": "active",
            "regionType": "县",
            "id": "1775"
          },
          {
            "regionName": "光山县",
            "pid": "181",
            "status": "active",
            "regionType": "县",
            "id": "1776"
          },
          {
            "regionName": "新县",
            "pid": "181",
            "status": "active",
            "regionType": "县",
            "id": "1777"
          },
          {
            "regionName": "商城县",
            "pid": "181",
            "status": "active",
            "regionType": "县",
            "id": "1778"
          },
          {
            "regionName": "固始县",
            "pid": "181",
            "status": "active",
            "regionType": "县",
            "id": "1779"
          },
          {
            "regionName": "潢川县",
            "pid": "181",
            "status": "active",
            "regionType": "县",
            "id": "1780"
          },
          {
            "regionName": "淮滨县",
            "pid": "181",
            "status": "active",
            "regionType": "县",
            "id": "1781"
          },
          {
            "regionName": "息县",
            "pid": "181",
            "status": "active",
            "regionType": "县",
            "id": "1782"
          }
        ],
        "id": "181"
      },
      {
        "regionName": "南阳市",
        "pid": "16",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "宛城区",
            "pid": "182",
            "status": "active",
            "regionType": "县",
            "id": "1783"
          },
          {
            "regionName": "卧龙区",
            "pid": "182",
            "status": "active",
            "regionType": "县",
            "id": "1784"
          },
          {
            "regionName": "南召县",
            "pid": "182",
            "status": "active",
            "regionType": "县",
            "id": "1785"
          },
          {
            "regionName": "方城县",
            "pid": "182",
            "status": "active",
            "regionType": "县",
            "id": "1786"
          },
          {
            "regionName": "西峡县",
            "pid": "182",
            "status": "active",
            "regionType": "县",
            "id": "1787"
          },
          {
            "regionName": "镇平县",
            "pid": "182",
            "status": "active",
            "regionType": "县",
            "id": "1788"
          },
          {
            "regionName": "内乡县",
            "pid": "182",
            "status": "active",
            "regionType": "县",
            "id": "1789"
          },
          {
            "regionName": "淅川县",
            "pid": "182",
            "status": "active",
            "regionType": "县",
            "id": "1790"
          },
          {
            "regionName": "社旗县",
            "pid": "182",
            "status": "active",
            "regionType": "县",
            "id": "1791"
          },
          {
            "regionName": "唐河县",
            "pid": "182",
            "status": "active",
            "regionType": "县",
            "id": "1792"
          },
          {
            "regionName": "新野县",
            "pid": "182",
            "status": "active",
            "regionType": "县",
            "id": "1793"
          },
          {
            "regionName": "桐柏县",
            "pid": "182",
            "status": "active",
            "regionType": "县",
            "id": "1794"
          },
          {
            "regionName": "邓州市",
            "pid": "182",
            "status": "active",
            "regionType": "县",
            "id": "1795"
          }
        ],
        "id": "182"
      },
      {
        "regionName": "开封市",
        "pid": "16",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "龙亭区",
            "pid": "183",
            "status": "active",
            "regionType": "县",
            "id": "1796"
          },
          {
            "regionName": "顺河回族区",
            "pid": "183",
            "status": "active",
            "regionType": "县",
            "id": "1797"
          },
          {
            "regionName": "鼓楼区",
            "pid": "183",
            "status": "active",
            "regionType": "县",
            "id": "1798"
          },
          {
            "regionName": "禹王台区",
            "pid": "183",
            "status": "active",
            "regionType": "县",
            "id": "1799"
          },
          {
            "regionName": "金明区",
            "pid": "183",
            "status": "active",
            "regionType": "县",
            "id": "1800"
          },
          {
            "regionName": "杞县",
            "pid": "183",
            "status": "active",
            "regionType": "县",
            "id": "1801"
          },
          {
            "regionName": "通许县",
            "pid": "183",
            "status": "active",
            "regionType": "县",
            "id": "1802"
          },
          {
            "regionName": "尉氏县",
            "pid": "183",
            "status": "active",
            "regionType": "县",
            "id": "1803"
          },
          {
            "regionName": "开封县",
            "pid": "183",
            "status": "active",
            "regionType": "县",
            "id": "1804"
          },
          {
            "regionName": "兰考县",
            "pid": "183",
            "status": "active",
            "regionType": "县",
            "id": "1805"
          }
        ],
        "id": "183"
      },
      {
        "regionName": "洛阳市",
        "pid": "16",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "老城区",
            "pid": "184",
            "status": "active",
            "regionType": "县",
            "id": "1806"
          },
          {
            "regionName": "西工区",
            "pid": "184",
            "status": "active",
            "regionType": "县",
            "id": "1807"
          },
          {
            "regionName": "瀍河回族区",
            "pid": "184",
            "status": "active",
            "regionType": "县",
            "id": "1808"
          },
          {
            "regionName": "涧西区",
            "pid": "184",
            "status": "active",
            "regionType": "县",
            "id": "1809"
          },
          {
            "regionName": "吉利区",
            "pid": "184",
            "status": "active",
            "regionType": "县",
            "id": "1810"
          },
          {
            "regionName": "洛龙区",
            "pid": "184",
            "status": "active",
            "regionType": "县",
            "id": "1811"
          },
          {
            "regionName": "孟津县",
            "pid": "184",
            "status": "active",
            "regionType": "县",
            "id": "1812"
          },
          {
            "regionName": "新安县",
            "pid": "184",
            "status": "active",
            "regionType": "县",
            "id": "1813"
          },
          {
            "regionName": "栾川县",
            "pid": "184",
            "status": "active",
            "regionType": "县",
            "id": "1814"
          },
          {
            "regionName": "嵩县",
            "pid": "184",
            "status": "active",
            "regionType": "县",
            "id": "1815"
          },
          {
            "regionName": "汝阳县",
            "pid": "184",
            "status": "active",
            "regionType": "县",
            "id": "1816"
          },
          {
            "regionName": "宜阳县",
            "pid": "184",
            "status": "active",
            "regionType": "县",
            "id": "1817"
          },
          {
            "regionName": "洛宁县",
            "pid": "184",
            "status": "active",
            "regionType": "县",
            "id": "1818"
          },
          {
            "regionName": "伊川县",
            "pid": "184",
            "status": "active",
            "regionType": "县",
            "id": "1819"
          },
          {
            "regionName": "偃师市",
            "pid": "184",
            "status": "active",
            "regionType": "县",
            "id": "1820"
          }
        ],
        "id": "184"
      },
      {
        "regionName": "济源市",
        "pid": "16",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "济源市",
            "pid": "185",
            "status": "active",
            "regionType": "县",
            "id": "3724"
          }
        ],
        "id": "185"
      },
      {
        "regionName": "焦作市",
        "pid": "16",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "解放区",
            "pid": "186",
            "status": "active",
            "regionType": "县",
            "id": "1821"
          },
          {
            "regionName": "中站区",
            "pid": "186",
            "status": "active",
            "regionType": "县",
            "id": "1822"
          },
          {
            "regionName": "马村区",
            "pid": "186",
            "status": "active",
            "regionType": "县",
            "id": "1823"
          },
          {
            "regionName": "山阳区",
            "pid": "186",
            "status": "active",
            "regionType": "县",
            "id": "1824"
          },
          {
            "regionName": "修武县",
            "pid": "186",
            "status": "active",
            "regionType": "县",
            "id": "1825"
          },
          {
            "regionName": "博爱县",
            "pid": "186",
            "status": "active",
            "regionType": "县",
            "id": "1826"
          },
          {
            "regionName": "武陟县",
            "pid": "186",
            "status": "active",
            "regionType": "县",
            "id": "1827"
          },
          {
            "regionName": "温县",
            "pid": "186",
            "status": "active",
            "regionType": "县",
            "id": "1828"
          },
          {
            "regionName": "沁阳市",
            "pid": "186",
            "status": "active",
            "regionType": "县",
            "id": "1829"
          },
          {
            "regionName": "孟州市",
            "pid": "186",
            "status": "active",
            "regionType": "县",
            "id": "1830"
          }
        ],
        "id": "186"
      },
      {
        "regionName": "鹤壁市",
        "pid": "16",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "鹤山区",
            "pid": "187",
            "status": "active",
            "regionType": "县",
            "id": "1831"
          },
          {
            "regionName": "山城区",
            "pid": "187",
            "status": "active",
            "regionType": "县",
            "id": "1832"
          },
          {
            "regionName": "淇滨区",
            "pid": "187",
            "status": "active",
            "regionType": "县",
            "id": "1833"
          },
          {
            "regionName": "浚县",
            "pid": "187",
            "status": "active",
            "regionType": "县",
            "id": "1834"
          },
          {
            "regionName": "淇县",
            "pid": "187",
            "status": "active",
            "regionType": "县",
            "id": "1835"
          }
        ],
        "id": "187"
      },
      {
        "regionName": "濮阳市",
        "pid": "16",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "华龙区",
            "pid": "188",
            "status": "active",
            "regionType": "县",
            "id": "1836"
          },
          {
            "regionName": "清丰县",
            "pid": "188",
            "status": "active",
            "regionType": "县",
            "id": "1837"
          },
          {
            "regionName": "南乐县",
            "pid": "188",
            "status": "active",
            "regionType": "县",
            "id": "1838"
          },
          {
            "regionName": "范县",
            "pid": "188",
            "status": "active",
            "regionType": "县",
            "id": "1839"
          },
          {
            "regionName": "台前县",
            "pid": "188",
            "status": "active",
            "regionType": "县",
            "id": "1840"
          },
          {
            "regionName": "濮阳县",
            "pid": "188",
            "status": "active",
            "regionType": "县",
            "id": "1841"
          }
        ],
        "id": "188"
      },
      {
        "regionName": "周口市",
        "pid": "16",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "川汇区",
            "pid": "189",
            "status": "active",
            "regionType": "县",
            "id": "1842"
          },
          {
            "regionName": "扶沟县",
            "pid": "189",
            "status": "active",
            "regionType": "县",
            "id": "1843"
          },
          {
            "regionName": "西华县",
            "pid": "189",
            "status": "active",
            "regionType": "县",
            "id": "1844"
          },
          {
            "regionName": "商水县",
            "pid": "189",
            "status": "active",
            "regionType": "县",
            "id": "1845"
          },
          {
            "regionName": "沈丘县",
            "pid": "189",
            "status": "active",
            "regionType": "县",
            "id": "1846"
          },
          {
            "regionName": "郸城县",
            "pid": "189",
            "status": "active",
            "regionType": "县",
            "id": "1847"
          },
          {
            "regionName": "淮阳县",
            "pid": "189",
            "status": "active",
            "regionType": "县",
            "id": "1848"
          },
          {
            "regionName": "太康县",
            "pid": "189",
            "status": "active",
            "regionType": "县",
            "id": "1849"
          },
          {
            "regionName": "鹿邑县",
            "pid": "189",
            "status": "active",
            "regionType": "县",
            "id": "1850"
          },
          {
            "regionName": "项城市",
            "pid": "189",
            "status": "active",
            "regionType": "县",
            "id": "1851"
          }
        ],
        "id": "189"
      },
      {
        "regionName": "漯河市",
        "pid": "16",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "源汇区",
            "pid": "190",
            "status": "active",
            "regionType": "县",
            "id": "1852"
          },
          {
            "regionName": "郾城区",
            "pid": "190",
            "status": "active",
            "regionType": "县",
            "id": "1853"
          },
          {
            "regionName": "召陵区",
            "pid": "190",
            "status": "active",
            "regionType": "县",
            "id": "1854"
          },
          {
            "regionName": "舞阳县",
            "pid": "190",
            "status": "active",
            "regionType": "县",
            "id": "1855"
          },
          {
            "regionName": "临颍县",
            "pid": "190",
            "status": "active",
            "regionType": "县",
            "id": "1856"
          }
        ],
        "id": "190"
      },
      {
        "regionName": "驻马店市",
        "pid": "16",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "驿城区",
            "pid": "191",
            "status": "active",
            "regionType": "县",
            "id": "1857"
          },
          {
            "regionName": "西平县",
            "pid": "191",
            "status": "active",
            "regionType": "县",
            "id": "1858"
          },
          {
            "regionName": "上蔡县",
            "pid": "191",
            "status": "active",
            "regionType": "县",
            "id": "1859"
          },
          {
            "regionName": "平舆县",
            "pid": "191",
            "status": "active",
            "regionType": "县",
            "id": "1860"
          },
          {
            "regionName": "正阳县",
            "pid": "191",
            "status": "active",
            "regionType": "县",
            "id": "1861"
          },
          {
            "regionName": "确山县",
            "pid": "191",
            "status": "active",
            "regionType": "县",
            "id": "1862"
          },
          {
            "regionName": "泌阳县",
            "pid": "191",
            "status": "active",
            "regionType": "县",
            "id": "1863"
          },
          {
            "regionName": "汝南县",
            "pid": "191",
            "status": "active",
            "regionType": "县",
            "id": "1864"
          },
          {
            "regionName": "遂平县",
            "pid": "191",
            "status": "active",
            "regionType": "县",
            "id": "1865"
          },
          {
            "regionName": "新蔡县",
            "pid": "191",
            "status": "active",
            "regionType": "县",
            "id": "1866"
          }
        ],
        "id": "191"
      },
      {
        "regionName": "三门峡市",
        "pid": "16",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "湖滨区",
            "pid": "192",
            "status": "active",
            "regionType": "县",
            "id": "1867"
          },
          {
            "regionName": "渑池县",
            "pid": "192",
            "status": "active",
            "regionType": "县",
            "id": "1868"
          },
          {
            "regionName": "陕县",
            "pid": "192",
            "status": "active",
            "regionType": "县",
            "id": "1869"
          },
          {
            "regionName": "卢氏县",
            "pid": "192",
            "status": "active",
            "regionType": "县",
            "id": "1870"
          },
          {
            "regionName": "义马市",
            "pid": "192",
            "status": "active",
            "regionType": "县",
            "id": "1871"
          },
          {
            "regionName": "灵宝市",
            "pid": "192",
            "status": "active",
            "regionType": "县",
            "id": "1872"
          }
        ],
        "id": "192"
      }
    ],
    "regionName": "河南省",
    "pid": "0",
    "status": "active",
    "regionType": "省",
    "id": "16"
  },
  {
    "city": [
      {
        "regionName": "武汉市",
        "pid": "17",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "江岸区",
            "pid": "193",
            "status": "active",
            "regionType": "县",
            "id": "1873"
          },
          {
            "regionName": "江汉区",
            "pid": "193",
            "status": "active",
            "regionType": "县",
            "id": "1874"
          },
          {
            "regionName": "硚口区",
            "pid": "193",
            "status": "active",
            "regionType": "县",
            "id": "1875"
          },
          {
            "regionName": "汉阳区",
            "pid": "193",
            "status": "active",
            "regionType": "县",
            "id": "1876"
          },
          {
            "regionName": "武昌区",
            "pid": "193",
            "status": "active",
            "regionType": "县",
            "id": "1877"
          },
          {
            "regionName": "青山区",
            "pid": "193",
            "status": "active",
            "regionType": "县",
            "id": "1878"
          },
          {
            "regionName": "洪山区",
            "pid": "193",
            "status": "active",
            "regionType": "县",
            "id": "1879"
          },
          {
            "regionName": "东西湖区",
            "pid": "193",
            "status": "active",
            "regionType": "县",
            "id": "1880"
          },
          {
            "regionName": "汉南区",
            "pid": "193",
            "status": "active",
            "regionType": "县",
            "id": "1881"
          },
          {
            "regionName": "蔡甸区",
            "pid": "193",
            "status": "active",
            "regionType": "县",
            "id": "1882"
          },
          {
            "regionName": "江夏区",
            "pid": "193",
            "status": "active",
            "regionType": "县",
            "id": "1883"
          },
          {
            "regionName": "黄陂区",
            "pid": "193",
            "status": "active",
            "regionType": "县",
            "id": "1884"
          },
          {
            "regionName": "新洲区",
            "pid": "193",
            "status": "active",
            "regionType": "县",
            "id": "1885"
          },
          {
            "regionName": "经济开发区",
            "pid": "193",
            "status": "active",
            "regionType": "县",
            "id": "3728"
          }
        ],
        "id": "193"
      },
      {
        "regionName": "襄阳市",
        "pid": "17",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "襄城区",
            "pid": "194",
            "status": "active",
            "regionType": "县",
            "id": "1886"
          },
          {
            "regionName": "樊城区",
            "pid": "194",
            "status": "active",
            "regionType": "县",
            "id": "1887"
          },
          {
            "regionName": "襄阳区",
            "pid": "194",
            "status": "active",
            "regionType": "县",
            "id": "1888"
          },
          {
            "regionName": "南漳县",
            "pid": "194",
            "status": "active",
            "regionType": "县",
            "id": "1889"
          },
          {
            "regionName": "谷城县",
            "pid": "194",
            "status": "active",
            "regionType": "县",
            "id": "1890"
          },
          {
            "regionName": "保康县",
            "pid": "194",
            "status": "active",
            "regionType": "县",
            "id": "1891"
          },
          {
            "regionName": "老河口市",
            "pid": "194",
            "status": "active",
            "regionType": "县",
            "id": "1892"
          },
          {
            "regionName": "枣阳市",
            "pid": "194",
            "status": "active",
            "regionType": "县",
            "id": "1893"
          },
          {
            "regionName": "宜城市",
            "pid": "194",
            "status": "active",
            "regionType": "县",
            "id": "1894"
          }
        ],
        "id": "194"
      },
      {
        "regionName": "鄂州市",
        "pid": "17",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "梁子湖区",
            "pid": "195",
            "status": "active",
            "regionType": "县",
            "id": "1895"
          },
          {
            "regionName": "华容区",
            "pid": "195",
            "status": "active",
            "regionType": "县",
            "id": "1896"
          },
          {
            "regionName": "鄂城区",
            "pid": "195",
            "status": "active",
            "regionType": "县",
            "id": "1897"
          }
        ],
        "id": "195"
      },
      {
        "regionName": "孝感市",
        "pid": "17",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "孝南区",
            "pid": "196",
            "status": "active",
            "regionType": "县",
            "id": "1898"
          },
          {
            "regionName": "孝昌县",
            "pid": "196",
            "status": "active",
            "regionType": "县",
            "id": "1899"
          },
          {
            "regionName": "大悟县",
            "pid": "196",
            "status": "active",
            "regionType": "县",
            "id": "1900"
          },
          {
            "regionName": "云梦县",
            "pid": "196",
            "status": "active",
            "regionType": "县",
            "id": "1901"
          },
          {
            "regionName": "应城市",
            "pid": "196",
            "status": "active",
            "regionType": "县",
            "id": "1902"
          },
          {
            "regionName": "安陆市",
            "pid": "196",
            "status": "active",
            "regionType": "县",
            "id": "1903"
          },
          {
            "regionName": "汉川市",
            "pid": "196",
            "status": "active",
            "regionType": "县",
            "id": "1904"
          }
        ],
        "id": "196"
      },
      {
        "regionName": "黄冈市",
        "pid": "17",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "黄州区",
            "pid": "197",
            "status": "active",
            "regionType": "县",
            "id": "1905"
          },
          {
            "regionName": "团风县",
            "pid": "197",
            "status": "active",
            "regionType": "县",
            "id": "1906"
          },
          {
            "regionName": "红安县",
            "pid": "197",
            "status": "active",
            "regionType": "县",
            "id": "1907"
          },
          {
            "regionName": "罗田县",
            "pid": "197",
            "status": "active",
            "regionType": "县",
            "id": "1908"
          },
          {
            "regionName": "英山县",
            "pid": "197",
            "status": "active",
            "regionType": "县",
            "id": "1909"
          },
          {
            "regionName": "浠水县",
            "pid": "197",
            "status": "active",
            "regionType": "县",
            "id": "1910"
          },
          {
            "regionName": "蕲春县",
            "pid": "197",
            "status": "active",
            "regionType": "县",
            "id": "1911"
          },
          {
            "regionName": "黄梅县",
            "pid": "197",
            "status": "active",
            "regionType": "县",
            "id": "1912"
          },
          {
            "regionName": "麻城市",
            "pid": "197",
            "status": "active",
            "regionType": "县",
            "id": "1913"
          },
          {
            "regionName": "武穴市",
            "pid": "197",
            "status": "active",
            "regionType": "县",
            "id": "1914"
          }
        ],
        "id": "197"
      },
      {
        "regionName": "黄石市",
        "pid": "17",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "黄石港区",
            "pid": "198",
            "status": "active",
            "regionType": "县",
            "id": "1915"
          },
          {
            "regionName": "西塞山区",
            "pid": "198",
            "status": "active",
            "regionType": "县",
            "id": "1916"
          },
          {
            "regionName": "下陆区",
            "pid": "198",
            "status": "active",
            "regionType": "县",
            "id": "1917"
          },
          {
            "regionName": "铁山区",
            "pid": "198",
            "status": "active",
            "regionType": "县",
            "id": "1918"
          },
          {
            "regionName": "阳新县",
            "pid": "198",
            "status": "active",
            "regionType": "县",
            "id": "1919"
          },
          {
            "regionName": "大冶市",
            "pid": "198",
            "status": "active",
            "regionType": "县",
            "id": "1920"
          }
        ],
        "id": "198"
      },
      {
        "regionName": "咸宁市",
        "pid": "17",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "咸安区",
            "pid": "199",
            "status": "active",
            "regionType": "县",
            "id": "1921"
          },
          {
            "regionName": "嘉鱼县",
            "pid": "199",
            "status": "active",
            "regionType": "县",
            "id": "1922"
          },
          {
            "regionName": "通城县",
            "pid": "199",
            "status": "active",
            "regionType": "县",
            "id": "1923"
          },
          {
            "regionName": "崇阳县",
            "pid": "199",
            "status": "active",
            "regionType": "县",
            "id": "1924"
          },
          {
            "regionName": "通山县",
            "pid": "199",
            "status": "active",
            "regionType": "县",
            "id": "1925"
          },
          {
            "regionName": "赤壁市",
            "pid": "199",
            "status": "active",
            "regionType": "县",
            "id": "1926"
          }
        ],
        "id": "199"
      },
      {
        "regionName": "荆州市",
        "pid": "17",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "沙市区",
            "pid": "200",
            "status": "active",
            "regionType": "县",
            "id": "1927"
          },
          {
            "regionName": "荆州区",
            "pid": "200",
            "status": "active",
            "regionType": "县",
            "id": "1928"
          },
          {
            "regionName": "公安县",
            "pid": "200",
            "status": "active",
            "regionType": "县",
            "id": "1929"
          },
          {
            "regionName": "监利县",
            "pid": "200",
            "status": "active",
            "regionType": "县",
            "id": "1930"
          },
          {
            "regionName": "江陵县",
            "pid": "200",
            "status": "active",
            "regionType": "县",
            "id": "1931"
          },
          {
            "regionName": "石首市",
            "pid": "200",
            "status": "active",
            "regionType": "县",
            "id": "1932"
          },
          {
            "regionName": "洪湖市",
            "pid": "200",
            "status": "active",
            "regionType": "县",
            "id": "1933"
          },
          {
            "regionName": "松滋市",
            "pid": "200",
            "status": "active",
            "regionType": "县",
            "id": "1934"
          }
        ],
        "id": "200"
      },
      {
        "regionName": "宜昌市",
        "pid": "17",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "西陵区",
            "pid": "201",
            "status": "active",
            "regionType": "县",
            "id": "1935"
          },
          {
            "regionName": "伍家岗区",
            "pid": "201",
            "status": "active",
            "regionType": "县",
            "id": "1936"
          },
          {
            "regionName": "点军区",
            "pid": "201",
            "status": "active",
            "regionType": "县",
            "id": "1937"
          },
          {
            "regionName": "猇亭区",
            "pid": "201",
            "status": "active",
            "regionType": "县",
            "id": "1938"
          },
          {
            "regionName": "夷陵区",
            "pid": "201",
            "status": "active",
            "regionType": "县",
            "id": "1939"
          },
          {
            "regionName": "远安县",
            "pid": "201",
            "status": "active",
            "regionType": "县",
            "id": "1940"
          },
          {
            "regionName": "兴山县",
            "pid": "201",
            "status": "active",
            "regionType": "县",
            "id": "1941"
          },
          {
            "regionName": "秭归县",
            "pid": "201",
            "status": "active",
            "regionType": "县",
            "id": "1942"
          },
          {
            "regionName": "长阳土家族自治县",
            "pid": "201",
            "status": "active",
            "regionType": "县",
            "id": "1943"
          },
          {
            "regionName": "五峰土家族自治县",
            "pid": "201",
            "status": "active",
            "regionType": "县",
            "id": "1944"
          },
          {
            "regionName": "宜都市",
            "pid": "201",
            "status": "active",
            "regionType": "县",
            "id": "1945"
          },
          {
            "regionName": "当阳市",
            "pid": "201",
            "status": "active",
            "regionType": "县",
            "id": "1946"
          },
          {
            "regionName": "枝江市",
            "pid": "201",
            "status": "active",
            "regionType": "县",
            "id": "1947"
          }
        ],
        "id": "201"
      },
      {
        "regionName": "恩施土家族苗族自治州",
        "pid": "17",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "恩施市",
            "pid": "202",
            "status": "active",
            "regionType": "县",
            "id": "1948"
          },
          {
            "regionName": "利川市",
            "pid": "202",
            "status": "active",
            "regionType": "县",
            "id": "1949"
          },
          {
            "regionName": "建始县",
            "pid": "202",
            "status": "active",
            "regionType": "县",
            "id": "1950"
          },
          {
            "regionName": "巴东县",
            "pid": "202",
            "status": "active",
            "regionType": "县",
            "id": "1951"
          },
          {
            "regionName": "宣恩县",
            "pid": "202",
            "status": "active",
            "regionType": "县",
            "id": "1952"
          },
          {
            "regionName": "咸丰县",
            "pid": "202",
            "status": "active",
            "regionType": "县",
            "id": "1953"
          },
          {
            "regionName": "来凤县",
            "pid": "202",
            "status": "active",
            "regionType": "县",
            "id": "1954"
          },
          {
            "regionName": "鹤峰县",
            "pid": "202",
            "status": "active",
            "regionType": "县",
            "id": "1955"
          }
        ],
        "id": "202"
      },
      {
        "regionName": "神农架林区",
        "pid": "17",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "神农架林区",
            "pid": "203",
            "status": "active",
            "regionType": "县",
            "id": "3731"
          }
        ],
        "id": "203"
      },
      {
        "regionName": "十堰市",
        "pid": "17",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "茅箭区",
            "pid": "204",
            "status": "active",
            "regionType": "县",
            "id": "1956"
          },
          {
            "regionName": "张湾区",
            "pid": "204",
            "status": "active",
            "regionType": "县",
            "id": "1957"
          },
          {
            "regionName": "郧县",
            "pid": "204",
            "status": "active",
            "regionType": "县",
            "id": "1958"
          },
          {
            "regionName": "郧西县",
            "pid": "204",
            "status": "active",
            "regionType": "县",
            "id": "1959"
          },
          {
            "regionName": "竹山县",
            "pid": "204",
            "status": "active",
            "regionType": "县",
            "id": "1960"
          },
          {
            "regionName": "竹溪县",
            "pid": "204",
            "status": "active",
            "regionType": "县",
            "id": "1961"
          },
          {
            "regionName": "房县",
            "pid": "204",
            "status": "active",
            "regionType": "县",
            "id": "1962"
          },
          {
            "regionName": "丹江口市",
            "pid": "204",
            "status": "active",
            "regionType": "县",
            "id": "1963"
          }
        ],
        "id": "204"
      },
      {
        "regionName": "随州市",
        "pid": "17",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "曾都区",
            "pid": "205",
            "status": "active",
            "regionType": "县",
            "id": "1964"
          },
          {
            "regionName": "广水市",
            "pid": "205",
            "status": "active",
            "regionType": "县",
            "id": "1965"
          }
        ],
        "id": "205"
      },
      {
        "regionName": "荆门市",
        "pid": "17",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "东宝区",
            "pid": "206",
            "status": "active",
            "regionType": "县",
            "id": "1966"
          },
          {
            "regionName": "掇刀区",
            "pid": "206",
            "status": "active",
            "regionType": "县",
            "id": "1967"
          },
          {
            "regionName": "京山县",
            "pid": "206",
            "status": "active",
            "regionType": "县",
            "id": "1968"
          },
          {
            "regionName": "沙洋县",
            "pid": "206",
            "status": "active",
            "regionType": "县",
            "id": "1969"
          },
          {
            "regionName": "钟祥市",
            "pid": "206",
            "status": "active",
            "regionType": "县",
            "id": "1970"
          }
        ],
        "id": "206"
      },
      {
        "regionName": "仙桃市",
        "pid": "17",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "仙桃市",
            "pid": "207",
            "status": "active",
            "regionType": "县",
            "id": "3729"
          }
        ],
        "id": "207"
      },
      {
        "regionName": "天门市",
        "pid": "17",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "天门市",
            "pid": "208",
            "status": "active",
            "regionType": "县",
            "id": "3732"
          }
        ],
        "id": "208"
      },
      {
        "regionName": "潜江市",
        "pid": "17",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "潜江市",
            "pid": "209",
            "status": "active",
            "regionType": "县",
            "id": "3730"
          }
        ],
        "id": "209"
      }
    ],
    "regionName": "湖北省",
    "pid": "0",
    "status": "active",
    "regionType": "省",
    "id": "17"
  },
  {
    "city": [
      {
        "regionName": "岳阳市",
        "pid": "18",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "岳阳楼区",
            "pid": "210",
            "status": "active",
            "regionType": "县",
            "id": "1971"
          },
          {
            "regionName": "云溪区",
            "pid": "210",
            "status": "active",
            "regionType": "县",
            "id": "1972"
          },
          {
            "regionName": "君山区",
            "pid": "210",
            "status": "active",
            "regionType": "县",
            "id": "1973"
          },
          {
            "regionName": "岳阳县",
            "pid": "210",
            "status": "active",
            "regionType": "县",
            "id": "1974"
          },
          {
            "regionName": "华容县",
            "pid": "210",
            "status": "active",
            "regionType": "县",
            "id": "1975"
          },
          {
            "regionName": "湘阴县",
            "pid": "210",
            "status": "active",
            "regionType": "县",
            "id": "1976"
          },
          {
            "regionName": "平江县",
            "pid": "210",
            "status": "active",
            "regionType": "县",
            "id": "1977"
          },
          {
            "regionName": "汨罗市",
            "pid": "210",
            "status": "active",
            "regionType": "县",
            "id": "1978"
          },
          {
            "regionName": "临湘市",
            "pid": "210",
            "status": "active",
            "regionType": "县",
            "id": "1979"
          }
        ],
        "id": "210"
      },
      {
        "regionName": "长沙市",
        "pid": "18",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "芙蓉区",
            "pid": "211",
            "status": "active",
            "regionType": "县",
            "id": "1980"
          },
          {
            "regionName": "天心区",
            "pid": "211",
            "status": "active",
            "regionType": "县",
            "id": "1981"
          },
          {
            "regionName": "岳麓区",
            "pid": "211",
            "status": "active",
            "regionType": "县",
            "id": "1982"
          },
          {
            "regionName": "开福区",
            "pid": "211",
            "status": "active",
            "regionType": "县",
            "id": "1983"
          },
          {
            "regionName": "雨花区",
            "pid": "211",
            "status": "active",
            "regionType": "县",
            "id": "1984"
          },
          {
            "regionName": "长沙县",
            "pid": "211",
            "status": "active",
            "regionType": "县",
            "id": "1985"
          },
          {
            "regionName": "望城县",
            "pid": "211",
            "status": "active",
            "regionType": "县",
            "id": "1986"
          },
          {
            "regionName": "宁乡县",
            "pid": "211",
            "status": "active",
            "regionType": "县",
            "id": "1987"
          },
          {
            "regionName": "浏阳市",
            "pid": "211",
            "status": "active",
            "regionType": "县",
            "id": "1988"
          },
          {
            "regionName": "开发区",
            "pid": "211",
            "status": "active",
            "regionType": "县",
            "id": "3733"
          }
        ],
        "id": "211"
      },
      {
        "regionName": "湘潭市",
        "pid": "18",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "雨湖区",
            "pid": "212",
            "status": "active",
            "regionType": "县",
            "id": "1989"
          },
          {
            "regionName": "岳塘区",
            "pid": "212",
            "status": "active",
            "regionType": "县",
            "id": "1990"
          },
          {
            "regionName": "湘潭县",
            "pid": "212",
            "status": "active",
            "regionType": "县",
            "id": "1991"
          },
          {
            "regionName": "湘乡市",
            "pid": "212",
            "status": "active",
            "regionType": "县",
            "id": "1992"
          },
          {
            "regionName": "韶山市",
            "pid": "212",
            "status": "active",
            "regionType": "县",
            "id": "1993"
          }
        ],
        "id": "212"
      },
      {
        "regionName": "株洲市",
        "pid": "18",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "荷塘区",
            "pid": "213",
            "status": "active",
            "regionType": "县",
            "id": "1994"
          },
          {
            "regionName": "芦淞区",
            "pid": "213",
            "status": "active",
            "regionType": "县",
            "id": "1995"
          },
          {
            "regionName": "石峰区",
            "pid": "213",
            "status": "active",
            "regionType": "县",
            "id": "1996"
          },
          {
            "regionName": "天元区",
            "pid": "213",
            "status": "active",
            "regionType": "县",
            "id": "1997"
          },
          {
            "regionName": "株洲县",
            "pid": "213",
            "status": "active",
            "regionType": "县",
            "id": "1998"
          },
          {
            "regionName": "攸县",
            "pid": "213",
            "status": "active",
            "regionType": "县",
            "id": "1999"
          },
          {
            "regionName": "茶陵县",
            "pid": "213",
            "status": "active",
            "regionType": "县",
            "id": "2000"
          },
          {
            "regionName": "炎陵县",
            "pid": "213",
            "status": "active",
            "regionType": "县",
            "id": "2001"
          },
          {
            "regionName": "醴陵市",
            "pid": "213",
            "status": "active",
            "regionType": "县",
            "id": "2002"
          }
        ],
        "id": "213"
      },
      {
        "regionName": "衡阳市",
        "pid": "18",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "珠晖区",
            "pid": "214",
            "status": "active",
            "regionType": "县",
            "id": "2003"
          },
          {
            "regionName": "雁峰区",
            "pid": "214",
            "status": "active",
            "regionType": "县",
            "id": "2004"
          },
          {
            "regionName": "石鼓区",
            "pid": "214",
            "status": "active",
            "regionType": "县",
            "id": "2005"
          },
          {
            "regionName": "蒸湘区",
            "pid": "214",
            "status": "active",
            "regionType": "县",
            "id": "2006"
          },
          {
            "regionName": "南岳区",
            "pid": "214",
            "status": "active",
            "regionType": "县",
            "id": "2007"
          },
          {
            "regionName": "衡阳县",
            "pid": "214",
            "status": "active",
            "regionType": "县",
            "id": "2008"
          },
          {
            "regionName": "衡南县",
            "pid": "214",
            "status": "active",
            "regionType": "县",
            "id": "2009"
          },
          {
            "regionName": "衡山县",
            "pid": "214",
            "status": "active",
            "regionType": "县",
            "id": "2010"
          },
          {
            "regionName": "衡东县",
            "pid": "214",
            "status": "active",
            "regionType": "县",
            "id": "2011"
          },
          {
            "regionName": "祁东县",
            "pid": "214",
            "status": "active",
            "regionType": "县",
            "id": "2012"
          },
          {
            "regionName": "耒阳市",
            "pid": "214",
            "status": "active",
            "regionType": "县",
            "id": "2013"
          },
          {
            "regionName": "常宁市",
            "pid": "214",
            "status": "active",
            "regionType": "县",
            "id": "2014"
          }
        ],
        "id": "214"
      },
      {
        "regionName": "郴州市",
        "pid": "18",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "北湖区",
            "pid": "215",
            "status": "active",
            "regionType": "县",
            "id": "2015"
          },
          {
            "regionName": "苏仙区",
            "pid": "215",
            "status": "active",
            "regionType": "县",
            "id": "2016"
          },
          {
            "regionName": "桂阳县",
            "pid": "215",
            "status": "active",
            "regionType": "县",
            "id": "2017"
          },
          {
            "regionName": "宜章县",
            "pid": "215",
            "status": "active",
            "regionType": "县",
            "id": "2018"
          },
          {
            "regionName": "永兴县",
            "pid": "215",
            "status": "active",
            "regionType": "县",
            "id": "2019"
          },
          {
            "regionName": "嘉禾县",
            "pid": "215",
            "status": "active",
            "regionType": "县",
            "id": "2020"
          },
          {
            "regionName": "临武县",
            "pid": "215",
            "status": "active",
            "regionType": "县",
            "id": "2021"
          },
          {
            "regionName": "汝城县",
            "pid": "215",
            "status": "active",
            "regionType": "县",
            "id": "2022"
          },
          {
            "regionName": "桂东县",
            "pid": "215",
            "status": "active",
            "regionType": "县",
            "id": "2023"
          },
          {
            "regionName": "安仁县",
            "pid": "215",
            "status": "active",
            "regionType": "县",
            "id": "2024"
          },
          {
            "regionName": "资兴市",
            "pid": "215",
            "status": "active",
            "regionType": "县",
            "id": "2025"
          }
        ],
        "id": "215"
      },
      {
        "regionName": "常德市",
        "pid": "18",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "武陵区",
            "pid": "216",
            "status": "active",
            "regionType": "县",
            "id": "2026"
          },
          {
            "regionName": "鼎城区",
            "pid": "216",
            "status": "active",
            "regionType": "县",
            "id": "2027"
          },
          {
            "regionName": "安乡县",
            "pid": "216",
            "status": "active",
            "regionType": "县",
            "id": "2028"
          },
          {
            "regionName": "汉寿县",
            "pid": "216",
            "status": "active",
            "regionType": "县",
            "id": "2029"
          },
          {
            "regionName": "澧县",
            "pid": "216",
            "status": "active",
            "regionType": "县",
            "id": "2030"
          },
          {
            "regionName": "临澧县",
            "pid": "216",
            "status": "active",
            "regionType": "县",
            "id": "2031"
          },
          {
            "regionName": "桃源县",
            "pid": "216",
            "status": "active",
            "regionType": "县",
            "id": "2032"
          },
          {
            "regionName": "石门县",
            "pid": "216",
            "status": "active",
            "regionType": "县",
            "id": "2033"
          },
          {
            "regionName": "津市市",
            "pid": "216",
            "status": "active",
            "regionType": "县",
            "id": "2034"
          }
        ],
        "id": "216"
      },
      {
        "regionName": "益阳市",
        "pid": "18",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "资阳区",
            "pid": "217",
            "status": "active",
            "regionType": "县",
            "id": "2035"
          },
          {
            "regionName": "赫山区",
            "pid": "217",
            "status": "active",
            "regionType": "县",
            "id": "2036"
          },
          {
            "regionName": "南县",
            "pid": "217",
            "status": "active",
            "regionType": "县",
            "id": "2037"
          },
          {
            "regionName": "桃江县",
            "pid": "217",
            "status": "active",
            "regionType": "县",
            "id": "2038"
          },
          {
            "regionName": "安化县",
            "pid": "217",
            "status": "active",
            "regionType": "县",
            "id": "2039"
          },
          {
            "regionName": "沅江市",
            "pid": "217",
            "status": "active",
            "regionType": "县",
            "id": "2040"
          }
        ],
        "id": "217"
      },
      {
        "regionName": "娄底市",
        "pid": "18",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "娄星区",
            "pid": "218",
            "status": "active",
            "regionType": "县",
            "id": "2041"
          },
          {
            "regionName": "双峰县",
            "pid": "218",
            "status": "active",
            "regionType": "县",
            "id": "2042"
          },
          {
            "regionName": "新化县",
            "pid": "218",
            "status": "active",
            "regionType": "县",
            "id": "2043"
          },
          {
            "regionName": "冷水江市",
            "pid": "218",
            "status": "active",
            "regionType": "县",
            "id": "2044"
          },
          {
            "regionName": "涟源市",
            "pid": "218",
            "status": "active",
            "regionType": "县",
            "id": "2045"
          }
        ],
        "id": "218"
      },
      {
        "regionName": "邵阳市",
        "pid": "18",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "双清区",
            "pid": "219",
            "status": "active",
            "regionType": "县",
            "id": "2046"
          },
          {
            "regionName": "大祥区",
            "pid": "219",
            "status": "active",
            "regionType": "县",
            "id": "2047"
          },
          {
            "regionName": "北塔区",
            "pid": "219",
            "status": "active",
            "regionType": "县",
            "id": "2048"
          },
          {
            "regionName": "邵东县",
            "pid": "219",
            "status": "active",
            "regionType": "县",
            "id": "2049"
          },
          {
            "regionName": "新邵县",
            "pid": "219",
            "status": "active",
            "regionType": "县",
            "id": "2050"
          },
          {
            "regionName": "邵阳县",
            "pid": "219",
            "status": "active",
            "regionType": "县",
            "id": "2051"
          },
          {
            "regionName": "隆回县",
            "pid": "219",
            "status": "active",
            "regionType": "县",
            "id": "2052"
          },
          {
            "regionName": "洞口县",
            "pid": "219",
            "status": "active",
            "regionType": "县",
            "id": "2053"
          },
          {
            "regionName": "绥宁县",
            "pid": "219",
            "status": "active",
            "regionType": "县",
            "id": "2054"
          },
          {
            "regionName": "新宁县",
            "pid": "219",
            "status": "active",
            "regionType": "县",
            "id": "2055"
          },
          {
            "regionName": "城步苗族自治县",
            "pid": "219",
            "status": "active",
            "regionType": "县",
            "id": "2056"
          },
          {
            "regionName": "武冈市",
            "pid": "219",
            "status": "active",
            "regionType": "县",
            "id": "2057"
          }
        ],
        "id": "219"
      },
      {
        "regionName": "湘西土家族苗族自治州",
        "pid": "18",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "吉首市",
            "pid": "220",
            "status": "active",
            "regionType": "县",
            "id": "2058"
          },
          {
            "regionName": "泸溪县",
            "pid": "220",
            "status": "active",
            "regionType": "县",
            "id": "2059"
          },
          {
            "regionName": "凤凰县",
            "pid": "220",
            "status": "active",
            "regionType": "县",
            "id": "2060"
          },
          {
            "regionName": "花垣县",
            "pid": "220",
            "status": "active",
            "regionType": "县",
            "id": "2061"
          },
          {
            "regionName": "保靖县",
            "pid": "220",
            "status": "active",
            "regionType": "县",
            "id": "2062"
          },
          {
            "regionName": "古丈县",
            "pid": "220",
            "status": "active",
            "regionType": "县",
            "id": "2063"
          },
          {
            "regionName": "永顺县",
            "pid": "220",
            "status": "active",
            "regionType": "县",
            "id": "2064"
          },
          {
            "regionName": "龙山县",
            "pid": "220",
            "status": "active",
            "regionType": "县",
            "id": "2065"
          }
        ],
        "id": "220"
      },
      {
        "regionName": "张家界市",
        "pid": "18",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "永定区",
            "pid": "221",
            "status": "active",
            "regionType": "县",
            "id": "2066"
          },
          {
            "regionName": "武陵源区",
            "pid": "221",
            "status": "active",
            "regionType": "县",
            "id": "2067"
          },
          {
            "regionName": "慈利县",
            "pid": "221",
            "status": "active",
            "regionType": "县",
            "id": "2068"
          },
          {
            "regionName": "桑植县",
            "pid": "221",
            "status": "active",
            "regionType": "县",
            "id": "2069"
          }
        ],
        "id": "221"
      },
      {
        "regionName": "怀化市",
        "pid": "18",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "鹤城区",
            "pid": "222",
            "status": "active",
            "regionType": "县",
            "id": "2070"
          },
          {
            "regionName": "中方县",
            "pid": "222",
            "status": "active",
            "regionType": "县",
            "id": "2071"
          },
          {
            "regionName": "沅陵县",
            "pid": "222",
            "status": "active",
            "regionType": "县",
            "id": "2072"
          },
          {
            "regionName": "辰溪县",
            "pid": "222",
            "status": "active",
            "regionType": "县",
            "id": "2073"
          },
          {
            "regionName": "溆浦县",
            "pid": "222",
            "status": "active",
            "regionType": "县",
            "id": "2074"
          },
          {
            "regionName": "会同县",
            "pid": "222",
            "status": "active",
            "regionType": "县",
            "id": "2075"
          },
          {
            "regionName": "麻阳苗族自治县",
            "pid": "222",
            "status": "active",
            "regionType": "县",
            "id": "2076"
          },
          {
            "regionName": "新晃侗族自治县",
            "pid": "222",
            "status": "active",
            "regionType": "县",
            "id": "2077"
          },
          {
            "regionName": "芷江侗族自治县",
            "pid": "222",
            "status": "active",
            "regionType": "县",
            "id": "2078"
          },
          {
            "regionName": "靖州苗族侗族自治县",
            "pid": "222",
            "status": "active",
            "regionType": "县",
            "id": "2079"
          },
          {
            "regionName": "通道侗族自治县",
            "pid": "222",
            "status": "active",
            "regionType": "县",
            "id": "2080"
          },
          {
            "regionName": "洪江市",
            "pid": "222",
            "status": "active",
            "regionType": "县",
            "id": "2081"
          }
        ],
        "id": "222"
      },
      {
        "regionName": "永州市",
        "pid": "18",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "零陵区",
            "pid": "223",
            "status": "active",
            "regionType": "县",
            "id": "2082"
          },
          {
            "regionName": "冷水滩区",
            "pid": "223",
            "status": "active",
            "regionType": "县",
            "id": "2083"
          },
          {
            "regionName": "祁阳县",
            "pid": "223",
            "status": "active",
            "regionType": "县",
            "id": "2084"
          },
          {
            "regionName": "东安县",
            "pid": "223",
            "status": "active",
            "regionType": "县",
            "id": "2085"
          },
          {
            "regionName": "双牌县",
            "pid": "223",
            "status": "active",
            "regionType": "县",
            "id": "2086"
          },
          {
            "regionName": "道县",
            "pid": "223",
            "status": "active",
            "regionType": "县",
            "id": "2087"
          },
          {
            "regionName": "江永县",
            "pid": "223",
            "status": "active",
            "regionType": "县",
            "id": "2088"
          },
          {
            "regionName": "宁远县",
            "pid": "223",
            "status": "active",
            "regionType": "县",
            "id": "2089"
          },
          {
            "regionName": "蓝山县",
            "pid": "223",
            "status": "active",
            "regionType": "县",
            "id": "2090"
          },
          {
            "regionName": "新田县",
            "pid": "223",
            "status": "active",
            "regionType": "县",
            "id": "2091"
          },
          {
            "regionName": "江华瑶族自治县",
            "pid": "223",
            "status": "active",
            "regionType": "县",
            "id": "2092"
          }
        ],
        "id": "223"
      }
    ],
    "regionName": "湖南省",
    "pid": "0",
    "status": "active",
    "regionType": "省",
    "id": "18"
  },
  {
    "city": [
      {
        "regionName": "广州市",
        "pid": "19",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "从化市",
            "pid": "224",
            "status": "active",
            "regionType": "县",
            "id": "2093"
          },
          {
            "regionName": "荔湾区",
            "pid": "224",
            "status": "active",
            "regionType": "县",
            "id": "2094"
          },
          {
            "regionName": "越秀区",
            "pid": "224",
            "status": "active",
            "regionType": "县",
            "id": "2095"
          },
          {
            "regionName": "海珠区",
            "pid": "224",
            "status": "active",
            "regionType": "县",
            "id": "2096"
          },
          {
            "regionName": "天河区",
            "pid": "224",
            "status": "active",
            "regionType": "县",
            "id": "2097"
          },
          {
            "regionName": "白云区",
            "pid": "224",
            "status": "active",
            "regionType": "县",
            "id": "2098"
          },
          {
            "regionName": "花都区",
            "pid": "224",
            "status": "active",
            "regionType": "县",
            "id": "2099"
          },
          {
            "regionName": "黄埔区",
            "pid": "224",
            "status": "active",
            "regionType": "县",
            "id": "2100"
          },
          {
            "regionName": "萝岗区",
            "pid": "224",
            "status": "active",
            "regionType": "县",
            "id": "2101"
          },
          {
            "regionName": "南沙区",
            "pid": "224",
            "status": "active",
            "regionType": "县",
            "id": "2102"
          },
          {
            "regionName": "番禺区",
            "pid": "224",
            "status": "active",
            "regionType": "县",
            "id": "2103"
          },
          {
            "regionName": "增城市",
            "pid": "224",
            "status": "active",
            "regionType": "县",
            "id": "2104"
          },
          {
            "regionName": "增城区",
            "pid": "224",
            "status": "active",
            "regionType": "县",
            "id": "3646"
          },
          {
            "regionName": "从化区",
            "pid": "224",
            "status": "active",
            "regionType": "县",
            "id": "3647"
          },
          {
            "regionName": "市郊",
            "pid": "224",
            "status": "active",
            "regionType": "县",
            "id": "3648"
          }
        ],
        "id": "224"
      },
      {
        "regionName": "汕尾市",
        "pid": "19",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "海丰县",
            "pid": "225",
            "status": "active",
            "regionType": "县",
            "id": "2105"
          },
          {
            "regionName": "陆河县",
            "pid": "225",
            "status": "active",
            "regionType": "县",
            "id": "2106"
          },
          {
            "regionName": "陆丰市",
            "pid": "225",
            "status": "active",
            "regionType": "县",
            "id": "2107"
          },
          {
            "regionName": "城区",
            "pid": "225",
            "status": "active",
            "regionType": "县",
            "id": "3681"
          }
        ],
        "id": "225"
      },
      {
        "regionName": "阳江市",
        "pid": "19",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "江城区",
            "pid": "226",
            "status": "active",
            "regionType": "县",
            "id": "2108"
          },
          {
            "regionName": "阳西县",
            "pid": "226",
            "status": "active",
            "regionType": "县",
            "id": "2109"
          },
          {
            "regionName": "阳东县",
            "pid": "226",
            "status": "active",
            "regionType": "县",
            "id": "2110"
          },
          {
            "regionName": "阳春市",
            "pid": "226",
            "status": "active",
            "regionType": "县",
            "id": "2111"
          }
        ],
        "id": "226"
      },
      {
        "regionName": "揭阳市",
        "pid": "19",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "榕城区",
            "pid": "227",
            "status": "active",
            "regionType": "县",
            "id": "2112"
          },
          {
            "regionName": "揭东县",
            "pid": "227",
            "status": "active",
            "regionType": "县",
            "id": "2113"
          },
          {
            "regionName": "揭西县",
            "pid": "227",
            "status": "active",
            "regionType": "县",
            "id": "2114"
          },
          {
            "regionName": "惠来县",
            "pid": "227",
            "status": "active",
            "regionType": "县",
            "id": "2115"
          },
          {
            "regionName": "普宁市",
            "pid": "227",
            "status": "active",
            "regionType": "县",
            "id": "2116"
          }
        ],
        "id": "227"
      },
      {
        "regionName": "茂名市",
        "pid": "19",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "茂南区",
            "pid": "228",
            "status": "active",
            "regionType": "县",
            "id": "2117"
          },
          {
            "regionName": "茂港区",
            "pid": "228",
            "status": "active",
            "regionType": "县",
            "id": "2118"
          },
          {
            "regionName": "电白县",
            "pid": "228",
            "status": "active",
            "regionType": "县",
            "id": "2119"
          },
          {
            "regionName": "高州市",
            "pid": "228",
            "status": "active",
            "regionType": "县",
            "id": "2120"
          },
          {
            "regionName": "化州市",
            "pid": "228",
            "status": "active",
            "regionType": "县",
            "id": "2121"
          },
          {
            "regionName": "信宜市",
            "pid": "228",
            "status": "active",
            "regionType": "县",
            "id": "2122"
          }
        ],
        "id": "228"
      },
      {
        "regionName": "惠州市",
        "pid": "19",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "惠城区",
            "pid": "229",
            "status": "active",
            "regionType": "县",
            "id": "2123"
          },
          {
            "regionName": "惠阳区",
            "pid": "229",
            "status": "active",
            "regionType": "县",
            "id": "2124"
          },
          {
            "regionName": "博罗县",
            "pid": "229",
            "status": "active",
            "regionType": "县",
            "id": "2125"
          },
          {
            "regionName": "惠东县",
            "pid": "229",
            "status": "active",
            "regionType": "县",
            "id": "2126"
          },
          {
            "regionName": "龙门县",
            "pid": "229",
            "status": "active",
            "regionType": "县",
            "id": "2127"
          },
          {
            "regionName": "大亚湾",
            "pid": "229",
            "status": "active",
            "regionType": "县",
            "id": "3680"
          }
        ],
        "id": "229"
      },
      {
        "regionName": "江门市",
        "pid": "19",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "蓬江区",
            "pid": "230",
            "status": "active",
            "regionType": "县",
            "id": "2128"
          },
          {
            "regionName": "江海区",
            "pid": "230",
            "status": "active",
            "regionType": "县",
            "id": "2129"
          },
          {
            "regionName": "新会区",
            "pid": "230",
            "status": "active",
            "regionType": "县",
            "id": "2130"
          },
          {
            "regionName": "台山市",
            "pid": "230",
            "status": "active",
            "regionType": "县",
            "id": "2131"
          },
          {
            "regionName": "开平市",
            "pid": "230",
            "status": "active",
            "regionType": "县",
            "id": "2132"
          },
          {
            "regionName": "鹤山市",
            "pid": "230",
            "status": "active",
            "regionType": "县",
            "id": "2133"
          },
          {
            "regionName": "恩平市",
            "pid": "230",
            "status": "active",
            "regionType": "县",
            "id": "2134"
          }
        ],
        "id": "230"
      },
      {
        "regionName": "韶关市",
        "pid": "19",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "武江区",
            "pid": "231",
            "status": "active",
            "regionType": "县",
            "id": "2135"
          },
          {
            "regionName": "浈江区",
            "pid": "231",
            "status": "active",
            "regionType": "县",
            "id": "2136"
          },
          {
            "regionName": "曲江区",
            "pid": "231",
            "status": "active",
            "regionType": "县",
            "id": "2137"
          },
          {
            "regionName": "始兴县",
            "pid": "231",
            "status": "active",
            "regionType": "县",
            "id": "2138"
          },
          {
            "regionName": "仁化县",
            "pid": "231",
            "status": "active",
            "regionType": "县",
            "id": "2139"
          },
          {
            "regionName": "翁源县",
            "pid": "231",
            "status": "active",
            "regionType": "县",
            "id": "2140"
          },
          {
            "regionName": "乳源瑶族自治县",
            "pid": "231",
            "status": "active",
            "regionType": "县",
            "id": "2141"
          },
          {
            "regionName": "新丰县",
            "pid": "231",
            "status": "active",
            "regionType": "县",
            "id": "2142"
          },
          {
            "regionName": "乐昌市",
            "pid": "231",
            "status": "active",
            "regionType": "县",
            "id": "2143"
          },
          {
            "regionName": "南雄市",
            "pid": "231",
            "status": "active",
            "regionType": "县",
            "id": "2144"
          },
          {
            "regionName": "曲江县",
            "pid": "231",
            "status": "active",
            "regionType": "县",
            "id": "3682"
          }
        ],
        "id": "231"
      },
      {
        "regionName": "梅州市",
        "pid": "19",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "梅江区",
            "pid": "232",
            "status": "active",
            "regionType": "县",
            "id": "2145"
          },
          {
            "regionName": "梅县",
            "pid": "232",
            "status": "active",
            "regionType": "县",
            "id": "2146"
          },
          {
            "regionName": "大埔县",
            "pid": "232",
            "status": "active",
            "regionType": "县",
            "id": "2147"
          },
          {
            "regionName": "丰顺县",
            "pid": "232",
            "status": "active",
            "regionType": "县",
            "id": "2148"
          },
          {
            "regionName": "五华县",
            "pid": "232",
            "status": "active",
            "regionType": "县",
            "id": "2149"
          },
          {
            "regionName": "平远县",
            "pid": "232",
            "status": "active",
            "regionType": "县",
            "id": "2150"
          },
          {
            "regionName": "蕉岭县",
            "pid": "232",
            "status": "active",
            "regionType": "县",
            "id": "2151"
          },
          {
            "regionName": "兴宁市",
            "pid": "232",
            "status": "active",
            "regionType": "县",
            "id": "2152"
          }
        ],
        "id": "232"
      },
      {
        "regionName": "汕头市",
        "pid": "19",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "龙湖区",
            "pid": "233",
            "status": "active",
            "regionType": "县",
            "id": "2153"
          },
          {
            "regionName": "金平区",
            "pid": "233",
            "status": "active",
            "regionType": "县",
            "id": "2154"
          },
          {
            "regionName": "濠江区",
            "pid": "233",
            "status": "active",
            "regionType": "县",
            "id": "2155"
          },
          {
            "regionName": "潮阳区",
            "pid": "233",
            "status": "active",
            "regionType": "县",
            "id": "2156"
          },
          {
            "regionName": "潮南区",
            "pid": "233",
            "status": "active",
            "regionType": "县",
            "id": "2157"
          },
          {
            "regionName": "澄海区",
            "pid": "233",
            "status": "active",
            "regionType": "县",
            "id": "2158"
          },
          {
            "regionName": "南澳县",
            "pid": "233",
            "status": "active",
            "regionType": "县",
            "id": "2159"
          }
        ],
        "id": "233"
      },
      {
        "regionName": "深圳市",
        "pid": "19",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "罗湖区",
            "pid": "234",
            "status": "active",
            "regionType": "县",
            "id": "2160"
          },
          {
            "regionName": "福田区",
            "pid": "234",
            "status": "active",
            "regionType": "县",
            "id": "2161"
          },
          {
            "regionName": "南山区",
            "pid": "234",
            "status": "active",
            "regionType": "县",
            "id": "2162"
          },
          {
            "regionName": "宝安区",
            "pid": "234",
            "status": "active",
            "regionType": "县",
            "id": "2163"
          },
          {
            "regionName": "龙岗区",
            "pid": "234",
            "status": "active",
            "regionType": "县",
            "id": "2164"
          },
          {
            "regionName": "盐田区",
            "pid": "234",
            "status": "active",
            "regionType": "县",
            "id": "2165"
          }
        ],
        "id": "234"
      },
      {
        "regionName": "珠海市",
        "pid": "19",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "香洲区",
            "pid": "235",
            "status": "active",
            "regionType": "县",
            "id": "2166"
          },
          {
            "regionName": "斗门区",
            "pid": "235",
            "status": "active",
            "regionType": "县",
            "id": "2167"
          },
          {
            "regionName": "金湾区",
            "pid": "235",
            "status": "active",
            "regionType": "县",
            "id": "2168"
          }
        ],
        "id": "235"
      },
      {
        "regionName": "佛山市",
        "pid": "19",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "禅城区",
            "pid": "236",
            "status": "active",
            "regionType": "县",
            "id": "2169"
          },
          {
            "regionName": "南海区",
            "pid": "236",
            "status": "active",
            "regionType": "县",
            "id": "2170"
          },
          {
            "regionName": "顺德区",
            "pid": "236",
            "status": "active",
            "regionType": "县",
            "id": "2171"
          },
          {
            "regionName": "三水区",
            "pid": "236",
            "status": "active",
            "regionType": "县",
            "id": "2172"
          },
          {
            "regionName": "高明区",
            "pid": "236",
            "status": "active",
            "regionType": "县",
            "id": "2173"
          }
        ],
        "id": "236"
      },
      {
        "regionName": "肇庆市",
        "pid": "19",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "端州区",
            "pid": "237",
            "status": "active",
            "regionType": "县",
            "id": "2174"
          },
          {
            "regionName": "鼎湖区",
            "pid": "237",
            "status": "active",
            "regionType": "县",
            "id": "2175"
          },
          {
            "regionName": "广宁县",
            "pid": "237",
            "status": "active",
            "regionType": "县",
            "id": "2176"
          },
          {
            "regionName": "怀集县",
            "pid": "237",
            "status": "active",
            "regionType": "县",
            "id": "2177"
          },
          {
            "regionName": "封开县",
            "pid": "237",
            "status": "active",
            "regionType": "县",
            "id": "2178"
          },
          {
            "regionName": "德庆县",
            "pid": "237",
            "status": "active",
            "regionType": "县",
            "id": "2179"
          },
          {
            "regionName": "高要市",
            "pid": "237",
            "status": "active",
            "regionType": "县",
            "id": "2180"
          },
          {
            "regionName": "四会市",
            "pid": "237",
            "status": "active",
            "regionType": "县",
            "id": "2181"
          },
          {
            "regionName": "肇庆市",
            "pid": "237",
            "status": "active",
            "regionType": "县",
            "id": "3683"
          }
        ],
        "id": "237"
      },
      {
        "regionName": "湛江市",
        "pid": "19",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "赤坎区",
            "pid": "238",
            "status": "active",
            "regionType": "县",
            "id": "2182"
          },
          {
            "regionName": "霞山区",
            "pid": "238",
            "status": "active",
            "regionType": "县",
            "id": "2183"
          },
          {
            "regionName": "坡头区",
            "pid": "238",
            "status": "active",
            "regionType": "县",
            "id": "2184"
          },
          {
            "regionName": "麻章区",
            "pid": "238",
            "status": "active",
            "regionType": "县",
            "id": "2185"
          },
          {
            "regionName": "遂溪县",
            "pid": "238",
            "status": "active",
            "regionType": "县",
            "id": "2186"
          },
          {
            "regionName": "徐闻县",
            "pid": "238",
            "status": "active",
            "regionType": "县",
            "id": "2187"
          },
          {
            "regionName": "廉江市",
            "pid": "238",
            "status": "active",
            "regionType": "县",
            "id": "2188"
          },
          {
            "regionName": "雷州市",
            "pid": "238",
            "status": "active",
            "regionType": "县",
            "id": "2189"
          },
          {
            "regionName": "吴川市",
            "pid": "238",
            "status": "active",
            "regionType": "县",
            "id": "2190"
          }
        ],
        "id": "238"
      },
      {
        "regionName": "中山市",
        "pid": "19",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "石岐街道",
            "pid": "239",
            "status": "active",
            "regionType": "县",
            "id": "3684"
          },
          {
            "regionName": "东区街道",
            "pid": "239",
            "status": "active",
            "regionType": "县",
            "id": "3685"
          },
          {
            "regionName": "西区街道",
            "pid": "239",
            "status": "active",
            "regionType": "县",
            "id": "3686"
          },
          {
            "regionName": "环城街道",
            "pid": "239",
            "status": "active",
            "regionType": "县",
            "id": "3687"
          },
          {
            "regionName": "中山港街道",
            "pid": "239",
            "status": "active",
            "regionType": "县",
            "id": "3688"
          },
          {
            "regionName": "五桂山街道",
            "pid": "239",
            "status": "active",
            "regionType": "县",
            "id": "3689"
          }
        ],
        "id": "239"
      },
      {
        "regionName": "河源市",
        "pid": "19",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "源城区",
            "pid": "240",
            "status": "active",
            "regionType": "县",
            "id": "2191"
          },
          {
            "regionName": "紫金县",
            "pid": "240",
            "status": "active",
            "regionType": "县",
            "id": "2192"
          },
          {
            "regionName": "龙川县",
            "pid": "240",
            "status": "active",
            "regionType": "县",
            "id": "2193"
          },
          {
            "regionName": "连平县",
            "pid": "240",
            "status": "active",
            "regionType": "县",
            "id": "2194"
          },
          {
            "regionName": "和平县",
            "pid": "240",
            "status": "active",
            "regionType": "县",
            "id": "2195"
          },
          {
            "regionName": "东源县",
            "pid": "240",
            "status": "active",
            "regionType": "县",
            "id": "2196"
          }
        ],
        "id": "240"
      },
      {
        "regionName": "清远市",
        "pid": "19",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "清城区",
            "pid": "241",
            "status": "active",
            "regionType": "县",
            "id": "2197"
          },
          {
            "regionName": "佛冈县",
            "pid": "241",
            "status": "active",
            "regionType": "县",
            "id": "2198"
          },
          {
            "regionName": "阳山县",
            "pid": "241",
            "status": "active",
            "regionType": "县",
            "id": "2199"
          },
          {
            "regionName": "连山壮族瑶族自治县",
            "pid": "241",
            "status": "active",
            "regionType": "县",
            "id": "2200"
          },
          {
            "regionName": "连南瑶族自治县",
            "pid": "241",
            "status": "active",
            "regionType": "县",
            "id": "2201"
          },
          {
            "regionName": "清新县",
            "pid": "241",
            "status": "active",
            "regionType": "县",
            "id": "2202"
          },
          {
            "regionName": "英德市",
            "pid": "241",
            "status": "active",
            "regionType": "县",
            "id": "2203"
          },
          {
            "regionName": "连州市",
            "pid": "241",
            "status": "active",
            "regionType": "县",
            "id": "2204"
          }
        ],
        "id": "241"
      },
      {
        "regionName": "云浮市",
        "pid": "19",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "云城区",
            "pid": "242",
            "status": "active",
            "regionType": "县",
            "id": "2205"
          },
          {
            "regionName": "新兴县",
            "pid": "242",
            "status": "active",
            "regionType": "县",
            "id": "2206"
          },
          {
            "regionName": "郁南县",
            "pid": "242",
            "status": "active",
            "regionType": "县",
            "id": "2207"
          },
          {
            "regionName": "云安县",
            "pid": "242",
            "status": "active",
            "regionType": "县",
            "id": "2208"
          },
          {
            "regionName": "罗定市",
            "pid": "242",
            "status": "active",
            "regionType": "县",
            "id": "2209"
          }
        ],
        "id": "242"
      },
      {
        "regionName": "潮州市",
        "pid": "19",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "湘桥区",
            "pid": "243",
            "status": "active",
            "regionType": "县",
            "id": "2210"
          },
          {
            "regionName": "潮安县",
            "pid": "243",
            "status": "active",
            "regionType": "县",
            "id": "2211"
          },
          {
            "regionName": "饶平县",
            "pid": "243",
            "status": "active",
            "regionType": "县",
            "id": "2212"
          }
        ],
        "id": "243"
      },
      {
        "regionName": "东莞市",
        "pid": "19",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "南城区",
            "pid": "244",
            "status": "active",
            "regionType": "县",
            "id": "3649"
          },
          {
            "regionName": "万江区",
            "pid": "244",
            "status": "active",
            "regionType": "县",
            "id": "3650"
          },
          {
            "regionName": "莞城区",
            "pid": "244",
            "status": "active",
            "regionType": "县",
            "id": "3651"
          },
          {
            "regionName": "石龙镇",
            "pid": "244",
            "status": "active",
            "regionType": "县",
            "id": "3652"
          },
          {
            "regionName": "虎门镇",
            "pid": "244",
            "status": "active",
            "regionType": "县",
            "id": "3653"
          },
          {
            "regionName": "麻涌镇",
            "pid": "244",
            "status": "active",
            "regionType": "县",
            "id": "3654"
          },
          {
            "regionName": "道滘镇",
            "pid": "244",
            "status": "active",
            "regionType": "县",
            "id": "3655"
          },
          {
            "regionName": "石碣镇",
            "pid": "244",
            "status": "active",
            "regionType": "县",
            "id": "3656"
          },
          {
            "regionName": "沙田镇",
            "pid": "244",
            "status": "active",
            "regionType": "县",
            "id": "3657"
          },
          {
            "regionName": "望牛墩镇",
            "pid": "244",
            "status": "active",
            "regionType": "县",
            "id": "3658"
          },
          {
            "regionName": "洪梅镇",
            "pid": "244",
            "status": "active",
            "regionType": "县",
            "id": "3659"
          },
          {
            "regionName": "茶山镇",
            "pid": "244",
            "status": "active",
            "regionType": "县",
            "id": "3660"
          },
          {
            "regionName": "寮步镇",
            "pid": "244",
            "status": "active",
            "regionType": "县",
            "id": "3661"
          },
          {
            "regionName": "大岭山镇",
            "pid": "244",
            "status": "active",
            "regionType": "县",
            "id": "3662"
          },
          {
            "regionName": "大朗镇",
            "pid": "244",
            "status": "active",
            "regionType": "县",
            "id": "3663"
          },
          {
            "regionName": "黄江镇",
            "pid": "244",
            "status": "active",
            "regionType": "县",
            "id": "3664"
          },
          {
            "regionName": "樟木头",
            "pid": "244",
            "status": "active",
            "regionType": "县",
            "id": "3665"
          },
          {
            "regionName": "凤岗镇",
            "pid": "244",
            "status": "active",
            "regionType": "县",
            "id": "3666"
          },
          {
            "regionName": "塘厦镇",
            "pid": "244",
            "status": "active",
            "regionType": "县",
            "id": "3667"
          },
          {
            "regionName": "谢岗镇",
            "pid": "244",
            "status": "active",
            "regionType": "县",
            "id": "3668"
          },
          {
            "regionName": "厚街镇",
            "pid": "244",
            "status": "active",
            "regionType": "县",
            "id": "3669"
          },
          {
            "regionName": "清溪镇",
            "pid": "244",
            "status": "active",
            "regionType": "县",
            "id": "3670"
          },
          {
            "regionName": "常平镇",
            "pid": "244",
            "status": "active",
            "regionType": "县",
            "id": "3671"
          },
          {
            "regionName": "桥头镇",
            "pid": "244",
            "status": "active",
            "regionType": "县",
            "id": "3672"
          },
          {
            "regionName": "横沥镇",
            "pid": "244",
            "status": "active",
            "regionType": "县",
            "id": "3673"
          },
          {
            "regionName": "东坑镇",
            "pid": "244",
            "status": "active",
            "regionType": "县",
            "id": "3674"
          },
          {
            "regionName": "企石镇",
            "pid": "244",
            "status": "active",
            "regionType": "县",
            "id": "3675"
          },
          {
            "regionName": "石排镇",
            "pid": "244",
            "status": "active",
            "regionType": "县",
            "id": "3676"
          },
          {
            "regionName": "长安镇",
            "pid": "244",
            "status": "active",
            "regionType": "县",
            "id": "3677"
          },
          {
            "regionName": "中堂镇",
            "pid": "244",
            "status": "active",
            "regionType": "县",
            "id": "3678"
          },
          {
            "regionName": "高埗镇",
            "pid": "244",
            "status": "active",
            "regionType": "县",
            "id": "3679"
          }
        ],
        "id": "244"
      }
    ],
    "regionName": "广东省",
    "pid": "0",
    "status": "active",
    "regionType": "省",
    "id": "19"
  },
  {
    "city": [
      {
        "regionName": "海口市",
        "pid": "20",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "秀英区",
            "pid": "289",
            "status": "active",
            "regionType": "县",
            "id": "2568"
          },
          {
            "regionName": "龙华区",
            "pid": "289",
            "status": "active",
            "regionType": "县",
            "id": "2569"
          },
          {
            "regionName": "琼山区",
            "pid": "289",
            "status": "active",
            "regionType": "县",
            "id": "2570"
          },
          {
            "regionName": "美兰区",
            "pid": "289",
            "status": "active",
            "regionType": "县",
            "id": "2571"
          }
        ],
        "id": "289"
      },
      {
        "regionName": "三亚市",
        "pid": "20",
        "status": "active",
        "regionType": "市",
        "id": "290"
      },
      {
        "regionName": "五指山市",
        "pid": "20",
        "status": "active",
        "regionType": "市",
        "id": "291"
      },
      {
        "regionName": "琼海市",
        "pid": "20",
        "status": "active",
        "regionType": "市",
        "id": "292"
      },
      {
        "regionName": "儋州市",
        "pid": "20",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "市区",
            "pid": "293",
            "status": "active",
            "regionType": "县",
            "id": "3696"
          },
          {
            "regionName": "洋浦开发区",
            "pid": "293",
            "status": "active",
            "regionType": "县",
            "id": "3697"
          },
          {
            "regionName": "那大镇",
            "pid": "293",
            "status": "active",
            "regionType": "县",
            "id": "3698"
          },
          {
            "regionName": "王五镇",
            "pid": "293",
            "status": "active",
            "regionType": "县",
            "id": "3699"
          },
          {
            "regionName": "雅星镇",
            "pid": "293",
            "status": "active",
            "regionType": "县",
            "id": "3700"
          },
          {
            "regionName": "大成镇",
            "pid": "293",
            "status": "active",
            "regionType": "县",
            "id": "3701"
          },
          {
            "regionName": "中和镇",
            "pid": "293",
            "status": "active",
            "regionType": "县",
            "id": "3702"
          },
          {
            "regionName": "峨蔓镇",
            "pid": "293",
            "status": "active",
            "regionType": "县",
            "id": "3703"
          },
          {
            "regionName": "南丰镇",
            "pid": "293",
            "status": "active",
            "regionType": "县",
            "id": "3704"
          },
          {
            "regionName": "白马井镇",
            "pid": "293",
            "status": "active",
            "regionType": "县",
            "id": "3705"
          },
          {
            "regionName": "兰洋镇",
            "pid": "293",
            "status": "active",
            "regionType": "县",
            "id": "3706"
          },
          {
            "regionName": "和庆镇",
            "pid": "293",
            "status": "active",
            "regionType": "县",
            "id": "3707"
          },
          {
            "regionName": "海头镇",
            "pid": "293",
            "status": "active",
            "regionType": "县",
            "id": "3708"
          },
          {
            "regionName": "排浦镇",
            "pid": "293",
            "status": "active",
            "regionType": "县",
            "id": "3709"
          },
          {
            "regionName": "东成镇",
            "pid": "293",
            "status": "active",
            "regionType": "县",
            "id": "3710"
          },
          {
            "regionName": "光村镇",
            "pid": "293",
            "status": "active",
            "regionType": "县",
            "id": "3711"
          },
          {
            "regionName": "木棠镇",
            "pid": "293",
            "status": "active",
            "regionType": "县",
            "id": "3712"
          },
          {
            "regionName": "新州镇",
            "pid": "293",
            "status": "active",
            "regionType": "县",
            "id": "3713"
          },
          {
            "regionName": "三都镇",
            "pid": "293",
            "status": "active",
            "regionType": "县",
            "id": "3714"
          },
          {
            "regionName": "其他",
            "pid": "293",
            "status": "active",
            "regionType": "县",
            "id": "3715"
          }
        ],
        "id": "293"
      },
      {
        "regionName": "文昌市",
        "pid": "20",
        "status": "active",
        "regionType": "市",
        "id": "294"
      },
      {
        "regionName": "万宁市",
        "pid": "20",
        "status": "active",
        "regionType": "市",
        "id": "295"
      },
      {
        "regionName": "东方市",
        "pid": "20",
        "status": "active",
        "regionType": "市",
        "id": "296"
      },
      {
        "regionName": "澄迈县",
        "pid": "20",
        "status": "active",
        "regionType": "市",
        "id": "297"
      },
      {
        "regionName": "定安县",
        "pid": "20",
        "status": "active",
        "regionType": "市",
        "id": "298"
      },
      {
        "regionName": "屯昌县",
        "pid": "20",
        "status": "active",
        "regionType": "市",
        "id": "299"
      },
      {
        "regionName": "临高县",
        "pid": "20",
        "status": "active",
        "regionType": "市",
        "id": "300"
      },
      {
        "regionName": "白沙黎族自治县",
        "pid": "20",
        "status": "active",
        "regionType": "市",
        "id": "301"
      },
      {
        "regionName": "昌江黎族自治县",
        "pid": "20",
        "status": "active",
        "regionType": "市",
        "id": "302"
      },
      {
        "regionName": "乐东黎族自治县",
        "pid": "20",
        "status": "active",
        "regionType": "市",
        "id": "303"
      },
      {
        "regionName": "陵水黎族自治县",
        "pid": "20",
        "status": "active",
        "regionType": "市",
        "id": "304"
      },
      {
        "regionName": "保亭黎族苗族自治县",
        "pid": "20",
        "status": "active",
        "regionType": "市",
        "id": "305"
      },
      {
        "regionName": "琼中黎族苗族自治县",
        "pid": "20",
        "status": "active",
        "regionType": "市",
        "id": "306"
      }
    ],
    "regionName": "海南省",
    "pid": "0",
    "status": "active",
    "regionType": "省",
    "id": "20"
  },
  {
    "city": [
      {
        "regionName": "防城港市",
        "pid": "21",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "港口区",
            "pid": "341",
            "status": "active",
            "regionType": "县",
            "id": "2851"
          },
          {
            "regionName": "防城区",
            "pid": "341",
            "status": "active",
            "regionType": "县",
            "id": "2852"
          },
          {
            "regionName": "上思县",
            "pid": "341",
            "status": "active",
            "regionType": "县",
            "id": "2853"
          },
          {
            "regionName": "东兴市",
            "pid": "341",
            "status": "active",
            "regionType": "县",
            "id": "2854"
          }
        ],
        "id": "341"
      },
      {
        "regionName": "南宁市",
        "pid": "21",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "兴宁区",
            "pid": "342",
            "status": "active",
            "regionType": "县",
            "id": "2855"
          },
          {
            "regionName": "青秀区",
            "pid": "342",
            "status": "active",
            "regionType": "县",
            "id": "2856"
          },
          {
            "regionName": "江南区",
            "pid": "342",
            "status": "active",
            "regionType": "县",
            "id": "2857"
          },
          {
            "regionName": "西乡塘区",
            "pid": "342",
            "status": "active",
            "regionType": "县",
            "id": "2858"
          },
          {
            "regionName": "良庆区",
            "pid": "342",
            "status": "active",
            "regionType": "县",
            "id": "2859"
          },
          {
            "regionName": "邕宁区",
            "pid": "342",
            "status": "active",
            "regionType": "县",
            "id": "2860"
          },
          {
            "regionName": "武鸣县",
            "pid": "342",
            "status": "active",
            "regionType": "县",
            "id": "2861"
          },
          {
            "regionName": "隆安县",
            "pid": "342",
            "status": "active",
            "regionType": "县",
            "id": "2862"
          },
          {
            "regionName": "马山县",
            "pid": "342",
            "status": "active",
            "regionType": "县",
            "id": "2863"
          },
          {
            "regionName": "上林县",
            "pid": "342",
            "status": "active",
            "regionType": "县",
            "id": "2864"
          },
          {
            "regionName": "宾阳县",
            "pid": "342",
            "status": "active",
            "regionType": "县",
            "id": "2865"
          },
          {
            "regionName": "横县",
            "pid": "342",
            "status": "active",
            "regionType": "县",
            "id": "2866"
          }
        ],
        "id": "342"
      },
      {
        "regionName": "崇左市",
        "pid": "21",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "江洲区",
            "pid": "343",
            "status": "active",
            "regionType": "县",
            "id": "2867"
          },
          {
            "regionName": "扶绥县",
            "pid": "343",
            "status": "active",
            "regionType": "县",
            "id": "2868"
          },
          {
            "regionName": "宁明县",
            "pid": "343",
            "status": "active",
            "regionType": "县",
            "id": "2869"
          },
          {
            "regionName": "龙州县",
            "pid": "343",
            "status": "active",
            "regionType": "县",
            "id": "2870"
          },
          {
            "regionName": "大新县",
            "pid": "343",
            "status": "active",
            "regionType": "县",
            "id": "2871"
          },
          {
            "regionName": "天等县",
            "pid": "343",
            "status": "active",
            "regionType": "县",
            "id": "2872"
          },
          {
            "regionName": "凭祥市",
            "pid": "343",
            "status": "active",
            "regionType": "县",
            "id": "2873"
          },
          {
            "regionName": "江州区",
            "pid": "343",
            "status": "active",
            "regionType": "县",
            "id": "3690"
          }
        ],
        "id": "343"
      },
      {
        "regionName": "来宾市",
        "pid": "21",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "兴宾区",
            "pid": "344",
            "status": "active",
            "regionType": "县",
            "id": "2874"
          },
          {
            "regionName": "忻城县",
            "pid": "344",
            "status": "active",
            "regionType": "县",
            "id": "2875"
          },
          {
            "regionName": "象州县",
            "pid": "344",
            "status": "active",
            "regionType": "县",
            "id": "2876"
          },
          {
            "regionName": "武宣县",
            "pid": "344",
            "status": "active",
            "regionType": "县",
            "id": "2877"
          },
          {
            "regionName": "金秀瑶族自治县",
            "pid": "344",
            "status": "active",
            "regionType": "县",
            "id": "2878"
          },
          {
            "regionName": "合山市",
            "pid": "344",
            "status": "active",
            "regionType": "县",
            "id": "2879"
          }
        ],
        "id": "344"
      },
      {
        "regionName": "柳州市",
        "pid": "21",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "城中区",
            "pid": "345",
            "status": "active",
            "regionType": "县",
            "id": "2880"
          },
          {
            "regionName": "鱼峰区",
            "pid": "345",
            "status": "active",
            "regionType": "县",
            "id": "2881"
          },
          {
            "regionName": "柳南区",
            "pid": "345",
            "status": "active",
            "regionType": "县",
            "id": "2882"
          },
          {
            "regionName": "柳北区",
            "pid": "345",
            "status": "active",
            "regionType": "县",
            "id": "2883"
          },
          {
            "regionName": "柳江县",
            "pid": "345",
            "status": "active",
            "regionType": "县",
            "id": "2884"
          },
          {
            "regionName": "柳城县",
            "pid": "345",
            "status": "active",
            "regionType": "县",
            "id": "2885"
          },
          {
            "regionName": "鹿寨县",
            "pid": "345",
            "status": "active",
            "regionType": "县",
            "id": "2886"
          },
          {
            "regionName": "融安县",
            "pid": "345",
            "status": "active",
            "regionType": "县",
            "id": "2887"
          },
          {
            "regionName": "融水苗族自治县",
            "pid": "345",
            "status": "active",
            "regionType": "县",
            "id": "2888"
          },
          {
            "regionName": "三江侗族自治县",
            "pid": "345",
            "status": "active",
            "regionType": "县",
            "id": "2889"
          }
        ],
        "id": "345"
      },
      {
        "regionName": "桂林市",
        "pid": "21",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "秀峰区",
            "pid": "346",
            "status": "active",
            "regionType": "县",
            "id": "2890"
          },
          {
            "regionName": "叠彩区",
            "pid": "346",
            "status": "active",
            "regionType": "县",
            "id": "2891"
          },
          {
            "regionName": "象山区",
            "pid": "346",
            "status": "active",
            "regionType": "县",
            "id": "2892"
          },
          {
            "regionName": "七星区",
            "pid": "346",
            "status": "active",
            "regionType": "县",
            "id": "2893"
          },
          {
            "regionName": "雁山区",
            "pid": "346",
            "status": "active",
            "regionType": "县",
            "id": "2894"
          },
          {
            "regionName": "阳朔县",
            "pid": "346",
            "status": "active",
            "regionType": "县",
            "id": "2895"
          },
          {
            "regionName": "临桂县",
            "pid": "346",
            "status": "active",
            "regionType": "县",
            "id": "2896"
          },
          {
            "regionName": "灵川县",
            "pid": "346",
            "status": "active",
            "regionType": "县",
            "id": "2897"
          },
          {
            "regionName": "全州县",
            "pid": "346",
            "status": "active",
            "regionType": "县",
            "id": "2898"
          },
          {
            "regionName": "兴安县",
            "pid": "346",
            "status": "active",
            "regionType": "县",
            "id": "2899"
          },
          {
            "regionName": "永福县",
            "pid": "346",
            "status": "active",
            "regionType": "县",
            "id": "2900"
          },
          {
            "regionName": "灌阳县",
            "pid": "346",
            "status": "active",
            "regionType": "县",
            "id": "2901"
          },
          {
            "regionName": "龙胜各族自治县",
            "pid": "346",
            "status": "active",
            "regionType": "县",
            "id": "2902"
          },
          {
            "regionName": "资源县",
            "pid": "346",
            "status": "active",
            "regionType": "县",
            "id": "2903"
          },
          {
            "regionName": "平乐县",
            "pid": "346",
            "status": "active",
            "regionType": "县",
            "id": "2904"
          },
          {
            "regionName": "荔浦县",
            "pid": "346",
            "status": "active",
            "regionType": "县",
            "id": "2905"
          },
          {
            "regionName": "恭城瑶族自治县",
            "pid": "346",
            "status": "active",
            "regionType": "县",
            "id": "2906"
          }
        ],
        "id": "346"
      },
      {
        "regionName": "梧州市",
        "pid": "21",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "万秀区",
            "pid": "347",
            "status": "active",
            "regionType": "县",
            "id": "2907"
          },
          {
            "regionName": "碟山区",
            "pid": "347",
            "status": "active",
            "regionType": "县",
            "id": "2908"
          },
          {
            "regionName": "长洲区",
            "pid": "347",
            "status": "active",
            "regionType": "县",
            "id": "2909"
          },
          {
            "regionName": "苍梧县",
            "pid": "347",
            "status": "active",
            "regionType": "县",
            "id": "2910"
          },
          {
            "regionName": "藤县",
            "pid": "347",
            "status": "active",
            "regionType": "县",
            "id": "2911"
          },
          {
            "regionName": "蒙山县",
            "pid": "347",
            "status": "active",
            "regionType": "县",
            "id": "2912"
          },
          {
            "regionName": "岑溪市",
            "pid": "347",
            "status": "active",
            "regionType": "县",
            "id": "2913"
          },
          {
            "regionName": "蝶山区",
            "pid": "347",
            "status": "active",
            "regionType": "县",
            "id": "3691"
          }
        ],
        "id": "347"
      },
      {
        "regionName": "贺州市",
        "pid": "21",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "八步区",
            "pid": "348",
            "status": "active",
            "regionType": "县",
            "id": "2914"
          },
          {
            "regionName": "昭平县",
            "pid": "348",
            "status": "active",
            "regionType": "县",
            "id": "2915"
          },
          {
            "regionName": "钟山县",
            "pid": "348",
            "status": "active",
            "regionType": "县",
            "id": "2916"
          },
          {
            "regionName": "富川瑶族自治县",
            "pid": "348",
            "status": "active",
            "regionType": "县",
            "id": "2917"
          }
        ],
        "id": "348"
      },
      {
        "regionName": "贵港市",
        "pid": "21",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "港北区",
            "pid": "349",
            "status": "active",
            "regionType": "县",
            "id": "2918"
          },
          {
            "regionName": "港南区",
            "pid": "349",
            "status": "active",
            "regionType": "县",
            "id": "2919"
          },
          {
            "regionName": "覃塘区",
            "pid": "349",
            "status": "active",
            "regionType": "县",
            "id": "2920"
          },
          {
            "regionName": "平南县",
            "pid": "349",
            "status": "active",
            "regionType": "县",
            "id": "2921"
          },
          {
            "regionName": "桂平市",
            "pid": "349",
            "status": "active",
            "regionType": "县",
            "id": "2922"
          }
        ],
        "id": "349"
      },
      {
        "regionName": "玉林市",
        "pid": "21",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "玉州区",
            "pid": "350",
            "status": "active",
            "regionType": "县",
            "id": "2923"
          },
          {
            "regionName": "容县",
            "pid": "350",
            "status": "active",
            "regionType": "县",
            "id": "2924"
          },
          {
            "regionName": "陆川县",
            "pid": "350",
            "status": "active",
            "regionType": "县",
            "id": "2925"
          },
          {
            "regionName": "博白县",
            "pid": "350",
            "status": "active",
            "regionType": "县",
            "id": "2926"
          },
          {
            "regionName": "兴业县",
            "pid": "350",
            "status": "active",
            "regionType": "县",
            "id": "2927"
          },
          {
            "regionName": "北流市",
            "pid": "350",
            "status": "active",
            "regionType": "县",
            "id": "2928"
          }
        ],
        "id": "350"
      },
      {
        "regionName": "百色市",
        "pid": "21",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "右江区",
            "pid": "351",
            "status": "active",
            "regionType": "县",
            "id": "2929"
          },
          {
            "regionName": "田阳县",
            "pid": "351",
            "status": "active",
            "regionType": "县",
            "id": "2930"
          },
          {
            "regionName": "田东县",
            "pid": "351",
            "status": "active",
            "regionType": "县",
            "id": "2931"
          },
          {
            "regionName": "平果县",
            "pid": "351",
            "status": "active",
            "regionType": "县",
            "id": "2932"
          },
          {
            "regionName": "德保县",
            "pid": "351",
            "status": "active",
            "regionType": "县",
            "id": "2933"
          },
          {
            "regionName": "靖西县",
            "pid": "351",
            "status": "active",
            "regionType": "县",
            "id": "2934"
          },
          {
            "regionName": "那坡县",
            "pid": "351",
            "status": "active",
            "regionType": "县",
            "id": "2935"
          },
          {
            "regionName": "凌云县",
            "pid": "351",
            "status": "active",
            "regionType": "县",
            "id": "2936"
          },
          {
            "regionName": "乐业县",
            "pid": "351",
            "status": "active",
            "regionType": "县",
            "id": "2937"
          },
          {
            "regionName": "田林县",
            "pid": "351",
            "status": "active",
            "regionType": "县",
            "id": "2938"
          },
          {
            "regionName": "西林县",
            "pid": "351",
            "status": "active",
            "regionType": "县",
            "id": "2939"
          },
          {
            "regionName": "隆林各族自治县",
            "pid": "351",
            "status": "active",
            "regionType": "县",
            "id": "2940"
          }
        ],
        "id": "351"
      },
      {
        "regionName": "钦州市",
        "pid": "21",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "钦南区",
            "pid": "352",
            "status": "active",
            "regionType": "县",
            "id": "2941"
          },
          {
            "regionName": "钦北区",
            "pid": "352",
            "status": "active",
            "regionType": "县",
            "id": "2942"
          },
          {
            "regionName": "灵山县",
            "pid": "352",
            "status": "active",
            "regionType": "县",
            "id": "2943"
          },
          {
            "regionName": "浦北县",
            "pid": "352",
            "status": "active",
            "regionType": "县",
            "id": "2944"
          }
        ],
        "id": "352"
      },
      {
        "regionName": "河池市",
        "pid": "21",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "金城江区",
            "pid": "353",
            "status": "active",
            "regionType": "县",
            "id": "2945"
          },
          {
            "regionName": "南丹县",
            "pid": "353",
            "status": "active",
            "regionType": "县",
            "id": "2946"
          },
          {
            "regionName": "天峨县",
            "pid": "353",
            "status": "active",
            "regionType": "县",
            "id": "2947"
          },
          {
            "regionName": "凤山县",
            "pid": "353",
            "status": "active",
            "regionType": "县",
            "id": "2948"
          },
          {
            "regionName": "东兰县",
            "pid": "353",
            "status": "active",
            "regionType": "县",
            "id": "2949"
          },
          {
            "regionName": "罗城仫佬族自治县",
            "pid": "353",
            "status": "active",
            "regionType": "县",
            "id": "2950"
          },
          {
            "regionName": "环江毛南族自治县",
            "pid": "353",
            "status": "active",
            "regionType": "县",
            "id": "2951"
          },
          {
            "regionName": "巴马瑶族自治县",
            "pid": "353",
            "status": "active",
            "regionType": "县",
            "id": "2952"
          },
          {
            "regionName": "都安瑶族自治县",
            "pid": "353",
            "status": "active",
            "regionType": "县",
            "id": "2953"
          },
          {
            "regionName": "大化瑶族自治县",
            "pid": "353",
            "status": "active",
            "regionType": "县",
            "id": "2954"
          },
          {
            "regionName": "宜州市",
            "pid": "353",
            "status": "active",
            "regionType": "县",
            "id": "2955"
          }
        ],
        "id": "353"
      },
      {
        "regionName": "北海市",
        "pid": "21",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "海城区",
            "pid": "354",
            "status": "active",
            "regionType": "县",
            "id": "2956"
          },
          {
            "regionName": "银海区",
            "pid": "354",
            "status": "active",
            "regionType": "县",
            "id": "2957"
          },
          {
            "regionName": "铁山港区",
            "pid": "354",
            "status": "active",
            "regionType": "县",
            "id": "2958"
          },
          {
            "regionName": "合浦县",
            "pid": "354",
            "status": "active",
            "regionType": "县",
            "id": "2959"
          }
        ],
        "id": "354"
      }
    ],
    "regionName": "广西壮族自治区",
    "pid": "0",
    "status": "active",
    "regionType": "省",
    "id": "21"
  },
  {
    "city": [
      {
        "regionName": "兰州市",
        "pid": "22",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "城关区",
            "pid": "245",
            "status": "active",
            "regionType": "县",
            "id": "2213"
          },
          {
            "regionName": "七里河区",
            "pid": "245",
            "status": "active",
            "regionType": "县",
            "id": "2214"
          },
          {
            "regionName": "西固区",
            "pid": "245",
            "status": "active",
            "regionType": "县",
            "id": "2215"
          },
          {
            "regionName": "安宁区",
            "pid": "245",
            "status": "active",
            "regionType": "县",
            "id": "2216"
          },
          {
            "regionName": "红古区",
            "pid": "245",
            "status": "active",
            "regionType": "县",
            "id": "2217"
          },
          {
            "regionName": "永登县",
            "pid": "245",
            "status": "active",
            "regionType": "县",
            "id": "2218"
          },
          {
            "regionName": "皋兰县",
            "pid": "245",
            "status": "active",
            "regionType": "县",
            "id": "2219"
          },
          {
            "regionName": "榆中县",
            "pid": "245",
            "status": "active",
            "regionType": "县",
            "id": "2220"
          }
        ],
        "id": "245"
      },
      {
        "regionName": "金昌市",
        "pid": "22",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "金川区",
            "pid": "246",
            "status": "active",
            "regionType": "县",
            "id": "2221"
          },
          {
            "regionName": "永昌县",
            "pid": "246",
            "status": "active",
            "regionType": "县",
            "id": "2222"
          }
        ],
        "id": "246"
      },
      {
        "regionName": "白银市",
        "pid": "22",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "白银区",
            "pid": "247",
            "status": "active",
            "regionType": "县",
            "id": "2223"
          },
          {
            "regionName": "平川区",
            "pid": "247",
            "status": "active",
            "regionType": "县",
            "id": "2224"
          },
          {
            "regionName": "靖远县",
            "pid": "247",
            "status": "active",
            "regionType": "县",
            "id": "2225"
          },
          {
            "regionName": "会宁县",
            "pid": "247",
            "status": "active",
            "regionType": "县",
            "id": "2226"
          },
          {
            "regionName": "景泰县",
            "pid": "247",
            "status": "active",
            "regionType": "县",
            "id": "2227"
          }
        ],
        "id": "247"
      },
      {
        "regionName": "天水市",
        "pid": "22",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "秦州区",
            "pid": "248",
            "status": "active",
            "regionType": "县",
            "id": "2228"
          },
          {
            "regionName": "麦积区",
            "pid": "248",
            "status": "active",
            "regionType": "县",
            "id": "2229"
          },
          {
            "regionName": "清水县",
            "pid": "248",
            "status": "active",
            "regionType": "县",
            "id": "2230"
          },
          {
            "regionName": "秦安县",
            "pid": "248",
            "status": "active",
            "regionType": "县",
            "id": "2231"
          },
          {
            "regionName": "甘谷县",
            "pid": "248",
            "status": "active",
            "regionType": "县",
            "id": "2232"
          },
          {
            "regionName": "武山县",
            "pid": "248",
            "status": "active",
            "regionType": "县",
            "id": "2233"
          },
          {
            "regionName": "张家川回族自治县",
            "pid": "248",
            "status": "active",
            "regionType": "县",
            "id": "2234"
          }
        ],
        "id": "248"
      },
      {
        "regionName": "嘉峪关市",
        "pid": "22",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "嘉峪关市",
            "pid": "249",
            "status": "active",
            "regionType": "县",
            "id": "3645"
          }
        ],
        "id": "249"
      },
      {
        "regionName": "武威市",
        "pid": "22",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "凉州区",
            "pid": "250",
            "status": "active",
            "regionType": "县",
            "id": "2235"
          },
          {
            "regionName": "民勤县",
            "pid": "250",
            "status": "active",
            "regionType": "县",
            "id": "2236"
          },
          {
            "regionName": "古浪县",
            "pid": "250",
            "status": "active",
            "regionType": "县",
            "id": "2237"
          },
          {
            "regionName": "天祝藏族自治县",
            "pid": "250",
            "status": "active",
            "regionType": "县",
            "id": "2238"
          }
        ],
        "id": "250"
      },
      {
        "regionName": "张掖市",
        "pid": "22",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "甘州区",
            "pid": "251",
            "status": "active",
            "regionType": "县",
            "id": "2239"
          },
          {
            "regionName": "肃南裕固族自治县",
            "pid": "251",
            "status": "active",
            "regionType": "县",
            "id": "2240"
          },
          {
            "regionName": "民乐县",
            "pid": "251",
            "status": "active",
            "regionType": "县",
            "id": "2241"
          },
          {
            "regionName": "临泽县",
            "pid": "251",
            "status": "active",
            "regionType": "县",
            "id": "2242"
          },
          {
            "regionName": "高台县",
            "pid": "251",
            "status": "active",
            "regionType": "县",
            "id": "2243"
          },
          {
            "regionName": "山丹县",
            "pid": "251",
            "status": "active",
            "regionType": "县",
            "id": "2244"
          }
        ],
        "id": "251"
      },
      {
        "regionName": "平凉市",
        "pid": "22",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "崆峒区",
            "pid": "252",
            "status": "active",
            "regionType": "县",
            "id": "2245"
          },
          {
            "regionName": "泾川县",
            "pid": "252",
            "status": "active",
            "regionType": "县",
            "id": "2246"
          },
          {
            "regionName": "灵台县",
            "pid": "252",
            "status": "active",
            "regionType": "县",
            "id": "2247"
          },
          {
            "regionName": "崇信县",
            "pid": "252",
            "status": "active",
            "regionType": "县",
            "id": "2248"
          },
          {
            "regionName": "华亭县",
            "pid": "252",
            "status": "active",
            "regionType": "县",
            "id": "2249"
          },
          {
            "regionName": "庄浪县",
            "pid": "252",
            "status": "active",
            "regionType": "县",
            "id": "2250"
          },
          {
            "regionName": "静宁县",
            "pid": "252",
            "status": "active",
            "regionType": "县",
            "id": "2251"
          }
        ],
        "id": "252"
      },
      {
        "regionName": "酒泉市",
        "pid": "22",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "肃州区",
            "pid": "253",
            "status": "active",
            "regionType": "县",
            "id": "2252"
          },
          {
            "regionName": "金塔县",
            "pid": "253",
            "status": "active",
            "regionType": "县",
            "id": "2253"
          },
          {
            "regionName": "瓜州县",
            "pid": "253",
            "status": "active",
            "regionType": "县",
            "id": "2254"
          },
          {
            "regionName": "肃北蒙古族自治县",
            "pid": "253",
            "status": "active",
            "regionType": "县",
            "id": "2255"
          },
          {
            "regionName": "阿克塞哈萨克族自治县",
            "pid": "253",
            "status": "active",
            "regionType": "县",
            "id": "2256"
          },
          {
            "regionName": "玉门市",
            "pid": "253",
            "status": "active",
            "regionType": "县",
            "id": "2257"
          },
          {
            "regionName": "敦煌市",
            "pid": "253",
            "status": "active",
            "regionType": "县",
            "id": "2258"
          }
        ],
        "id": "253"
      },
      {
        "regionName": "庆阳市",
        "pid": "22",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "西峰区",
            "pid": "254",
            "status": "active",
            "regionType": "县",
            "id": "2259"
          },
          {
            "regionName": "庆城县",
            "pid": "254",
            "status": "active",
            "regionType": "县",
            "id": "2260"
          },
          {
            "regionName": "环县",
            "pid": "254",
            "status": "active",
            "regionType": "县",
            "id": "2261"
          },
          {
            "regionName": "华池县",
            "pid": "254",
            "status": "active",
            "regionType": "县",
            "id": "2262"
          },
          {
            "regionName": "合水县",
            "pid": "254",
            "status": "active",
            "regionType": "县",
            "id": "2263"
          },
          {
            "regionName": "正宁县",
            "pid": "254",
            "status": "active",
            "regionType": "县",
            "id": "2264"
          },
          {
            "regionName": "宁县",
            "pid": "254",
            "status": "active",
            "regionType": "县",
            "id": "2265"
          },
          {
            "regionName": "镇原县",
            "pid": "254",
            "status": "active",
            "regionType": "县",
            "id": "2266"
          }
        ],
        "id": "254"
      },
      {
        "regionName": "定西市",
        "pid": "22",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "安定区",
            "pid": "255",
            "status": "active",
            "regionType": "县",
            "id": "2267"
          },
          {
            "regionName": "通渭县",
            "pid": "255",
            "status": "active",
            "regionType": "县",
            "id": "2268"
          },
          {
            "regionName": "陇西县",
            "pid": "255",
            "status": "active",
            "regionType": "县",
            "id": "2269"
          },
          {
            "regionName": "渭源县",
            "pid": "255",
            "status": "active",
            "regionType": "县",
            "id": "2270"
          },
          {
            "regionName": "临洮县",
            "pid": "255",
            "status": "active",
            "regionType": "县",
            "id": "2271"
          },
          {
            "regionName": "漳县",
            "pid": "255",
            "status": "active",
            "regionType": "县",
            "id": "2272"
          },
          {
            "regionName": "岷县",
            "pid": "255",
            "status": "active",
            "regionType": "县",
            "id": "2273"
          }
        ],
        "id": "255"
      },
      {
        "regionName": "陇南市",
        "pid": "22",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "武都区",
            "pid": "256",
            "status": "active",
            "regionType": "县",
            "id": "2274"
          },
          {
            "regionName": "成县",
            "pid": "256",
            "status": "active",
            "regionType": "县",
            "id": "2275"
          },
          {
            "regionName": "文县",
            "pid": "256",
            "status": "active",
            "regionType": "县",
            "id": "2276"
          },
          {
            "regionName": "宕昌县",
            "pid": "256",
            "status": "active",
            "regionType": "县",
            "id": "2277"
          },
          {
            "regionName": "康县",
            "pid": "256",
            "status": "active",
            "regionType": "县",
            "id": "2278"
          },
          {
            "regionName": "西和县",
            "pid": "256",
            "status": "active",
            "regionType": "县",
            "id": "2279"
          },
          {
            "regionName": "礼县",
            "pid": "256",
            "status": "active",
            "regionType": "县",
            "id": "2280"
          },
          {
            "regionName": "徽县",
            "pid": "256",
            "status": "active",
            "regionType": "县",
            "id": "2281"
          },
          {
            "regionName": "两当县",
            "pid": "256",
            "status": "active",
            "regionType": "县",
            "id": "2282"
          }
        ],
        "id": "256"
      },
      {
        "regionName": "临夏回族自治州",
        "pid": "22",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "临夏市",
            "pid": "257",
            "status": "active",
            "regionType": "县",
            "id": "2283"
          },
          {
            "regionName": "临夏县",
            "pid": "257",
            "status": "active",
            "regionType": "县",
            "id": "2284"
          },
          {
            "regionName": "康乐县",
            "pid": "257",
            "status": "active",
            "regionType": "县",
            "id": "2285"
          },
          {
            "regionName": "永靖县",
            "pid": "257",
            "status": "active",
            "regionType": "县",
            "id": "2286"
          },
          {
            "regionName": "广河县",
            "pid": "257",
            "status": "active",
            "regionType": "县",
            "id": "2287"
          },
          {
            "regionName": "和政县",
            "pid": "257",
            "status": "active",
            "regionType": "县",
            "id": "2288"
          },
          {
            "regionName": "东乡族自治县",
            "pid": "257",
            "status": "active",
            "regionType": "县",
            "id": "2289"
          },
          {
            "regionName": "积石山保安族东乡族撒拉族自治县",
            "pid": "257",
            "status": "active",
            "regionType": "县",
            "id": "2290"
          }
        ],
        "id": "257"
      },
      {
        "regionName": "甘南藏族自治州",
        "pid": "22",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "合作市",
            "pid": "258",
            "status": "active",
            "regionType": "县",
            "id": "2291"
          },
          {
            "regionName": "临潭县",
            "pid": "258",
            "status": "active",
            "regionType": "县",
            "id": "2292"
          },
          {
            "regionName": "卓尼县",
            "pid": "258",
            "status": "active",
            "regionType": "县",
            "id": "2293"
          },
          {
            "regionName": "舟曲县",
            "pid": "258",
            "status": "active",
            "regionType": "县",
            "id": "2294"
          },
          {
            "regionName": "迭部县",
            "pid": "258",
            "status": "active",
            "regionType": "县",
            "id": "2295"
          },
          {
            "regionName": "玛曲县",
            "pid": "258",
            "status": "active",
            "regionType": "县",
            "id": "2296"
          },
          {
            "regionName": "碌曲县",
            "pid": "258",
            "status": "active",
            "regionType": "县",
            "id": "2297"
          },
          {
            "regionName": "夏河县",
            "pid": "258",
            "status": "active",
            "regionType": "县",
            "id": "2298"
          }
        ],
        "id": "258"
      }
    ],
    "regionName": "甘肃省",
    "pid": "0",
    "status": "active",
    "regionType": "省",
    "id": "22"
  },
  {
    "city": [
      {
        "regionName": "西安市",
        "pid": "23",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "新城区",
            "pid": "331",
            "status": "active",
            "regionType": "县",
            "id": "2744"
          },
          {
            "regionName": "碑林区",
            "pid": "331",
            "status": "active",
            "regionType": "县",
            "id": "2745"
          },
          {
            "regionName": "莲湖区",
            "pid": "331",
            "status": "active",
            "regionType": "县",
            "id": "2746"
          },
          {
            "regionName": "灞桥区",
            "pid": "331",
            "status": "active",
            "regionType": "县",
            "id": "2747"
          },
          {
            "regionName": "未央区",
            "pid": "331",
            "status": "active",
            "regionType": "县",
            "id": "2748"
          },
          {
            "regionName": "雁塔区",
            "pid": "331",
            "status": "active",
            "regionType": "县",
            "id": "2749"
          },
          {
            "regionName": "阎良区",
            "pid": "331",
            "status": "active",
            "regionType": "县",
            "id": "2750"
          },
          {
            "regionName": "临潼区",
            "pid": "331",
            "status": "active",
            "regionType": "县",
            "id": "2751"
          },
          {
            "regionName": "长安区",
            "pid": "331",
            "status": "active",
            "regionType": "县",
            "id": "2752"
          },
          {
            "regionName": "蓝田县",
            "pid": "331",
            "status": "active",
            "regionType": "县",
            "id": "2753"
          },
          {
            "regionName": "周至县",
            "pid": "331",
            "status": "active",
            "regionType": "县",
            "id": "2754"
          },
          {
            "regionName": "户县",
            "pid": "331",
            "status": "active",
            "regionType": "县",
            "id": "2755"
          },
          {
            "regionName": "高陵县",
            "pid": "331",
            "status": "active",
            "regionType": "县",
            "id": "2756"
          }
        ],
        "id": "331"
      },
      {
        "regionName": "咸阳市",
        "pid": "23",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "秦都区",
            "pid": "332",
            "status": "active",
            "regionType": "县",
            "id": "2757"
          },
          {
            "regionName": "杨陵区",
            "pid": "332",
            "status": "active",
            "regionType": "县",
            "id": "2758"
          },
          {
            "regionName": "渭城区",
            "pid": "332",
            "status": "active",
            "regionType": "县",
            "id": "2759"
          },
          {
            "regionName": "三原县",
            "pid": "332",
            "status": "active",
            "regionType": "县",
            "id": "2760"
          },
          {
            "regionName": "泾阳县",
            "pid": "332",
            "status": "active",
            "regionType": "县",
            "id": "2761"
          },
          {
            "regionName": "乾县",
            "pid": "332",
            "status": "active",
            "regionType": "县",
            "id": "2762"
          },
          {
            "regionName": "礼泉县",
            "pid": "332",
            "status": "active",
            "regionType": "县",
            "id": "2763"
          },
          {
            "regionName": "永寿县",
            "pid": "332",
            "status": "active",
            "regionType": "县",
            "id": "2764"
          },
          {
            "regionName": "彬县",
            "pid": "332",
            "status": "active",
            "regionType": "县",
            "id": "2765"
          },
          {
            "regionName": "长武县",
            "pid": "332",
            "status": "active",
            "regionType": "县",
            "id": "2766"
          },
          {
            "regionName": "旬邑县",
            "pid": "332",
            "status": "active",
            "regionType": "县",
            "id": "2767"
          },
          {
            "regionName": "淳化县",
            "pid": "332",
            "status": "active",
            "regionType": "县",
            "id": "2768"
          },
          {
            "regionName": "武功县",
            "pid": "332",
            "status": "active",
            "regionType": "县",
            "id": "2769"
          },
          {
            "regionName": "兴平市",
            "pid": "332",
            "status": "active",
            "regionType": "县",
            "id": "2770"
          }
        ],
        "id": "332"
      },
      {
        "regionName": "延安市",
        "pid": "23",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "宝塔区",
            "pid": "333",
            "status": "active",
            "regionType": "县",
            "id": "2771"
          },
          {
            "regionName": "延长县",
            "pid": "333",
            "status": "active",
            "regionType": "县",
            "id": "2772"
          },
          {
            "regionName": "延川县",
            "pid": "333",
            "status": "active",
            "regionType": "县",
            "id": "2773"
          },
          {
            "regionName": "子长县",
            "pid": "333",
            "status": "active",
            "regionType": "县",
            "id": "2774"
          },
          {
            "regionName": "安塞县",
            "pid": "333",
            "status": "active",
            "regionType": "县",
            "id": "2775"
          },
          {
            "regionName": "志丹县",
            "pid": "333",
            "status": "active",
            "regionType": "县",
            "id": "2776"
          },
          {
            "regionName": "吴起县",
            "pid": "333",
            "status": "active",
            "regionType": "县",
            "id": "2777"
          },
          {
            "regionName": "甘泉县",
            "pid": "333",
            "status": "active",
            "regionType": "县",
            "id": "2778"
          },
          {
            "regionName": "富县",
            "pid": "333",
            "status": "active",
            "regionType": "县",
            "id": "2779"
          },
          {
            "regionName": "洛川县",
            "pid": "333",
            "status": "active",
            "regionType": "县",
            "id": "2780"
          },
          {
            "regionName": "宜川县",
            "pid": "333",
            "status": "active",
            "regionType": "县",
            "id": "2781"
          },
          {
            "regionName": "黄龙县",
            "pid": "333",
            "status": "active",
            "regionType": "县",
            "id": "2782"
          },
          {
            "regionName": "黄陵县",
            "pid": "333",
            "status": "active",
            "regionType": "县",
            "id": "2783"
          }
        ],
        "id": "333"
      },
      {
        "regionName": "榆林市",
        "pid": "23",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "榆阳区",
            "pid": "334",
            "status": "active",
            "regionType": "县",
            "id": "2784"
          },
          {
            "regionName": "神木县",
            "pid": "334",
            "status": "active",
            "regionType": "县",
            "id": "2785"
          },
          {
            "regionName": "府谷县",
            "pid": "334",
            "status": "active",
            "regionType": "县",
            "id": "2786"
          },
          {
            "regionName": "横山县",
            "pid": "334",
            "status": "active",
            "regionType": "县",
            "id": "2787"
          },
          {
            "regionName": "靖边县",
            "pid": "334",
            "status": "active",
            "regionType": "县",
            "id": "2788"
          },
          {
            "regionName": "定边县",
            "pid": "334",
            "status": "active",
            "regionType": "县",
            "id": "2789"
          },
          {
            "regionName": "绥德县",
            "pid": "334",
            "status": "active",
            "regionType": "县",
            "id": "2790"
          },
          {
            "regionName": "米脂县",
            "pid": "334",
            "status": "active",
            "regionType": "县",
            "id": "2791"
          },
          {
            "regionName": "佳县",
            "pid": "334",
            "status": "active",
            "regionType": "县",
            "id": "2792"
          },
          {
            "regionName": "吴堡县",
            "pid": "334",
            "status": "active",
            "regionType": "县",
            "id": "2793"
          },
          {
            "regionName": "清涧县",
            "pid": "334",
            "status": "active",
            "regionType": "县",
            "id": "2794"
          },
          {
            "regionName": "子洲县",
            "pid": "334",
            "status": "active",
            "regionType": "县",
            "id": "2795"
          }
        ],
        "id": "334"
      },
      {
        "regionName": "渭南市",
        "pid": "23",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "临渭区",
            "pid": "335",
            "status": "active",
            "regionType": "县",
            "id": "2796"
          },
          {
            "regionName": "华县",
            "pid": "335",
            "status": "active",
            "regionType": "县",
            "id": "2797"
          },
          {
            "regionName": "潼关县",
            "pid": "335",
            "status": "active",
            "regionType": "县",
            "id": "2798"
          },
          {
            "regionName": "大荔县",
            "pid": "335",
            "status": "active",
            "regionType": "县",
            "id": "2799"
          },
          {
            "regionName": "合阳县",
            "pid": "335",
            "status": "active",
            "regionType": "县",
            "id": "2800"
          },
          {
            "regionName": "澄城县",
            "pid": "335",
            "status": "active",
            "regionType": "县",
            "id": "2801"
          },
          {
            "regionName": "蒲城县",
            "pid": "335",
            "status": "active",
            "regionType": "县",
            "id": "2802"
          },
          {
            "regionName": "白水县",
            "pid": "335",
            "status": "active",
            "regionType": "县",
            "id": "2803"
          },
          {
            "regionName": "富平县",
            "pid": "335",
            "status": "active",
            "regionType": "县",
            "id": "2804"
          },
          {
            "regionName": "韩城市",
            "pid": "335",
            "status": "active",
            "regionType": "县",
            "id": "2805"
          },
          {
            "regionName": "华阴市",
            "pid": "335",
            "status": "active",
            "regionType": "县",
            "id": "2806"
          }
        ],
        "id": "335"
      },
      {
        "regionName": "商洛市",
        "pid": "23",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "商州区",
            "pid": "336",
            "status": "active",
            "regionType": "县",
            "id": "2807"
          },
          {
            "regionName": "洛南县",
            "pid": "336",
            "status": "active",
            "regionType": "县",
            "id": "2808"
          },
          {
            "regionName": "丹凤县",
            "pid": "336",
            "status": "active",
            "regionType": "县",
            "id": "2809"
          },
          {
            "regionName": "商南县",
            "pid": "336",
            "status": "active",
            "regionType": "县",
            "id": "2810"
          },
          {
            "regionName": "山阳县",
            "pid": "336",
            "status": "active",
            "regionType": "县",
            "id": "2811"
          },
          {
            "regionName": "镇安县",
            "pid": "336",
            "status": "active",
            "regionType": "县",
            "id": "2812"
          },
          {
            "regionName": "柞水县",
            "pid": "336",
            "status": "active",
            "regionType": "县",
            "id": "2813"
          }
        ],
        "id": "336"
      },
      {
        "regionName": "安康市",
        "pid": "23",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "汉滨区",
            "pid": "337",
            "status": "active",
            "regionType": "县",
            "id": "2814"
          },
          {
            "regionName": "汉阴县",
            "pid": "337",
            "status": "active",
            "regionType": "县",
            "id": "2815"
          },
          {
            "regionName": "石泉县",
            "pid": "337",
            "status": "active",
            "regionType": "县",
            "id": "2816"
          },
          {
            "regionName": "宁陕县",
            "pid": "337",
            "status": "active",
            "regionType": "县",
            "id": "2817"
          },
          {
            "regionName": "紫阳县",
            "pid": "337",
            "status": "active",
            "regionType": "县",
            "id": "2818"
          },
          {
            "regionName": "岚皋县",
            "pid": "337",
            "status": "active",
            "regionType": "县",
            "id": "2819"
          },
          {
            "regionName": "平利县",
            "pid": "337",
            "status": "active",
            "regionType": "县",
            "id": "2820"
          },
          {
            "regionName": "镇坪县",
            "pid": "337",
            "status": "active",
            "regionType": "县",
            "id": "2821"
          },
          {
            "regionName": "旬阳县",
            "pid": "337",
            "status": "active",
            "regionType": "县",
            "id": "2822"
          },
          {
            "regionName": "白河县",
            "pid": "337",
            "status": "active",
            "regionType": "县",
            "id": "2823"
          }
        ],
        "id": "337"
      },
      {
        "regionName": "汉中市",
        "pid": "23",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "汉台区",
            "pid": "338",
            "status": "active",
            "regionType": "县",
            "id": "2824"
          },
          {
            "regionName": "南郑县",
            "pid": "338",
            "status": "active",
            "regionType": "县",
            "id": "2825"
          },
          {
            "regionName": "城固县",
            "pid": "338",
            "status": "active",
            "regionType": "县",
            "id": "2826"
          },
          {
            "regionName": "洋县",
            "pid": "338",
            "status": "active",
            "regionType": "县",
            "id": "2827"
          },
          {
            "regionName": "西乡县",
            "pid": "338",
            "status": "active",
            "regionType": "县",
            "id": "2828"
          },
          {
            "regionName": "勉县",
            "pid": "338",
            "status": "active",
            "regionType": "县",
            "id": "2829"
          },
          {
            "regionName": "宁强县",
            "pid": "338",
            "status": "active",
            "regionType": "县",
            "id": "2830"
          },
          {
            "regionName": "略阳县",
            "pid": "338",
            "status": "active",
            "regionType": "县",
            "id": "2831"
          },
          {
            "regionName": "镇巴县",
            "pid": "338",
            "status": "active",
            "regionType": "县",
            "id": "2832"
          },
          {
            "regionName": "留坝县",
            "pid": "338",
            "status": "active",
            "regionType": "县",
            "id": "2833"
          },
          {
            "regionName": "佛坪县",
            "pid": "338",
            "status": "active",
            "regionType": "县",
            "id": "2834"
          }
        ],
        "id": "338"
      },
      {
        "regionName": "宝鸡市",
        "pid": "23",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "渭滨区",
            "pid": "339",
            "status": "active",
            "regionType": "县",
            "id": "2835"
          },
          {
            "regionName": "金台区",
            "pid": "339",
            "status": "active",
            "regionType": "县",
            "id": "2836"
          },
          {
            "regionName": "陈仓区",
            "pid": "339",
            "status": "active",
            "regionType": "县",
            "id": "2837"
          },
          {
            "regionName": "凤翔县",
            "pid": "339",
            "status": "active",
            "regionType": "县",
            "id": "2838"
          },
          {
            "regionName": "岐山县",
            "pid": "339",
            "status": "active",
            "regionType": "县",
            "id": "2839"
          },
          {
            "regionName": "扶风县",
            "pid": "339",
            "status": "active",
            "regionType": "县",
            "id": "2840"
          },
          {
            "regionName": "眉县",
            "pid": "339",
            "status": "active",
            "regionType": "县",
            "id": "2841"
          },
          {
            "regionName": "陇县",
            "pid": "339",
            "status": "active",
            "regionType": "县",
            "id": "2842"
          },
          {
            "regionName": "千阳县",
            "pid": "339",
            "status": "active",
            "regionType": "县",
            "id": "2843"
          },
          {
            "regionName": "麟游县",
            "pid": "339",
            "status": "active",
            "regionType": "县",
            "id": "2844"
          },
          {
            "regionName": "凤县",
            "pid": "339",
            "status": "active",
            "regionType": "县",
            "id": "2845"
          },
          {
            "regionName": "太白县",
            "pid": "339",
            "status": "active",
            "regionType": "县",
            "id": "2846"
          }
        ],
        "id": "339"
      },
      {
        "regionName": "铜川市",
        "pid": "23",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "王益区",
            "pid": "340",
            "status": "active",
            "regionType": "县",
            "id": "2847"
          },
          {
            "regionName": "印台区",
            "pid": "340",
            "status": "active",
            "regionType": "县",
            "id": "2848"
          },
          {
            "regionName": "耀州区",
            "pid": "340",
            "status": "active",
            "regionType": "县",
            "id": "2849"
          },
          {
            "regionName": "宜君县",
            "pid": "340",
            "status": "active",
            "regionType": "县",
            "id": "2850"
          }
        ],
        "id": "340"
      }
    ],
    "regionName": "陕西省",
    "pid": "0",
    "status": "active",
    "regionType": "省",
    "id": "23"
  },
  {
    "city": [
      {
        "regionName": "塔城地区",
        "pid": "24",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "塔城市",
            "pid": "367",
            "status": "active",
            "regionType": "县",
            "id": "3054"
          },
          {
            "regionName": "乌苏市",
            "pid": "367",
            "status": "active",
            "regionType": "县",
            "id": "3055"
          },
          {
            "regionName": "额敏县",
            "pid": "367",
            "status": "active",
            "regionType": "县",
            "id": "3056"
          },
          {
            "regionName": "沙湾县",
            "pid": "367",
            "status": "active",
            "regionType": "县",
            "id": "3057"
          },
          {
            "regionName": "托里县",
            "pid": "367",
            "status": "active",
            "regionType": "县",
            "id": "3058"
          },
          {
            "regionName": "裕民县",
            "pid": "367",
            "status": "active",
            "regionType": "县",
            "id": "3059"
          },
          {
            "regionName": "和布克赛尔蒙古自治县",
            "pid": "367",
            "status": "active",
            "regionType": "县",
            "id": "3060"
          }
        ],
        "id": "367"
      },
      {
        "regionName": "哈密地区",
        "pid": "24",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "哈密市",
            "pid": "368",
            "status": "active",
            "regionType": "县",
            "id": "3061"
          },
          {
            "regionName": "巴里坤哈萨克自治县",
            "pid": "368",
            "status": "active",
            "regionType": "县",
            "id": "3062"
          },
          {
            "regionName": "伊吾县",
            "pid": "368",
            "status": "active",
            "regionType": "县",
            "id": "3063"
          }
        ],
        "id": "368"
      },
      {
        "regionName": "和田地区",
        "pid": "24",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "和田市",
            "pid": "369",
            "status": "active",
            "regionType": "县",
            "id": "3064"
          },
          {
            "regionName": "和田县",
            "pid": "369",
            "status": "active",
            "regionType": "县",
            "id": "3065"
          },
          {
            "regionName": "墨玉县",
            "pid": "369",
            "status": "active",
            "regionType": "县",
            "id": "3066"
          },
          {
            "regionName": "皮山县",
            "pid": "369",
            "status": "active",
            "regionType": "县",
            "id": "3067"
          },
          {
            "regionName": "洛浦县",
            "pid": "369",
            "status": "active",
            "regionType": "县",
            "id": "3068"
          },
          {
            "regionName": "策勒县",
            "pid": "369",
            "status": "active",
            "regionType": "县",
            "id": "3069"
          },
          {
            "regionName": "于田县",
            "pid": "369",
            "status": "active",
            "regionType": "县",
            "id": "3070"
          },
          {
            "regionName": "民丰县",
            "pid": "369",
            "status": "active",
            "regionType": "县",
            "id": "3071"
          }
        ],
        "id": "369"
      },
      {
        "regionName": "阿勒泰地区",
        "pid": "24",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "阿勒泰市",
            "pid": "370",
            "status": "active",
            "regionType": "县",
            "id": "3072"
          },
          {
            "regionName": "布尔津县",
            "pid": "370",
            "status": "active",
            "regionType": "县",
            "id": "3073"
          },
          {
            "regionName": "富蕴县",
            "pid": "370",
            "status": "active",
            "regionType": "县",
            "id": "3074"
          },
          {
            "regionName": "福海县",
            "pid": "370",
            "status": "active",
            "regionType": "县",
            "id": "3075"
          },
          {
            "regionName": "哈巴河县",
            "pid": "370",
            "status": "active",
            "regionType": "县",
            "id": "3076"
          },
          {
            "regionName": "青河县",
            "pid": "370",
            "status": "active",
            "regionType": "县",
            "id": "3077"
          },
          {
            "regionName": "吉木乃县",
            "pid": "370",
            "status": "active",
            "regionType": "县",
            "id": "3078"
          }
        ],
        "id": "370"
      },
      {
        "regionName": "克孜勒苏柯尔克孜自治州",
        "pid": "24",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "阿图什市",
            "pid": "371",
            "status": "active",
            "regionType": "县",
            "id": "3079"
          },
          {
            "regionName": "阿克陶县",
            "pid": "371",
            "status": "active",
            "regionType": "县",
            "id": "3080"
          },
          {
            "regionName": "阿合奇县",
            "pid": "371",
            "status": "active",
            "regionType": "县",
            "id": "3081"
          },
          {
            "regionName": "乌恰县",
            "pid": "371",
            "status": "active",
            "regionType": "县",
            "id": "3082"
          }
        ],
        "id": "371"
      },
      {
        "regionName": "博尔塔拉蒙古自治州",
        "pid": "24",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "博乐市",
            "pid": "372",
            "status": "active",
            "regionType": "县",
            "id": "3083"
          },
          {
            "regionName": "精河县",
            "pid": "372",
            "status": "active",
            "regionType": "县",
            "id": "3084"
          },
          {
            "regionName": "温泉县",
            "pid": "372",
            "status": "active",
            "regionType": "县",
            "id": "3085"
          }
        ],
        "id": "372"
      },
      {
        "regionName": "克拉玛依市",
        "pid": "24",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "独山子区",
            "pid": "373",
            "status": "active",
            "regionType": "县",
            "id": "3086"
          },
          {
            "regionName": "克拉玛依区",
            "pid": "373",
            "status": "active",
            "regionType": "县",
            "id": "3087"
          },
          {
            "regionName": "白碱滩区",
            "pid": "373",
            "status": "active",
            "regionType": "县",
            "id": "3088"
          },
          {
            "regionName": "乌尔禾区",
            "pid": "373",
            "status": "active",
            "regionType": "县",
            "id": "3089"
          },
          {
            "regionName": "克拉玛依市",
            "pid": "373",
            "status": "active",
            "regionType": "县",
            "id": "3770"
          }
        ],
        "id": "373"
      },
      {
        "regionName": "乌鲁木齐市",
        "pid": "24",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "天山区",
            "pid": "374",
            "status": "active",
            "regionType": "县",
            "id": "3090"
          },
          {
            "regionName": "沙依巴克区",
            "pid": "374",
            "status": "active",
            "regionType": "县",
            "id": "3091"
          },
          {
            "regionName": "新市区",
            "pid": "374",
            "status": "active",
            "regionType": "县",
            "id": "3092"
          },
          {
            "regionName": "水磨沟区",
            "pid": "374",
            "status": "active",
            "regionType": "县",
            "id": "3093"
          },
          {
            "regionName": "头屯河区",
            "pid": "374",
            "status": "active",
            "regionType": "县",
            "id": "3094"
          },
          {
            "regionName": "达坂城区",
            "pid": "374",
            "status": "active",
            "regionType": "县",
            "id": "3095"
          },
          {
            "regionName": "米东区",
            "pid": "374",
            "status": "active",
            "regionType": "县",
            "id": "3096"
          },
          {
            "regionName": "乌鲁木齐县",
            "pid": "374",
            "status": "active",
            "regionType": "县",
            "id": "3097"
          }
        ],
        "id": "374"
      },
      {
        "regionName": "石河子市",
        "pid": "24",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "石河子市",
            "pid": "375",
            "status": "active",
            "regionType": "县",
            "id": "3771"
          }
        ],
        "id": "375"
      },
      {
        "regionName": "昌吉回族自治州",
        "pid": "24",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "昌吉市",
            "pid": "376",
            "status": "active",
            "regionType": "县",
            "id": "3098"
          },
          {
            "regionName": "阜康市",
            "pid": "376",
            "status": "active",
            "regionType": "县",
            "id": "3099"
          },
          {
            "regionName": "呼图壁县",
            "pid": "376",
            "status": "active",
            "regionType": "县",
            "id": "3100"
          },
          {
            "regionName": "玛纳斯县",
            "pid": "376",
            "status": "active",
            "regionType": "县",
            "id": "3101"
          },
          {
            "regionName": "奇台县",
            "pid": "376",
            "status": "active",
            "regionType": "县",
            "id": "3102"
          },
          {
            "regionName": "吉木萨尔县",
            "pid": "376",
            "status": "active",
            "regionType": "县",
            "id": "3103"
          },
          {
            "regionName": "木垒哈萨克自治县",
            "pid": "376",
            "status": "active",
            "regionType": "县",
            "id": "3104"
          },
          {
            "regionName": "米泉市",
            "pid": "376",
            "status": "active",
            "regionType": "县",
            "id": "3769"
          }
        ],
        "id": "376"
      },
      {
        "regionName": "五家渠市",
        "pid": "24",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "五家渠市",
            "pid": "377",
            "status": "active",
            "regionType": "县",
            "id": "3773"
          }
        ],
        "id": "377"
      },
      {
        "regionName": "吐鲁番地区",
        "pid": "24",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "吐鲁番市",
            "pid": "378",
            "status": "active",
            "regionType": "县",
            "id": "3105"
          },
          {
            "regionName": "鄯善县",
            "pid": "378",
            "status": "active",
            "regionType": "县",
            "id": "3106"
          },
          {
            "regionName": "托克逊县",
            "pid": "378",
            "status": "active",
            "regionType": "县",
            "id": "3107"
          }
        ],
        "id": "378"
      },
      {
        "regionName": "巴音郭楞蒙古自治州",
        "pid": "24",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "库尔勒市",
            "pid": "379",
            "status": "active",
            "regionType": "县",
            "id": "3108"
          },
          {
            "regionName": "轮台县",
            "pid": "379",
            "status": "active",
            "regionType": "县",
            "id": "3109"
          },
          {
            "regionName": "尉犁县",
            "pid": "379",
            "status": "active",
            "regionType": "县",
            "id": "3110"
          },
          {
            "regionName": "若羌县",
            "pid": "379",
            "status": "active",
            "regionType": "县",
            "id": "3111"
          },
          {
            "regionName": "且末县",
            "pid": "379",
            "status": "active",
            "regionType": "县",
            "id": "3112"
          },
          {
            "regionName": "焉耆回族自治县",
            "pid": "379",
            "status": "active",
            "regionType": "县",
            "id": "3113"
          },
          {
            "regionName": "和静县",
            "pid": "379",
            "status": "active",
            "regionType": "县",
            "id": "3114"
          },
          {
            "regionName": "和硕县",
            "pid": "379",
            "status": "active",
            "regionType": "县",
            "id": "3115"
          },
          {
            "regionName": "博湖县",
            "pid": "379",
            "status": "active",
            "regionType": "县",
            "id": "3116"
          }
        ],
        "id": "379"
      },
      {
        "regionName": "阿克苏地区",
        "pid": "24",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "阿克苏市",
            "pid": "380",
            "status": "active",
            "regionType": "县",
            "id": "3117"
          },
          {
            "regionName": "温宿县",
            "pid": "380",
            "status": "active",
            "regionType": "县",
            "id": "3118"
          },
          {
            "regionName": "库车县",
            "pid": "380",
            "status": "active",
            "regionType": "县",
            "id": "3119"
          },
          {
            "regionName": "沙雅县",
            "pid": "380",
            "status": "active",
            "regionType": "县",
            "id": "3120"
          },
          {
            "regionName": "新和县",
            "pid": "380",
            "status": "active",
            "regionType": "县",
            "id": "3121"
          },
          {
            "regionName": "拜城县",
            "pid": "380",
            "status": "active",
            "regionType": "县",
            "id": "3122"
          },
          {
            "regionName": "乌什县",
            "pid": "380",
            "status": "active",
            "regionType": "县",
            "id": "3123"
          },
          {
            "regionName": "阿瓦提县",
            "pid": "380",
            "status": "active",
            "regionType": "县",
            "id": "3124"
          },
          {
            "regionName": "柯坪县",
            "pid": "380",
            "status": "active",
            "regionType": "县",
            "id": "3125"
          }
        ],
        "id": "380"
      },
      {
        "regionName": "阿拉尔市",
        "pid": "24",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "阿拉尔市",
            "pid": "381",
            "status": "active",
            "regionType": "县",
            "id": "3768"
          }
        ],
        "id": "381"
      },
      {
        "regionName": "喀什地区",
        "pid": "24",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "喀什市",
            "pid": "382",
            "status": "active",
            "regionType": "县",
            "id": "3126"
          },
          {
            "regionName": "疏附县",
            "pid": "382",
            "status": "active",
            "regionType": "县",
            "id": "3127"
          },
          {
            "regionName": "疏勒县",
            "pid": "382",
            "status": "active",
            "regionType": "县",
            "id": "3128"
          },
          {
            "regionName": "英吉沙县",
            "pid": "382",
            "status": "active",
            "regionType": "县",
            "id": "3129"
          },
          {
            "regionName": "泽普县",
            "pid": "382",
            "status": "active",
            "regionType": "县",
            "id": "3130"
          },
          {
            "regionName": "莎车县",
            "pid": "382",
            "status": "active",
            "regionType": "县",
            "id": "3131"
          },
          {
            "regionName": "叶城县",
            "pid": "382",
            "status": "active",
            "regionType": "县",
            "id": "3132"
          },
          {
            "regionName": "麦盖提县",
            "pid": "382",
            "status": "active",
            "regionType": "县",
            "id": "3133"
          },
          {
            "regionName": "岳普湖县",
            "pid": "382",
            "status": "active",
            "regionType": "县",
            "id": "3134"
          },
          {
            "regionName": "伽师县",
            "pid": "382",
            "status": "active",
            "regionType": "县",
            "id": "3135"
          },
          {
            "regionName": "巴楚县",
            "pid": "382",
            "status": "active",
            "regionType": "县",
            "id": "3136"
          },
          {
            "regionName": "塔什库尔干塔吉克自治县",
            "pid": "382",
            "status": "active",
            "regionType": "县",
            "id": "3137"
          }
        ],
        "id": "382"
      },
      {
        "regionName": "图木舒克市",
        "pid": "24",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "图木舒克市",
            "pid": "383",
            "status": "active",
            "regionType": "县",
            "id": "3772"
          }
        ],
        "id": "383"
      },
      {
        "regionName": "伊犁哈萨克自治州",
        "pid": "24",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "伊宁市",
            "pid": "384",
            "status": "active",
            "regionType": "县",
            "id": "3138"
          },
          {
            "regionName": "奎屯市",
            "pid": "384",
            "status": "active",
            "regionType": "县",
            "id": "3139"
          },
          {
            "regionName": "伊宁县",
            "pid": "384",
            "status": "active",
            "regionType": "县",
            "id": "3140"
          },
          {
            "regionName": "察布查尔锡伯自治县",
            "pid": "384",
            "status": "active",
            "regionType": "县",
            "id": "3141"
          },
          {
            "regionName": "霍城县",
            "pid": "384",
            "status": "active",
            "regionType": "县",
            "id": "3142"
          },
          {
            "regionName": "巩留县",
            "pid": "384",
            "status": "active",
            "regionType": "县",
            "id": "3143"
          },
          {
            "regionName": "新源县",
            "pid": "384",
            "status": "active",
            "regionType": "县",
            "id": "3144"
          },
          {
            "regionName": "昭苏县",
            "pid": "384",
            "status": "active",
            "regionType": "县",
            "id": "3145"
          },
          {
            "regionName": "特克斯县",
            "pid": "384",
            "status": "active",
            "regionType": "县",
            "id": "3146"
          },
          {
            "regionName": "尼勒克县",
            "pid": "384",
            "status": "active",
            "regionType": "县",
            "id": "3147"
          },
          {
            "regionName": "布克赛尔",
            "pid": "384",
            "status": "active",
            "regionType": "县",
            "id": "3774"
          }
        ],
        "id": "384"
      }
    ],
    "regionName": "新疆维吾尔自治区",
    "pid": "0",
    "status": "active",
    "regionType": "省",
    "id": "24"
  },
  {
    "city": [
      {
        "regionName": "海北藏族自治州",
        "pid": "25",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "门源回族自治县",
            "pid": "323",
            "status": "active",
            "regionType": "县",
            "id": "2701"
          },
          {
            "regionName": "祁连县",
            "pid": "323",
            "status": "active",
            "regionType": "县",
            "id": "2702"
          },
          {
            "regionName": "海晏县",
            "pid": "323",
            "status": "active",
            "regionType": "县",
            "id": "2703"
          },
          {
            "regionName": "刚察县",
            "pid": "323",
            "status": "active",
            "regionType": "县",
            "id": "2704"
          }
        ],
        "id": "323"
      },
      {
        "regionName": "西宁市",
        "pid": "25",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "城东区",
            "pid": "324",
            "status": "active",
            "regionType": "县",
            "id": "2705"
          },
          {
            "regionName": "城中区",
            "pid": "324",
            "status": "active",
            "regionType": "县",
            "id": "2706"
          },
          {
            "regionName": "城西区",
            "pid": "324",
            "status": "active",
            "regionType": "县",
            "id": "2707"
          },
          {
            "regionName": "城北区",
            "pid": "324",
            "status": "active",
            "regionType": "县",
            "id": "2708"
          },
          {
            "regionName": "大通回族土族自治县",
            "pid": "324",
            "status": "active",
            "regionType": "县",
            "id": "2709"
          },
          {
            "regionName": "湟中县",
            "pid": "324",
            "status": "active",
            "regionType": "县",
            "id": "2710"
          },
          {
            "regionName": "湟源县",
            "pid": "324",
            "status": "active",
            "regionType": "县",
            "id": "2711"
          }
        ],
        "id": "324"
      },
      {
        "regionName": "海东市",
        "pid": "25",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "平安县",
            "pid": "325",
            "status": "active",
            "regionType": "县",
            "id": "2712"
          },
          {
            "regionName": "民和回族土族自治县",
            "pid": "325",
            "status": "active",
            "regionType": "县",
            "id": "2713"
          },
          {
            "regionName": "乐都县",
            "pid": "325",
            "status": "active",
            "regionType": "县",
            "id": "2714"
          },
          {
            "regionName": "互助土族自治县",
            "pid": "325",
            "status": "active",
            "regionType": "县",
            "id": "2715"
          },
          {
            "regionName": "化隆回族自治县",
            "pid": "325",
            "status": "active",
            "regionType": "县",
            "id": "2716"
          },
          {
            "regionName": "循化撒拉族自治县",
            "pid": "325",
            "status": "active",
            "regionType": "县",
            "id": "2717"
          }
        ],
        "id": "325"
      },
      {
        "regionName": "黄南藏族自治州",
        "pid": "25",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "同仁县",
            "pid": "326",
            "status": "active",
            "regionType": "县",
            "id": "2718"
          },
          {
            "regionName": "尖扎县",
            "pid": "326",
            "status": "active",
            "regionType": "县",
            "id": "2719"
          },
          {
            "regionName": "泽库县",
            "pid": "326",
            "status": "active",
            "regionType": "县",
            "id": "2720"
          },
          {
            "regionName": "河南蒙古族自治县",
            "pid": "326",
            "status": "active",
            "regionType": "县",
            "id": "2721"
          }
        ],
        "id": "326"
      },
      {
        "regionName": "海南藏族自治州",
        "pid": "25",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "共和县",
            "pid": "327",
            "status": "active",
            "regionType": "县",
            "id": "2722"
          },
          {
            "regionName": "同德县",
            "pid": "327",
            "status": "active",
            "regionType": "县",
            "id": "2723"
          },
          {
            "regionName": "贵德县",
            "pid": "327",
            "status": "active",
            "regionType": "县",
            "id": "2724"
          },
          {
            "regionName": "兴海县",
            "pid": "327",
            "status": "active",
            "regionType": "县",
            "id": "2725"
          },
          {
            "regionName": "贵南县",
            "pid": "327",
            "status": "active",
            "regionType": "县",
            "id": "2726"
          }
        ],
        "id": "327"
      },
      {
        "regionName": "果洛藏族自治州",
        "pid": "25",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "玛沁县",
            "pid": "328",
            "status": "active",
            "regionType": "县",
            "id": "2727"
          },
          {
            "regionName": "班玛县",
            "pid": "328",
            "status": "active",
            "regionType": "县",
            "id": "2728"
          },
          {
            "regionName": "甘德县",
            "pid": "328",
            "status": "active",
            "regionType": "县",
            "id": "2729"
          },
          {
            "regionName": "达日县",
            "pid": "328",
            "status": "active",
            "regionType": "县",
            "id": "2730"
          },
          {
            "regionName": "久治县",
            "pid": "328",
            "status": "active",
            "regionType": "县",
            "id": "2731"
          },
          {
            "regionName": "玛多县",
            "pid": "328",
            "status": "active",
            "regionType": "县",
            "id": "2732"
          }
        ],
        "id": "328"
      },
      {
        "regionName": "玉树藏族自治州",
        "pid": "25",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "玉树县",
            "pid": "329",
            "status": "active",
            "regionType": "县",
            "id": "2733"
          },
          {
            "regionName": "杂多县",
            "pid": "329",
            "status": "active",
            "regionType": "县",
            "id": "2734"
          },
          {
            "regionName": "称多县",
            "pid": "329",
            "status": "active",
            "regionType": "县",
            "id": "2735"
          },
          {
            "regionName": "治多县",
            "pid": "329",
            "status": "active",
            "regionType": "县",
            "id": "2736"
          },
          {
            "regionName": "囊谦县",
            "pid": "329",
            "status": "active",
            "regionType": "县",
            "id": "2737"
          },
          {
            "regionName": "曲麻莱县",
            "pid": "329",
            "status": "active",
            "regionType": "县",
            "id": "2738"
          }
        ],
        "id": "329"
      },
      {
        "regionName": "海西蒙古族藏族自治州",
        "pid": "25",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "格尔木市",
            "pid": "330",
            "status": "active",
            "regionType": "县",
            "id": "2739"
          },
          {
            "regionName": "德令哈市",
            "pid": "330",
            "status": "active",
            "regionType": "县",
            "id": "2740"
          },
          {
            "regionName": "乌兰县",
            "pid": "330",
            "status": "active",
            "regionType": "县",
            "id": "2741"
          },
          {
            "regionName": "都兰县",
            "pid": "330",
            "status": "active",
            "regionType": "县",
            "id": "2742"
          },
          {
            "regionName": "天峻县",
            "pid": "330",
            "status": "active",
            "regionType": "县",
            "id": "2743"
          }
        ],
        "id": "330"
      }
    ],
    "regionName": "青海省",
    "pid": "0",
    "status": "active",
    "regionType": "省",
    "id": "25"
  },
  {
    "city": [
      {
        "regionName": "银川市",
        "pid": "26",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "兴庆区",
            "pid": "362",
            "status": "active",
            "regionType": "县",
            "id": "3033"
          },
          {
            "regionName": "西夏区",
            "pid": "362",
            "status": "active",
            "regionType": "县",
            "id": "3034"
          },
          {
            "regionName": "金凤区",
            "pid": "362",
            "status": "active",
            "regionType": "县",
            "id": "3035"
          },
          {
            "regionName": "永宁县",
            "pid": "362",
            "status": "active",
            "regionType": "县",
            "id": "3036"
          },
          {
            "regionName": "贺兰县",
            "pid": "362",
            "status": "active",
            "regionType": "县",
            "id": "3037"
          },
          {
            "regionName": "灵武市",
            "pid": "362",
            "status": "active",
            "regionType": "县",
            "id": "3038"
          }
        ],
        "id": "362"
      },
      {
        "regionName": "石嘴山市",
        "pid": "26",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "大武口区",
            "pid": "363",
            "status": "active",
            "regionType": "县",
            "id": "3039"
          },
          {
            "regionName": "惠农区",
            "pid": "363",
            "status": "active",
            "regionType": "县",
            "id": "3040"
          },
          {
            "regionName": "平罗县",
            "pid": "363",
            "status": "active",
            "regionType": "县",
            "id": "3041"
          },
          {
            "regionName": "惠农县",
            "pid": "363",
            "status": "active",
            "regionType": "县",
            "id": "3757"
          },
          {
            "regionName": "陶乐县",
            "pid": "363",
            "status": "active",
            "regionType": "县",
            "id": "3758"
          }
        ],
        "id": "363"
      },
      {
        "regionName": "吴忠市",
        "pid": "26",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "利通区",
            "pid": "364",
            "status": "active",
            "regionType": "县",
            "id": "3042"
          },
          {
            "regionName": "盐池县",
            "pid": "364",
            "status": "active",
            "regionType": "县",
            "id": "3043"
          },
          {
            "regionName": "同心县",
            "pid": "364",
            "status": "active",
            "regionType": "县",
            "id": "3044"
          },
          {
            "regionName": "青铜峡市",
            "pid": "364",
            "status": "active",
            "regionType": "县",
            "id": "3045"
          },
          {
            "regionName": "中卫县",
            "pid": "364",
            "status": "active",
            "regionType": "县",
            "id": "3759"
          }
        ],
        "id": "364"
      },
      {
        "regionName": "固原市",
        "pid": "26",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "原州区",
            "pid": "365",
            "status": "active",
            "regionType": "县",
            "id": "3046"
          },
          {
            "regionName": "西吉县",
            "pid": "365",
            "status": "active",
            "regionType": "县",
            "id": "3047"
          },
          {
            "regionName": "隆德县",
            "pid": "365",
            "status": "active",
            "regionType": "县",
            "id": "3048"
          },
          {
            "regionName": "泾源县",
            "pid": "365",
            "status": "active",
            "regionType": "县",
            "id": "3049"
          },
          {
            "regionName": "彭阳县",
            "pid": "365",
            "status": "active",
            "regionType": "县",
            "id": "3050"
          }
        ],
        "id": "365"
      },
      {
        "regionName": "中卫市",
        "pid": "26",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "沙坡头区",
            "pid": "366",
            "status": "active",
            "regionType": "县",
            "id": "3051"
          },
          {
            "regionName": "中宁县",
            "pid": "366",
            "status": "active",
            "regionType": "县",
            "id": "3052"
          },
          {
            "regionName": "海原县",
            "pid": "366",
            "status": "active",
            "regionType": "县",
            "id": "3053"
          }
        ],
        "id": "366"
      }
    ],
    "regionName": "宁夏回族自治区",
    "pid": "0",
    "status": "active",
    "regionType": "省",
    "id": "26"
  },
  {
    "city": [
      {
        "regionName": "重庆市",
        "pid": "27",
        "status": "new",
        "regionType": "市",
        "county": [
          {
            "regionName": "万州区",
            "pid": "38",
            "status": "active",
            "regionType": "县",
            "id": "480"
          },
          {
            "regionName": "涪陵区",
            "pid": "38",
            "status": "active",
            "regionType": "县",
            "id": "481"
          },
          {
            "regionName": "渝中区",
            "pid": "38",
            "status": "active",
            "regionType": "县",
            "id": "482"
          },
          {
            "regionName": "大渡口区",
            "pid": "38",
            "status": "active",
            "regionType": "县",
            "id": "483"
          },
          {
            "regionName": "江北区",
            "pid": "38",
            "status": "active",
            "regionType": "县",
            "id": "484"
          },
          {
            "regionName": "沙坪坝区",
            "pid": "38",
            "status": "active",
            "regionType": "县",
            "id": "485"
          },
          {
            "regionName": "九龙坡区",
            "pid": "38",
            "status": "active",
            "regionType": "县",
            "id": "486"
          },
          {
            "regionName": "南岸区",
            "pid": "38",
            "status": "active",
            "regionType": "县",
            "id": "487"
          },
          {
            "regionName": "北碚区",
            "pid": "38",
            "status": "active",
            "regionType": "县",
            "id": "488"
          },
          {
            "regionName": "万盛区",
            "pid": "38",
            "status": "active",
            "regionType": "县",
            "id": "489"
          },
          {
            "regionName": "双桥区",
            "pid": "38",
            "status": "active",
            "regionType": "县",
            "id": "490"
          },
          {
            "regionName": "渝北区",
            "pid": "38",
            "status": "active",
            "regionType": "县",
            "id": "491"
          },
          {
            "regionName": "巴南区",
            "pid": "38",
            "status": "active",
            "regionType": "县",
            "id": "492"
          },
          {
            "regionName": "黔江区",
            "pid": "38",
            "status": "active",
            "regionType": "县",
            "id": "493"
          },
          {
            "regionName": "长寿区",
            "pid": "38",
            "status": "active",
            "regionType": "县",
            "id": "494"
          },
          {
            "regionName": "江津区",
            "pid": "38",
            "status": "active",
            "regionType": "县",
            "id": "495"
          },
          {
            "regionName": "合川区",
            "pid": "38",
            "status": "active",
            "regionType": "县",
            "id": "496"
          },
          {
            "regionName": "永川区",
            "pid": "38",
            "status": "active",
            "regionType": "县",
            "id": "497"
          },
          {
            "regionName": "南川区",
            "pid": "38",
            "status": "active",
            "regionType": "县",
            "id": "498"
          },
          {
            "regionName": "綦江县",
            "pid": "38",
            "status": "active",
            "regionType": "县",
            "id": "499"
          },
          {
            "regionName": "潼南县",
            "pid": "38",
            "status": "active",
            "regionType": "县",
            "id": "500"
          },
          {
            "regionName": "铜梁县",
            "pid": "38",
            "status": "active",
            "regionType": "县",
            "id": "501"
          },
          {
            "regionName": "大足县",
            "pid": "38",
            "status": "active",
            "regionType": "县",
            "id": "502"
          },
          {
            "regionName": "荣昌县",
            "pid": "38",
            "status": "active",
            "regionType": "县",
            "id": "503"
          },
          {
            "regionName": "璧山县",
            "pid": "38",
            "status": "active",
            "regionType": "县",
            "id": "504"
          },
          {
            "regionName": "梁平县",
            "pid": "38",
            "status": "active",
            "regionType": "县",
            "id": "505"
          },
          {
            "regionName": "城口县",
            "pid": "38",
            "status": "active",
            "regionType": "县",
            "id": "506"
          },
          {
            "regionName": "丰都县",
            "pid": "38",
            "status": "active",
            "regionType": "县",
            "id": "507"
          },
          {
            "regionName": "垫江县",
            "pid": "38",
            "status": "active",
            "regionType": "县",
            "id": "508"
          },
          {
            "regionName": "武隆县",
            "pid": "38",
            "status": "active",
            "regionType": "县",
            "id": "509"
          },
          {
            "regionName": "忠县",
            "pid": "38",
            "status": "active",
            "regionType": "县",
            "id": "510"
          },
          {
            "regionName": "开县",
            "pid": "38",
            "status": "active",
            "regionType": "县",
            "id": "511"
          },
          {
            "regionName": "云阳县",
            "pid": "38",
            "status": "active",
            "regionType": "县",
            "id": "512"
          },
          {
            "regionName": "奉节县",
            "pid": "38",
            "status": "active",
            "regionType": "县",
            "id": "513"
          },
          {
            "regionName": "巫山县",
            "pid": "38",
            "status": "active",
            "regionType": "县",
            "id": "514"
          },
          {
            "regionName": "巫溪县",
            "pid": "38",
            "status": "active",
            "regionType": "县",
            "id": "515"
          },
          {
            "regionName": "石柱土家族自治县",
            "pid": "38",
            "status": "active",
            "regionType": "县",
            "id": "516"
          },
          {
            "regionName": "秀山土家族苗族自治县",
            "pid": "38",
            "status": "active",
            "regionType": "县",
            "id": "517"
          },
          {
            "regionName": "酉阳土家族苗族自治县",
            "pid": "38",
            "status": "active",
            "regionType": "县",
            "id": "518"
          },
          {
            "regionName": "彭水苗族土家族自治县",
            "pid": "38",
            "status": "active",
            "regionType": "县",
            "id": "519"
          },
          {
            "regionName": "黔江开发区",
            "pid": "38",
            "status": "active",
            "regionType": "县",
            "id": "3790"
          }
        ],
        "id": "38"
      }
    ],
    "regionName": "重庆",
    "pid": "0",
    "status": "active",
    "regionType": "省",
    "id": "27"
  },
  {
    "city": [
      {
        "regionName": "成都市",
        "pid": "28",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "锦江区",
            "pid": "259",
            "status": "active",
            "regionType": "县",
            "id": "2299"
          },
          {
            "regionName": "青羊区",
            "pid": "259",
            "status": "active",
            "regionType": "县",
            "id": "2300"
          },
          {
            "regionName": "金牛区",
            "pid": "259",
            "status": "active",
            "regionType": "县",
            "id": "2301"
          },
          {
            "regionName": "武侯区",
            "pid": "259",
            "status": "active",
            "regionType": "县",
            "id": "2302"
          },
          {
            "regionName": "成华区",
            "pid": "259",
            "status": "active",
            "regionType": "县",
            "id": "2303"
          },
          {
            "regionName": "龙泉驿区",
            "pid": "259",
            "status": "active",
            "regionType": "县",
            "id": "2304"
          },
          {
            "regionName": "青白江区",
            "pid": "259",
            "status": "active",
            "regionType": "县",
            "id": "2305"
          },
          {
            "regionName": "新都区",
            "pid": "259",
            "status": "active",
            "regionType": "县",
            "id": "2306"
          },
          {
            "regionName": "温江区",
            "pid": "259",
            "status": "active",
            "regionType": "县",
            "id": "2307"
          },
          {
            "regionName": "金堂县",
            "pid": "259",
            "status": "active",
            "regionType": "县",
            "id": "2308"
          },
          {
            "regionName": "双流县",
            "pid": "259",
            "status": "active",
            "regionType": "县",
            "id": "2309"
          },
          {
            "regionName": "郫县",
            "pid": "259",
            "status": "active",
            "regionType": "县",
            "id": "2310"
          },
          {
            "regionName": "大邑县",
            "pid": "259",
            "status": "active",
            "regionType": "县",
            "id": "2311"
          },
          {
            "regionName": "蒲江县",
            "pid": "259",
            "status": "active",
            "regionType": "县",
            "id": "2312"
          },
          {
            "regionName": "新津县",
            "pid": "259",
            "status": "active",
            "regionType": "县",
            "id": "2313"
          },
          {
            "regionName": "都江堰市",
            "pid": "259",
            "status": "active",
            "regionType": "县",
            "id": "2314"
          },
          {
            "regionName": "彭州市",
            "pid": "259",
            "status": "active",
            "regionType": "县",
            "id": "2315"
          },
          {
            "regionName": "邛崃市",
            "pid": "259",
            "status": "active",
            "regionType": "县",
            "id": "2316"
          },
          {
            "regionName": "崇州市",
            "pid": "259",
            "status": "active",
            "regionType": "县",
            "id": "2317"
          },
          {
            "regionName": "高新西区",
            "pid": "259",
            "status": "active",
            "regionType": "县",
            "id": "3762"
          }
        ],
        "id": "259"
      },
      {
        "regionName": "攀枝花市",
        "pid": "28",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "东区",
            "pid": "260",
            "status": "active",
            "regionType": "县",
            "id": "2318"
          },
          {
            "regionName": "西区",
            "pid": "260",
            "status": "active",
            "regionType": "县",
            "id": "2319"
          },
          {
            "regionName": "仁和区",
            "pid": "260",
            "status": "active",
            "regionType": "县",
            "id": "2320"
          },
          {
            "regionName": "米易县",
            "pid": "260",
            "status": "active",
            "regionType": "县",
            "id": "2321"
          },
          {
            "regionName": "盐边县",
            "pid": "260",
            "status": "active",
            "regionType": "县",
            "id": "2322"
          },
          {
            "regionName": "东  区",
            "pid": "260",
            "status": "active",
            "regionType": "县",
            "id": "3766"
          },
          {
            "regionName": "西  区",
            "pid": "260",
            "status": "active",
            "regionType": "县",
            "id": "3767"
          }
        ],
        "id": "260"
      },
      {
        "regionName": "自贡市",
        "pid": "28",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "自流井区",
            "pid": "261",
            "status": "active",
            "regionType": "县",
            "id": "2323"
          },
          {
            "regionName": "贡井区",
            "pid": "261",
            "status": "active",
            "regionType": "县",
            "id": "2324"
          },
          {
            "regionName": "大安区",
            "pid": "261",
            "status": "active",
            "regionType": "县",
            "id": "2325"
          },
          {
            "regionName": "沿滩区",
            "pid": "261",
            "status": "active",
            "regionType": "县",
            "id": "2326"
          },
          {
            "regionName": "荣县",
            "pid": "261",
            "status": "active",
            "regionType": "县",
            "id": "2327"
          },
          {
            "regionName": "富顺县",
            "pid": "261",
            "status": "active",
            "regionType": "县",
            "id": "2328"
          }
        ],
        "id": "261"
      },
      {
        "regionName": "绵阳市",
        "pid": "28",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "涪城区",
            "pid": "262",
            "status": "active",
            "regionType": "县",
            "id": "2329"
          },
          {
            "regionName": "游仙区",
            "pid": "262",
            "status": "active",
            "regionType": "县",
            "id": "2330"
          },
          {
            "regionName": "三台县",
            "pid": "262",
            "status": "active",
            "regionType": "县",
            "id": "2331"
          },
          {
            "regionName": "盐亭县",
            "pid": "262",
            "status": "active",
            "regionType": "县",
            "id": "2332"
          },
          {
            "regionName": "安县",
            "pid": "262",
            "status": "active",
            "regionType": "县",
            "id": "2333"
          },
          {
            "regionName": "梓潼县",
            "pid": "262",
            "status": "active",
            "regionType": "县",
            "id": "2334"
          },
          {
            "regionName": "北川羌族自治县",
            "pid": "262",
            "status": "active",
            "regionType": "县",
            "id": "2335"
          },
          {
            "regionName": "平武县",
            "pid": "262",
            "status": "active",
            "regionType": "县",
            "id": "2336"
          },
          {
            "regionName": "江油市",
            "pid": "262",
            "status": "active",
            "regionType": "县",
            "id": "2337"
          },
          {
            "regionName": "北川县",
            "pid": "262",
            "status": "active",
            "regionType": "县",
            "id": "3763"
          }
        ],
        "id": "262"
      },
      {
        "regionName": "南充市",
        "pid": "28",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "顺庆区",
            "pid": "263",
            "status": "active",
            "regionType": "县",
            "id": "2338"
          },
          {
            "regionName": "高坪区",
            "pid": "263",
            "status": "active",
            "regionType": "县",
            "id": "2339"
          },
          {
            "regionName": "嘉陵区",
            "pid": "263",
            "status": "active",
            "regionType": "县",
            "id": "2340"
          },
          {
            "regionName": "南部县",
            "pid": "263",
            "status": "active",
            "regionType": "县",
            "id": "2341"
          },
          {
            "regionName": "营山县",
            "pid": "263",
            "status": "active",
            "regionType": "县",
            "id": "2342"
          },
          {
            "regionName": "蓬安县",
            "pid": "263",
            "status": "active",
            "regionType": "县",
            "id": "2343"
          },
          {
            "regionName": "仪陇县",
            "pid": "263",
            "status": "active",
            "regionType": "县",
            "id": "2344"
          },
          {
            "regionName": "西充县",
            "pid": "263",
            "status": "active",
            "regionType": "县",
            "id": "2345"
          },
          {
            "regionName": "阆中市",
            "pid": "263",
            "status": "active",
            "regionType": "县",
            "id": "2346"
          }
        ],
        "id": "263"
      },
      {
        "regionName": "达州市",
        "pid": "28",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "通川区",
            "pid": "264",
            "status": "active",
            "regionType": "县",
            "id": "2347"
          },
          {
            "regionName": "达县",
            "pid": "264",
            "status": "active",
            "regionType": "县",
            "id": "2348"
          },
          {
            "regionName": "宣汉县",
            "pid": "264",
            "status": "active",
            "regionType": "县",
            "id": "2349"
          },
          {
            "regionName": "开江县",
            "pid": "264",
            "status": "active",
            "regionType": "县",
            "id": "2350"
          },
          {
            "regionName": "大竹县",
            "pid": "264",
            "status": "active",
            "regionType": "县",
            "id": "2351"
          },
          {
            "regionName": "渠县",
            "pid": "264",
            "status": "active",
            "regionType": "县",
            "id": "2352"
          },
          {
            "regionName": "万源市",
            "pid": "264",
            "status": "active",
            "regionType": "县",
            "id": "2353"
          }
        ],
        "id": "264"
      },
      {
        "regionName": "遂宁市",
        "pid": "28",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "船山区",
            "pid": "265",
            "status": "active",
            "regionType": "县",
            "id": "2354"
          },
          {
            "regionName": "安居区",
            "pid": "265",
            "status": "active",
            "regionType": "县",
            "id": "2355"
          },
          {
            "regionName": "蓬溪县",
            "pid": "265",
            "status": "active",
            "regionType": "县",
            "id": "2356"
          },
          {
            "regionName": "射洪县",
            "pid": "265",
            "status": "active",
            "regionType": "县",
            "id": "2357"
          },
          {
            "regionName": "大英县",
            "pid": "265",
            "status": "active",
            "regionType": "县",
            "id": "2358"
          }
        ],
        "id": "265"
      },
      {
        "regionName": "广安市",
        "pid": "28",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "广安区",
            "pid": "266",
            "status": "active",
            "regionType": "县",
            "id": "2359"
          },
          {
            "regionName": "岳池县",
            "pid": "266",
            "status": "active",
            "regionType": "县",
            "id": "2360"
          },
          {
            "regionName": "武胜县",
            "pid": "266",
            "status": "active",
            "regionType": "县",
            "id": "2361"
          },
          {
            "regionName": "邻水县",
            "pid": "266",
            "status": "active",
            "regionType": "县",
            "id": "2362"
          },
          {
            "regionName": "华蓥市",
            "pid": "266",
            "status": "active",
            "regionType": "县",
            "id": "2363"
          }
        ],
        "id": "266"
      },
      {
        "regionName": "巴中市",
        "pid": "28",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "巴州区",
            "pid": "267",
            "status": "active",
            "regionType": "县",
            "id": "2364"
          },
          {
            "regionName": "通江县",
            "pid": "267",
            "status": "active",
            "regionType": "县",
            "id": "2365"
          },
          {
            "regionName": "南江县",
            "pid": "267",
            "status": "active",
            "regionType": "县",
            "id": "2366"
          },
          {
            "regionName": "平昌县",
            "pid": "267",
            "status": "active",
            "regionType": "县",
            "id": "2367"
          }
        ],
        "id": "267"
      },
      {
        "regionName": "泸州市",
        "pid": "28",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "江阳区",
            "pid": "268",
            "status": "active",
            "regionType": "县",
            "id": "2368"
          },
          {
            "regionName": "纳溪区",
            "pid": "268",
            "status": "active",
            "regionType": "县",
            "id": "2369"
          },
          {
            "regionName": "龙马潭区",
            "pid": "268",
            "status": "active",
            "regionType": "县",
            "id": "2370"
          },
          {
            "regionName": "泸县",
            "pid": "268",
            "status": "active",
            "regionType": "县",
            "id": "2371"
          },
          {
            "regionName": "合江县",
            "pid": "268",
            "status": "active",
            "regionType": "县",
            "id": "2372"
          },
          {
            "regionName": "叙永县",
            "pid": "268",
            "status": "active",
            "regionType": "县",
            "id": "2373"
          },
          {
            "regionName": "古蔺县",
            "pid": "268",
            "status": "active",
            "regionType": "县",
            "id": "2374"
          }
        ],
        "id": "268"
      },
      {
        "regionName": "宜宾市",
        "pid": "28",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "翠屏区",
            "pid": "269",
            "status": "active",
            "regionType": "县",
            "id": "2375"
          },
          {
            "regionName": "宜宾县",
            "pid": "269",
            "status": "active",
            "regionType": "县",
            "id": "2376"
          },
          {
            "regionName": "南溪县",
            "pid": "269",
            "status": "active",
            "regionType": "县",
            "id": "2377"
          },
          {
            "regionName": "江安县",
            "pid": "269",
            "status": "active",
            "regionType": "县",
            "id": "2378"
          },
          {
            "regionName": "长宁县",
            "pid": "269",
            "status": "active",
            "regionType": "县",
            "id": "2379"
          },
          {
            "regionName": "高县",
            "pid": "269",
            "status": "active",
            "regionType": "县",
            "id": "2380"
          },
          {
            "regionName": "珙县",
            "pid": "269",
            "status": "active",
            "regionType": "县",
            "id": "2381"
          },
          {
            "regionName": "筠连县",
            "pid": "269",
            "status": "active",
            "regionType": "县",
            "id": "2382"
          },
          {
            "regionName": "兴文县",
            "pid": "269",
            "status": "active",
            "regionType": "县",
            "id": "2383"
          },
          {
            "regionName": "屏山县",
            "pid": "269",
            "status": "active",
            "regionType": "县",
            "id": "2384"
          }
        ],
        "id": "269"
      },
      {
        "regionName": "资阳市",
        "pid": "28",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "雁江区",
            "pid": "270",
            "status": "active",
            "regionType": "县",
            "id": "2385"
          },
          {
            "regionName": "安岳县",
            "pid": "270",
            "status": "active",
            "regionType": "县",
            "id": "2386"
          },
          {
            "regionName": "乐至县",
            "pid": "270",
            "status": "active",
            "regionType": "县",
            "id": "2387"
          },
          {
            "regionName": "简阳市",
            "pid": "270",
            "status": "active",
            "regionType": "县",
            "id": "2388"
          }
        ],
        "id": "270"
      },
      {
        "regionName": "内江市",
        "pid": "28",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "市中区",
            "pid": "271",
            "status": "active",
            "regionType": "县",
            "id": "2389"
          },
          {
            "regionName": "东兴区",
            "pid": "271",
            "status": "active",
            "regionType": "县",
            "id": "2390"
          },
          {
            "regionName": "威远县",
            "pid": "271",
            "status": "active",
            "regionType": "县",
            "id": "2391"
          },
          {
            "regionName": "资中县",
            "pid": "271",
            "status": "active",
            "regionType": "县",
            "id": "2392"
          },
          {
            "regionName": "隆昌县",
            "pid": "271",
            "status": "active",
            "regionType": "县",
            "id": "2393"
          }
        ],
        "id": "271"
      },
      {
        "regionName": "乐山市",
        "pid": "28",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "市中区",
            "pid": "272",
            "status": "active",
            "regionType": "县",
            "id": "2394"
          },
          {
            "regionName": "沙湾区",
            "pid": "272",
            "status": "active",
            "regionType": "县",
            "id": "2395"
          },
          {
            "regionName": "五通桥区",
            "pid": "272",
            "status": "active",
            "regionType": "县",
            "id": "2396"
          },
          {
            "regionName": "金口河区",
            "pid": "272",
            "status": "active",
            "regionType": "县",
            "id": "2397"
          },
          {
            "regionName": "犍为县",
            "pid": "272",
            "status": "active",
            "regionType": "县",
            "id": "2398"
          },
          {
            "regionName": "井研县",
            "pid": "272",
            "status": "active",
            "regionType": "县",
            "id": "2399"
          },
          {
            "regionName": "夹江县",
            "pid": "272",
            "status": "active",
            "regionType": "县",
            "id": "2400"
          },
          {
            "regionName": "沐川县",
            "pid": "272",
            "status": "active",
            "regionType": "县",
            "id": "2401"
          },
          {
            "regionName": "峨边彝族自治县",
            "pid": "272",
            "status": "active",
            "regionType": "县",
            "id": "2402"
          },
          {
            "regionName": "马边彝族自治县",
            "pid": "272",
            "status": "active",
            "regionType": "县",
            "id": "2403"
          },
          {
            "regionName": "峨眉山市",
            "pid": "272",
            "status": "active",
            "regionType": "县",
            "id": "2404"
          },
          {
            "regionName": "乐山市",
            "pid": "272",
            "status": "active",
            "regionType": "县",
            "id": "3765"
          }
        ],
        "id": "272"
      },
      {
        "regionName": "眉山市",
        "pid": "28",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "东坡区",
            "pid": "273",
            "status": "active",
            "regionType": "县",
            "id": "2405"
          },
          {
            "regionName": "仁寿县",
            "pid": "273",
            "status": "active",
            "regionType": "县",
            "id": "2406"
          },
          {
            "regionName": "彭山县",
            "pid": "273",
            "status": "active",
            "regionType": "县",
            "id": "2407"
          },
          {
            "regionName": "洪雅县",
            "pid": "273",
            "status": "active",
            "regionType": "县",
            "id": "2408"
          },
          {
            "regionName": "丹棱县",
            "pid": "273",
            "status": "active",
            "regionType": "县",
            "id": "2409"
          },
          {
            "regionName": "青神县",
            "pid": "273",
            "status": "active",
            "regionType": "县",
            "id": "2410"
          }
        ],
        "id": "273"
      },
      {
        "regionName": "凉山彝族自治州",
        "pid": "28",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "西昌市",
            "pid": "274",
            "status": "active",
            "regionType": "县",
            "id": "2411"
          },
          {
            "regionName": "木里藏族自治县",
            "pid": "274",
            "status": "active",
            "regionType": "县",
            "id": "2412"
          },
          {
            "regionName": "盐源县",
            "pid": "274",
            "status": "active",
            "regionType": "县",
            "id": "2413"
          },
          {
            "regionName": "德昌县",
            "pid": "274",
            "status": "active",
            "regionType": "县",
            "id": "2414"
          },
          {
            "regionName": "会理县",
            "pid": "274",
            "status": "active",
            "regionType": "县",
            "id": "2415"
          },
          {
            "regionName": "会东县",
            "pid": "274",
            "status": "active",
            "regionType": "县",
            "id": "2416"
          },
          {
            "regionName": "宁南县",
            "pid": "274",
            "status": "active",
            "regionType": "县",
            "id": "2417"
          },
          {
            "regionName": "普格县",
            "pid": "274",
            "status": "active",
            "regionType": "县",
            "id": "2418"
          },
          {
            "regionName": "布拖县",
            "pid": "274",
            "status": "active",
            "regionType": "县",
            "id": "2419"
          },
          {
            "regionName": "金阳县",
            "pid": "274",
            "status": "active",
            "regionType": "县",
            "id": "2420"
          },
          {
            "regionName": "昭觉县",
            "pid": "274",
            "status": "active",
            "regionType": "县",
            "id": "2421"
          },
          {
            "regionName": "喜德县",
            "pid": "274",
            "status": "active",
            "regionType": "县",
            "id": "2422"
          },
          {
            "regionName": "冕宁县",
            "pid": "274",
            "status": "active",
            "regionType": "县",
            "id": "2423"
          },
          {
            "regionName": "越西县",
            "pid": "274",
            "status": "active",
            "regionType": "县",
            "id": "2424"
          },
          {
            "regionName": "甘洛县",
            "pid": "274",
            "status": "active",
            "regionType": "县",
            "id": "2425"
          },
          {
            "regionName": "美姑县",
            "pid": "274",
            "status": "active",
            "regionType": "县",
            "id": "2426"
          },
          {
            "regionName": "雷波县",
            "pid": "274",
            "status": "active",
            "regionType": "县",
            "id": "2427"
          }
        ],
        "id": "274"
      },
      {
        "regionName": "雅安市",
        "pid": "28",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "雨城区",
            "pid": "275",
            "status": "active",
            "regionType": "县",
            "id": "2428"
          },
          {
            "regionName": "名山县",
            "pid": "275",
            "status": "active",
            "regionType": "县",
            "id": "2429"
          },
          {
            "regionName": "荥经县",
            "pid": "275",
            "status": "active",
            "regionType": "县",
            "id": "2430"
          },
          {
            "regionName": "汉源县",
            "pid": "275",
            "status": "active",
            "regionType": "县",
            "id": "2431"
          },
          {
            "regionName": "石棉县",
            "pid": "275",
            "status": "active",
            "regionType": "县",
            "id": "2432"
          },
          {
            "regionName": "天全县",
            "pid": "275",
            "status": "active",
            "regionType": "县",
            "id": "2433"
          },
          {
            "regionName": "芦山县",
            "pid": "275",
            "status": "active",
            "regionType": "县",
            "id": "2434"
          },
          {
            "regionName": "宝兴县",
            "pid": "275",
            "status": "active",
            "regionType": "县",
            "id": "2435"
          }
        ],
        "id": "275"
      },
      {
        "regionName": "甘孜藏族自治州",
        "pid": "28",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "康定县",
            "pid": "276",
            "status": "active",
            "regionType": "县",
            "id": "2436"
          },
          {
            "regionName": "泸定县",
            "pid": "276",
            "status": "active",
            "regionType": "县",
            "id": "2437"
          },
          {
            "regionName": "丹巴县",
            "pid": "276",
            "status": "active",
            "regionType": "县",
            "id": "2438"
          },
          {
            "regionName": "九龙县",
            "pid": "276",
            "status": "active",
            "regionType": "县",
            "id": "2439"
          },
          {
            "regionName": "雅江县",
            "pid": "276",
            "status": "active",
            "regionType": "县",
            "id": "2440"
          },
          {
            "regionName": "道孚县",
            "pid": "276",
            "status": "active",
            "regionType": "县",
            "id": "2441"
          },
          {
            "regionName": "炉霍县",
            "pid": "276",
            "status": "active",
            "regionType": "县",
            "id": "2442"
          },
          {
            "regionName": "甘孜县",
            "pid": "276",
            "status": "active",
            "regionType": "县",
            "id": "2443"
          },
          {
            "regionName": "新龙县",
            "pid": "276",
            "status": "active",
            "regionType": "县",
            "id": "2444"
          },
          {
            "regionName": "德格县",
            "pid": "276",
            "status": "active",
            "regionType": "县",
            "id": "2445"
          },
          {
            "regionName": "白玉县",
            "pid": "276",
            "status": "active",
            "regionType": "县",
            "id": "2446"
          },
          {
            "regionName": "石渠县",
            "pid": "276",
            "status": "active",
            "regionType": "县",
            "id": "2447"
          },
          {
            "regionName": "色达县",
            "pid": "276",
            "status": "active",
            "regionType": "县",
            "id": "2448"
          },
          {
            "regionName": "理塘县",
            "pid": "276",
            "status": "active",
            "regionType": "县",
            "id": "2449"
          },
          {
            "regionName": "巴塘县",
            "pid": "276",
            "status": "active",
            "regionType": "县",
            "id": "2450"
          },
          {
            "regionName": "乡城县",
            "pid": "276",
            "status": "active",
            "regionType": "县",
            "id": "2451"
          },
          {
            "regionName": "稻城县",
            "pid": "276",
            "status": "active",
            "regionType": "县",
            "id": "2452"
          },
          {
            "regionName": "得荣县",
            "pid": "276",
            "status": "active",
            "regionType": "县",
            "id": "2453"
          }
        ],
        "id": "276"
      },
      {
        "regionName": "阿坝藏族羌族自治州",
        "pid": "28",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "汶川县",
            "pid": "277",
            "status": "active",
            "regionType": "县",
            "id": "2454"
          },
          {
            "regionName": "理县",
            "pid": "277",
            "status": "active",
            "regionType": "县",
            "id": "2455"
          },
          {
            "regionName": "茂县",
            "pid": "277",
            "status": "active",
            "regionType": "县",
            "id": "2456"
          },
          {
            "regionName": "松潘县",
            "pid": "277",
            "status": "active",
            "regionType": "县",
            "id": "2457"
          },
          {
            "regionName": "九寨沟县",
            "pid": "277",
            "status": "active",
            "regionType": "县",
            "id": "2458"
          },
          {
            "regionName": "金川县",
            "pid": "277",
            "status": "active",
            "regionType": "县",
            "id": "2459"
          },
          {
            "regionName": "小金县",
            "pid": "277",
            "status": "active",
            "regionType": "县",
            "id": "2460"
          },
          {
            "regionName": "黑水县",
            "pid": "277",
            "status": "active",
            "regionType": "县",
            "id": "2461"
          },
          {
            "regionName": "马尔康县",
            "pid": "277",
            "status": "active",
            "regionType": "县",
            "id": "2462"
          },
          {
            "regionName": "壤塘县",
            "pid": "277",
            "status": "active",
            "regionType": "县",
            "id": "2463"
          },
          {
            "regionName": "阿坝县",
            "pid": "277",
            "status": "active",
            "regionType": "县",
            "id": "2464"
          },
          {
            "regionName": "若尔盖县",
            "pid": "277",
            "status": "active",
            "regionType": "县",
            "id": "2465"
          },
          {
            "regionName": "红原县",
            "pid": "277",
            "status": "active",
            "regionType": "县",
            "id": "2466"
          }
        ],
        "id": "277"
      },
      {
        "regionName": "德阳市",
        "pid": "28",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "旌阳区",
            "pid": "278",
            "status": "active",
            "regionType": "县",
            "id": "2467"
          },
          {
            "regionName": "中江县",
            "pid": "278",
            "status": "active",
            "regionType": "县",
            "id": "2468"
          },
          {
            "regionName": "罗江县",
            "pid": "278",
            "status": "active",
            "regionType": "县",
            "id": "2469"
          },
          {
            "regionName": "广汉市",
            "pid": "278",
            "status": "active",
            "regionType": "县",
            "id": "2470"
          },
          {
            "regionName": "什邡市",
            "pid": "278",
            "status": "active",
            "regionType": "县",
            "id": "2471"
          },
          {
            "regionName": "绵竹市",
            "pid": "278",
            "status": "active",
            "regionType": "县",
            "id": "2472"
          }
        ],
        "id": "278"
      },
      {
        "regionName": "广元市",
        "pid": "28",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "市中区",
            "pid": "279",
            "status": "active",
            "regionType": "县",
            "id": "2473"
          },
          {
            "regionName": "元坝区",
            "pid": "279",
            "status": "active",
            "regionType": "县",
            "id": "2474"
          },
          {
            "regionName": "朝天区",
            "pid": "279",
            "status": "active",
            "regionType": "县",
            "id": "2475"
          },
          {
            "regionName": "旺苍县",
            "pid": "279",
            "status": "active",
            "regionType": "县",
            "id": "2476"
          },
          {
            "regionName": "青川县",
            "pid": "279",
            "status": "active",
            "regionType": "县",
            "id": "2477"
          },
          {
            "regionName": "剑阁县",
            "pid": "279",
            "status": "active",
            "regionType": "县",
            "id": "2478"
          },
          {
            "regionName": "苍溪县",
            "pid": "279",
            "status": "active",
            "regionType": "县",
            "id": "2479"
          },
          {
            "regionName": "利州区",
            "pid": "279",
            "status": "active",
            "regionType": "县",
            "id": "3764"
          }
        ],
        "id": "279"
      }
    ],
    "regionName": "四川省",
    "pid": "0",
    "status": "active",
    "regionType": "省",
    "id": "28"
  },
  {
    "city": [
      {
        "regionName": "贵阳市",
        "pid": "29",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "南明区",
            "pid": "280",
            "status": "active",
            "regionType": "县",
            "id": "2480"
          },
          {
            "regionName": "云岩区",
            "pid": "280",
            "status": "active",
            "regionType": "县",
            "id": "2481"
          },
          {
            "regionName": "花溪区",
            "pid": "280",
            "status": "active",
            "regionType": "县",
            "id": "2482"
          },
          {
            "regionName": "乌当区",
            "pid": "280",
            "status": "active",
            "regionType": "县",
            "id": "2483"
          },
          {
            "regionName": "白云区",
            "pid": "280",
            "status": "active",
            "regionType": "县",
            "id": "2484"
          },
          {
            "regionName": "小河区",
            "pid": "280",
            "status": "active",
            "regionType": "县",
            "id": "2485"
          },
          {
            "regionName": "开阳县",
            "pid": "280",
            "status": "active",
            "regionType": "县",
            "id": "2486"
          },
          {
            "regionName": "息烽县",
            "pid": "280",
            "status": "active",
            "regionType": "县",
            "id": "2487"
          },
          {
            "regionName": "修文县",
            "pid": "280",
            "status": "active",
            "regionType": "县",
            "id": "2488"
          },
          {
            "regionName": "清镇市",
            "pid": "280",
            "status": "active",
            "regionType": "县",
            "id": "2489"
          },
          {
            "regionName": "金阳新区",
            "pid": "280",
            "status": "active",
            "regionType": "县",
            "id": "3692"
          },
          {
            "regionName": "新天园区",
            "pid": "280",
            "status": "active",
            "regionType": "县",
            "id": "3693"
          }
        ],
        "id": "280"
      },
      {
        "regionName": "遵义市",
        "pid": "29",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "红花岗区",
            "pid": "281",
            "status": "active",
            "regionType": "县",
            "id": "2490"
          },
          {
            "regionName": "汇川区",
            "pid": "281",
            "status": "active",
            "regionType": "县",
            "id": "2491"
          },
          {
            "regionName": "遵义县",
            "pid": "281",
            "status": "active",
            "regionType": "县",
            "id": "2492"
          },
          {
            "regionName": "桐梓县",
            "pid": "281",
            "status": "active",
            "regionType": "县",
            "id": "2493"
          },
          {
            "regionName": "绥阳县",
            "pid": "281",
            "status": "active",
            "regionType": "县",
            "id": "2494"
          },
          {
            "regionName": "正安县",
            "pid": "281",
            "status": "active",
            "regionType": "县",
            "id": "2495"
          },
          {
            "regionName": "道真仡佬族苗族自治县",
            "pid": "281",
            "status": "active",
            "regionType": "县",
            "id": "2496"
          },
          {
            "regionName": "务川仡佬族苗族自治县",
            "pid": "281",
            "status": "active",
            "regionType": "县",
            "id": "2497"
          },
          {
            "regionName": "凤冈县",
            "pid": "281",
            "status": "active",
            "regionType": "县",
            "id": "2498"
          },
          {
            "regionName": "湄潭县",
            "pid": "281",
            "status": "active",
            "regionType": "县",
            "id": "2499"
          },
          {
            "regionName": "余庆县",
            "pid": "281",
            "status": "active",
            "regionType": "县",
            "id": "2500"
          },
          {
            "regionName": "习水县",
            "pid": "281",
            "status": "active",
            "regionType": "县",
            "id": "2501"
          },
          {
            "regionName": "赤水市",
            "pid": "281",
            "status": "active",
            "regionType": "县",
            "id": "2502"
          },
          {
            "regionName": "仁怀市",
            "pid": "281",
            "status": "active",
            "regionType": "县",
            "id": "2503"
          },
          {
            "regionName": "务川县",
            "pid": "281",
            "status": "active",
            "regionType": "县",
            "id": "3694"
          },
          {
            "regionName": "道真县",
            "pid": "281",
            "status": "active",
            "regionType": "县",
            "id": "3695"
          }
        ],
        "id": "281"
      },
      {
        "regionName": "安顺市",
        "pid": "29",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "西秀区",
            "pid": "282",
            "status": "active",
            "regionType": "县",
            "id": "2504"
          },
          {
            "regionName": "平坝县",
            "pid": "282",
            "status": "active",
            "regionType": "县",
            "id": "2505"
          },
          {
            "regionName": "普定县",
            "pid": "282",
            "status": "active",
            "regionType": "县",
            "id": "2506"
          },
          {
            "regionName": "镇宁布依族苗族自治县",
            "pid": "282",
            "status": "active",
            "regionType": "县",
            "id": "2507"
          },
          {
            "regionName": "关岭布依族苗族自治县",
            "pid": "282",
            "status": "active",
            "regionType": "县",
            "id": "2508"
          },
          {
            "regionName": "紫云苗族布依族自治县",
            "pid": "282",
            "status": "active",
            "regionType": "县",
            "id": "2509"
          }
        ],
        "id": "282"
      },
      {
        "regionName": "黔南布依族苗族自治州",
        "pid": "29",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "都匀市",
            "pid": "283",
            "status": "active",
            "regionType": "县",
            "id": "2510"
          },
          {
            "regionName": "福泉市",
            "pid": "283",
            "status": "active",
            "regionType": "县",
            "id": "2511"
          },
          {
            "regionName": "荔波县",
            "pid": "283",
            "status": "active",
            "regionType": "县",
            "id": "2512"
          },
          {
            "regionName": "贵定县",
            "pid": "283",
            "status": "active",
            "regionType": "县",
            "id": "2513"
          },
          {
            "regionName": "瓮安县",
            "pid": "283",
            "status": "active",
            "regionType": "县",
            "id": "2514"
          },
          {
            "regionName": "独山县",
            "pid": "283",
            "status": "active",
            "regionType": "县",
            "id": "2515"
          },
          {
            "regionName": "平塘县",
            "pid": "283",
            "status": "active",
            "regionType": "县",
            "id": "2516"
          },
          {
            "regionName": "罗甸县",
            "pid": "283",
            "status": "active",
            "regionType": "县",
            "id": "2517"
          },
          {
            "regionName": "长顺县",
            "pid": "283",
            "status": "active",
            "regionType": "县",
            "id": "2518"
          },
          {
            "regionName": "龙里县",
            "pid": "283",
            "status": "active",
            "regionType": "县",
            "id": "2519"
          },
          {
            "regionName": "惠水县",
            "pid": "283",
            "status": "active",
            "regionType": "县",
            "id": "2520"
          },
          {
            "regionName": "三都水族自治县",
            "pid": "283",
            "status": "active",
            "regionType": "县",
            "id": "2521"
          }
        ],
        "id": "283"
      },
      {
        "regionName": "黔东南苗族侗族自治州",
        "pid": "29",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "凯里市",
            "pid": "284",
            "status": "active",
            "regionType": "县",
            "id": "2522"
          },
          {
            "regionName": "黄平县",
            "pid": "284",
            "status": "active",
            "regionType": "县",
            "id": "2523"
          },
          {
            "regionName": "施秉县",
            "pid": "284",
            "status": "active",
            "regionType": "县",
            "id": "2524"
          },
          {
            "regionName": "三穗县",
            "pid": "284",
            "status": "active",
            "regionType": "县",
            "id": "2525"
          },
          {
            "regionName": "镇远县",
            "pid": "284",
            "status": "active",
            "regionType": "县",
            "id": "2526"
          },
          {
            "regionName": "岑巩县",
            "pid": "284",
            "status": "active",
            "regionType": "县",
            "id": "2527"
          },
          {
            "regionName": "天柱县",
            "pid": "284",
            "status": "active",
            "regionType": "县",
            "id": "2528"
          },
          {
            "regionName": "锦屏县",
            "pid": "284",
            "status": "active",
            "regionType": "县",
            "id": "2529"
          },
          {
            "regionName": "剑河县",
            "pid": "284",
            "status": "active",
            "regionType": "县",
            "id": "2530"
          },
          {
            "regionName": "台江县",
            "pid": "284",
            "status": "active",
            "regionType": "县",
            "id": "2531"
          },
          {
            "regionName": "黎平县",
            "pid": "284",
            "status": "active",
            "regionType": "县",
            "id": "2532"
          },
          {
            "regionName": "榕江县",
            "pid": "284",
            "status": "active",
            "regionType": "县",
            "id": "2533"
          },
          {
            "regionName": "从江县",
            "pid": "284",
            "status": "active",
            "regionType": "县",
            "id": "2534"
          },
          {
            "regionName": "雷山县",
            "pid": "284",
            "status": "active",
            "regionType": "县",
            "id": "2535"
          },
          {
            "regionName": "麻江县",
            "pid": "284",
            "status": "active",
            "regionType": "县",
            "id": "2536"
          },
          {
            "regionName": "丹寨县",
            "pid": "284",
            "status": "active",
            "regionType": "县",
            "id": "2537"
          }
        ],
        "id": "284"
      },
      {
        "regionName": "铜仁地区",
        "pid": "29",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "铜仁市",
            "pid": "285",
            "status": "active",
            "regionType": "县",
            "id": "2538"
          },
          {
            "regionName": "江口县",
            "pid": "285",
            "status": "active",
            "regionType": "县",
            "id": "2539"
          },
          {
            "regionName": "玉屏侗族自治县",
            "pid": "285",
            "status": "active",
            "regionType": "县",
            "id": "2540"
          },
          {
            "regionName": "石阡县",
            "pid": "285",
            "status": "active",
            "regionType": "县",
            "id": "2541"
          },
          {
            "regionName": "思南县",
            "pid": "285",
            "status": "active",
            "regionType": "县",
            "id": "2542"
          },
          {
            "regionName": "印江土家族苗族自治县",
            "pid": "285",
            "status": "active",
            "regionType": "县",
            "id": "2543"
          },
          {
            "regionName": "德江县",
            "pid": "285",
            "status": "active",
            "regionType": "县",
            "id": "2544"
          },
          {
            "regionName": "沿河土家族自治县",
            "pid": "285",
            "status": "active",
            "regionType": "县",
            "id": "2545"
          },
          {
            "regionName": "松桃苗族自治县",
            "pid": "285",
            "status": "active",
            "regionType": "县",
            "id": "2546"
          },
          {
            "regionName": "万山特区",
            "pid": "285",
            "status": "active",
            "regionType": "县",
            "id": "2547"
          }
        ],
        "id": "285"
      },
      {
        "regionName": "毕节地区",
        "pid": "29",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "毕节市",
            "pid": "286",
            "status": "active",
            "regionType": "县",
            "id": "2548"
          },
          {
            "regionName": "大方县",
            "pid": "286",
            "status": "active",
            "regionType": "县",
            "id": "2549"
          },
          {
            "regionName": "黔西县",
            "pid": "286",
            "status": "active",
            "regionType": "县",
            "id": "2550"
          },
          {
            "regionName": "金沙县",
            "pid": "286",
            "status": "active",
            "regionType": "县",
            "id": "2551"
          },
          {
            "regionName": "织金县",
            "pid": "286",
            "status": "active",
            "regionType": "县",
            "id": "2552"
          },
          {
            "regionName": "纳雍县",
            "pid": "286",
            "status": "active",
            "regionType": "县",
            "id": "2553"
          },
          {
            "regionName": "威宁彝族回族苗族自治县",
            "pid": "286",
            "status": "active",
            "regionType": "县",
            "id": "2554"
          },
          {
            "regionName": "赫章县",
            "pid": "286",
            "status": "active",
            "regionType": "县",
            "id": "2555"
          }
        ],
        "id": "286"
      },
      {
        "regionName": "六盘水市",
        "pid": "29",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "钟山区",
            "pid": "287",
            "status": "active",
            "regionType": "县",
            "id": "2556"
          },
          {
            "regionName": "六枝特区",
            "pid": "287",
            "status": "active",
            "regionType": "县",
            "id": "2557"
          },
          {
            "regionName": "水城县",
            "pid": "287",
            "status": "active",
            "regionType": "县",
            "id": "2558"
          },
          {
            "regionName": "盘县",
            "pid": "287",
            "status": "active",
            "regionType": "县",
            "id": "2559"
          }
        ],
        "id": "287"
      },
      {
        "regionName": "黔西南布依族苗族自治州",
        "pid": "29",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "兴义市",
            "pid": "288",
            "status": "active",
            "regionType": "县",
            "id": "2560"
          },
          {
            "regionName": "兴仁县",
            "pid": "288",
            "status": "active",
            "regionType": "县",
            "id": "2561"
          },
          {
            "regionName": "普安县",
            "pid": "288",
            "status": "active",
            "regionType": "县",
            "id": "2562"
          },
          {
            "regionName": "晴隆县",
            "pid": "288",
            "status": "active",
            "regionType": "县",
            "id": "2563"
          },
          {
            "regionName": "贞丰县",
            "pid": "288",
            "status": "active",
            "regionType": "县",
            "id": "2564"
          },
          {
            "regionName": "望谟县",
            "pid": "288",
            "status": "active",
            "regionType": "县",
            "id": "2565"
          },
          {
            "regionName": "册亨县",
            "pid": "288",
            "status": "active",
            "regionType": "县",
            "id": "2566"
          },
          {
            "regionName": "安龙县",
            "pid": "288",
            "status": "active",
            "regionType": "县",
            "id": "2567"
          }
        ],
        "id": "288"
      }
    ],
    "regionName": "贵州省",
    "pid": "0",
    "status": "active",
    "regionType": "省",
    "id": "29"
  },
  {
    "city": [
      {
        "regionName": "西双版纳傣族自治州",
        "pid": "30",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "景洪市",
            "pid": "307",
            "status": "active",
            "regionType": "县",
            "id": "2572"
          },
          {
            "regionName": "勐海县",
            "pid": "307",
            "status": "active",
            "regionType": "县",
            "id": "2573"
          },
          {
            "regionName": "勐腊县",
            "pid": "307",
            "status": "active",
            "regionType": "县",
            "id": "2574"
          }
        ],
        "id": "307"
      },
      {
        "regionName": "德宏傣族景颇族自治州",
        "pid": "30",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "瑞丽市",
            "pid": "308",
            "status": "active",
            "regionType": "县",
            "id": "2575"
          },
          {
            "regionName": "潞西市",
            "pid": "308",
            "status": "active",
            "regionType": "县",
            "id": "2576"
          },
          {
            "regionName": "梁河县",
            "pid": "308",
            "status": "active",
            "regionType": "县",
            "id": "2577"
          },
          {
            "regionName": "盈江县",
            "pid": "308",
            "status": "active",
            "regionType": "县",
            "id": "2578"
          },
          {
            "regionName": "陇川县",
            "pid": "308",
            "status": "active",
            "regionType": "县",
            "id": "2579"
          }
        ],
        "id": "308"
      },
      {
        "regionName": "昭通市",
        "pid": "30",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "昭阳区",
            "pid": "309",
            "status": "active",
            "regionType": "县",
            "id": "2580"
          },
          {
            "regionName": "鲁甸县",
            "pid": "309",
            "status": "active",
            "regionType": "县",
            "id": "2581"
          },
          {
            "regionName": "巧家县",
            "pid": "309",
            "status": "active",
            "regionType": "县",
            "id": "2582"
          },
          {
            "regionName": "盐津县",
            "pid": "309",
            "status": "active",
            "regionType": "县",
            "id": "2583"
          },
          {
            "regionName": "大关县",
            "pid": "309",
            "status": "active",
            "regionType": "县",
            "id": "2584"
          },
          {
            "regionName": "永善县",
            "pid": "309",
            "status": "active",
            "regionType": "县",
            "id": "2585"
          },
          {
            "regionName": "绥江县",
            "pid": "309",
            "status": "active",
            "regionType": "县",
            "id": "2586"
          },
          {
            "regionName": "镇雄县",
            "pid": "309",
            "status": "active",
            "regionType": "县",
            "id": "2587"
          },
          {
            "regionName": "彝良县",
            "pid": "309",
            "status": "active",
            "regionType": "县",
            "id": "2588"
          },
          {
            "regionName": "威信县",
            "pid": "309",
            "status": "active",
            "regionType": "县",
            "id": "2589"
          },
          {
            "regionName": "水富县",
            "pid": "309",
            "status": "active",
            "regionType": "县",
            "id": "2590"
          }
        ],
        "id": "309"
      },
      {
        "regionName": "昆明市",
        "pid": "30",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "五华区",
            "pid": "310",
            "status": "active",
            "regionType": "县",
            "id": "2591"
          },
          {
            "regionName": "盘龙区",
            "pid": "310",
            "status": "active",
            "regionType": "县",
            "id": "2592"
          },
          {
            "regionName": "官渡区",
            "pid": "310",
            "status": "active",
            "regionType": "县",
            "id": "2593"
          },
          {
            "regionName": "西山区",
            "pid": "310",
            "status": "active",
            "regionType": "县",
            "id": "2594"
          },
          {
            "regionName": "东川区",
            "pid": "310",
            "status": "active",
            "regionType": "县",
            "id": "2595"
          },
          {
            "regionName": "呈贡县",
            "pid": "310",
            "status": "active",
            "regionType": "县",
            "id": "2596"
          },
          {
            "regionName": "晋宁县",
            "pid": "310",
            "status": "active",
            "regionType": "县",
            "id": "2597"
          },
          {
            "regionName": "富民县",
            "pid": "310",
            "status": "active",
            "regionType": "县",
            "id": "2598"
          },
          {
            "regionName": "宜良县",
            "pid": "310",
            "status": "active",
            "regionType": "县",
            "id": "2599"
          },
          {
            "regionName": "石林彝族自治县",
            "pid": "310",
            "status": "active",
            "regionType": "县",
            "id": "2600"
          },
          {
            "regionName": "嵩明县",
            "pid": "310",
            "status": "active",
            "regionType": "县",
            "id": "2601"
          },
          {
            "regionName": "禄劝彝族苗族自治县",
            "pid": "310",
            "status": "active",
            "regionType": "县",
            "id": "2602"
          },
          {
            "regionName": "寻甸回族彝族自治县",
            "pid": "310",
            "status": "active",
            "regionType": "县",
            "id": "2603"
          },
          {
            "regionName": "安宁市",
            "pid": "310",
            "status": "active",
            "regionType": "县",
            "id": "2604"
          },
          {
            "regionName": "石林县",
            "pid": "310",
            "status": "active",
            "regionType": "县",
            "id": "3775"
          }
        ],
        "id": "310"
      },
      {
        "regionName": "大理白族自治州",
        "pid": "30",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "大理市",
            "pid": "311",
            "status": "active",
            "regionType": "县",
            "id": "2605"
          },
          {
            "regionName": "漾濞彝族自治县",
            "pid": "311",
            "status": "active",
            "regionType": "县",
            "id": "2606"
          },
          {
            "regionName": "祥云县",
            "pid": "311",
            "status": "active",
            "regionType": "县",
            "id": "2607"
          },
          {
            "regionName": "宾川县",
            "pid": "311",
            "status": "active",
            "regionType": "县",
            "id": "2608"
          },
          {
            "regionName": "弥渡县",
            "pid": "311",
            "status": "active",
            "regionType": "县",
            "id": "2609"
          },
          {
            "regionName": "南涧彝族自治县",
            "pid": "311",
            "status": "active",
            "regionType": "县",
            "id": "2610"
          },
          {
            "regionName": "巍山彝族回族自治县",
            "pid": "311",
            "status": "active",
            "regionType": "县",
            "id": "2611"
          },
          {
            "regionName": "永平县",
            "pid": "311",
            "status": "active",
            "regionType": "县",
            "id": "2612"
          },
          {
            "regionName": "云龙县",
            "pid": "311",
            "status": "active",
            "regionType": "县",
            "id": "2613"
          },
          {
            "regionName": "洱源县",
            "pid": "311",
            "status": "active",
            "regionType": "县",
            "id": "2614"
          },
          {
            "regionName": "剑川县",
            "pid": "311",
            "status": "active",
            "regionType": "县",
            "id": "2615"
          },
          {
            "regionName": "鹤庆县",
            "pid": "311",
            "status": "active",
            "regionType": "县",
            "id": "2616"
          }
        ],
        "id": "311"
      },
      {
        "regionName": "红河哈尼族彝族自治州",
        "pid": "30",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "个旧市",
            "pid": "312",
            "status": "active",
            "regionType": "县",
            "id": "2617"
          },
          {
            "regionName": "开远市",
            "pid": "312",
            "status": "active",
            "regionType": "县",
            "id": "2618"
          },
          {
            "regionName": "蒙自县",
            "pid": "312",
            "status": "active",
            "regionType": "县",
            "id": "2619"
          },
          {
            "regionName": "屏边苗族自治县",
            "pid": "312",
            "status": "active",
            "regionType": "县",
            "id": "2620"
          },
          {
            "regionName": "建水县",
            "pid": "312",
            "status": "active",
            "regionType": "县",
            "id": "2621"
          },
          {
            "regionName": "石屏县",
            "pid": "312",
            "status": "active",
            "regionType": "县",
            "id": "2622"
          },
          {
            "regionName": "弥勒县",
            "pid": "312",
            "status": "active",
            "regionType": "县",
            "id": "2623"
          },
          {
            "regionName": "泸西县",
            "pid": "312",
            "status": "active",
            "regionType": "县",
            "id": "2624"
          },
          {
            "regionName": "元阳县",
            "pid": "312",
            "status": "active",
            "regionType": "县",
            "id": "2625"
          },
          {
            "regionName": "红河县",
            "pid": "312",
            "status": "active",
            "regionType": "县",
            "id": "2626"
          },
          {
            "regionName": "金平苗族瑶族傣族自治县",
            "pid": "312",
            "status": "active",
            "regionType": "县",
            "id": "2627"
          },
          {
            "regionName": "绿春县",
            "pid": "312",
            "status": "active",
            "regionType": "县",
            "id": "2628"
          },
          {
            "regionName": "河口瑶族自治县",
            "pid": "312",
            "status": "active",
            "regionType": "县",
            "id": "2629"
          }
        ],
        "id": "312"
      },
      {
        "regionName": "曲靖市",
        "pid": "30",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "麒麟区",
            "pid": "313",
            "status": "active",
            "regionType": "县",
            "id": "2630"
          },
          {
            "regionName": "马龙县",
            "pid": "313",
            "status": "active",
            "regionType": "县",
            "id": "2631"
          },
          {
            "regionName": "陆良县",
            "pid": "313",
            "status": "active",
            "regionType": "县",
            "id": "2632"
          },
          {
            "regionName": "师宗县",
            "pid": "313",
            "status": "active",
            "regionType": "县",
            "id": "2633"
          },
          {
            "regionName": "罗平县",
            "pid": "313",
            "status": "active",
            "regionType": "县",
            "id": "2634"
          },
          {
            "regionName": "富源县",
            "pid": "313",
            "status": "active",
            "regionType": "县",
            "id": "2635"
          },
          {
            "regionName": "会泽县",
            "pid": "313",
            "status": "active",
            "regionType": "县",
            "id": "2636"
          },
          {
            "regionName": "沾益县",
            "pid": "313",
            "status": "active",
            "regionType": "县",
            "id": "2637"
          },
          {
            "regionName": "宣威市",
            "pid": "313",
            "status": "active",
            "regionType": "县",
            "id": "2638"
          }
        ],
        "id": "313"
      },
      {
        "regionName": "保山市",
        "pid": "30",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "隆阳区",
            "pid": "314",
            "status": "active",
            "regionType": "县",
            "id": "2639"
          },
          {
            "regionName": "施甸县",
            "pid": "314",
            "status": "active",
            "regionType": "县",
            "id": "2640"
          },
          {
            "regionName": "腾冲县",
            "pid": "314",
            "status": "active",
            "regionType": "县",
            "id": "2641"
          },
          {
            "regionName": "龙陵县",
            "pid": "314",
            "status": "active",
            "regionType": "县",
            "id": "2642"
          },
          {
            "regionName": "昌宁县",
            "pid": "314",
            "status": "active",
            "regionType": "县",
            "id": "2643"
          }
        ],
        "id": "314"
      },
      {
        "regionName": "文山壮族苗族自治州",
        "pid": "30",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "文山县",
            "pid": "315",
            "status": "active",
            "regionType": "县",
            "id": "2644"
          },
          {
            "regionName": "砚山县",
            "pid": "315",
            "status": "active",
            "regionType": "县",
            "id": "2645"
          },
          {
            "regionName": "西畴县",
            "pid": "315",
            "status": "active",
            "regionType": "县",
            "id": "2646"
          },
          {
            "regionName": "麻栗坡县",
            "pid": "315",
            "status": "active",
            "regionType": "县",
            "id": "2647"
          },
          {
            "regionName": "马关县",
            "pid": "315",
            "status": "active",
            "regionType": "县",
            "id": "2648"
          },
          {
            "regionName": "丘北县",
            "pid": "315",
            "status": "active",
            "regionType": "县",
            "id": "2649"
          },
          {
            "regionName": "广南县",
            "pid": "315",
            "status": "active",
            "regionType": "县",
            "id": "2650"
          },
          {
            "regionName": "富宁县",
            "pid": "315",
            "status": "active",
            "regionType": "县",
            "id": "2651"
          }
        ],
        "id": "315"
      },
      {
        "regionName": "玉溪市",
        "pid": "30",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "红塔区",
            "pid": "316",
            "status": "active",
            "regionType": "县",
            "id": "2652"
          },
          {
            "regionName": "江川县",
            "pid": "316",
            "status": "active",
            "regionType": "县",
            "id": "2653"
          },
          {
            "regionName": "澄江县",
            "pid": "316",
            "status": "active",
            "regionType": "县",
            "id": "2654"
          },
          {
            "regionName": "通海县",
            "pid": "316",
            "status": "active",
            "regionType": "县",
            "id": "2655"
          },
          {
            "regionName": "华宁县",
            "pid": "316",
            "status": "active",
            "regionType": "县",
            "id": "2656"
          },
          {
            "regionName": "易门县",
            "pid": "316",
            "status": "active",
            "regionType": "县",
            "id": "2657"
          },
          {
            "regionName": "峨山彝族自治县",
            "pid": "316",
            "status": "active",
            "regionType": "县",
            "id": "2658"
          },
          {
            "regionName": "新平彝族傣族自治县",
            "pid": "316",
            "status": "active",
            "regionType": "县",
            "id": "2659"
          },
          {
            "regionName": "元江哈尼族彝族傣族自治县",
            "pid": "316",
            "status": "active",
            "regionType": "县",
            "id": "2660"
          }
        ],
        "id": "316"
      },
      {
        "regionName": "楚雄彝族自治州",
        "pid": "30",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "楚雄市",
            "pid": "317",
            "status": "active",
            "regionType": "县",
            "id": "2661"
          },
          {
            "regionName": "双柏县",
            "pid": "317",
            "status": "active",
            "regionType": "县",
            "id": "2662"
          },
          {
            "regionName": "牟定县",
            "pid": "317",
            "status": "active",
            "regionType": "县",
            "id": "2663"
          },
          {
            "regionName": "南华县",
            "pid": "317",
            "status": "active",
            "regionType": "县",
            "id": "2664"
          },
          {
            "regionName": "姚安县",
            "pid": "317",
            "status": "active",
            "regionType": "县",
            "id": "2665"
          },
          {
            "regionName": "大姚县",
            "pid": "317",
            "status": "active",
            "regionType": "县",
            "id": "2666"
          },
          {
            "regionName": "永仁县",
            "pid": "317",
            "status": "active",
            "regionType": "县",
            "id": "2667"
          },
          {
            "regionName": "元谋县",
            "pid": "317",
            "status": "active",
            "regionType": "县",
            "id": "2668"
          },
          {
            "regionName": "武定县",
            "pid": "317",
            "status": "active",
            "regionType": "县",
            "id": "2669"
          },
          {
            "regionName": "禄丰县",
            "pid": "317",
            "status": "active",
            "regionType": "县",
            "id": "2670"
          }
        ],
        "id": "317"
      },
      {
        "regionName": "普洱市",
        "pid": "30",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "思茅区",
            "pid": "318",
            "status": "active",
            "regionType": "县",
            "id": "2671"
          },
          {
            "regionName": "宁洱哈尼族彝族自治县",
            "pid": "318",
            "status": "active",
            "regionType": "县",
            "id": "2672"
          },
          {
            "regionName": "墨江哈尼族自治县",
            "pid": "318",
            "status": "active",
            "regionType": "县",
            "id": "2673"
          },
          {
            "regionName": "景东彝族自治县",
            "pid": "318",
            "status": "active",
            "regionType": "县",
            "id": "2674"
          },
          {
            "regionName": "景谷傣族彝族自治县",
            "pid": "318",
            "status": "active",
            "regionType": "县",
            "id": "2675"
          },
          {
            "regionName": "镇沅彝族哈尼族拉祜族自治县",
            "pid": "318",
            "status": "active",
            "regionType": "县",
            "id": "2676"
          },
          {
            "regionName": "江城哈尼族彝族自治县",
            "pid": "318",
            "status": "active",
            "regionType": "县",
            "id": "2677"
          },
          {
            "regionName": "孟连傣族拉祜族佤族自治县",
            "pid": "318",
            "status": "active",
            "regionType": "县",
            "id": "2678"
          },
          {
            "regionName": "澜沧拉祜族自治县",
            "pid": "318",
            "status": "active",
            "regionType": "县",
            "id": "2679"
          },
          {
            "regionName": "西盟佤族自治县",
            "pid": "318",
            "status": "active",
            "regionType": "县",
            "id": "2680"
          }
        ],
        "id": "318"
      },
      {
        "regionName": "临沧市",
        "pid": "30",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "临翔区",
            "pid": "319",
            "status": "active",
            "regionType": "县",
            "id": "2681"
          },
          {
            "regionName": "凤庆县",
            "pid": "319",
            "status": "active",
            "regionType": "县",
            "id": "2682"
          },
          {
            "regionName": "云县",
            "pid": "319",
            "status": "active",
            "regionType": "县",
            "id": "2683"
          },
          {
            "regionName": "永德县",
            "pid": "319",
            "status": "active",
            "regionType": "县",
            "id": "2684"
          },
          {
            "regionName": "镇康县",
            "pid": "319",
            "status": "active",
            "regionType": "县",
            "id": "2685"
          },
          {
            "regionName": "双江拉祜族佤族布朗族傣族自治县",
            "pid": "319",
            "status": "active",
            "regionType": "县",
            "id": "2686"
          },
          {
            "regionName": "耿马傣族佤族自治县",
            "pid": "319",
            "status": "active",
            "regionType": "县",
            "id": "2687"
          },
          {
            "regionName": "沧源佤族自治县",
            "pid": "319",
            "status": "active",
            "regionType": "县",
            "id": "2688"
          }
        ],
        "id": "319"
      },
      {
        "regionName": "怒江傈僳族自治州",
        "pid": "30",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "泸水县",
            "pid": "320",
            "status": "active",
            "regionType": "县",
            "id": "2689"
          },
          {
            "regionName": "福贡县",
            "pid": "320",
            "status": "active",
            "regionType": "县",
            "id": "2690"
          },
          {
            "regionName": "贡山独龙族怒族自治县",
            "pid": "320",
            "status": "active",
            "regionType": "县",
            "id": "2691"
          },
          {
            "regionName": "兰坪白族普米族自治县",
            "pid": "320",
            "status": "active",
            "regionType": "县",
            "id": "2692"
          }
        ],
        "id": "320"
      },
      {
        "regionName": "迪庆藏族自治州",
        "pid": "30",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "香格里拉县",
            "pid": "321",
            "status": "active",
            "regionType": "县",
            "id": "2693"
          },
          {
            "regionName": "德钦县",
            "pid": "321",
            "status": "active",
            "regionType": "县",
            "id": "2694"
          },
          {
            "regionName": "维西傈僳族自治县",
            "pid": "321",
            "status": "active",
            "regionType": "县",
            "id": "2695"
          }
        ],
        "id": "321"
      },
      {
        "regionName": "丽江市",
        "pid": "30",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "古城区",
            "pid": "322",
            "status": "active",
            "regionType": "县",
            "id": "2696"
          },
          {
            "regionName": "玉龙纳西族自治县",
            "pid": "322",
            "status": "active",
            "regionType": "县",
            "id": "2697"
          },
          {
            "regionName": "永胜县",
            "pid": "322",
            "status": "active",
            "regionType": "县",
            "id": "2698"
          },
          {
            "regionName": "华坪县",
            "pid": "322",
            "status": "active",
            "regionType": "县",
            "id": "2699"
          },
          {
            "regionName": "宁蒗彝族自治县",
            "pid": "322",
            "status": "active",
            "regionType": "县",
            "id": "2700"
          }
        ],
        "id": "322"
      }
    ],
    "regionName": "云南省",
    "pid": "0",
    "status": "active",
    "regionType": "省",
    "id": "30"
  },
  {
    "city": [
      {
        "regionName": "拉萨市",
        "pid": "31",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "城关区",
            "pid": "355",
            "status": "active",
            "regionType": "县",
            "id": "2960"
          },
          {
            "regionName": "林周县",
            "pid": "355",
            "status": "active",
            "regionType": "县",
            "id": "2961"
          },
          {
            "regionName": "当雄县",
            "pid": "355",
            "status": "active",
            "regionType": "县",
            "id": "2962"
          },
          {
            "regionName": "尼木县",
            "pid": "355",
            "status": "active",
            "regionType": "县",
            "id": "2963"
          },
          {
            "regionName": "曲水县",
            "pid": "355",
            "status": "active",
            "regionType": "县",
            "id": "2964"
          },
          {
            "regionName": "堆龙德庆县",
            "pid": "355",
            "status": "active",
            "regionType": "县",
            "id": "2965"
          },
          {
            "regionName": "达孜县",
            "pid": "355",
            "status": "active",
            "regionType": "县",
            "id": "2966"
          },
          {
            "regionName": "墨竹工卡县",
            "pid": "355",
            "status": "active",
            "regionType": "县",
            "id": "2967"
          }
        ],
        "id": "355"
      },
      {
        "regionName": "日喀则地区",
        "pid": "31",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "日喀则市",
            "pid": "356",
            "status": "active",
            "regionType": "县",
            "id": "2968"
          },
          {
            "regionName": "南木林县",
            "pid": "356",
            "status": "active",
            "regionType": "县",
            "id": "2969"
          },
          {
            "regionName": "江孜县",
            "pid": "356",
            "status": "active",
            "regionType": "县",
            "id": "2970"
          },
          {
            "regionName": "定日县",
            "pid": "356",
            "status": "active",
            "regionType": "县",
            "id": "2971"
          },
          {
            "regionName": "萨迦县",
            "pid": "356",
            "status": "active",
            "regionType": "县",
            "id": "2972"
          },
          {
            "regionName": "拉孜县",
            "pid": "356",
            "status": "active",
            "regionType": "县",
            "id": "2973"
          },
          {
            "regionName": "昂仁县",
            "pid": "356",
            "status": "active",
            "regionType": "县",
            "id": "2974"
          },
          {
            "regionName": "谢通门县",
            "pid": "356",
            "status": "active",
            "regionType": "县",
            "id": "2975"
          },
          {
            "regionName": "白朗县",
            "pid": "356",
            "status": "active",
            "regionType": "县",
            "id": "2976"
          },
          {
            "regionName": "仁布县",
            "pid": "356",
            "status": "active",
            "regionType": "县",
            "id": "2977"
          },
          {
            "regionName": "康马县",
            "pid": "356",
            "status": "active",
            "regionType": "县",
            "id": "2978"
          },
          {
            "regionName": "定结县",
            "pid": "356",
            "status": "active",
            "regionType": "县",
            "id": "2979"
          },
          {
            "regionName": "仲巴县",
            "pid": "356",
            "status": "active",
            "regionType": "县",
            "id": "2980"
          },
          {
            "regionName": "亚东县",
            "pid": "356",
            "status": "active",
            "regionType": "县",
            "id": "2981"
          },
          {
            "regionName": "吉隆县",
            "pid": "356",
            "status": "active",
            "regionType": "县",
            "id": "2982"
          },
          {
            "regionName": "聂拉木县",
            "pid": "356",
            "status": "active",
            "regionType": "县",
            "id": "2983"
          },
          {
            "regionName": "萨嘎县",
            "pid": "356",
            "status": "active",
            "regionType": "县",
            "id": "2984"
          },
          {
            "regionName": "岗巴县",
            "pid": "356",
            "status": "active",
            "regionType": "县",
            "id": "2985"
          }
        ],
        "id": "356"
      },
      {
        "regionName": "山南地区",
        "pid": "31",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "乃东县",
            "pid": "357",
            "status": "active",
            "regionType": "县",
            "id": "2986"
          },
          {
            "regionName": "扎囊县",
            "pid": "357",
            "status": "active",
            "regionType": "县",
            "id": "2987"
          },
          {
            "regionName": "贡嘎县",
            "pid": "357",
            "status": "active",
            "regionType": "县",
            "id": "2988"
          },
          {
            "regionName": "桑日县",
            "pid": "357",
            "status": "active",
            "regionType": "县",
            "id": "2989"
          },
          {
            "regionName": "琼结县",
            "pid": "357",
            "status": "active",
            "regionType": "县",
            "id": "2990"
          },
          {
            "regionName": "曲松县",
            "pid": "357",
            "status": "active",
            "regionType": "县",
            "id": "2991"
          },
          {
            "regionName": "措美县",
            "pid": "357",
            "status": "active",
            "regionType": "县",
            "id": "2992"
          },
          {
            "regionName": "洛扎县",
            "pid": "357",
            "status": "active",
            "regionType": "县",
            "id": "2993"
          },
          {
            "regionName": "加查县",
            "pid": "357",
            "status": "active",
            "regionType": "县",
            "id": "2994"
          },
          {
            "regionName": "隆子县",
            "pid": "357",
            "status": "active",
            "regionType": "县",
            "id": "2995"
          },
          {
            "regionName": "错那县",
            "pid": "357",
            "status": "active",
            "regionType": "县",
            "id": "2996"
          },
          {
            "regionName": "浪卡子县",
            "pid": "357",
            "status": "active",
            "regionType": "县",
            "id": "2997"
          }
        ],
        "id": "357"
      },
      {
        "regionName": "林芝市",
        "pid": "31",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "林芝县",
            "pid": "358",
            "status": "active",
            "regionType": "县",
            "id": "2998"
          },
          {
            "regionName": "工布江达县",
            "pid": "358",
            "status": "active",
            "regionType": "县",
            "id": "2999"
          },
          {
            "regionName": "米林县",
            "pid": "358",
            "status": "active",
            "regionType": "县",
            "id": "3000"
          },
          {
            "regionName": "墨脱县",
            "pid": "358",
            "status": "active",
            "regionType": "县",
            "id": "3001"
          },
          {
            "regionName": "波密县",
            "pid": "358",
            "status": "active",
            "regionType": "县",
            "id": "3002"
          },
          {
            "regionName": "察隅县",
            "pid": "358",
            "status": "active",
            "regionType": "县",
            "id": "3003"
          },
          {
            "regionName": "朗县",
            "pid": "358",
            "status": "active",
            "regionType": "县",
            "id": "3004"
          }
        ],
        "id": "358"
      },
      {
        "regionName": "昌都市",
        "pid": "31",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "昌都县",
            "pid": "359",
            "status": "active",
            "regionType": "县",
            "id": "3005"
          },
          {
            "regionName": "江达县",
            "pid": "359",
            "status": "active",
            "regionType": "县",
            "id": "3006"
          },
          {
            "regionName": "贡觉县",
            "pid": "359",
            "status": "active",
            "regionType": "县",
            "id": "3007"
          },
          {
            "regionName": "类乌齐县",
            "pid": "359",
            "status": "active",
            "regionType": "县",
            "id": "3008"
          },
          {
            "regionName": "丁青县",
            "pid": "359",
            "status": "active",
            "regionType": "县",
            "id": "3009"
          },
          {
            "regionName": "察雅县",
            "pid": "359",
            "status": "active",
            "regionType": "县",
            "id": "3010"
          },
          {
            "regionName": "八宿县",
            "pid": "359",
            "status": "active",
            "regionType": "县",
            "id": "3011"
          },
          {
            "regionName": "左贡县",
            "pid": "359",
            "status": "active",
            "regionType": "县",
            "id": "3012"
          },
          {
            "regionName": "芒康县",
            "pid": "359",
            "status": "active",
            "regionType": "县",
            "id": "3013"
          },
          {
            "regionName": "洛隆县",
            "pid": "359",
            "status": "active",
            "regionType": "县",
            "id": "3014"
          },
          {
            "regionName": "边坝县",
            "pid": "359",
            "status": "active",
            "regionType": "县",
            "id": "3015"
          }
        ],
        "id": "359"
      },
      {
        "regionName": "那曲地区",
        "pid": "31",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "那曲县",
            "pid": "360",
            "status": "active",
            "regionType": "县",
            "id": "3016"
          },
          {
            "regionName": "嘉黎县",
            "pid": "360",
            "status": "active",
            "regionType": "县",
            "id": "3017"
          },
          {
            "regionName": "比如县",
            "pid": "360",
            "status": "active",
            "regionType": "县",
            "id": "3018"
          },
          {
            "regionName": "聂荣县",
            "pid": "360",
            "status": "active",
            "regionType": "县",
            "id": "3019"
          },
          {
            "regionName": "安多县",
            "pid": "360",
            "status": "active",
            "regionType": "县",
            "id": "3020"
          },
          {
            "regionName": "申扎县",
            "pid": "360",
            "status": "active",
            "regionType": "县",
            "id": "3021"
          },
          {
            "regionName": "索县",
            "pid": "360",
            "status": "active",
            "regionType": "县",
            "id": "3022"
          },
          {
            "regionName": "班戈县",
            "pid": "360",
            "status": "active",
            "regionType": "县",
            "id": "3023"
          },
          {
            "regionName": "巴青县",
            "pid": "360",
            "status": "active",
            "regionType": "县",
            "id": "3024"
          },
          {
            "regionName": "尼玛县",
            "pid": "360",
            "status": "active",
            "regionType": "县",
            "id": "3025"
          }
        ],
        "id": "360"
      },
      {
        "regionName": "阿里地区",
        "pid": "31",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "普兰县",
            "pid": "361",
            "status": "active",
            "regionType": "县",
            "id": "3026"
          },
          {
            "regionName": "札达县",
            "pid": "361",
            "status": "active",
            "regionType": "县",
            "id": "3027"
          },
          {
            "regionName": "噶尔县",
            "pid": "361",
            "status": "active",
            "regionType": "县",
            "id": "3028"
          },
          {
            "regionName": "日土县",
            "pid": "361",
            "status": "active",
            "regionType": "县",
            "id": "3029"
          },
          {
            "regionName": "革吉县",
            "pid": "361",
            "status": "active",
            "regionType": "县",
            "id": "3030"
          },
          {
            "regionName": "改则县",
            "pid": "361",
            "status": "active",
            "regionType": "县",
            "id": "3031"
          },
          {
            "regionName": "措勤县",
            "pid": "361",
            "status": "active",
            "regionType": "县",
            "id": "3032"
          }
        ],
        "id": "361"
      }
    ],
    "regionName": "西藏自治区",
    "pid": "0",
    "status": "active",
    "regionType": "省",
    "id": "31"
  },
  {
    "city": [
      {
        "regionName": "台北市",
        "pid": "32",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "中正区",
            "pid": "398",
            "status": "active",
            "regionType": "县",
            "id": "3267"
          },
          {
            "regionName": "大同区",
            "pid": "398",
            "status": "active",
            "regionType": "县",
            "id": "3268"
          },
          {
            "regionName": "中山区",
            "pid": "398",
            "status": "active",
            "regionType": "县",
            "id": "3269"
          },
          {
            "regionName": "松山区",
            "pid": "398",
            "status": "active",
            "regionType": "县",
            "id": "3270"
          },
          {
            "regionName": "大安区",
            "pid": "398",
            "status": "active",
            "regionType": "县",
            "id": "3271"
          },
          {
            "regionName": "万华区",
            "pid": "398",
            "status": "active",
            "regionType": "县",
            "id": "3272"
          },
          {
            "regionName": "信义区",
            "pid": "398",
            "status": "active",
            "regionType": "县",
            "id": "3273"
          },
          {
            "regionName": "士林区",
            "pid": "398",
            "status": "active",
            "regionType": "县",
            "id": "3274"
          },
          {
            "regionName": "北投区",
            "pid": "398",
            "status": "active",
            "regionType": "县",
            "id": "3275"
          },
          {
            "regionName": "内湖区",
            "pid": "398",
            "status": "active",
            "regionType": "县",
            "id": "3276"
          },
          {
            "regionName": "南港区",
            "pid": "398",
            "status": "active",
            "regionType": "县",
            "id": "3277"
          },
          {
            "regionName": "文山区",
            "pid": "398",
            "status": "active",
            "regionType": "县",
            "id": "3278"
          }
        ],
        "id": "398"
      },
      {
        "regionName": "高雄市",
        "pid": "32",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "新兴区",
            "pid": "399",
            "status": "active",
            "regionType": "县",
            "id": "3279"
          },
          {
            "regionName": "前金区",
            "pid": "399",
            "status": "active",
            "regionType": "县",
            "id": "3280"
          },
          {
            "regionName": "芩雅区",
            "pid": "399",
            "status": "active",
            "regionType": "县",
            "id": "3281"
          },
          {
            "regionName": "盐埕区",
            "pid": "399",
            "status": "active",
            "regionType": "县",
            "id": "3282"
          },
          {
            "regionName": "鼓山区",
            "pid": "399",
            "status": "active",
            "regionType": "县",
            "id": "3283"
          },
          {
            "regionName": "旗津区",
            "pid": "399",
            "status": "active",
            "regionType": "县",
            "id": "3284"
          },
          {
            "regionName": "前镇区",
            "pid": "399",
            "status": "active",
            "regionType": "县",
            "id": "3285"
          },
          {
            "regionName": "三民区",
            "pid": "399",
            "status": "active",
            "regionType": "县",
            "id": "3286"
          },
          {
            "regionName": "左营区",
            "pid": "399",
            "status": "active",
            "regionType": "县",
            "id": "3287"
          },
          {
            "regionName": "楠梓区",
            "pid": "399",
            "status": "active",
            "regionType": "县",
            "id": "3288"
          },
          {
            "regionName": "小港区",
            "pid": "399",
            "status": "active",
            "regionType": "县",
            "id": "3289"
          },
          {
            "regionName": "苓雅区",
            "pid": "399",
            "status": "active",
            "regionType": "县",
            "id": "3290"
          },
          {
            "regionName": "仁武区",
            "pid": "399",
            "status": "active",
            "regionType": "县",
            "id": "3291"
          },
          {
            "regionName": "大社区",
            "pid": "399",
            "status": "active",
            "regionType": "县",
            "id": "3292"
          },
          {
            "regionName": "冈山区",
            "pid": "399",
            "status": "active",
            "regionType": "县",
            "id": "3293"
          },
          {
            "regionName": "路竹区",
            "pid": "399",
            "status": "active",
            "regionType": "县",
            "id": "3294"
          },
          {
            "regionName": "阿莲区",
            "pid": "399",
            "status": "active",
            "regionType": "县",
            "id": "3295"
          },
          {
            "regionName": "田寮区",
            "pid": "399",
            "status": "active",
            "regionType": "县",
            "id": "3296"
          },
          {
            "regionName": "燕巢区",
            "pid": "399",
            "status": "active",
            "regionType": "县",
            "id": "3297"
          },
          {
            "regionName": "桥头区",
            "pid": "399",
            "status": "active",
            "regionType": "县",
            "id": "3298"
          },
          {
            "regionName": "梓官区",
            "pid": "399",
            "status": "active",
            "regionType": "县",
            "id": "3299"
          },
          {
            "regionName": "弥陀区",
            "pid": "399",
            "status": "active",
            "regionType": "县",
            "id": "3300"
          },
          {
            "regionName": "永安区",
            "pid": "399",
            "status": "active",
            "regionType": "县",
            "id": "3301"
          },
          {
            "regionName": "湖内区",
            "pid": "399",
            "status": "active",
            "regionType": "县",
            "id": "3302"
          },
          {
            "regionName": "凤山区",
            "pid": "399",
            "status": "active",
            "regionType": "县",
            "id": "3303"
          },
          {
            "regionName": "大寮区",
            "pid": "399",
            "status": "active",
            "regionType": "县",
            "id": "3304"
          },
          {
            "regionName": "林园区",
            "pid": "399",
            "status": "active",
            "regionType": "县",
            "id": "3305"
          },
          {
            "regionName": "鸟松区",
            "pid": "399",
            "status": "active",
            "regionType": "县",
            "id": "3306"
          },
          {
            "regionName": "大树区",
            "pid": "399",
            "status": "active",
            "regionType": "县",
            "id": "3307"
          },
          {
            "regionName": "旗山区",
            "pid": "399",
            "status": "active",
            "regionType": "县",
            "id": "3308"
          },
          {
            "regionName": "美浓区",
            "pid": "399",
            "status": "active",
            "regionType": "县",
            "id": "3309"
          },
          {
            "regionName": "六龟区",
            "pid": "399",
            "status": "active",
            "regionType": "县",
            "id": "3310"
          },
          {
            "regionName": "内门区",
            "pid": "399",
            "status": "active",
            "regionType": "县",
            "id": "3311"
          },
          {
            "regionName": "杉林区",
            "pid": "399",
            "status": "active",
            "regionType": "县",
            "id": "3312"
          },
          {
            "regionName": "甲仙区",
            "pid": "399",
            "status": "active",
            "regionType": "县",
            "id": "3313"
          },
          {
            "regionName": "桃源区",
            "pid": "399",
            "status": "active",
            "regionType": "县",
            "id": "3314"
          },
          {
            "regionName": "那玛夏区",
            "pid": "399",
            "status": "active",
            "regionType": "县",
            "id": "3315"
          },
          {
            "regionName": "茂林区",
            "pid": "399",
            "status": "active",
            "regionType": "县",
            "id": "3316"
          },
          {
            "regionName": "茄萣区",
            "pid": "399",
            "status": "active",
            "regionType": "县",
            "id": "3317"
          }
        ],
        "id": "399"
      },
      {
        "regionName": "台南市",
        "pid": "32",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "中西区",
            "pid": "400",
            "status": "active",
            "regionType": "县",
            "id": "3318"
          },
          {
            "regionName": "东区",
            "pid": "400",
            "status": "active",
            "regionType": "县",
            "id": "3319"
          },
          {
            "regionName": "南区",
            "pid": "400",
            "status": "active",
            "regionType": "县",
            "id": "3320"
          },
          {
            "regionName": "北区",
            "pid": "400",
            "status": "active",
            "regionType": "县",
            "id": "3321"
          },
          {
            "regionName": "安平区",
            "pid": "400",
            "status": "active",
            "regionType": "县",
            "id": "3322"
          },
          {
            "regionName": "安南区",
            "pid": "400",
            "status": "active",
            "regionType": "县",
            "id": "3323"
          },
          {
            "regionName": "永康区",
            "pid": "400",
            "status": "active",
            "regionType": "县",
            "id": "3324"
          },
          {
            "regionName": "归仁区",
            "pid": "400",
            "status": "active",
            "regionType": "县",
            "id": "3325"
          },
          {
            "regionName": "新化区",
            "pid": "400",
            "status": "active",
            "regionType": "县",
            "id": "3326"
          },
          {
            "regionName": "左镇区",
            "pid": "400",
            "status": "active",
            "regionType": "县",
            "id": "3327"
          },
          {
            "regionName": "玉井区",
            "pid": "400",
            "status": "active",
            "regionType": "县",
            "id": "3328"
          },
          {
            "regionName": "楠西区",
            "pid": "400",
            "status": "active",
            "regionType": "县",
            "id": "3329"
          },
          {
            "regionName": "南化区",
            "pid": "400",
            "status": "active",
            "regionType": "县",
            "id": "3330"
          },
          {
            "regionName": "仁德区",
            "pid": "400",
            "status": "active",
            "regionType": "县",
            "id": "3331"
          },
          {
            "regionName": "关庙区",
            "pid": "400",
            "status": "active",
            "regionType": "县",
            "id": "3332"
          },
          {
            "regionName": "龙崎区",
            "pid": "400",
            "status": "active",
            "regionType": "县",
            "id": "3333"
          },
          {
            "regionName": "官田区",
            "pid": "400",
            "status": "active",
            "regionType": "县",
            "id": "3334"
          },
          {
            "regionName": "麻豆区",
            "pid": "400",
            "status": "active",
            "regionType": "县",
            "id": "3335"
          },
          {
            "regionName": "佳里区",
            "pid": "400",
            "status": "active",
            "regionType": "县",
            "id": "3336"
          },
          {
            "regionName": "西港区",
            "pid": "400",
            "status": "active",
            "regionType": "县",
            "id": "3337"
          },
          {
            "regionName": "七股区",
            "pid": "400",
            "status": "active",
            "regionType": "县",
            "id": "3338"
          },
          {
            "regionName": "将军区",
            "pid": "400",
            "status": "active",
            "regionType": "县",
            "id": "3339"
          },
          {
            "regionName": "学甲区",
            "pid": "400",
            "status": "active",
            "regionType": "县",
            "id": "3340"
          },
          {
            "regionName": "北门区",
            "pid": "400",
            "status": "active",
            "regionType": "县",
            "id": "3341"
          },
          {
            "regionName": "新营区",
            "pid": "400",
            "status": "active",
            "regionType": "县",
            "id": "3342"
          },
          {
            "regionName": "后壁区",
            "pid": "400",
            "status": "active",
            "regionType": "县",
            "id": "3343"
          },
          {
            "regionName": "白河区",
            "pid": "400",
            "status": "active",
            "regionType": "县",
            "id": "3344"
          },
          {
            "regionName": "东山区",
            "pid": "400",
            "status": "active",
            "regionType": "县",
            "id": "3345"
          },
          {
            "regionName": "六甲区",
            "pid": "400",
            "status": "active",
            "regionType": "县",
            "id": "3346"
          },
          {
            "regionName": "下营区",
            "pid": "400",
            "status": "active",
            "regionType": "县",
            "id": "3347"
          },
          {
            "regionName": "柳营区",
            "pid": "400",
            "status": "active",
            "regionType": "县",
            "id": "3348"
          },
          {
            "regionName": "盐水区",
            "pid": "400",
            "status": "active",
            "regionType": "县",
            "id": "3349"
          },
          {
            "regionName": "善化区",
            "pid": "400",
            "status": "active",
            "regionType": "县",
            "id": "3350"
          },
          {
            "regionName": "大内区",
            "pid": "400",
            "status": "active",
            "regionType": "县",
            "id": "3351"
          },
          {
            "regionName": "山上区",
            "pid": "400",
            "status": "active",
            "regionType": "县",
            "id": "3352"
          },
          {
            "regionName": "新市区",
            "pid": "400",
            "status": "active",
            "regionType": "县",
            "id": "3353"
          },
          {
            "regionName": "安定区",
            "pid": "400",
            "status": "active",
            "regionType": "县",
            "id": "3354"
          }
        ],
        "id": "400"
      },
      {
        "regionName": "台中市",
        "pid": "32",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "中区",
            "pid": "401",
            "status": "active",
            "regionType": "县",
            "id": "3355"
          },
          {
            "regionName": "东区",
            "pid": "401",
            "status": "active",
            "regionType": "县",
            "id": "3356"
          },
          {
            "regionName": "南区",
            "pid": "401",
            "status": "active",
            "regionType": "县",
            "id": "3357"
          },
          {
            "regionName": "西区",
            "pid": "401",
            "status": "active",
            "regionType": "县",
            "id": "3358"
          },
          {
            "regionName": "北区",
            "pid": "401",
            "status": "active",
            "regionType": "县",
            "id": "3359"
          },
          {
            "regionName": "北屯区",
            "pid": "401",
            "status": "active",
            "regionType": "县",
            "id": "3360"
          },
          {
            "regionName": "西屯区",
            "pid": "401",
            "status": "active",
            "regionType": "县",
            "id": "3361"
          },
          {
            "regionName": "南屯区",
            "pid": "401",
            "status": "active",
            "regionType": "县",
            "id": "3362"
          },
          {
            "regionName": "太平区",
            "pid": "401",
            "status": "active",
            "regionType": "县",
            "id": "3363"
          },
          {
            "regionName": "大里区",
            "pid": "401",
            "status": "active",
            "regionType": "县",
            "id": "3364"
          },
          {
            "regionName": "雾峰区",
            "pid": "401",
            "status": "active",
            "regionType": "县",
            "id": "3365"
          },
          {
            "regionName": "乌日区",
            "pid": "401",
            "status": "active",
            "regionType": "县",
            "id": "3366"
          },
          {
            "regionName": "丰原区",
            "pid": "401",
            "status": "active",
            "regionType": "县",
            "id": "3367"
          },
          {
            "regionName": "后里区",
            "pid": "401",
            "status": "active",
            "regionType": "县",
            "id": "3368"
          },
          {
            "regionName": "石冈区",
            "pid": "401",
            "status": "active",
            "regionType": "县",
            "id": "3369"
          },
          {
            "regionName": "东势区",
            "pid": "401",
            "status": "active",
            "regionType": "县",
            "id": "3370"
          },
          {
            "regionName": "和平区",
            "pid": "401",
            "status": "active",
            "regionType": "县",
            "id": "3371"
          },
          {
            "regionName": "新社区",
            "pid": "401",
            "status": "active",
            "regionType": "县",
            "id": "3372"
          },
          {
            "regionName": "潭子区",
            "pid": "401",
            "status": "active",
            "regionType": "县",
            "id": "3373"
          },
          {
            "regionName": "大雅区",
            "pid": "401",
            "status": "active",
            "regionType": "县",
            "id": "3374"
          },
          {
            "regionName": "神冈区",
            "pid": "401",
            "status": "active",
            "regionType": "县",
            "id": "3375"
          },
          {
            "regionName": "大肚区",
            "pid": "401",
            "status": "active",
            "regionType": "县",
            "id": "3376"
          },
          {
            "regionName": "沙鹿区",
            "pid": "401",
            "status": "active",
            "regionType": "县",
            "id": "3377"
          },
          {
            "regionName": "龙井区",
            "pid": "401",
            "status": "active",
            "regionType": "县",
            "id": "3378"
          },
          {
            "regionName": "梧栖区",
            "pid": "401",
            "status": "active",
            "regionType": "县",
            "id": "3379"
          },
          {
            "regionName": "清水区",
            "pid": "401",
            "status": "active",
            "regionType": "县",
            "id": "3380"
          },
          {
            "regionName": "大甲区",
            "pid": "401",
            "status": "active",
            "regionType": "县",
            "id": "3381"
          },
          {
            "regionName": "外埔区",
            "pid": "401",
            "status": "active",
            "regionType": "县",
            "id": "3382"
          },
          {
            "regionName": "大安区",
            "pid": "401",
            "status": "active",
            "regionType": "县",
            "id": "3383"
          }
        ],
        "id": "401"
      },
      {
        "regionName": "金门县",
        "pid": "32",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "金沙镇",
            "pid": "402",
            "status": "active",
            "regionType": "县",
            "id": "3384"
          },
          {
            "regionName": "金湖镇",
            "pid": "402",
            "status": "active",
            "regionType": "县",
            "id": "3385"
          },
          {
            "regionName": "金宁乡",
            "pid": "402",
            "status": "active",
            "regionType": "县",
            "id": "3386"
          },
          {
            "regionName": "金城镇",
            "pid": "402",
            "status": "active",
            "regionType": "县",
            "id": "3387"
          },
          {
            "regionName": "烈屿乡",
            "pid": "402",
            "status": "active",
            "regionType": "县",
            "id": "3388"
          },
          {
            "regionName": "乌坵乡",
            "pid": "402",
            "status": "active",
            "regionType": "县",
            "id": "3389"
          }
        ],
        "id": "402"
      },
      {
        "regionName": "南投县",
        "pid": "32",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "南投市",
            "pid": "403",
            "status": "active",
            "regionType": "县",
            "id": "3390"
          },
          {
            "regionName": "中寮乡",
            "pid": "403",
            "status": "active",
            "regionType": "县",
            "id": "3391"
          },
          {
            "regionName": "草屯镇",
            "pid": "403",
            "status": "active",
            "regionType": "县",
            "id": "3392"
          },
          {
            "regionName": "国姓乡",
            "pid": "403",
            "status": "active",
            "regionType": "县",
            "id": "3393"
          },
          {
            "regionName": "埔里镇",
            "pid": "403",
            "status": "active",
            "regionType": "县",
            "id": "3394"
          },
          {
            "regionName": "仁爱乡",
            "pid": "403",
            "status": "active",
            "regionType": "县",
            "id": "3395"
          },
          {
            "regionName": "名间乡",
            "pid": "403",
            "status": "active",
            "regionType": "县",
            "id": "3396"
          },
          {
            "regionName": "集集镇",
            "pid": "403",
            "status": "active",
            "regionType": "县",
            "id": "3397"
          },
          {
            "regionName": "水里乡",
            "pid": "403",
            "status": "active",
            "regionType": "县",
            "id": "3398"
          },
          {
            "regionName": "鱼池乡",
            "pid": "403",
            "status": "active",
            "regionType": "县",
            "id": "3399"
          },
          {
            "regionName": "信义乡",
            "pid": "403",
            "status": "active",
            "regionType": "县",
            "id": "3400"
          },
          {
            "regionName": "竹山镇",
            "pid": "403",
            "status": "active",
            "regionType": "县",
            "id": "3401"
          },
          {
            "regionName": "鹿谷乡",
            "pid": "403",
            "status": "active",
            "regionType": "县",
            "id": "3402"
          }
        ],
        "id": "403"
      },
      {
        "regionName": "基隆市",
        "pid": "32",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "仁爱区",
            "pid": "404",
            "status": "active",
            "regionType": "县",
            "id": "3403"
          },
          {
            "regionName": "信义区",
            "pid": "404",
            "status": "active",
            "regionType": "县",
            "id": "3404"
          },
          {
            "regionName": "中正区",
            "pid": "404",
            "status": "active",
            "regionType": "县",
            "id": "3405"
          },
          {
            "regionName": "中山区",
            "pid": "404",
            "status": "active",
            "regionType": "县",
            "id": "3406"
          },
          {
            "regionName": "安乐区",
            "pid": "404",
            "status": "active",
            "regionType": "县",
            "id": "3407"
          },
          {
            "regionName": "暖暖区",
            "pid": "404",
            "status": "active",
            "regionType": "县",
            "id": "3408"
          },
          {
            "regionName": "七堵区",
            "pid": "404",
            "status": "active",
            "regionType": "县",
            "id": "3409"
          }
        ],
        "id": "404"
      },
      {
        "regionName": "新竹市",
        "pid": "32",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "东区",
            "pid": "405",
            "status": "active",
            "regionType": "县",
            "id": "3410"
          },
          {
            "regionName": "北区",
            "pid": "405",
            "status": "active",
            "regionType": "县",
            "id": "3411"
          },
          {
            "regionName": "香山区",
            "pid": "405",
            "status": "active",
            "regionType": "县",
            "id": "3412"
          }
        ],
        "id": "405"
      },
      {
        "regionName": "嘉义市",
        "pid": "32",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "东区",
            "pid": "406",
            "status": "active",
            "regionType": "县",
            "id": "3413"
          },
          {
            "regionName": "西区",
            "pid": "406",
            "status": "active",
            "regionType": "县",
            "id": "3414"
          }
        ],
        "id": "406"
      },
      {
        "regionName": "新北市",
        "pid": "32",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "万里区",
            "pid": "407",
            "status": "active",
            "regionType": "县",
            "id": "3415"
          },
          {
            "regionName": "金山区",
            "pid": "407",
            "status": "active",
            "regionType": "县",
            "id": "3416"
          },
          {
            "regionName": "板桥区",
            "pid": "407",
            "status": "active",
            "regionType": "县",
            "id": "3417"
          },
          {
            "regionName": "汐止区",
            "pid": "407",
            "status": "active",
            "regionType": "县",
            "id": "3418"
          },
          {
            "regionName": "深坑区",
            "pid": "407",
            "status": "active",
            "regionType": "县",
            "id": "3419"
          },
          {
            "regionName": "石碇区",
            "pid": "407",
            "status": "active",
            "regionType": "县",
            "id": "3420"
          },
          {
            "regionName": "瑞芳区",
            "pid": "407",
            "status": "active",
            "regionType": "县",
            "id": "3421"
          },
          {
            "regionName": "平溪区",
            "pid": "407",
            "status": "active",
            "regionType": "县",
            "id": "3422"
          },
          {
            "regionName": "双溪区",
            "pid": "407",
            "status": "active",
            "regionType": "县",
            "id": "3423"
          },
          {
            "regionName": "贡寮区",
            "pid": "407",
            "status": "active",
            "regionType": "县",
            "id": "3424"
          },
          {
            "regionName": "新店区",
            "pid": "407",
            "status": "active",
            "regionType": "县",
            "id": "3425"
          },
          {
            "regionName": "坪林区",
            "pid": "407",
            "status": "active",
            "regionType": "县",
            "id": "3426"
          },
          {
            "regionName": "乌来区",
            "pid": "407",
            "status": "active",
            "regionType": "县",
            "id": "3427"
          },
          {
            "regionName": "永和区",
            "pid": "407",
            "status": "active",
            "regionType": "县",
            "id": "3428"
          },
          {
            "regionName": "中和区",
            "pid": "407",
            "status": "active",
            "regionType": "县",
            "id": "3429"
          },
          {
            "regionName": "土城区",
            "pid": "407",
            "status": "active",
            "regionType": "县",
            "id": "3430"
          },
          {
            "regionName": "三峡区",
            "pid": "407",
            "status": "active",
            "regionType": "县",
            "id": "3431"
          },
          {
            "regionName": "树林区",
            "pid": "407",
            "status": "active",
            "regionType": "县",
            "id": "3432"
          },
          {
            "regionName": "莺歌区",
            "pid": "407",
            "status": "active",
            "regionType": "县",
            "id": "3433"
          },
          {
            "regionName": "三重区",
            "pid": "407",
            "status": "active",
            "regionType": "县",
            "id": "3434"
          },
          {
            "regionName": "新庄区",
            "pid": "407",
            "status": "active",
            "regionType": "县",
            "id": "3435"
          },
          {
            "regionName": "泰山区",
            "pid": "407",
            "status": "active",
            "regionType": "县",
            "id": "3436"
          },
          {
            "regionName": "林口区",
            "pid": "407",
            "status": "active",
            "regionType": "县",
            "id": "3437"
          },
          {
            "regionName": "芦洲区",
            "pid": "407",
            "status": "active",
            "regionType": "县",
            "id": "3438"
          },
          {
            "regionName": "五股区",
            "pid": "407",
            "status": "active",
            "regionType": "县",
            "id": "3439"
          },
          {
            "regionName": "八里区",
            "pid": "407",
            "status": "active",
            "regionType": "县",
            "id": "3440"
          },
          {
            "regionName": "淡水区",
            "pid": "407",
            "status": "active",
            "regionType": "县",
            "id": "3441"
          },
          {
            "regionName": "三芝区",
            "pid": "407",
            "status": "active",
            "regionType": "县",
            "id": "3442"
          },
          {
            "regionName": "石门区",
            "pid": "407",
            "status": "active",
            "regionType": "县",
            "id": "3443"
          }
        ],
        "id": "407"
      },
      {
        "regionName": "宜兰县",
        "pid": "32",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "宜兰市",
            "pid": "408",
            "status": "active",
            "regionType": "县",
            "id": "3444"
          },
          {
            "regionName": "头城镇",
            "pid": "408",
            "status": "active",
            "regionType": "县",
            "id": "3445"
          },
          {
            "regionName": "礁溪乡",
            "pid": "408",
            "status": "active",
            "regionType": "县",
            "id": "3446"
          },
          {
            "regionName": "壮围乡",
            "pid": "408",
            "status": "active",
            "regionType": "县",
            "id": "3447"
          },
          {
            "regionName": "员山乡",
            "pid": "408",
            "status": "active",
            "regionType": "县",
            "id": "3448"
          },
          {
            "regionName": "罗东镇",
            "pid": "408",
            "status": "active",
            "regionType": "县",
            "id": "3449"
          },
          {
            "regionName": "三星乡",
            "pid": "408",
            "status": "active",
            "regionType": "县",
            "id": "3450"
          },
          {
            "regionName": "大同乡",
            "pid": "408",
            "status": "active",
            "regionType": "县",
            "id": "3451"
          },
          {
            "regionName": "五结乡",
            "pid": "408",
            "status": "active",
            "regionType": "县",
            "id": "3452"
          },
          {
            "regionName": "冬山乡",
            "pid": "408",
            "status": "active",
            "regionType": "县",
            "id": "3453"
          },
          {
            "regionName": "苏澳镇",
            "pid": "408",
            "status": "active",
            "regionType": "县",
            "id": "3454"
          },
          {
            "regionName": "南澳乡",
            "pid": "408",
            "status": "active",
            "regionType": "县",
            "id": "3455"
          },
          {
            "regionName": "钓鱼台",
            "pid": "408",
            "status": "active",
            "regionType": "县",
            "id": "3456"
          }
        ],
        "id": "408"
      },
      {
        "regionName": "新竹县",
        "pid": "32",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "竹北市",
            "pid": "409",
            "status": "active",
            "regionType": "县",
            "id": "3457"
          },
          {
            "regionName": "湖口乡",
            "pid": "409",
            "status": "active",
            "regionType": "县",
            "id": "3458"
          },
          {
            "regionName": "新丰乡",
            "pid": "409",
            "status": "active",
            "regionType": "县",
            "id": "3459"
          },
          {
            "regionName": "新埔镇",
            "pid": "409",
            "status": "active",
            "regionType": "县",
            "id": "3460"
          },
          {
            "regionName": "关西镇",
            "pid": "409",
            "status": "active",
            "regionType": "县",
            "id": "3461"
          },
          {
            "regionName": "芎林乡",
            "pid": "409",
            "status": "active",
            "regionType": "县",
            "id": "3462"
          },
          {
            "regionName": "宝山乡",
            "pid": "409",
            "status": "active",
            "regionType": "县",
            "id": "3463"
          },
          {
            "regionName": "竹东镇",
            "pid": "409",
            "status": "active",
            "regionType": "县",
            "id": "3464"
          },
          {
            "regionName": "五峰乡",
            "pid": "409",
            "status": "active",
            "regionType": "县",
            "id": "3465"
          },
          {
            "regionName": "横山乡",
            "pid": "409",
            "status": "active",
            "regionType": "县",
            "id": "3466"
          },
          {
            "regionName": "尖石乡",
            "pid": "409",
            "status": "active",
            "regionType": "县",
            "id": "3467"
          },
          {
            "regionName": "北埔乡",
            "pid": "409",
            "status": "active",
            "regionType": "县",
            "id": "3468"
          },
          {
            "regionName": "峨眉乡",
            "pid": "409",
            "status": "active",
            "regionType": "县",
            "id": "3469"
          }
        ],
        "id": "409"
      },
      {
        "regionName": "桃园县",
        "pid": "32",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "中坜市",
            "pid": "410",
            "status": "active",
            "regionType": "县",
            "id": "3470"
          },
          {
            "regionName": "平镇市",
            "pid": "410",
            "status": "active",
            "regionType": "县",
            "id": "3471"
          },
          {
            "regionName": "龙潭乡",
            "pid": "410",
            "status": "active",
            "regionType": "县",
            "id": "3472"
          },
          {
            "regionName": "杨梅市",
            "pid": "410",
            "status": "active",
            "regionType": "县",
            "id": "3473"
          },
          {
            "regionName": "新屋乡",
            "pid": "410",
            "status": "active",
            "regionType": "县",
            "id": "3474"
          },
          {
            "regionName": "观音乡",
            "pid": "410",
            "status": "active",
            "regionType": "县",
            "id": "3475"
          },
          {
            "regionName": "桃园市",
            "pid": "410",
            "status": "active",
            "regionType": "县",
            "id": "3476"
          },
          {
            "regionName": "龟山乡",
            "pid": "410",
            "status": "active",
            "regionType": "县",
            "id": "3477"
          },
          {
            "regionName": "八德市",
            "pid": "410",
            "status": "active",
            "regionType": "县",
            "id": "3478"
          },
          {
            "regionName": "大溪镇",
            "pid": "410",
            "status": "active",
            "regionType": "县",
            "id": "3479"
          },
          {
            "regionName": "复兴乡",
            "pid": "410",
            "status": "active",
            "regionType": "县",
            "id": "3480"
          },
          {
            "regionName": "大园乡",
            "pid": "410",
            "status": "active",
            "regionType": "县",
            "id": "3481"
          },
          {
            "regionName": "芦竹乡",
            "pid": "410",
            "status": "active",
            "regionType": "县",
            "id": "3482"
          }
        ],
        "id": "410"
      },
      {
        "regionName": "苗栗县",
        "pid": "32",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "竹南镇",
            "pid": "411",
            "status": "active",
            "regionType": "县",
            "id": "3483"
          },
          {
            "regionName": "头份镇",
            "pid": "411",
            "status": "active",
            "regionType": "县",
            "id": "3484"
          },
          {
            "regionName": "三湾乡",
            "pid": "411",
            "status": "active",
            "regionType": "县",
            "id": "3485"
          },
          {
            "regionName": "南庄乡",
            "pid": "411",
            "status": "active",
            "regionType": "县",
            "id": "3486"
          },
          {
            "regionName": "狮潭乡",
            "pid": "411",
            "status": "active",
            "regionType": "县",
            "id": "3487"
          },
          {
            "regionName": "后龙镇",
            "pid": "411",
            "status": "active",
            "regionType": "县",
            "id": "3488"
          },
          {
            "regionName": "通霄镇",
            "pid": "411",
            "status": "active",
            "regionType": "县",
            "id": "3489"
          },
          {
            "regionName": "苑里镇",
            "pid": "411",
            "status": "active",
            "regionType": "县",
            "id": "3490"
          },
          {
            "regionName": "苗栗市",
            "pid": "411",
            "status": "active",
            "regionType": "县",
            "id": "3491"
          },
          {
            "regionName": "造桥乡",
            "pid": "411",
            "status": "active",
            "regionType": "县",
            "id": "3492"
          },
          {
            "regionName": "头屋乡",
            "pid": "411",
            "status": "active",
            "regionType": "县",
            "id": "3493"
          },
          {
            "regionName": "公馆乡",
            "pid": "411",
            "status": "active",
            "regionType": "县",
            "id": "3494"
          },
          {
            "regionName": "大湖乡",
            "pid": "411",
            "status": "active",
            "regionType": "县",
            "id": "3495"
          },
          {
            "regionName": "泰安乡",
            "pid": "411",
            "status": "active",
            "regionType": "县",
            "id": "3496"
          },
          {
            "regionName": "铜锣乡",
            "pid": "411",
            "status": "active",
            "regionType": "县",
            "id": "3497"
          },
          {
            "regionName": "三义乡",
            "pid": "411",
            "status": "active",
            "regionType": "县",
            "id": "3498"
          },
          {
            "regionName": "西湖乡",
            "pid": "411",
            "status": "active",
            "regionType": "县",
            "id": "3499"
          },
          {
            "regionName": "卓兰镇",
            "pid": "411",
            "status": "active",
            "regionType": "县",
            "id": "3500"
          }
        ],
        "id": "411"
      },
      {
        "regionName": "彰化县",
        "pid": "32",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "彰化市",
            "pid": "412",
            "status": "active",
            "regionType": "县",
            "id": "3501"
          },
          {
            "regionName": "芬园乡",
            "pid": "412",
            "status": "active",
            "regionType": "县",
            "id": "3502"
          },
          {
            "regionName": "花坛乡",
            "pid": "412",
            "status": "active",
            "regionType": "县",
            "id": "3503"
          },
          {
            "regionName": "秀水乡",
            "pid": "412",
            "status": "active",
            "regionType": "县",
            "id": "3504"
          },
          {
            "regionName": "鹿港镇",
            "pid": "412",
            "status": "active",
            "regionType": "县",
            "id": "3505"
          },
          {
            "regionName": "福兴乡",
            "pid": "412",
            "status": "active",
            "regionType": "县",
            "id": "3506"
          },
          {
            "regionName": "线西乡",
            "pid": "412",
            "status": "active",
            "regionType": "县",
            "id": "3507"
          },
          {
            "regionName": "和美镇",
            "pid": "412",
            "status": "active",
            "regionType": "县",
            "id": "3508"
          },
          {
            "regionName": "伸港乡",
            "pid": "412",
            "status": "active",
            "regionType": "县",
            "id": "3509"
          },
          {
            "regionName": "造桥乡",
            "pid": "412",
            "status": "active",
            "regionType": "县",
            "id": "3510"
          },
          {
            "regionName": "头屋乡",
            "pid": "412",
            "status": "active",
            "regionType": "县",
            "id": "3511"
          },
          {
            "regionName": "员林镇",
            "pid": "412",
            "status": "active",
            "regionType": "县",
            "id": "3512"
          },
          {
            "regionName": "社头乡",
            "pid": "412",
            "status": "active",
            "regionType": "县",
            "id": "3513"
          },
          {
            "regionName": "永靖乡",
            "pid": "412",
            "status": "active",
            "regionType": "县",
            "id": "3514"
          },
          {
            "regionName": "埔心乡",
            "pid": "412",
            "status": "active",
            "regionType": "县",
            "id": "3515"
          },
          {
            "regionName": "溪湖镇",
            "pid": "412",
            "status": "active",
            "regionType": "县",
            "id": "3516"
          },
          {
            "regionName": "大村乡",
            "pid": "412",
            "status": "active",
            "regionType": "县",
            "id": "3517"
          },
          {
            "regionName": "埔盐乡",
            "pid": "412",
            "status": "active",
            "regionType": "县",
            "id": "3518"
          },
          {
            "regionName": "田中镇",
            "pid": "412",
            "status": "active",
            "regionType": "县",
            "id": "3519"
          },
          {
            "regionName": "北斗镇",
            "pid": "412",
            "status": "active",
            "regionType": "县",
            "id": "3520"
          },
          {
            "regionName": "田尾乡",
            "pid": "412",
            "status": "active",
            "regionType": "县",
            "id": "3521"
          },
          {
            "regionName": "埤头乡",
            "pid": "412",
            "status": "active",
            "regionType": "县",
            "id": "3522"
          },
          {
            "regionName": "溪州乡",
            "pid": "412",
            "status": "active",
            "regionType": "县",
            "id": "3523"
          },
          {
            "regionName": "竹塘乡",
            "pid": "412",
            "status": "active",
            "regionType": "县",
            "id": "3524"
          },
          {
            "regionName": "二林镇",
            "pid": "412",
            "status": "active",
            "regionType": "县",
            "id": "3525"
          },
          {
            "regionName": "大城乡",
            "pid": "412",
            "status": "active",
            "regionType": "县",
            "id": "3526"
          },
          {
            "regionName": "芳苑乡",
            "pid": "412",
            "status": "active",
            "regionType": "县",
            "id": "3527"
          },
          {
            "regionName": "二水乡",
            "pid": "412",
            "status": "active",
            "regionType": "县",
            "id": "3528"
          }
        ],
        "id": "412"
      },
      {
        "regionName": "嘉义县",
        "pid": "32",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "番路乡",
            "pid": "413",
            "status": "active",
            "regionType": "县",
            "id": "3529"
          },
          {
            "regionName": "梅山乡",
            "pid": "413",
            "status": "active",
            "regionType": "县",
            "id": "3530"
          },
          {
            "regionName": "竹崎乡",
            "pid": "413",
            "status": "active",
            "regionType": "县",
            "id": "3531"
          },
          {
            "regionName": "阿里山乡",
            "pid": "413",
            "status": "active",
            "regionType": "县",
            "id": "3532"
          },
          {
            "regionName": "中埔乡",
            "pid": "413",
            "status": "active",
            "regionType": "县",
            "id": "3533"
          },
          {
            "regionName": "大埔乡",
            "pid": "413",
            "status": "active",
            "regionType": "县",
            "id": "3534"
          },
          {
            "regionName": "水上乡",
            "pid": "413",
            "status": "active",
            "regionType": "县",
            "id": "3535"
          },
          {
            "regionName": "鹿草乡",
            "pid": "413",
            "status": "active",
            "regionType": "县",
            "id": "3536"
          },
          {
            "regionName": "太保市",
            "pid": "413",
            "status": "active",
            "regionType": "县",
            "id": "3537"
          },
          {
            "regionName": "朴子市",
            "pid": "413",
            "status": "active",
            "regionType": "县",
            "id": "3538"
          },
          {
            "regionName": "东石乡",
            "pid": "413",
            "status": "active",
            "regionType": "县",
            "id": "3539"
          },
          {
            "regionName": "六脚乡",
            "pid": "413",
            "status": "active",
            "regionType": "县",
            "id": "3540"
          },
          {
            "regionName": "新港乡",
            "pid": "413",
            "status": "active",
            "regionType": "县",
            "id": "3541"
          },
          {
            "regionName": "民雄乡",
            "pid": "413",
            "status": "active",
            "regionType": "县",
            "id": "3542"
          },
          {
            "regionName": "大林镇",
            "pid": "413",
            "status": "active",
            "regionType": "县",
            "id": "3543"
          },
          {
            "regionName": "溪口乡",
            "pid": "413",
            "status": "active",
            "regionType": "县",
            "id": "3544"
          },
          {
            "regionName": "义竹乡",
            "pid": "413",
            "status": "active",
            "regionType": "县",
            "id": "3545"
          },
          {
            "regionName": "布袋镇",
            "pid": "413",
            "status": "active",
            "regionType": "县",
            "id": "3546"
          }
        ],
        "id": "413"
      },
      {
        "regionName": "云林县",
        "pid": "32",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "斗南镇",
            "pid": "414",
            "status": "active",
            "regionType": "县",
            "id": "3547"
          },
          {
            "regionName": "大埤乡",
            "pid": "414",
            "status": "active",
            "regionType": "县",
            "id": "3548"
          },
          {
            "regionName": "虎尾镇",
            "pid": "414",
            "status": "active",
            "regionType": "县",
            "id": "3549"
          },
          {
            "regionName": "土库镇",
            "pid": "414",
            "status": "active",
            "regionType": "县",
            "id": "3550"
          },
          {
            "regionName": "褒忠乡",
            "pid": "414",
            "status": "active",
            "regionType": "县",
            "id": "3551"
          },
          {
            "regionName": "东势乡",
            "pid": "414",
            "status": "active",
            "regionType": "县",
            "id": "3552"
          },
          {
            "regionName": "台西乡",
            "pid": "414",
            "status": "active",
            "regionType": "县",
            "id": "3553"
          },
          {
            "regionName": "仑背乡",
            "pid": "414",
            "status": "active",
            "regionType": "县",
            "id": "3554"
          },
          {
            "regionName": "麦寮乡",
            "pid": "414",
            "status": "active",
            "regionType": "县",
            "id": "3555"
          },
          {
            "regionName": "斗六市",
            "pid": "414",
            "status": "active",
            "regionType": "县",
            "id": "3556"
          },
          {
            "regionName": "林内乡",
            "pid": "414",
            "status": "active",
            "regionType": "县",
            "id": "3557"
          },
          {
            "regionName": "古坑乡",
            "pid": "414",
            "status": "active",
            "regionType": "县",
            "id": "3558"
          },
          {
            "regionName": "莿桐乡",
            "pid": "414",
            "status": "active",
            "regionType": "县",
            "id": "3559"
          },
          {
            "regionName": "西螺镇",
            "pid": "414",
            "status": "active",
            "regionType": "县",
            "id": "3560"
          },
          {
            "regionName": "二仑乡",
            "pid": "414",
            "status": "active",
            "regionType": "县",
            "id": "3561"
          },
          {
            "regionName": "北港镇",
            "pid": "414",
            "status": "active",
            "regionType": "县",
            "id": "3562"
          },
          {
            "regionName": "水林乡",
            "pid": "414",
            "status": "active",
            "regionType": "县",
            "id": "3563"
          },
          {
            "regionName": "口湖乡",
            "pid": "414",
            "status": "active",
            "regionType": "县",
            "id": "3564"
          },
          {
            "regionName": "四湖乡",
            "pid": "414",
            "status": "active",
            "regionType": "县",
            "id": "3565"
          },
          {
            "regionName": "元长乡",
            "pid": "414",
            "status": "active",
            "regionType": "县",
            "id": "3566"
          }
        ],
        "id": "414"
      },
      {
        "regionName": "屏东县",
        "pid": "32",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "屏东市",
            "pid": "415",
            "status": "active",
            "regionType": "县",
            "id": "3567"
          },
          {
            "regionName": "三地门乡",
            "pid": "415",
            "status": "active",
            "regionType": "县",
            "id": "3568"
          },
          {
            "regionName": "雾台乡",
            "pid": "415",
            "status": "active",
            "regionType": "县",
            "id": "3569"
          },
          {
            "regionName": "玛家乡",
            "pid": "415",
            "status": "active",
            "regionType": "县",
            "id": "3570"
          },
          {
            "regionName": "九如乡",
            "pid": "415",
            "status": "active",
            "regionType": "县",
            "id": "3571"
          },
          {
            "regionName": "里港乡",
            "pid": "415",
            "status": "active",
            "regionType": "县",
            "id": "3572"
          },
          {
            "regionName": "高树乡",
            "pid": "415",
            "status": "active",
            "regionType": "县",
            "id": "3573"
          },
          {
            "regionName": "盐埔乡",
            "pid": "415",
            "status": "active",
            "regionType": "县",
            "id": "3574"
          },
          {
            "regionName": "长治乡",
            "pid": "415",
            "status": "active",
            "regionType": "县",
            "id": "3575"
          },
          {
            "regionName": "麟洛乡",
            "pid": "415",
            "status": "active",
            "regionType": "县",
            "id": "3576"
          },
          {
            "regionName": "竹田乡",
            "pid": "415",
            "status": "active",
            "regionType": "县",
            "id": "3577"
          },
          {
            "regionName": "内埔乡",
            "pid": "415",
            "status": "active",
            "regionType": "县",
            "id": "3578"
          },
          {
            "regionName": "万丹乡",
            "pid": "415",
            "status": "active",
            "regionType": "县",
            "id": "3579"
          },
          {
            "regionName": "潮州镇",
            "pid": "415",
            "status": "active",
            "regionType": "县",
            "id": "3580"
          },
          {
            "regionName": "泰武乡",
            "pid": "415",
            "status": "active",
            "regionType": "县",
            "id": "3581"
          },
          {
            "regionName": "来义乡",
            "pid": "415",
            "status": "active",
            "regionType": "县",
            "id": "3582"
          },
          {
            "regionName": "万峦乡",
            "pid": "415",
            "status": "active",
            "regionType": "县",
            "id": "3583"
          },
          {
            "regionName": "崁顶乡",
            "pid": "415",
            "status": "active",
            "regionType": "县",
            "id": "3584"
          },
          {
            "regionName": "新埤乡",
            "pid": "415",
            "status": "active",
            "regionType": "县",
            "id": "3585"
          },
          {
            "regionName": "南州乡",
            "pid": "415",
            "status": "active",
            "regionType": "县",
            "id": "3586"
          },
          {
            "regionName": "林边乡",
            "pid": "415",
            "status": "active",
            "regionType": "县",
            "id": "3587"
          },
          {
            "regionName": "东港镇",
            "pid": "415",
            "status": "active",
            "regionType": "县",
            "id": "3588"
          },
          {
            "regionName": "琉球乡",
            "pid": "415",
            "status": "active",
            "regionType": "县",
            "id": "3589"
          },
          {
            "regionName": "佳冬乡",
            "pid": "415",
            "status": "active",
            "regionType": "县",
            "id": "3590"
          },
          {
            "regionName": "新园乡",
            "pid": "415",
            "status": "active",
            "regionType": "县",
            "id": "3591"
          },
          {
            "regionName": "枋寮乡",
            "pid": "415",
            "status": "active",
            "regionType": "县",
            "id": "3592"
          },
          {
            "regionName": "枋山乡",
            "pid": "415",
            "status": "active",
            "regionType": "县",
            "id": "3593"
          },
          {
            "regionName": "春日乡",
            "pid": "415",
            "status": "active",
            "regionType": "县",
            "id": "3594"
          },
          {
            "regionName": "狮子乡",
            "pid": "415",
            "status": "active",
            "regionType": "县",
            "id": "3595"
          },
          {
            "regionName": "车城乡",
            "pid": "415",
            "status": "active",
            "regionType": "县",
            "id": "3596"
          },
          {
            "regionName": "牡丹乡",
            "pid": "415",
            "status": "active",
            "regionType": "县",
            "id": "3597"
          },
          {
            "regionName": "恒春镇",
            "pid": "415",
            "status": "active",
            "regionType": "县",
            "id": "3598"
          },
          {
            "regionName": "满州乡",
            "pid": "415",
            "status": "active",
            "regionType": "县",
            "id": "3599"
          }
        ],
        "id": "415"
      },
      {
        "regionName": "台东县",
        "pid": "32",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "台东市",
            "pid": "416",
            "status": "active",
            "regionType": "县",
            "id": "3600"
          },
          {
            "regionName": "绿岛乡",
            "pid": "416",
            "status": "active",
            "regionType": "县",
            "id": "3601"
          },
          {
            "regionName": "兰屿乡",
            "pid": "416",
            "status": "active",
            "regionType": "县",
            "id": "3602"
          },
          {
            "regionName": "延平乡",
            "pid": "416",
            "status": "active",
            "regionType": "县",
            "id": "3603"
          },
          {
            "regionName": "卑南乡",
            "pid": "416",
            "status": "active",
            "regionType": "县",
            "id": "3604"
          },
          {
            "regionName": "鹿野乡",
            "pid": "416",
            "status": "active",
            "regionType": "县",
            "id": "3605"
          },
          {
            "regionName": "关山镇",
            "pid": "416",
            "status": "active",
            "regionType": "县",
            "id": "3606"
          },
          {
            "regionName": "海端乡",
            "pid": "416",
            "status": "active",
            "regionType": "县",
            "id": "3607"
          },
          {
            "regionName": "池上乡",
            "pid": "416",
            "status": "active",
            "regionType": "县",
            "id": "3608"
          },
          {
            "regionName": "东河乡",
            "pid": "416",
            "status": "active",
            "regionType": "县",
            "id": "3609"
          },
          {
            "regionName": "成功镇",
            "pid": "416",
            "status": "active",
            "regionType": "县",
            "id": "3610"
          },
          {
            "regionName": "长滨乡",
            "pid": "416",
            "status": "active",
            "regionType": "县",
            "id": "3611"
          },
          {
            "regionName": "金峰乡",
            "pid": "416",
            "status": "active",
            "regionType": "县",
            "id": "3612"
          },
          {
            "regionName": "大武乡",
            "pid": "416",
            "status": "active",
            "regionType": "县",
            "id": "3613"
          },
          {
            "regionName": "达仁乡",
            "pid": "416",
            "status": "active",
            "regionType": "县",
            "id": "3614"
          },
          {
            "regionName": "太麻里乡",
            "pid": "416",
            "status": "active",
            "regionType": "县",
            "id": "3615"
          }
        ],
        "id": "416"
      },
      {
        "regionName": "花莲县",
        "pid": "32",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "花莲市",
            "pid": "417",
            "status": "active",
            "regionType": "县",
            "id": "3616"
          },
          {
            "regionName": "新城乡",
            "pid": "417",
            "status": "active",
            "regionType": "县",
            "id": "3617"
          },
          {
            "regionName": "太鲁阁",
            "pid": "417",
            "status": "active",
            "regionType": "县",
            "id": "3618"
          },
          {
            "regionName": "秀林乡",
            "pid": "417",
            "status": "active",
            "regionType": "县",
            "id": "3619"
          },
          {
            "regionName": "寿丰乡",
            "pid": "417",
            "status": "active",
            "regionType": "县",
            "id": "3620"
          },
          {
            "regionName": "凤林镇",
            "pid": "417",
            "status": "active",
            "regionType": "县",
            "id": "3621"
          },
          {
            "regionName": "光复乡",
            "pid": "417",
            "status": "active",
            "regionType": "县",
            "id": "3622"
          },
          {
            "regionName": "丰滨乡",
            "pid": "417",
            "status": "active",
            "regionType": "县",
            "id": "3623"
          },
          {
            "regionName": "瑞穗乡",
            "pid": "417",
            "status": "active",
            "regionType": "县",
            "id": "3624"
          },
          {
            "regionName": "万荣乡",
            "pid": "417",
            "status": "active",
            "regionType": "县",
            "id": "3625"
          },
          {
            "regionName": "玉里镇",
            "pid": "417",
            "status": "active",
            "regionType": "县",
            "id": "3626"
          },
          {
            "regionName": "卓溪乡",
            "pid": "417",
            "status": "active",
            "regionType": "县",
            "id": "3627"
          },
          {
            "regionName": "富里乡",
            "pid": "417",
            "status": "active",
            "regionType": "县",
            "id": "3628"
          }
        ],
        "id": "417"
      },
      {
        "regionName": "澎湖县",
        "pid": "32",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "马公市",
            "pid": "418",
            "status": "active",
            "regionType": "县",
            "id": "3629"
          },
          {
            "regionName": "西屿乡",
            "pid": "418",
            "status": "active",
            "regionType": "县",
            "id": "3630"
          },
          {
            "regionName": "望安乡",
            "pid": "418",
            "status": "active",
            "regionType": "县",
            "id": "3631"
          },
          {
            "regionName": "七美乡",
            "pid": "418",
            "status": "active",
            "regionType": "县",
            "id": "3632"
          },
          {
            "regionName": "白沙乡",
            "pid": "418",
            "status": "active",
            "regionType": "县",
            "id": "3633"
          },
          {
            "regionName": "湖西乡",
            "pid": "418",
            "status": "active",
            "regionType": "县",
            "id": "3634"
          }
        ],
        "id": "418"
      },
      {
        "regionName": "连江县",
        "pid": "32",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "南竿乡",
            "pid": "419",
            "status": "active",
            "regionType": "县",
            "id": "3635"
          },
          {
            "regionName": "北竿乡",
            "pid": "419",
            "status": "active",
            "regionType": "县",
            "id": "3636"
          },
          {
            "regionName": "莒光乡",
            "pid": "419",
            "status": "active",
            "regionType": "县",
            "id": "3637"
          },
          {
            "regionName": "东引乡",
            "pid": "419",
            "status": "active",
            "regionType": "县",
            "id": "3638"
          }
        ],
        "id": "419"
      },
      {
        "regionName": "台湾",
        "pid": "32",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "台北",
            "pid": "424",
            "status": "active",
            "regionType": "县",
            "id": "3792"
          },
          {
            "regionName": "高雄",
            "pid": "424",
            "status": "active",
            "regionType": "县",
            "id": "3793"
          },
          {
            "regionName": "基隆",
            "pid": "424",
            "status": "active",
            "regionType": "县",
            "id": "3794"
          },
          {
            "regionName": "台中",
            "pid": "424",
            "status": "active",
            "regionType": "县",
            "id": "3795"
          },
          {
            "regionName": "台南",
            "pid": "424",
            "status": "active",
            "regionType": "县",
            "id": "3796"
          },
          {
            "regionName": "新竹",
            "pid": "424",
            "status": "active",
            "regionType": "县",
            "id": "3797"
          },
          {
            "regionName": "嘉义",
            "pid": "424",
            "status": "active",
            "regionType": "县",
            "id": "3798"
          },
          {
            "regionName": "宜兰县",
            "pid": "424",
            "status": "active",
            "regionType": "县",
            "id": "3799"
          },
          {
            "regionName": "桃园县",
            "pid": "424",
            "status": "active",
            "regionType": "县",
            "id": "3800"
          },
          {
            "regionName": "苗栗县",
            "pid": "424",
            "status": "active",
            "regionType": "县",
            "id": "3801"
          },
          {
            "regionName": "彰化县",
            "pid": "424",
            "status": "active",
            "regionType": "县",
            "id": "3802"
          },
          {
            "regionName": "南投县",
            "pid": "424",
            "status": "active",
            "regionType": "县",
            "id": "3803"
          },
          {
            "regionName": "云林县",
            "pid": "424",
            "status": "active",
            "regionType": "县",
            "id": "3804"
          },
          {
            "regionName": "屏东县",
            "pid": "424",
            "status": "active",
            "regionType": "县",
            "id": "3805"
          },
          {
            "regionName": "台东县",
            "pid": "424",
            "status": "active",
            "regionType": "县",
            "id": "3806"
          },
          {
            "regionName": "花莲县",
            "pid": "424",
            "status": "active",
            "regionType": "县",
            "id": "3807"
          },
          {
            "regionName": "澎湖县",
            "pid": "424",
            "status": "active",
            "regionType": "县",
            "id": "3808"
          }
        ],
        "id": "424"
      }
    ],
    "regionName": "台湾省",
    "pid": "0",
    "status": "active",
    "regionType": "省",
    "id": "32"
  },
  {
    "city": [
      {
        "regionName": "澳门特别行政区",
        "pid": "33",
        "status": "active",
        "regionType": "市",
        "county": [
          {
            "regionName": "澳门",
            "pid": "397",
            "status": "active",
            "regionType": "县",
            "id": "3791"
          }
        ],
        "id": "397"
      }
    ],
    "regionName": "澳门特别行政区",
    "pid": "0",
    "status": "active",
    "regionType": "省",
    "id": "33"
  },
  {
    "city": [
      {
        "regionName": "香港岛",
        "pid": "34",
        "status": "deleted",
        "regionType": "市",
        "county": [
          {
            "regionName": "中西区",
            "pid": "420",
            "status": "deleted",
            "regionType": "县",
            "id": "3249"
          },
          {
            "regionName": "湾仔区",
            "pid": "420",
            "status": "deleted",
            "regionType": "县",
            "id": "3250"
          },
          {
            "regionName": "东区",
            "pid": "420",
            "status": "deleted",
            "regionType": "县",
            "id": "3251"
          },
          {
            "regionName": "新界",
            "pid": "420",
            "status": "deleted",
            "regionType": "县",
            "id": "3252"
          }
        ],
        "id": "420"
      },
      {
        "regionName": "九龙",
        "pid": "34",
        "status": "deleted",
        "regionType": "市",
        "county": [
          {
            "regionName": "九龙城区",
            "pid": "421",
            "status": "deleted",
            "regionType": "县",
            "id": "3253"
          },
          {
            "regionName": "油尖旺区",
            "pid": "421",
            "status": "deleted",
            "regionType": "县",
            "id": "3254"
          },
          {
            "regionName": "深水埗区",
            "pid": "421",
            "status": "deleted",
            "regionType": "县",
            "id": "3255"
          },
          {
            "regionName": "黄大仙区",
            "pid": "421",
            "status": "deleted",
            "regionType": "县",
            "id": "3256"
          },
          {
            "regionName": "观塘区",
            "pid": "421",
            "status": "deleted",
            "regionType": "县",
            "id": "3257"
          }
        ],
        "id": "421"
      },
      {
        "regionName": "新界",
        "pid": "34",
        "status": "deleted",
        "regionType": "市",
        "county": [
          {
            "regionName": "北区",
            "pid": "422",
            "status": "deleted",
            "regionType": "县",
            "id": "3258"
          },
          {
            "regionName": "大埔区",
            "pid": "422",
            "status": "deleted",
            "regionType": "县",
            "id": "3259"
          },
          {
            "regionName": "沙田区",
            "pid": "422",
            "status": "deleted",
            "regionType": "县",
            "id": "3260"
          },
          {
            "regionName": "西贡区",
            "pid": "422",
            "status": "deleted",
            "regionType": "县",
            "id": "3261"
          },
          {
            "regionName": "元朗区",
            "pid": "422",
            "status": "deleted",
            "regionType": "县",
            "id": "3262"
          },
          {
            "regionName": "屯门区",
            "pid": "422",
            "status": "deleted",
            "regionType": "县",
            "id": "3263"
          },
          {
            "regionName": "荃湾区",
            "pid": "422",
            "status": "deleted",
            "regionType": "县",
            "id": "3264"
          },
          {
            "regionName": "葵青区",
            "pid": "422",
            "status": "deleted",
            "regionType": "县",
            "id": "3265"
          },
          {
            "regionName": "离岛区",
            "pid": "422",
            "status": "deleted",
            "regionType": "县",
            "id": "3266"
          }
        ],
        "id": "422"
      }
    ],
    "regionName": "香港特别行政区",
    "pid": "0",
    "status": "deleted",
    "regionType": "省",
    "id": "34"
  }
];
export const area_name = {
  "127": "铜陵市",
  "71": "辽阳市",
  "1801": "杞县",
  "1648": "昌邑市",
  "1481": "东湖区",
  "3596": "车城乡",
  "3074": "富蕴县",
  "3509": "伸港乡",
  "2927": "兴业县",
  "2266": "镇原县",
  "3163": "玉泉区",
  "1178": "灌云县",
  "2915": "昭平县",
  "1387": "广德县",
  "512": "云阳县",
  "1932": "石首市",
  "463": "徐汇区",
  "517": "秀山土家族苗族自治县",
  "458": "宁河县",
  "2634": "罗平县",
  "1785": "南召县",
  "1250": "鹿城区",
  "722": "矿区",
  "3588": "东港镇",
  "1363": "灵璧县",
  "2507": "镇宁布依族苗族自治县",
  "3051": "沙坡头区",
  "1109": "惠山区",
  "2067": "武陵源区",
  "1630": "龙口市",
  "3497": "铜锣乡",
  "1597": "黄岛区",
  "3185": "商都县",
  "3109": "轮台县",
  "728": "灵丘县",
  "1244": "越城区",
  "2154": "金平区",
  "1638": "寒亭区",
  "742": "祁县",
  "29": "贵州省",
  "350": "玉林市",
  "1969": "沙洋县",
  "1810": "吉利区",
  "2203": "英德市",
  "58": "临汾市",
  "153": "宜春市",
  "2932": "平果县",
  "2754": "周至县",
  "2387": "乐至县",
  "1546": "永新县",
  "101": "南通市",
  "340": "铜川市",
  "2994": "加查县",
  "3256": "黄大仙区",
  "311": "大理白族自治州",
  "825": "长海县",
  "3655": "道滘镇",
  "917": "船营区",
  "3431": "三峡区",
  "2425": "甘洛县",
  "3536": "鹿草乡",
  "495": "江津区",
  "1703": "五莲县",
  "3302": "湖内区",
  "2086": "双牌县",
  "1322": "濉溪县 ",
  "1816": "汝阳县",
  "3571": "九如乡",
  "2460": "小金县",
  "2510": "都匀市",
  "1172": "金湖县",
  "2699": "华坪县",
  "2458": "九寨沟县",
  "1259": "瑞安市",
  "834": "庄河市",
  "285": "铜仁地区",
  "3574": "盐埔乡",
  "2976": "白朗县",
  "2441": "道孚县",
  "3475": "观音乡",
  "2414": "德昌县",
  "1216": "淳安县",
  "3421": "瑞芳区",
  "3238": "正蓝旗",
  "2285": "康乐县",
  "2274": "武都区",
  "2194": "连平县",
  "3092": "新市区",
  "1135": "如皋市",
  "2002": "醴陵市",
  "2864": "上林县",
  "1203": "衢江区",
  "96": "大庆市",
  "2088": "江永县",
  "1068": "友好区",
  "1667": "兰山区",
  "486": "九龙坡区",
  "2114": "揭西县",
  "2134": "恩平市",
  "1354": "颍泉区",
  "569": "徐水县",
  "8": "黑龙江省",
  "3239": "多伦县",
  "2359": "广安区",
  "3111": "若羌县",
  "2045": "涟源市",
  "686": "山海关区",
  "1396": "晋安区",
  "3149": "阿荣旗",
  "1760": "襄城县",
  "391": "赤峰市",
  "2033": "石门县",
  "943": "梅河口市",
  "2676": "镇沅彝族哈尼族拉祜族自治县",
  "1887": "樊城区",
  "2907": "万秀区",
  "180": "平顶山市",
  "1375": "金寨县",
  "1585": "市中区",
  "2939": "西林县",
  "1877": "武昌区",
  "246": "金昌市",
  "2705": "城东区",
  "690": "抚宁县",
  "2227": "景泰县",
  "61": "沈阳市",
  "3241": "阿尔山市",
  "1168": "清浦区",
  "536": "魏县",
  "1767": "宝丰县",
  "1653": "金乡县",
  "3540": "六脚乡",
  "2237": "古浪县",
  "1688": "垦利县",
  "2394": "市中区",
  "1266": "云和县",
  "3419": "深坑区",
  "3326": "新化区",
  "2654": "澄江县",
  "3311": "内门区",
  "2958": "铁山港区",
  "1458": "宁化县",
  "444": "河东区",
  "508": "垫江县",
  "3627": "卓溪乡",
  "1336": "桐城市",
  "39": "邯郸市",
  "3260": "沙田区",
  "558": "藁城市",
  "1089": "肇源县",
  "12": "安徽省",
  "3200": "霍林郭勒市",
  "3036": "永宁县",
  "1554": "安远县",
  "2168": "金湾区",
  "573": "容城县",
  "3707": "和庆镇",
  "3518": "埔盐乡",
  "2710": "湟中县",
  "1084": "龙凤区",
  "3413": "东区",
  "3343": "后壁区",
  "638": "三河市",
  "3446": "礁溪乡",
  "875": "新邱区",
  "2350": "开江县",
  "3467": "尖石乡",
  "2479": "苍溪县",
  "1522": "资溪县",
  "1": "北京",
  "506": "城口县",
  "3218": "杭锦旗",
  "136": "池州市",
  "116": "绍兴市",
  "1197": "泗洪县",
  "1580": "郓城县",
  "3274": "士林区",
  "2937": "乐业县",
  "2419": "布拖县",
  "2146": "梅县",
  "661": "故城县",
  "3157": "牙克石市",
  "2845": "凤县",
  "2482": "花溪区",
  "2719": "尖扎县",
  "1935": "西陵区",
  "2690": "福贡县",
  "581": "博野县",
  "308": "德宏傣族景颇族自治州",
  "2727": "玛沁县",
  "3485": "三湾乡",
  "678": "广宗县",
  "3802": "彰化县",
  "1517": "南丰县",
  "2808": "洛南县",
  "3025": "尼玛县",
  "3004": "朗县",
  "1975": "华容县",
  "3676": "石排镇",
  "2910": "苍梧县",
  "1973": "君山区",
  "1991": "湘潭县",
  "3027": "札达县",
  "927": "珲春市",
  "301": "白沙黎族自治县",
  "3180": "海南区",
  "2302": "武侯区",
  "51": "忻州市",
  "1758": "许昌县",
  "456": "武清区",
  "1822": "中站区",
  "3063": "伊吾县",
  "2745": "碑林区",
  "652": "任丘市",
  "1033": "南山区",
  "2736": "治多县",
  "2400": "夹江县",
  "2258": "敦煌市",
  "2034": "津市市",
  "1539": "峡江县",
  "2029": "汉寿县",
  "796": "稷山县",
  "2349": "宣汉县",
  "366": "中卫市",
  "3552": "东势乡",
  "844": "望花区",
  "1541": "永丰县",
  "3727": "梅里斯达斡尔区",
  "2723": "同德县",
  "272": "乐山市",
  "3527": "芳苑乡",
  "775": "蒲县",
  "2343": "蓬安县",
  "2518": "长顺县",
  "3044": "同心县",
  "2108": "江城区",
  "20": "海南省",
  "2376": "宜宾县",
  "888": "双塔区",
  "3771": "石河子市",
  "3743": "花桥镇",
  "1983": "开福区",
  "1011": "西安区",
  "3100": "呼图壁县",
  "1754": "长垣县",
  "3787": "苏溪镇",
  "3562": "北港镇",
  "1627": "牟平区",
  "3683": "肇庆市",
  "468": "虹口区",
  "1161": "铜山县",
  "2093": "从化市",
  "700": "五台县",
  "3030": "革吉县",
  "1019": "桃山区",
  "78": "四平市",
  "1927": "沙市区",
  "3369": "石冈区",
  "3406": "中山区",
  "2853": "上思县",
  "1380": "利辛县",
  "990": "龙江县",
  "413": "嘉义县",
  "294": "文昌市",
  "764": "翼城县",
  "349": "贵港市",
  "2316": "邛崃市",
  "2218": "永登县",
  "1614": "德城区",
  "1442": "东山县",
  "1743": "内黄县",
  "3364": "大里区",
  "2075": "会同县",
  "3251": "东区",
  "1981": "天心区",
  "3638": "东引乡",
  "3205": "巴林左旗",
  "2081": "洪江市",
  "606": "鹰手营子矿区",
  "1383": "石台县",
  "137": "宣城市",
  "1414": "屏南县",
  "3559": "莿桐乡",
  "2522": "凯里市",
  "1855": "舞阳县",
  "666": "桥东区",
  "432": "海淀区",
  "3794": "基隆",
  "860": "凤城市",
  "1074": "五营区",
  "2308": "金堂县",
  "1567": "珠山区",
  "1063": "呼玛县",
  "1776": "光山县",
  "2565": "望谟县",
  "3047": "西吉县",
  "2158": "澄海区",
  "2576": "潞西市",
  "708": "河曲县",
  "3287": "左营区",
  "2415": "会理县",
  "2362": "邻水县",
  "2583": "盐津县",
  "2796": "临渭区",
  "2589": "威信县",
  "3286": "三民区",
  "1601": "胶州市",
  "710": "偏关县",
  "2814": "汉滨区",
  "1656": "泗水县",
  "323": "海北藏族自治州",
  "856": "振兴区",
  "2142": "新丰县",
  "1834": "浚县",
  "1664": "东平县",
  "112": "杭州市",
  "545": "井陉县",
  "3211": "宁城县",
  "191": "驻马店市",
  "2733": "玉树县",
  "2467": "旌阳区",
  "187": "鹤壁市",
  "588": "桥西区",
  "3612": "金峰乡",
  "1684": "博兴县",
  "756": "潞城市",
  "2326": "沿滩区",
  "262": "绵阳市",
  "1283": "三门县",
  "1944": "五峰土家族自治县",
  "3089": "乌尔禾区",
  "212": "湘潭市",
  "3384": "金沙镇",
  "2436": "康定县",
  "1331": "潜山县",
  "542": "新华区",
  "2590": "水富县",
  "2383": "兴文县",
  "3750": "盐都县",
  "3114": "和静县",
  "1305": "淮上区",
  "961": "抚松县",
  "2686": "双江拉祜族佤族布朗族傣族自治县",
  "3234": "西乌珠穆沁旗",
  "2882": "柳南区",
  "2099": "花都区",
  "1662": "岱岳区",
  "2476": "旺苍县",
  "574": "涞源县",
  "2988": "贡嘎县",
  "170": "威海市",
  "660": "安平县",
  "3397": "集集镇",
  "1921": "咸安区",
  "3217": "鄂托克旗",
  "26": "宁夏回族自治区",
  "977": "木兰县",
  "2116": "普宁市",
  "2250": "庄浪县",
  "566": "清苑县",
  "526": "成安县",
  "1901": "云梦县",
  "3500": "卓兰镇",
  "359": "昌都市",
  "2765": "彬县",
  "1229": " 海盐县",
  "2299": "锦江区",
  "108": "泰州市",
  "2820": "平利县",
  "604": "双桥区",
  "2614": "洱源县",
  "2608": "宾川县",
  "1001": "滴道区",
  "3694": "务川县",
  "232": "梅州市",
  "477": "南汇区",
  "1338": "黄山区",
  "3458": "湖口乡",
  "3054": "塔城市",
  "2623": "弥勒县",
  "1182": "戚墅堰区",
  "225": "汕尾市",
  "330": "海西蒙古族藏族自治州",
  "207": "仙桃市",
  "1447": "新罗区",
  "142": "泉州市",
  "1510": "鄱阳县",
  "48": "邢台市",
  "360": "那曲地区",
  "1857": "驿城区",
  "3641": "郊区",
  "3585": "新埤乡",
  "3416": "金山区",
  "3170": "东河区",
  "3160": "根河市",
  "3279": "新兴区",
  "3377": "沙鹿区",
  "2321": "米易县",
  "1988": "浏阳市",
  "3730": "潜江市",
  "3135": "伽师县",
  "1076": "汤旺河区",
  "3665": "樟木头",
  "3082": "乌恰县",
  "766": "洪洞县",
  "449": "塘沽区",
  "1574": "芦溪县",
  "3506": "福兴乡",
  "1579": "巨野县",
  "659": "饶阳县",
  "2774": "子长县",
  "2763": "礼泉县",
  "1141": "维扬区",
  "682": "临西县",
  "353": "河池市",
  "2971": "定日县",
  "375": "石河子市",
  "3633": "白沙乡",
  "984": "建华区",
  "2989": "桑日县",
  "2833": "留坝县",
  "2409": "丹棱县",
  "1155": "云龙区",
  "3372": "新社区",
  "788": "中阳县",
  "1485": "青山湖区",
  "128": "安庆市",
  "3692": "金阳新区",
  "3726": "铁峰区",
  "501": "铜梁县",
  "2944": "浦北县",
  "278": "德阳市",
  "1313": "潘集区",
  "1617": "庆云县",
  "490": "双桥区",
  "3521": "田尾乡",
  "3144": "新源县",
  "2650": "广南县",
  "1843": "扶沟县",
  "155": "赣州市",
  "387": "包头市",
  "2626": "红河县",
  "1913": "麻城市",
  "626": "唐海县",
  "1112": "宜兴市",
  "1294": "肥西县",
  "461": "黄浦区",
  "2712": "平安县",
  "257": "临夏回族自治州",
  "1562": "寻乌县",
  "1426": "丰泽区",
  "3451": "大同乡",
  "1358": "颍上县",
  "951": "西安区",
  "782": "兴县",
  "85": "齐齐哈尔市",
  "809": "铁西区",
  "3647": "从化区",
  "2200": "连山壮族瑶族自治县",
  "1156": "九里区",
  "2281": "徽县",
  "1557": "全南县",
  "425": "东城区",
  "1486": "南昌县",
  "3614": "达仁乡",
  "3057": "沙湾县",
  "2056": "城步苗族自治县",
  "736": "榆社县",
  "539": "长安区",
  "3607": "海端乡",
  "2876": "象州县",
  "781": "交城县",
  "3648": "市郊",
  "3428": "永和区",
  "2847": "王益区",
  "3233": "东乌珠穆沁旗",
  "3015": "边坝县",
  "3339": "将军区",
  "1950": "建始县",
  "520": "邯山区",
  "2865": "宾阳县",
  "1698": "台儿庄区",
  "2782": "黄龙县",
  "2037": "南县",
  "532": "邱县",
  "1193": "宿城区",
  "2455": "理县",
  "55": "晋中市",
  "3592": "枋寮乡",
  "1890": "谷城县",
  "57": "晋城市",
  "1681": "阳信县",
  "872": "盖州市",
  "2642": "龙陵县",
  "2354": "船山区",
  "3790": "黔江开发区",
  "3479": "大溪镇",
  "3660": "茶山镇",
  "395": "兴安盟",
  "3435": "新庄区",
  "1146": "盐都区",
  "89": "佳木斯市",
  "175": "商丘市",
  "584": "定州市",
  "988": "碾子山区",
  "3307": "大树区",
  "35": "北京市",
  "3584": "崁顶乡",
  "2453": "得荣县",
  "2295": "迭部县",
  "1882": "蔡甸区",
  "1550": "信丰县",
  "1421": "涵江区",
  "1454": "梅列区",
  "665": "深州市",
  "2827": "洋县",
  "3021": "申扎县",
  "2758": "杨陵区",
  "1476": "月湖区",
  "2533": "榕江县",
  "1207": "江山市",
  "2641": "腾冲县",
  "2670": "禄丰县",
  "3007": "贡觉县",
  "1584": "历下区",
  "904": "兴城市",
  "930": "汪清县",
  "1675": "平邑县",
  "649": "献县",
  "2972": "萨迦县",
  "648": "吴桥县",
  "642": "青县",
  "2150": "平远县",
  "1318": "当涂县",
  "2006": "蒸湘区",
  "2245": "崆峒区",
  "3178": "达尔罕茂明安联合旗",
  "1764": "卫东区",
  "3348": "柳营区",
  "2130": "新会区",
  "1908": "罗田县",
  "1028": "抚远县",
  "198": "黄石市",
  "1589": "长清区",
  "2792": "佳县",
  "2550": "黔西县",
  "1718": "睢县",
  "1098": "鼓楼区",
  "1059": "逊克县",
  "2683": "云县",
  "3003": "察隅县",
  "3713": "新州镇",
  "3349": "盐水区",
  "913": "榆树市",
  "3644": "金门县",
  "2019": "永兴县",
  "2665": "姚安县",
  "361": "阿里地区",
  "202": "恩施土家族苗族自治州",
  "2468": "中江县",
  "184": "洛阳市",
  "3282": "盐埕区",
  "776": "汾西县",
  "3738": "新区",
  "2183": "霞山区",
  "1819": "伊川县",
  "1459": "大田县",
  "1570": "安源区",
  "2673": "墨江哈尼族自治县",
  "1984": "雨花区",
  "1269": "龙泉市",
  "412": "彰化县",
  "181": "信阳市",
  "307": "西双版纳傣族自治州",
  "3472": "龙潭乡",
  "1671": "郯城县",
  "830": "甘井子区",
  "2041": "娄星区",
  "154": "吉安市",
  "1467": "顺昌县",
  "1463": "泰宁县",
  "3721": "经济技术开发区",
  "2893": "七星区",
  "2062": "保靖县",
  "1101": "雨花台区",
  "704": "静乐县",
  "2801": "澄城县",
  "326": "黄南藏族自治州",
  "1462": "将乐县",
  "1165": "清河区",
  "2886": "鹿寨县",
  "681": "清河县",
  "2543": "印江土家族苗族自治县",
  "335": "渭南市",
  "3062": "巴里坤哈萨克自治县",
  "1029": "同江市",
  "5": "内蒙古自治区",
  "3531": "竹崎乡",
  "2715": "互助土族自治县",
  "3292": "大社区",
  "2694": "德钦县",
  "2105": "海丰县",
  "3455": "南澳乡",
  "554": "平山县",
  "2791": "米脂县",
  "1957": "张湾区",
  "552": "赞皇县",
  "2657": "易门县",
  "1867": "湖滨区",
  "3766": "东 区",
  "1623": "乐陵市",
  "2505": "平坝县",
  "74": "葫芦岛市",
  "3533": "中埔乡",
  "890": "朝阳县",
  "440": "平谷区",
  "2936": "凌云县",
  "3699": "王五镇",
  "1926": "赤壁市",
  "299": "屯昌县",
  "1289": "庐阳区",
  "2024": "安仁县",
  "2525": "三穗县",
  "1282": "玉环县",
  "841": "海城市",
  "1694": "乳山市",
  "1898": "孝南区",
  "1044": "友谊县",
  "3513": "社头乡",
  "1350": "天长市",
  "1751": "原阳县",
  "91": "双鸭山市",
  "2137": "曲江区",
  "3183": "卓资县",
  "1240": "宁海县",
  "2815": "汉阴县",
  "467": "闸北区",
  "3079": "阿图什市",
  "481": "涪陵区",
  "474": "金山区",
  "2121": "化州市",
  "867": "北镇市",
  "3563": "水林乡",
  "3355": "中区",
  "1976": "湘阴县",
  "3669": "厚街镇",
  "3442": "三芝区",
  "817": "新民市",
  "563": "北市区",
  "2751": "临潼区",
  "3470": "中坜市",
  "3248": "额济纳旗",
  "2919": "港南区",
  "2953": "都安瑶族自治县",
  "229": "惠州市",
  "673": "任县",
  "3489": "通霄镇",
  "3322": "安平区",
  "68": "锦州市",
  "2059": "泸溪县",
  "315": "文山壮族苗族自治州",
  "2514": "瓮安县",
  "1827": "武陟县",
  "3628": "富里乡",
  "2501": "习水县",
  "2366": "南江县",
  "1947": "枝江市",
  "3807": "花莲县",
  "1347": "全椒县",
  "222": "怀化市",
  "3350": "善化区",
  "2911": "藤县",
  "25": "青海省",
  "1504": "广丰县",
  "2270": "渭源县",
  "2418": "普格县",
  "3132": "叶城县",
  "305": "保亭黎族苗族自治县",
  "1253": "洞头县",
  "928": "龙井市",
  "1644": "诸城市",
  "1526": "奉新县",
  "3245": "突泉县",
  "217": "益阳市",
  "2648": "马关县",
  "281": "遵义市",
  "1730": "中牟县",
  "158": "菏泽市",
  "3784": "上溪镇",
  "46": "沧州市",
  "3623": "丰滨乡",
  "3412": "香山区",
  "1851": "项城市",
  "1316": "花山区",
  "3327": "左镇区",
  "2630": "麒麟区",
  "3658": "望牛墩镇",
  "36": "天津市",
  "2373": "叙永县",
  "1418": "福安市",
  "2263": "合水县",
  "3386": "金宁乡",
  "748": "屯留县",
  "472": "嘉定区",
  "1368": "含山县",
  "3505": "鹿港镇",
  "1655": "汶上县",
  "317": "楚雄彝族自治州",
  "1943": "长阳土家族自治县",
  "711": "原平市",
  "132": "宿州市",
  "1791": "社旗县",
  "1254": "永嘉县",
  "3712": "木棠镇",
  "1642": "昌乐县",
  "892": "喀喇沁左翼蒙古族自治县",
  "3779": "嘉善县",
  "3747": "千灯镇",
  "2180": "高要市",
  "546": "正定县",
  "2769": "武功县",
  "2071": "中方县",
  "1428": "泉港区",
  "537": "曲周县",
  "1018": "新兴区",
  "1125": "太仓市",
  "2279": "西和县",
  "1007": "密山市",
  "741": "太谷县",
  "1443": "南靖县",
  "3298": "桥头区",
  "1833": "淇滨区",
  "998": "讷河市",
  "1186": "金坛市",
  "3119": "库车县",
  "2806": "华阴市",
  "3032": "措勤县",
  "1789": "内乡县",
  "3566": "元长乡",
  "2240": "肃南裕固族自治县",
  "3192": "丰镇市",
  "2076": "麻阳苗族自治县",
  "529": "磁县",
  "3556": "斗六市",
  "1545": "安福县",
  "1838": "南乐县",
  "1773": "浉河区",
  "1058": "嫩江县",
  "3704": "南丰镇",
  "3166": "托克托县",
  "2573": "勐海县",
  "987": "富拉尔基区",
  "2984": "萨嘎县",
  "1150": "射阳县",
  "3392": "草屯镇",
  "2860": "邕宁区",
  "3141": "察布查尔锡伯自治县",
  "1535": "吉州区",
  "3775": "石林县",
  "2390": "东兴区",
  "908": "二道区",
  "1335": "岳西县",
  "3780": "平湖市",
  "2580": "昭阳区",
  "3409": "七堵区",
  "3127": "疏附县",
  "284": "黔东南苗族侗族自治州",
  "903": "建昌县",
  "247": "白银市",
  "1340": "歙县",
  "289": "海口市",
  "165": "济宁市",
  "729": "浑源县",
  "2351": "大竹县",
  "2119": "电白县",
  "2": "天津",
  "808": "皇姑区",
  "845": "顺城区",
  "2125": "博罗县",
  "2553": "纳雍县",
  "1847": "郸城县",
  "1231": " 平湖市",
  "2979": "定结县",
  "3270": "松山区",
  "147": "鹰潭市",
  "1249": "嵊州市",
  "973": "依兰县",
  "2446": "白玉县",
  "2961": "林周县",
  "2569": "龙华区",
  "1046": "饶河县",
  "1142": "宝应县",
  "2095": "越秀区",
  "1291": "包河区",
  "3227": "杭锦后旗",
  "2601": "嵩明县",
  "2599": "宜良县",
  "319": "临沧市",
  "2960": "城关区",
  "2571": "美兰区",
  "2857": "江南区",
  "1179": "灌南县",
  "1052": "明水县",
  "735": "榆次区",
  "1922": "嘉鱼县",
  "3048": "隆德县",
  "1493": "武宁县",
  "2948": "凤山县",
  "2397": "金口河区",
  "974": "方正县",
  "2629": "河口瑶族自治县",
  "1271": "金东区",
  "1668": "罗庄区",
  "344": "来宾市",
  "1715": "梁园区",
  "1613": "沂源县",
  "2103": "番禺区",
  "2949": "东兰县",
  "636": "大厂回族自治县",
  "1710": "茌平县",
  "1104": "高淳县",
  "1406": "海沧区",
  "2224": "平川区",
  "1133": "如东县",
  "2421": "昭觉县",
  "209": "潜江市",
  "2837": "陈仓区",
  "1905": "黄州区",
  "3203": "松山区",
  "1118": "句容市",
  "1575": "牡丹区",
  "117": "温州市",
  "2428": "雨城区",
  "2207": "郁南县",
  "80": "白城市",
  "600": "怀来县",
  "3754": "浑南新区",
  "336": "商洛市",
  "2472": "绵竹市",
  "457": "宝坻区",
  "1301": "南陵县",
  "821": "西丰县",
  "696": "右玉县",
  "383": "图木舒克市",
  "2532": "黎平县",
  "1873": "江岸区",
  "1721": "虞城县",
  "2497": "务川仡佬族苗族自治县",
  "3651": "莞城区",
  "3376": "大肚区",
  "2179": "德庆县",
  "2172": "三水区",
  "1431": "永春县",
  "92": "绥化市",
  "1489": "进贤县",
  "3050": "彭阳县",
  "3687": "环城街道",
  "1212": "西湖区",
  "2253": "金塔县",
  "2787": "横山县",
  "2433": "天全县",
  "1805": "兰考县",
  "3226": "乌拉特后旗",
  "1727": "金水区",
  "1477": "余江县",
  "1164": "邳州市",
  "2922": "桂平市",
  "2824": "汉台区",
  "505": "梁平县",
  "670": "内丘县",
  "2739": "格尔木市",
  "1094": "玄武区",
  "419": "连江县",
  "995": "克山县",
  "2178": "封开县",
  "837": "立山区",
  "1225": "安吉县",
  "2909": "长洲区",
  "290": "三亚市",
  "2015": "北湖区",
  "625": "玉田县",
  "149": "南昌市",
  "3208": "克什克腾旗",
  "712": "小店区",
  "210": "岳阳市",
  "406": "嘉义市",
  "3365": "雾峰区",
  "2560": "兴义市",
  "2289": "东乡族自治县",
  "3283": "鼓山区",
  "2312": "蒲江县",
  "19": "广东省",
  "3096": "米东区",
  "2702": "祁连县",
  "365": "固原市",
  "3637": "莒光乡",
  "1030": "富锦市",
  "763": "曲沃县",
  "2730": "达日县",
  "3255": "深水埗区",
  "3332": "关庙区",
  "2593": "官渡区",
  "3196": "开鲁县",
  "2021": "临武县",
  "3430": "土城区",
  "1895": "梁子湖区",
  "3318": "中西区",
  "2920": "覃塘区",
  "570": "定兴县",
  "2038": "桃江县",
  "3799": "宜兰县",
  "3123": "乌什县",
  "1880": "东西湖区",
  "3761": "离石市",
  "252": "平凉市",
  "883": "宏伟区",
  "3389": "乌坵乡",
  "1159": "丰县",
  "2048": "北塔区",
  "655": "桃城区",
  "3110": "尉犁县",
  "421": "九龙",
  "1998": "株洲县",
  "2930": "田阳县",
  "2332": "盐亭县",
  "1367": "无为县",
  "271": "内江市",
  "3742": "陆家镇",
  "1024": "东风区",
  "1070": "翠峦区",
  "3174": "白云鄂博矿区",
  "3117": "阿克苏市",
  "2867": "江洲区",
  "491": "渝北区",
  "2871": "大新县",
  "3618": "太鲁阁",
  "1863": "泌阳县",
  "3275": "北投区",
  "2463": "壤塘县",
  "13": "福建省",
  "2493": "桐梓县",
  "105": "淮安市",
  "1514": "临川区",
  "840": "岫岩满族自治县",
  "1647": "高密市",
  "597": "阳原县",
  "2380": "高县",
  "111": "衢州市",
  "3549": "虎尾镇",
  "408": "宜兰县",
  "1411": "蕉城区",
  "1480": "分宜县",
  "3581": "泰武乡",
  "3577": "竹田乡",
  "3265": "葵青区",
  "2777": "吴起县",
  "242": "云浮市",
  "559": "晋州市",
  "32": "台湾省",
  "1588": "历城区",
  "443": "和平区",
  "3601": "绿岛乡",
  "2234": "张家川回族自治县",
  "1795": "邓州市",
  "580": "顺平县",
  "2800": "合阳县",
  "2523": "黄平县",
  "3519": "田中镇",
  "3808": "澎湖县",
  "3273": "信义区",
  "846": "抚顺县",
  "1257": "文成县",
  "31": "西藏自治区",
  "1689": "利津县",
  "3484": "头份镇",
  "2307": "温江区",
  "1861": "正阳县",
  "2825": "南郑县",
  "2706": "城中区",
  "3312": "杉林区",
  "1296": "弋江区",
  "3415": "万里区",
  "1553": "崇义县",
  "2161": "福田区",
  "2897": "灵川县",
  "3336": "佳里区",
  "1303": "蚌山区",
  "2133": "鹤山市",
  "1654": "嘉祥县",
  "968": "平房区",
  "675": "宁晋县",
  "3494": "公馆乡",
  "3510": "造桥乡",
  "15": "山东省",
  "3268": "大同区",
  "431": "石景山区",
  "382": "喀什地区",
  "3541": "新港乡",
  "3016": "那曲县",
  "3487": "狮潭乡",
  "2236": "民勤县",
  "2846": "太白县",
  "1506": "铅山县",
  "2855": "兴宁区",
  "139": "厦门市",
  "129": "黄山市",
  "926": "敦化市",
  "3008": "类乌齐县",
  "2145": "梅江区",
  "859": "东港市",
  "1246": "新昌县",
  "3693": "新天园区",
  "739": "昔阳县",
  "1083": "萨尔图区",
  "1293": "肥东县",
  "876": "太平区",
  "3024": "巴青县",
  "1792": "唐河县",
  "2890": "秀峰区",
  "662": "景县",
  "168": "滨州市",
  "135": "亳州市",
  "3344": "白河区",
  "145": "三明市",
  "1518": "崇仁县",
  "3447": "壮围乡",
  "3444": "宜兰市",
  "178": "新乡市",
  "2674": "景东彝族自治县",
  "3624": "瑞穗乡",
  "1131": "港闸区",
  "3156": "满洲里市",
  "2728": "班玛县",
  "772": "大宁县",
  "3803": "南投县",
  "3439": "五股区",
  "124": "淮南市",
  "1876": "汉阳区",
  "1759": "鄢陵县",
  "1429": "惠安县",
  "1974": "岳阳县",
  "2032": "桃源县",
  "2536": "麻江县",
  "3611": "长滨乡",
  "2483": "乌当区",
  "3026": "普兰县",
  "1374": "舒城县",
  "1528": "上高县",
  "653": "黄骅市",
  "2807": "商州区",
  "2303": "成华区",
  "1692": "文登市",
  "2677": "江城哈尼族彝族自治县",
  "2259": "西峰区",
  "3064": "和田市",
  "509": "武隆县",
  "3708": "海头镇",
  "2212": "饶平县",
  "1015": "海林市",
  "976": "巴彦县",
  "367": "塔城地区",
  "716": "万柏林区",
  "1886": "襄城区",
  "1821": "解放区",
  "1972": "云溪区",
  "940": "通化县",
  "743": "平遥县",
  "685": "海港区",
  "3589": "琉球乡",
  "2265": "宁县",
  "21": "广西壮族自治区",
  "523": "峰峰矿区",
  "2377": "南溪县",
  "2129": "江海区",
  "723": "南郊区",
  "453": "西青区",
  "3597": "牡丹乡",
  "1460": "尤溪县",
  "2500": "余庆县",
  "1202": "柯城区",
  "3162": "回民区",
  "351": "百色市",
  "3303": "凤山区",
  "1040": "岭东区",
  "595": "尚义县",
  "2838": "凤翔县",
  "1755": "卫辉市",
  "488": "北碚区",
  "1138": "高邮市",
  "2926": "博白县",
  "1854": "召陵区",
  "1012": "东宁县",
  "835": "铁东区",
  "1498": "都昌县",
  "2182": "赤坎区",
  "1267": "庆元县",
  "1032": "工农区",
  "901": "南票区",
  "113": "湖州市",
  "2191": "源城区",
  "152": "抚州市",
  "342": "南宁市",
  "2931": "田东县",
  "862": "凌河区",
  "1419": "福鼎市",
  "341": "防城港市",
  "1056": "海伦市",
  "3664": "黄江镇",
  "3586": "南州乡",
  "2883": "柳北区",
  "2189": "雷州市",
  "2287": "广河县",
  "2540": "玉屏侗族自治县",
  "3108": "库尔勒市",
  "3793": "高雄",
  "2284": "临夏县",
  "64": "鞍山市",
  "2753": "蓝田县",
  "1473": "武夷山市",
  "881": "白塔区",
  "2461": "黑水县",
  "45": "廊坊市",
  "3186": "兴和县",
  "507": "丰都县",
  "405": "新竹市",
  "1173": "连云区",
  "309": "昭通市",
  "1963": "丹江口市",
  "1734": "新郑市",
  "3565": "四湖乡",
  "2085": "东安县",
  "1733": "新密市",
  "3230": "阿巴嘎旗",
  "2113": "揭东县",
  "2153": "龙湖区",
  "3383": "大安区",
  "1258": "泰顺县",
  "824": "开原市",
  "120": "台州市",
  "2568": "秀英区",
  "1148": "滨海县",
  "392": "鄂尔多斯市",
  "2841": "眉县",
  "254": "庆阳市",
  "2386": "安岳县",
  "2313": "新津县",
  "1321": "烈山区",
  "3653": "虎门镇",
  "2242": "临泽县",
  "2442": "炉霍县",
  "2254": "瓜州县",
  "1987": "宁乡县",
  "3354": "安定区",
  "813": "于洪区",
  "2014": "常宁市",
  "644": "海兴县",
  "3570": "玛家乡",
  "2602": "禄劝彝族苗族自治县",
  "851": "明山区",
  "2477": "青川县",
  "399": "高雄市",
  "3360": "北屯区",
  "1820": "偃师市",
  "2296": "玛曲县",
  "2110": "阳东县",
  "1811": "洛龙区",
  "436": "顺义区",
  "1342": "黟县",
  "94": "大兴安岭地区",
  "2457": "松潘县",
  "213": "株洲市",
  "1968": "京山县",
  "1802": "通许县",
  "2775": "安塞县",
  "1450": "上杭县",
  "3011": "八宿县",
  "568": "阜平县",
  "2863": "马山县",
  "2668": "元谋县",
  "3250": "湾仔区",
  "3098": "昌吉市",
  "2273": "岷县",
  "2411": "西昌市",
  "3476": "桃园市",
  "791": "汾阳市",
  "1129": "张家港市",
  "3330": "南化区",
  "1143": "江都市",
  "1355": "临泉县",
  "3640": "东市区",
  "2848": "印台区",
  "2231": "秦安县",
  "916": "龙潭区",
  "386": "呼和浩特市",
  "3617": "新城乡",
  "3231": "苏尼特左旗",
  "3095": "达坂城区",
  "1961": "竹溪县",
  "2043": "新化县",
  "3646": "增城区",
  "1457": "清流县",
  "200": "荆州市",
  "1261": "莲都区",
  "1352": "颍州区",
  "329": "玉树藏族自治州",
  "525": "临漳县",
  "787": "方山县",
  "2970": "江孜县",
  "27": "重庆",
  "1621": "夏津县",
  "2331": "三台县",
  "1561": "会昌县",
  "161": "淄博市",
  "1902": "应城市",
  "1866": "新蔡县",
  "2001": "炎陵县",
  "3736": "汽车产业开发区",
  "3731": "神农架林区",
  "3216": "鄂托克前旗",
  "109": "宿迁市",
  "1310": "田家庵区",
  "3459": "新丰乡",
  "2115": "惠来县",
  "2318": "东区",
  "3695": "道真县",
  "2651": "富宁县",
  "1239": "象山县",
  "3035": "金凤区",
  "2764": "永寿县",
  "769": "浮山县",
  "2797": "华县",
  "1181": "钟楼区",
  "1556": "定南县",
  "803": "永济市",
  "1809": "涧西区",
  "2744": "新城区",
  "3682": "曲江县",
  "2559": "盘县",
  "3199": "扎鲁特旗",
  "60": "运城市",
  "3378": "龙井区",
  "1766": "湛河区",
  "1245": "绍兴县",
  "691": "卢龙县",
  "1067": "南岔区",
  "1400": "闽清县",
  "2615": "剑川县",
  "1388": "泾县",
  "1676": "莒南县",
  "3153": "陈巴尔虎旗",
  "346": "桂林市",
  "3134": "岳普湖县",
  "911": "农安县",
  "3085": "温泉县",
  "3171": "昆都仑区",
  "427": "崇文区",
  "2072": "沅陵县",
  "82": "松原市",
  "3507": "线西乡",
  "3121": "新和县",
  "650": "孟村回族自治县",
  "3464": "竹东镇",
  "2202": "清新县",
  "1154": "鼓楼区",
  "3427": "乌来区",
  "2624": "泸西县",
  "895": "双台子区",
  "1763": "新华区",
  "69": "营口市",
  "2965": "堆龙德庆县",
  "1157": "贾汪区",
  "1910": "浠水县",
  "1470": "松溪县",
  "2762": "乾县",
  "3076": "哈巴河县",
  "224": "广州市",
  "3608": "池上乡",
  "3402": "鹿谷乡",
  "3264": "荃湾区",
  "2711": "湟源县",
  "3501": "彰化市",
  "2100": "黄埔区",
  "1982": "岳麓区",
  "1006": "虎林市",
  "2393": "隆昌县",
  "3423": "双溪区",
  "426": "西城区",
  "996": "克东县",
  "3222": "五原县",
  "3005": "昌都县",
  "1435": "南安市",
  "3656": "石碣镇",
  "279": "广元市",
  "1840": "台前县",
  "2408": "洪雅县",
  "2069": "桑植县",
  "956": "长岭县",
  "629": "安次区",
  "498": "南川区",
  "483": "大渡口区",
  "3520": "北斗镇",
  "2055": "新宁县",
  "372": "博尔塔拉蒙古自治州",
  "1487": "新建县",
  "2951": "环江毛南族自治县",
  "3204": "阿鲁科尔沁旗",
  "2028": "安乡县",
  "1540": "新干县",
  "3075": "福海县",
  "1284": "天台县",
  "1330": "枞阳县",
  "1661": "泰山区",
  "3041": "平罗县",
  "3772": "图木舒克市",
  "3526": "大城乡",
  "1606": "淄川区",
  "2064": "永顺县",
  "99": "镇江市",
  "1160": "沛县",
  "3553": "台西乡",
  "869": "西市区",
  "1592": "商河县",
  "1933": "洪湖市",
  "790": "孝义市",
  "2022": "汝城县",
  "533": "鸡泽县",
  "2080": "通道侗族自治县",
  "3551": "褒忠乡",
  "1122": "金阊区",
  "2997": "浪卡子县",
  "2416": "会东县",
  "1697": "峄城区",
  "1053": "绥棱县",
  "462": "卢湾区",
  "414": "云林县",
  "1770": "郏县",
  "2735": "称多县",
  "1209": "下城区",
  "263": "南充市",
  "991": "依安县",
  "3746": "周庄镇",
  "3361": "西屯区",
  "2985": "岗巴县",
  "3535": "水上乡",
  "931": "安图县",
  "3593": "枋山乡",
  "2348": "达县",
  "615": "路南区",
  "2246": "泾川县",
  "476": "青浦区",
  "1198": "定海区",
  "3319": "东区",
  "3755": "鲅鱼圈区",
  "3673": "横沥镇",
  "3210": "喀喇沁旗",
  "1409": "同安区",
  "1626": "福山区",
  "2219": "皋兰县",
  "2141": "乳源瑶族自治县",
  "2464": "阿坝县",
  "1077": "带岭区",
  "1716": "睢阳区",
  "293": "儋州市",
  "2854": "东兴市",
  "1272": "武义县",
  "1299": "芜湖县",
  "1781": "淮滨县",
  "1663": "宁阳县",
  "967": "道外区",
  "2888": "融水苗族自治县",
  "2157": "潮南区",
  "1611": "桓台县",
  "322": "丽江市",
  "469": "杨浦区",
  "635": "文安县",
  "3046": "原州区",
  "575": "望都县",
  "1088": "肇州县",
  "1835": "淇县",
  "1566": "昌江区",
  "979": "延寿县",
  "709": "保德县",
  "3737": "园区",
  "3603": "延平乡",
  "40": "石家庄市",
  "310": "昆明市",
  "192": "三门峡市",
  "699": "定襄县",
  "1115": "丹徒区",
  "960": "江源区",
  "818": "银州区",
  "3529": "番路乡",
  "2363": "华蓥市",
  "1038": "绥滨县",
  "3764": "利州区",
  "2908": "碟山区",
  "2293": "卓尼县",
  "1707": "东昌府区",
  "543": "井陉矿区",
  "3103": "吉木萨尔县",
  "267": "巴中市",
  "3088": "白碱滩区",
  "1892": "老河口市",
  "1777": "新县",
  "2044": "冷水江市",
  "354": "北海市",
  "1437": "龙文区",
  "2813": "柞水县",
  "1064": "塔河县",
  "2724": "贵德县",
  "2517": "罗甸县",
  "757": "沁水县",
  "2577": "梁河县",
  "9": "上海",
  "3359": "北区",
  "2734": "杂多县",
  "1217": "建德市",
  "3240": "乌兰浩特市",
  "1600": "城阳区",
  "1740": "安阳县",
  "3288": "楠梓区",
  "603": "崇礼县",
  "2750": "阎良区",
  "2527": "岑巩县",
  "90": "鹤岗市",
  "3514": "永靖乡",
  "1850": "鹿邑县",
  "565": "满城县",
  "1346": "来安县",
  "3102": "奇台县",
  "1964": "曾都区",
  "3396": "名间乡",
  "3247": "阿拉善右旗",
  "850": "溪湖区",
  "2818": "紫阳县",
  "2424": "越西县",
  "891": "建平县",
  "3471": "平镇市",
  "1004": "麻山区",
  "2106": "陆河县",
  "2696": "古城区",
  "1360": "埇桥区",
  "3620": "寿丰乡",
  "233": "汕头市",
  "1013": "林口县",
  "1490": "庐山区",
  "2198": "佛冈县",
  "1693": "荣成市",
  "316": "玉溪市",
  "2947": "天峨县",
  "1806": "老城区",
  "2288": "和政县",
  "1738": "殷都区",
  "2025": "资兴市",
  "1370": "金安区",
  "2954": "大化瑶族自治县",
  "11": "浙江省",
  "3668": "谢岗镇",
  "2649": "丘北县",
  "3804": "云林县",
  "842": "新抚区",
  "511": "开县",
  "2367": "平昌县",
  "899": "连山区",
  "3443": "石门区",
  "3259": "大埔区",
  "2000": "茶陵县",
  "3340": "学甲区",
  "3573": "高树乡",
  "2437": "泸定县",
  "2531": "台江县",
  "3131": "莎车县",
  "2689": "泸水县",
  "3765": "乐山市",
  "199": "咸宁市",
  "2410": "青神县",
  "1979": "临湘市",
  "1899": "孝昌县",
  "3066": "墨玉县",
  "1929": "公安县",
  "2485": "小河区",
  "1737": "北关区",
  "1948": "恩施市",
  "3143": "巩留县",
  "795": "闻喜县",
  "794": "万荣县",
  "1609": "临淄区",
  "3411": "北区",
  "944": "集安市",
  "3284": "旗津区",
  "1780": "潢川县",
  "3223": "磴口县",
  "1113": "京口区",
  "674": "南和县",
  "3405": "中正区",
  "3244": "扎赉特旗",
  "2122": "信宜市",
  "2280": "礼县",
  "1317": "雨山区",
  "957": "乾安县",
  "280": "贵阳市",
  "273": "眉山市",
  "471": "宝山区",
  "2430": "荥经县",
  "2943": "灵山县",
  "2596": "呈贡县",
  "1503": "上饶县",
  "3498": "三义乡",
  "2262": "华池县",
  "1509": "余干县",
  "1936": "伍家岗区",
  "2912": "蒙山县",
  "1325": "铜陵县",
  "2512": "荔波县",
  "131": "阜阳市",
  "1643": "青州市",
  "1565": "南康市",
  "502": "大足县",
  "314": "保山市",
  "1286": "温岭市",
  "1796": "龙亭区",
  "3385": "金湖镇",
  "2998": "林芝县",
  "1502": "信州区",
  "2638": "宣威市",
  "1872": "灵宝市",
  "355": "拉萨市",
  "553": "无极县",
  "2058": "吉首市",
  "3546": "布袋镇",
  "1252": "瓯海区",
  "555": "元氏县",
  "3488": "后龙镇",
  "2877": "武宣县",
  "2643": "昌宁县",
  "1037": "萝北县",
  "2935": "那坡县",
  "37": "上海市",
  "2513": "贵定县",
  "855": "元宝区",
  "3328": "玉井区",
  "3659": "洪梅镇",
  "195": "鄂州市",
  "2005": "石鼓区",
  "1706": "钢城区",
  "2828": "西乡县",
  "1788": "镇平县",
  "1839": "范县",
  "680": "威县",
  "679": "平乡县",
  "2186": "遂溪县",
  "831": "金州区",
  "1147": "响水县",
  "1960": "竹山县",
  "2355": "安居区",
  "1241": "余姚市",
  "2783": "黄陵县",
  "647": "南皮县",
  "1441": "长泰县",
  "334": "榆林市",
  "1206": "龙游县",
  "2292": "临潭县",
  "3582": "来义乡",
  "1997": "天元区",
  "1027": "汤原县",
  "423": "巴彦淖尔盟",
  "1680": "惠民县",
  "2879": "合山市",
  "1953": "咸丰县",
  "1139": "广陵区",
  "2757": "秦都区",
  "1319": "杜集区",
  "1826": "博爱县",
  "2454": "汶川县",
  "2077": "新晃侗族自治县",
  "1222": "南浔区",
  "3473": "杨梅市",
  "2036": "赫山区",
  "1747": "凤泉区",
  "820": "铁岭县",
  "174": "聊城市",
  "1799": "禹王台区",
  "1571": "湘东区",
  "422": "新界",
  "905": "南关区",
  "3308": "旗山区",
  "1194": "宿豫区",
  "1552": "上犹县",
  "3716": "高新区",
  "41": "保定市",
  "3681": "城区",
  "3014": "洛隆县",
  "52": "太原市",
  "3084": "精河县",
  "2887": "融安县",
  "302": "昌江黎族自治县",
  "1451": "武平县",
  "866": "凌海市",
  "1453": "漳平市",
  "2452": "稻城县",
  "2223": "白银区",
  "3532": "阿里山乡",
  "770": "吉县",
  "593": "康保县",
  "3358": "西区",
  "3380": "清水区",
  "188": "濮阳市",
  "402": "金门县",
  "3152": "鄂温克族自治旗",
  "1940": "远安县",
  "641": "沧县",
  "1097": "建邺区",
  "3366": "乌日区",
  "1641": "临朐县",
  "838": "千山区",
  "616": "路北区",
  "2962": "当雄县",
  "2664": "南华县",
  "640": "运河区",
  "870": "鮁鱼圈区",
  "1121": "平江区",
  "1384": "青阳县",
  "896": "兴隆台区",
  "1468": "浦城县",
  "3530": "梅山乡",
  "3184": "化德县",
  "2068": "慈利县",
  "1726": "管城回族区",
  "3672": "桥头镇",
  "2903": "资源县",
  "1464": "建宁县",
  "2165": "盐田区",
  "2347": "通川区",
  "1494": "修水县",
  "3440": "八里区",
  "777": "侯马市",
  "3426": "坪林区",
  "2018": "宜章县",
  "3609": "东河乡",
  "1906": "团风县",
  "464": "长宁区",
  "2786": "府谷县",
  "3235": "太仆寺旗",
  "2977": "仁布县",
  "1672": "沂水县",
  "2325": "大安区",
  "1685": "邹平县",
  "2011": "衡东县",
  "1891": "保康县",
  "6": "辽宁省",
  "3452": "五结乡",
  "562": "新市区",
  "2768": "淳化县",
  "1304": "禹会区",
  "2327": "荣县",
  "2269": "陇西县",
  "1102": "六合区",
  "183": "开封市",
  "3569": "雾台乡",
  "3189": "察哈尔右翼中旗",
  "3179": "海勃湾区",
  "2544": "德江县",
  "1478": "贵溪市",
  "439": "怀柔区",
  "362": "银川市",
  "2541": "石阡县",
  "1379": "蒙城县",
  "2607": "祥云县",
  "1593": "章丘市",
  "705": "神池县",
  "3345": "东山区",
  "1720": "柘城县",
  "3798": "嘉义",
  "3053": "海原县",
  "2206": "新兴县",
  "407": "新北市",
  "2496": "道真仡佬族苗族自治县",
  "2177": "怀集县",
  "3686": "西区街道",
  "18": "湖南省",
  "912": "九台市",
  "376": "昌吉回族自治州",
  "785": "石楼县",
  "1432": "德化县",
  "599": "万全县",
  "1930": "监利县",
  "609": "平泉县",
  "587": "桥东区",
  "1393": "台江区",
  "1167": "淮阴区",
  "1235": "江北区",
  "95": "伊春市",
  "298": "定安县",
  "3291": "仁武区",
  "923": "磐石市",
  "3652": "石龙镇",
  "3373": "潭子区",
  "243": "潮州市",
  "2051": "邵阳县",
  "2682": "凤庆县",
  "148": "新余市",
  "753": "武乡县",
  "1343": "祁门县",
  "2489": "清镇市",
  "2655": "通海县",
  "2404": "峨眉山市",
  "726": "天镇县",
  "2509": "紫云苗族布依族自治县",
  "2955": "宜州市",
  "2703": "海晏县",
  "2171": "顺德区",
  "2611": "巍山彝族回族自治县",
  "106": "连云港市",
  "964": "临江市",
  "157": "萍乡市",
  "65": "抚顺市",
  "2009": "衡南县",
  "1909": "英山县",
  "935": "伊通满族自治县",
  "203": "神农架林区",
  "2627": "金平苗族瑶族傣族自治县",
  "3576": "麟洛乡",
  "1213": "滨江区",
  "1093": "浦口区",
  "81": "辽源市",
  "1023": "前进区",
  "2742": "都兰县",
  "86": "鸡西市",
  "624": "迁西县",
  "2473": "市中区",
  "2084": "祁阳县",
  "1300": "繁昌县",
  "1199": "普陀区",
  "2598": "富民县",
  "1158": "泉山区",
  "656": "枣强县",
  "371": "克孜勒苏柯尔克孜自治州",
  "2170": "南海区",
  "204": "十堰市",
  "2335": "北川羌族自治县",
  "1041": "四方台区",
  "2921": "平南县",
  "3468": "北埔乡",
  "435": "通州区",
  "1990": "岳塘区",
  "814": "辽中县",
  "3254": "油尖旺区",
  "3195": "科尔沁左翼后旗",
  "2492": "遵义县",
  "1482": "西湖区",
  "885": "太子河区",
  "2109": "阳西县",
  "884": "弓长岭区",
  "1412": "霞浦县",
  "1709": "莘县",
  "339": "宝鸡市",
  "3539": "东石乡",
  "228": "茂名市",
  "749": "平顺县",
  "3783": "佛堂镇",
  "268": "泸州市",
  "829": "沙河口区",
  "3677": "长安镇",
  "345": "柳州市",
  "2872": "天等县",
  "596": "蔚县",
  "3323": "安南区",
  "1297": "鸠江区",
  "2090": "蓝山县",
  "1521": "金溪县",
  "1862": "确山县",
  "613": "宽城满族自治县",
  "2352": "渠县",
  "3495": "大湖乡",
  "1082": "铁力市",
  "1066": "伊春区",
  "121": "合肥市",
  "952": "东丰县",
  "2691": "贡山独龙族怒族自治县",
  "494": "长寿区",
  "487": "南岸区",
  "1071": "新青区",
  "3058": "托里县",
  "3333": "龙崎区",
  "1956": "茅箭区",
  "2778": "甘泉县",
  "238": "湛江市",
  "2235": "凉州区",
  "3175": "九原区",
  "873": "大石桥市",
  "3604": "卑南乡",
  "3081": "阿合奇县",
  "253": "酒泉市",
  "3099": "阜康市",
  "448": "红桥区",
  "3634": "湖西乡",
  "3760": "民营经济开发区",
  "3278": "文山区",
  "2631": "马龙县",
  "2278": "康县",
  "2427": "雷波县",
  "63": "大连市",
  "1637": "潍城区",
  "3297": "燕巢区",
  "179": "许昌市",
  "1532": "丰城市",
  "1105": "崇安区",
  "713": "迎泽区",
  "3705": "白马井镇",
  "1334": "望江县",
  "2499": "湄潭县",
  "3776": "南湖区",
  "2805": "韩城市",
  "2096": "海珠区",
  "3557": "林内乡",
  "1784": "卧龙区",
  "938": "东昌区",
  "2839": "岐山县",
  "2149": "五华县",
  "1679": "滨城区",
  "1830": "孟州市",
  "1620": "平原县",
  "2241": "民乐县",
  "3060": "和布克赛尔蒙古自治县",
  "1262": "青田县",
  "3167": "和林格尔县",
  "1290": "蜀山区",
  "1527": "万载县",
  "2162": "南山区",
  "1132": "海安县",
  "929": "和龙市",
  "2370": "龙马潭区",
  "2554": "威宁彝族回族苗族自治县",
  "1925": "通山县",
  "2916": "钟山县",
  "2574": "勐腊县",
  "3126": "喀什市",
  "631": "固安县",
  "547": "栾城县",
  "1538": "吉水县",
  "1544": "万安县",
  "1583": "东明县",
  "1616": "宁津县",
  "396": "阿拉善盟",
  "258": "甘南藏族自治州",
  "1422": "荔城区",
  "482": "渝中区",
  "949": "大安市",
  "2620": "屏边苗族自治县",
  "499": "綦江县",
  "3432": "树林区",
  "1047": "北林区",
  "2138": "始兴县",
  "1055": "肇东市",
  "3610": "成功镇",
  "2447": "石渠县",
  "1276": "义乌市",
  "3228": "二连浩特市",
  "3140": "伊宁县",
  "141": "莆田市",
  "909": "绿园区",
  "3043": "盐池县",
  "2981": "亚东县",
  "2618": "开远市",
  "1124": "昆山市",
  "75": "长春市",
  "1230": " 海宁市",
  "2793": "吴堡县",
  "2993": "洛扎县",
  "2588": "彝良县",
  "1917": "下陆区",
  "1163": "新沂市",
  "450": "汉沽区",
  "1702": "岚山区",
  "3118": "温宿县",
  "1405": "思明区",
  "1713": "高唐县",
  "3590": "佳冬乡",
  "1060": "孙吴县",
  "3759": "中卫县",
  "3722": "高新开发区",
  "2420": "金阳县",
  "2104": "增城市",
  "2894": "雁山区",
  "2126": "惠东县",
  "2858": "西乡塘区",
  "900": "龙港区",
  "318": "普洱市",
  "1729": "惠济区",
  "972": "阿城区",
  "2526": "镇远县",
  "473": "浦东新区",
  "2572": "景洪市",
  "3": "河北省",
  "1774": "平桥区",
  "248": "天水市",
  "146": "南平市",
  "3202": "元宝山区",
  "1351": "明光市",
  "802": "芮城县",
  "356": "日喀则地区",
  "2396": "五通桥区",
  "2720": "泽库县",
  "528": "涉县",
  "3420": "石碇区",
  "2063": "古丈县",
  "164": "潍坊市",
  "807": "大东区",
  "3723": "出口加工区",
  "3269": "中山区",
  "2040": "沅江市",
  "2632": "陆良县",
  "2678": "孟连傣族拉祜族佤族自治县",
  "1049": "兰西县",
  "2898": "全州县",
  "882": "文圣区",
  "2812": "镇安县",
  "1050": "青冈县",
  "1488": "安义县",
  "560": "新乐市",
  "2830": "宁强县",
  "898": "盘山县",
  "798": "绛县",
  "2725": "兴海县",
  "3670": "清溪镇",
  "1031": "向阳区",
  "1273": "浦江县",
  "2942": "钦北区",
  "451": "大港区",
  "3401": "竹山镇",
  "2516": "平塘县",
  "454": "津南区",
  "3362": "南屯区",
  "3139": "奎屯市",
  "2616": "鹤庆县",
  "1364": "泗县 ",
  "2538": "铜仁市",
  "1408": "集美区",
  "2448": "色达县",
  "2969": "南木林县",
  "634": "大城县",
  "2721": "河南蒙古族自治县",
  "578": "曲阳县",
  "3595": "狮子乡",
  "2551": "金沙县",
  "695": "应县",
  "978": "通河县",
  "3741": "周市镇",
  "3324": "永康区",
  "3752": "昌北区",
  "2144": "南雄市",
  "378": "吐鲁番地区",
  "325": "海东市",
  "889": "龙城区",
  "3331": "仁德区",
  "1233": "海曙区",
  "3390": "南投市",
  "540": "桥东区",
  "1162": "睢宁县",
  "1615": "陵县",
  "684": "沙河市",
  "3137": "塔什库尔干塔吉克自治县",
  "211": "长沙市",
  "2831": "略阳县",
  "3065": "和田县",
  "1732": "荥阳市",
  "2073": "辰溪县",
  "861": "古塔区",
  "3706": "兰洋镇",
  "337": "安康市",
  "3315": "那玛夏区",
  "2406": "仁寿县",
  "76": "吉林市",
  "3172": "青山区",
  "1924": "崇阳县",
  "2718": "同仁县",
  "982": "五常市",
  "3042": "利通区",
  "571": "唐县",
  "1214": "余杭区",
  "1190": "靖江市",
  "389": "乌兰察布市",
  "2592": "盘龙区",
  "1660": "邹城市",
  "3525": "二林镇",
  "3207": "林西县",
  "1171": "盱眙县",
  "1345": "南谯区",
  "2290": "积石山保安族东乡族撒拉族自治县",
  "966": "南岗区",
  "1123": "虎丘区",
  "2216": "安宁区",
  "2314": "都江堰市",
  "992": "泰来县",
  "758": "阳城县",
  "1954": "来凤县",
  "236": "佛山市",
  "706": "五寨县",
  "2843": "千阳县",
  "218": "娄底市",
  "14": "江西省",
  "2345": "西充县",
  "3124": "阿瓦提县",
  "2587": "镇雄县",
  "1608": "博山区",
  "3391": "中寮乡",
  "2973": "拉孜县",
  "2328": "富顺县",
  "2999": "工布江达县",
  "2567": "安龙县",
  "3232": "苏尼特右旗",
  "2474": "元坝区",
  "2889": "三江侗族自治县",
  "3786": "大陈镇",
  "234": "深圳市",
  "594": "沽源县",
  "2924": "容县",
  "1438": "云霄县",
  "3289": "小港区",
  "3158": "扎兰屯市",
  "1903": "安陆市",
  "2188": "廉江市",
  "2767": "旬邑县",
  "3667": "塘厦镇",
  "3554": "仑背乡",
  "1778": "商城县",
  "1859": "上蔡县",
  "2339": "高坪区",
  "160": "青岛市",
  "3782": "海盐县",
  "3116": "博湖县",
  "98": "无锡市",
  "2776": "志丹县",
  "2901": "灌阳县",
  "1048": "望奎县",
  "1278": "永康市",
  "2434": "芦山县",
  "1000": "恒山区",
  "1381": "贵池区",
  "43": "承德市",
  "1061": "北安市",
  "2582": "巧家县",
  "3792": "台北",
  "2054": "绥宁县",
  "3735": "高新技术开发区",
  "3502": "芬园乡",
  "1728": "上街区",
  "2785": "神木县",
  "3732": "天门市",
  "3635": "南竿乡",
  "3224": "乌拉特前旗",
  "3763": "北川县",
  "288": "黔西南布依族苗族自治州",
  "193": "武汉市",
  "119": "金华市",
  "1555": "龙南县",
  "586": "高碑店市",
  "2870": "龙州县",
  "410": "桃园县",
  "2859": "良庆区",
  "999": "鸡冠区",
  "3193": "科尔沁区",
  "3019": "聂荣县",
  "3374": "大雅区",
  "1180": "天宁区",
  "430": "丰台区",
  "1185": "溧阳市",
  "2169": "禅城区",
  "447": "河北区",
  "3602": "兰屿乡",
  "3258": "北区",
  "1446": "龙海市",
  "1741": "汤阴县",
  "2118": "茂港区",
  "415": "屏东县",
  "1130": "崇川区",
  "1315": "金家庄区",
  "189": "周口市",
  "1292": "长丰县",
  "2597": "晋宁县",
  "1356": "太和县",
  "2330": "游仙区",
  "2849": "耀州区",
  "480": "万州区",
  "438": "大兴区",
  "107": "常州市",
  "1153": "大丰市",
  "1871": "义马市",
  "87": "牡丹江市",
  "2385": "雁江区",
  "1022": "向阳区",
  "1832": "山城区",
  "2795": "子洲县",
  "953": "东辽县",
  "3796": "台南",
  "2704": "刚察县",
  "221": "张家界市",
  "3147": "尼勒克县",
  "3176": "土默特右旗",
  "1424": "仙游县",
  "1560": "兴国县",
  "417": "花莲县",
  "784": "柳林县",
  "1762": "长葛市",
  "260": "攀枝花市",
  "3080": "阿克陶县",
  "2061": "花垣县",
  "1844": "西华县",
  "1530": "靖安县",
  "762": "尧都区",
  "1144": "仪征市",
  "2504": "西秀区",
  "734": "盂县",
  "2798": "潼关县",
  "2952": "巴马瑶族自治县",
  "1723": "永城市",
  "2621": "建水县",
  "2047": "大祥区",
  "144": "龙岩市",
  "3724": "济源市",
  "1440": "诏安县",
  "3696": "市区",
  "2524": "施秉县",
  "381": "阿拉尔市",
  "1471": "政和县",
  "1814": "栾川县",
  "906": "宽城区",
  "1349": "凤阳县",
  "2205": "云城区",
  "2966": "达孜县",
  "177": "安阳市",
  "373": "克拉玛依市",
  "3379": "梧栖区",
  "2213": "城关区",
  "2078": "芷江侗族自治县",
  "3346": "六甲区",
  "773": "隰县",
  "1247": "诸暨市",
  "2940": "隆林各族自治县",
  "205": "随州市",
  "22": "甘肃省",
  "3072": "阿勒泰市",
  "1309": "大通区",
  "1752": "延津县",
  "3213": "东胜区",
  "1576": "曹县",
  "3448": "员山乡",
  "3296": "田寮区",
  "2874": "兴宾区",
  "2681": "临翔区",
  "1622": "武城县",
  "1260": "乐清市",
  "874": "海州区",
  "3685": "东区街道",
  "975": "宾县",
  "3605": "鹿野乡",
  "493": "黔江区",
  "1708": "阳谷县",
  "3719": "管城区",
  "1436": "芗城区",
  "1911": "蕲春县",
  "2220": "榆中县",
  "2856": "青秀区",
  "1591": "济阳县",
  "2528": "天柱县",
  "1677": "蒙阴县",
  "2174": "端州区",
  "2199": "阳山县",
  "1320": "相山区",
  "3709": "排浦镇",
  "1026": "桦川县",
  "3002": "波密县",
  "2752": "长安区",
  "1390": "旌德县",
  "3113": "焉耆回族自治县",
  "1993": "韶山市",
  "1893": "枣阳市",
  "3544": "溪口乡",
  "1469": "光泽县",
  "1499": "湖口县",
  "1646": "安丘市",
  "3010": "察雅县",
  "919": "永吉县",
  "746": "长治县",
  "534": "广平县",
  "400": "台南市",
  "3572": "里港乡",
  "3690": "江州区",
  "744": "灵石县",
  "1268": "景宁畲族自治县",
  "633": "香河县",
  "1372": "寿县",
  "151": "上饶市",
  "1977": "平江县",
  "2023": "桂东县",
  "3445": "头城镇",
  "1669": "河东区",
  "1825": "修武县",
  "1285": "仙居县",
  "1952": "宣恩县",
  "287": "六盘水市",
  "475": "松江区",
  "3309": "美浓区",
  "932": "铁西区",
  "3594": "春日乡",
  "2595": "东川区",
  "3757": "惠农县",
  "1549": "赣县",
  "1959": "郧西县",
  "515": "巫溪县",
  "1525": "袁州区",
  "1242": "慈溪市",
  "2545": "沿河土家族自治县",
  "2761": "泾阳县",
  "2996": "错那县",
  "1208": "上城区",
  "1107": "北塘区",
  "138": "福州市",
  "1874": "江汉区",
  "3499": "西湖乡",
  "1803": "尉氏县",
  "3542": "民雄乡",
  "724": "新荣区",
  "1201": "嵊泗县",
  "3598": "恒春镇",
  "519": "彭水苗族土家族自治县",
  "3534": "大埔乡",
  "1195": "沭阳县",
  "3300": "弥陀区",
  "17": "湖北省",
  "2451": "乡城县",
  "1327": "大观区",
  "3337": "西港区",
  "1274": "磐安县",
  "2192": "紫金县",
  "2667": "永仁县",
  "110": "舟山市",
  "333": "延安市",
  "1995": "芦淞区",
  "2356": "蓬溪县",
  "2210": "湘桥区",
  "3700": "雅星镇",
  "2658": "峨山彝族自治县",
  "646": "肃宁县",
  "2780": "洛川县",
  "446": "南开区",
  "2181": "四会市",
  "2229": "麦积区",
  "1220": "萧山区",
  "1582": "定陶县",
  "2842": "陇县",
  "3663": "大朗镇",
  "1599": "李沧区",
  "3013": "芒康县",
  "2306": "新都区",
  "1149": "阜宁县",
  "2900": "永福县",
  "2652": "红塔区",
  "2337": "江油市",
  "2283": "临夏市",
  "2603": "寻甸回族彝族自治县",
  "2243": "高台县",
  "2407": "彭山县",
  "1087": "大同区",
  "1288": "瑶海区",
  "2695": "维西傈僳族自治县",
  "810": "苏家屯区",
  "1238": "鄞州区",
  "33": "澳门特别行政区",
  "1587": "天桥区",
  "2866": "横县",
  "1559": "于都县",
  "7": "吉林省",
  "1793": "新野县",
  "1701": "东港区",
  "227": "揭阳市",
  "1860": "平舆县",
  "2443": "甘孜县",
  "1937": "点军区",
  "2013": "耒阳市",
  "806": "沈河区",
  "255": "定西市",
  "264": "达州市",
  "2230": "清水县",
  "1885": "新洲区",
  "3422": "平溪区",
  "182": "南阳市",
  "2905": "荔浦县",
  "1817": "宜阳县",
  "2707": "城西区",
  "556": "赵县",
  "717": "晋源区",
  "2817": "宁陕县",
  "815": "康平县",
  "671": "柏乡县",
  "3486": "南庄乡",
  "1511": "万年县",
  "2249": "华亭县",
  "167": "临沂市",
  "3353": "新市区",
  "692": "朔城区",
  "2423": "冕宁县",
  "1605": "莱西市",
  "663": "阜城县",
  "3564": "口湖乡",
  "1907": "红安县",
  "2431": "汉源县",
  "854": "桓仁满族自治县",
  "1945": "宜都市",
  "969": "松北区",
  "3120": "沙雅县",
  "3769": "米泉市",
  "1174": "新浦区",
  "1946": "当阳市",
  "510": "忠县",
  "393": "巴彦淖尔市",
  "3020": "安多县",
  "2276": "文县",
  "1501": "瑞昌市",
  "658": "武强县",
  "3262": "元朗区",
  "274": "凉山彝族自治州",
  "3550": "土库镇",
  "549": "灵寿县",
  "877": "清河门区",
  "3465": "五峰乡",
  "1508": "弋阳县",
  "3629": "马公市",
  "3034": "西夏区",
  "1128": "相城区",
  "1771": "舞钢市",
  "2891": "叠彩区",
  "946": "镇赉县",
  "3515": "埔心乡",
  "1724": "中原区",
  "1520": "宜黄县",
  "303": "乐东黎族自治县",
  "2148": "丰顺县",
  "250": "武威市",
  "2644": "文山县",
  "1361": "砀山县",
  "614": "围场满族蒙古族自治县",
  "2963": "尼木县",
  "1765": "石龙区",
  "3155": "新巴尔虎右旗",
  "2959": "合浦县",
  "3773": "五家渠市",
  "3280": "前金区",
  "130": "滁州市",
  "53": "大同市",
  "1373": "霍邱县",
  "2925": "陆川县",
  "1465": "永安市",
  "2990": "琼结县",
  "1302": "龙子湖区",
  "2239": "甘州区",
  "1397": "闽侯县",
  "3678": "中堂镇",
  "941": "辉南县",
  "3341": "北门区",
  "583": "涿州市",
  "3029": "日土县",
  "2392": "资中县",
  "3587": "林边乡",
  "3436": "泰山区",
  "1879": "洪山区",
  "3313": "甲仙区",
  "1824": "山阳区",
  "2917": "富川瑶族自治县",
  "1869": "陕县",
  "3190": "察哈尔右翼后旗",
  "2342": "营山县",
  "591": "宣化县",
  "3516": "溪湖镇",
  "832": "普兰店市",
  "2304": "龙泉驿区",
  "3481": "大园乡",
  "2135": "武江区",
  "2341": "南部县",
  "2804": "富平县",
  "3583": "万峦乡",
  "828": "西岗区",
  "276": "甘孜藏族自治州",
  "102": "扬州市",
  "1920": "大冶市",
  "1831": "鹤山区",
  "2465": "若尔盖县",
  "3523": "溪州乡",
  "2992": "措美县",
  "2639": "隆阳区",
  "3483": "竹南镇",
  "1218": "富阳市",
  "1404": "长乐市",
  "2398": "犍为县",
  "1543": "遂川县",
  "259": "成都市",
  "424": "台湾",
  "1625": "芝罘区",
  "163": "烟台市",
  "1402": "平潭县",
  "1106": "南长区",
  "1836": "华龙区",
  "2986": "乃东县",
  "1531": "铜鼓县",
  "2402": "峨边彝族自治县",
  "2731": "久治县",
  "2929": "右江区",
  "1841": "濮阳县",
  "347": "梧州市",
  "3558": "古坑乡",
  "3294": "路竹区",
  "1333": "宿松县",
  "2738": "曲麻莱县",
  "434": "房山区",
  "2586": "绥江县",
  "865": "义县",
  "1184": "武进区",
  "3165": "土默特左旗",
  "2770": "兴平市",
  "3087": "克拉玛依区",
  "442": "延庆县",
  "1577": "单县",
  "2156": "潮阳区",
  "1572": "莲花县",
  "2851": "港口区",
  "689": "昌黎县",
  "3129": "英吉沙县",
  "886": "辽阳县",
  "3462": "芎林乡",
  "1116": "丹阳市",
  "1329": "怀宁县",
  "2835": "渭滨区",
  "2869": "宁明县",
  "3728": "经济开发区",
  "1725": "二七区",
  "3568": "三地门乡",
  "727": "广灵县",
  "2379": "长宁县",
  "3243": "科尔沁右翼中旗",
  "939": "二道江区",
  "3777": "秀洲区",
  "320": "怒江傈僳族自治州",
  "3528": "二水乡",
  "2619": "蒙自县",
  "811": "东陵区",
  "3756": "白云矿区",
  "1670": "沂南县",
  "2010": "衡山县",
  "465": "静安区",
  "249": "嘉峪关市",
  "2834": "佛坪县",
  "3342": "新营区",
  "1612": "高青县",
  "819": "清河区",
  "1189": "兴化市",
  "1177": "东海县",
  "1127": "吴中区",
  "1537": "吉安县",
  "894": "凌源市",
  "3680": "大亚湾",
  "1748": "牧野区",
  "858": "宽甸满族自治县",
  "3425": "新店区",
  "1298": "三山区",
  "2127": "龙门县",
  "140": "宁德市",
  "2222": "永昌县",
  "1900": "大悟县",
  "3768": "阿拉尔市",
  "954": "宁江区",
  "385": "呼伦贝尔市",
  "3460": "新埔镇",
  "1359": "界首市",
  "1479": "渝水区",
  "801": "平陆县",
  "2578": "盈江县",
  "985": "铁锋区",
  "971": "呼兰区",
  "754": "沁县",
  "3151": "鄂伦春自治旗",
  "847": "新宾满族自治县",
  "479": "崇明县",
  "1166": "楚州区",
  "3061": "哈密市",
  "3091": "沙依巴克区",
  "1563": "石城县",
  "2166": "香洲区",
  "1378": "涡阳县",
  "1003": "城子河区",
  "1054": "安达市",
  "1800": "金明区",
  "2821": "镇坪县",
  "619": "丰南区",
  "2101": "萝岗区",
  "1717": "民权县",
  "2557": "六枝特区",
  "698": "忻府区",
  "1634": "招远市",
  "621": "滦县",
  "3797": "新竹",
  "3616": "花莲市",
  "524": "邯郸县",
  "1848": "淮阳县",
  "2176": "广宁县",
  "2714": "乐都县",
  "2310": "郫县",
  "3418": "汐止区",
  "2495": "正安县",
  "598": "怀安县",
  "3395": "仁爱乡",
  "3052": "中宁县",
  "2486": "开阳县",
  "780": "文水县",
  "2322": "盐边县",
  "2438": "丹巴县",
  "3547": "斗南镇",
  "3334": "官田区",
  "3277": "南港区",
  "2317": "崇州市",
  "3490": "苑里镇",
  "3246": "阿拉善左旗",
  "1433": "石狮市",
  "240": "河源市",
  "1666": "肥城市",
  "2209": "罗定市",
  "230": "江门市",
  "115": "宁波市",
  "377": "五家渠市",
  "2374": "古蔺县",
  "922": "舒兰市",
  "602": "赤城县",
  "2050": "新邵县",
  "1311": "谢家集区",
  "2319": "西区",
  "3740": "巴城镇",
  "2628": "绿春县",
  "2741": "乌兰县",
  "1072": "美溪区",
  "2470": "广汉市",
  "1787": "西峡县",
  "1394": "仓山区",
  "612": "丰宁满族自治县",
  "2772": "延长县",
  "936": "公主岭市",
  "1391": "宁国市",
  "3456": "钓鱼台",
  "1277": "东阳市",
  "2251": "静宁县",
  "3579": "万丹乡",
  "1086": "红岗区",
  "701": "代县",
  "2794": "清涧县",
  "3710": "东成镇",
  "214": "衡阳市",
  "3630": "西屿乡",
  "564": "南市区",
  "3070": "于田县",
  "2562": "普安县",
  "2708": "城北区",
  "3094": "头屯河区",
  "1650": "任城区",
  "2789": "定边县",
  "2074": "溆浦县",
  "2539": "江口县",
  "731": "大同县",
  "2850": "宜君县",
  "1967": "掇刀区",
  "2547": "万山特区",
  "3639": "中市区",
  "2779": "富县",
  "657": "武邑县",
  "1865": "遂平县",
  "2139": "仁化县",
  "1783": "宛城区",
  "768": "安泽县",
  "1928": "荆州区",
  "1092": "江宁区",
  "503": "荣昌县",
  "1756": "辉县市",
  "2255": "肃北蒙古族自治县",
  "1636": "海阳市",
  "2491": "汇川区",
  "1483": "青云谱区",
  "3800": "桃园县",
  "338": "汉中市",
  "761": "高平市",
  "576": "安新县",
  "3105": "吐鲁番市",
  "1996": "石峰区",
  "738": "和顺县",
  "1775": "罗山县",
  "1415": "寿宁县",
  "484": "江北区",
  "3408": "暖暖区",
  "1243": "奉化市",
  "1036": "兴山区",
  "1078": "乌伊岭区",
  "2334": "梓潼县",
  "2530": "剑河县",
  "3492": "造桥乡",
  "1265": "松阳县",
  "2065": "龙山县",
  "623": "乐亭县",
  "544": "裕华区",
  "1512": "婺源县",
  "3253": "九龙城区",
  "2956": "海城区",
  "1196": "泗阳县",
  "1114": "润州区",
  "2389": "市中区",
  "3657": "沙田镇",
  "2946": "南丹县",
  "2382": "筠连县",
  "2564": "贞丰县",
  "328": "果洛藏族自治州",
  "239": "中山市",
  "122": "芜湖市",
  "2635": "富源县",
  "878": "细河区",
  "628": "迁安市",
  "1223": "德清县",
  "269": "宜宾市",
  "363": "石嘴山市",
  "2277": "宕昌县",
  "2353": "万源市",
  "3538": "朴子市",
  "3198": "奈曼旗",
  "3215": "准格尔旗",
  "733": "平定县",
  "3745": "张浦镇",
  "2159": "南澳县",
  "997": "拜泉县",
  "630": "广阳区",
  "3059": "裕民县",
  "3394": "埔里镇",
  "1449": "永定县",
  "608": "兴隆县",
  "3263": "屯门区",
  "2873": "凭祥市",
  "1234": "江东区",
  "1649": "市中区",
  "2226": "会宁县",
  "2878": "金秀瑶族自治县",
  "3591": "新园乡",
  "1314": "凤台县",
  "2748": "未央区",
  "1798": "鼓楼区",
  "1474": "建瓯市",
  "2535": "雷山县",
  "522": "复兴区",
  "125": "马鞍山市",
  "1632": "莱州市",
  "44": "唐山市",
  "1423": "秀屿区",
  "3352": "山上区",
  "1687": "河口区",
  "2152": "兴宁市",
  "2412": "木里藏族自治县",
  "667": "桥西区",
  "1188": "高港区",
  "3142": "霍城县",
  "2008": "衡阳县",
  "2862": "隆安县",
  "714": "杏花岭区",
  "1280": "黄岩区",
  "1564": "瑞金市",
  "313": "曲靖市",
  "2017": "桂阳县",
  "2663": "牟定县",
  "3023": "班戈县",
  "2884": "柳江县",
  "2661": "楚雄市",
  "1324": "狮子山区",
  "397": "澳门特别行政区",
  "1096": "秦淮区",
  "3077": "青河县",
  "3305": "林园区",
  "3285": "前镇区",
  "3433": "莺歌区",
  "2934": "靖西县",
  "1657": "梁山县",
  "3009": "丁青县",
  "2185": "麻章区",
  "1191": "泰兴市",
  "2717": "循化撒拉族自治县",
  "459": "静海县",
  "3477": "龟山乡",
  "823": "调兵山市",
  "3715": "其他",
  "1495": "永修县",
  "771": "乡宁县",
  "1753": "封丘县",
  "401": "台中市",
  "3187": "凉城县",
  "186": "焦作市",
  "2688": "沧源佤族自治县",
  "1797": "顺河回族区",
  "1119": "沧浪区",
  "1914": "武穴市",
  "3039": "大武口区",
  "1705": "莱城区",
  "1919": "阳新县",
  "1938": "猇亭区",
  "2756": "高陵县",
  "3000": "米林县",
  "915": "昌邑区",
  "3107": "托克逊县",
  "2978": "康马县",
  "1586": "槐荫区",
  "1986": "望城县",
  "3441": "淡水区",
  "1456": "明溪县",
  "404": "基隆市",
  "2606": "漾濞彝族自治县",
  "516": "石柱土家族自治县",
  "1813": "新安县",
  "2004": "雁峰区",
  "2060": "凤凰县",
  "3561": "二仑乡",
  "1551": "大余县",
  "702": "繁峙县",
  "2297": "碌曲县",
  "2163": "宝安区",
  "2214": "七里河区",
  "2904": "平乐县",
  "3643": "清濛开发区",
  "2346": "阆中市",
  "561": "鹿泉市",
  "2195": "和平县",
  "2112": "榕城区",
  "2221": "金川区",
  "2555": "赫章县",
  "3718": "邙山区",
  "357": "山南地区",
  "2982": "吉隆县",
  "1307": "五河县",
  "3236": "镶黄旗",
  "1812": "孟津县",
  "1941": "兴山县",
  "1769": "鲁山县",
  "2826": "城固县",
  "455": "北辰区",
  "2475": "朝天区",
  "1875": "硚口区",
  "1673": "苍山县",
  "2132": "开平市",
  "963": "长白朝鲜族自治县",
  "297": "澄迈县",
  "3181": "乌达区",
  "2612": "永平县",
  "3751": "红谷滩新区",
  "2031": "临澧县",
  "1889": "南漳县",
  "2272": "漳县",
  "2692": "兰坪白族普米族自治县",
  "2646": "西畴县",
  "980": "双城市",
  "10": "江苏省",
  "1596": "四方区",
  "550": "高邑县",
  "2083": "冷水滩区",
  "2097": "天河区",
  "2697": "玉龙纳西族自治县",
  "1081": "嘉荫县",
  "1651": "微山县",
  "958": "扶余县",
  "1569": "乐平市",
  "1736": "文峰区",
  "592": "张北县",
  "3299": "梓官区",
  "2542": "思南县",
  "1978": "汨罗市",
  "2123": "惠城区",
  "2364": "巴州区",
  "1640": "奎文区",
  "173": "莱芜市",
  "530": "肥乡县",
  "66": "本溪市",
  "3701": "大成镇",
  "3805": "屏东县",
  "2709": "大通回族土族自治县",
  "3067": "皮山县",
  "2675": "景谷傣族彝族自治县",
  "470": "闵行区",
  "2026": "武陵区",
  "1524": "广昌县",
  "3130": "泽普县",
  "793": "临猗县",
  "2360": "岳池县",
  "1287": "临海市",
  "1205": "开化县",
  "1696": "薛城区",
  "654": "河间市",
  "3168": "清水河县",
  "2403": "马边彝族自治县",
  "3674": "东坑镇",
  "2261": "环县",
  "3469": "峨眉乡",
  "156": "景德镇市",
  "283": "黔南布依族苗族自治州",
  "3625": "万荣乡",
  "3414": "西区",
  "59": "吕梁市",
  "3388": "烈屿乡",
  "3329": "楠西区",
  "2091": "新田县",
  "1971": "岳阳楼区",
  "2358": "大英县",
  "1226": " 南湖区",
  "1256": "苍南县",
  "1949": "利川市",
  "2498": "凤冈县",
  "1744": "林州市",
  "2247": "灵台县",
  "1853": "郾城区",
  "864": "黑山县",
  "2913": "岑溪市",
  "1016": "宁安市",
  "219": "邵阳市",
  "2300": "青羊区",
  "2480": "南明区",
  "799": "垣曲县",
  "3734": "净月潭开发区",
  "1170": "洪泽县",
  "925": "图们市",
  "3382": "外埔区",
  "1896": "华容区",
  "390": "通辽市",
  "2895": "阳朔县",
  "3357": "南区",
  "1042": "宝山区",
  "1515": "南城县",
  "1686": "东营区",
  "2368": "江阳区",
  "38": "重庆市",
  "1955": "鹤峰县",
  "196": "孝感市",
  "945": "洮北区",
  "1169": "涟水县",
  "2784": "榆阳区",
  "118": "丽水市",
  "206": "荆门市",
  "959": "八道江区",
  "1674": "费县",
  "3791": "澳门",
  "3194": "科尔沁左翼中旗",
  "358": "林芝市",
  "331": "西安市",
  "1065": "漠河县",
  "1659": "兖州市",
  "3606": "关山镇",
  "2746": "莲湖区",
  "737": "左权县",
  "767": "古县",
  "3037": "贺兰县",
  "2228": "秦州区",
  "2070": "鹤城区",
  "84": "哈尔滨市",
  "805": "和平区",
  "1020": "茄子河区",
  "2173": "高明区",
  "437": "昌平区",
  "194": "襄阳市",
  "3503": "花坛乡",
  "1768": "叶县",
  "2749": "雁塔区",
  "220": "湘西土家族苗族自治州",
  "1312": "八公山区",
  "2395": "沙湾区",
  "1021": "勃利县",
  "2365": "通江县",
  "1263": "缙云县",
  "934": "梨树县",
  "1989": "雨湖区",
  "3537": "太保市",
  "948": "洮南市",
  "2160": "罗湖区",
  "572": "高阳县",
  "3785": "义亭镇",
  "3762": "高新西区",
  "2450": "巴塘县",
  "1398": "连江县",
  "226": "阳江市",
  "527": "大名县",
  "1430": "安溪县",
  "1145": "亭湖区",
  "1870": "卢氏县",
  "3795": "台中",
  "1448": "长汀县",
  "2549": "大方县",
  "62": "铁岭市",
  "3229": "锡林浩特市",
  "2466": "红原县",
  "833": "瓦房店市",
  "3146": "特克斯县",
  "3684": "石岐街道",
  "1573": "上栗县",
  "1472": "邵武市",
  "2743": "天峻县",
  "3276": "内湖区",
  "3649": "南城区",
  "548": "行唐县",
  "2020": "嘉禾县",
  "3770": "克拉玛依市",
  "3524": "竹塘乡",
  "3450": "三星乡",
  "2575": "瑞丽市",
  "3697": "洋浦开发区",
  "1110": "滨湖区",
  "3466": "横山乡",
  "1999": "攸县",
  "2204": "连州市",
  "2622": "石屏县",
  "3725": "动力区",
  "2799": "大荔县",
  "1772": "汝州市",
  "418": "澎湖县",
  "3632": "七美乡",
  "2324": "贡井区",
  "933": "铁东区",
  "783": "临县",
  "1357": "阜南县",
  "2217": "红古区",
  "348": "贺州市",
  "2333": "安县",
  "1152": "东台市",
  "789": "交口县",
  "49": "秦皇岛市",
  "2046": "双清区",
  "2052": "隆回县",
  "993": "甘南县",
  "627": "遵化市",
  "2967": "墨竹工卡县",
  "2868": "扶绥县",
  "1090": "林甸县",
  "1308": "固镇县",
  "2117": "茂南区",
  "715": "尖草坪区",
  "1934": "松滋市",
  "3615": "太麻里乡",
  "1916": "西塞山区",
  "2201": "连南瑶族自治县",
  "2503": "仁怀市",
  "1722": "夏邑县",
  "23": "陕西省",
  "388": "乌海市",
  "364": "吴忠市",
  "3069": "策勒县",
  "1425": "鲤城区",
  "950": "龙山区",
  "2680": "西盟佤族自治县",
  "2957": "银海区",
  "1845": "商水县",
  "1678": "临沭县",
  "1445": "华安县",
  "1025": "桦南县",
  "3429": "中和区",
  "3580": "潮州镇",
  "3083": "博乐市",
  "3073": "布尔津县",
  "1992": "湘乡市",
  "1842": "川汇区",
  "2478": "剑阁县",
  "1466": "延平区",
  "485": "沙坪坝区",
  "2340": "嘉陵区",
  "778": "霍州市",
  "2143": "乐昌市",
  "3555": "麦寮乡",
  "3316": "茂林区",
  "720": "娄烦县",
  "1270": "婺城区",
  "460": "蓟县",
  "2449": "理塘县",
  "1645": "寿光市",
  "3508": "和美镇",
  "324": "西宁市",
  "1389": "绩溪县",
  "244": "东莞市",
  "637": "霸州市",
  "2066": "永定区",
  "3744": "淀山湖镇",
  "3220": "伊金霍洛旗",
  "2811": "山阳县",
  "752": "长子县",
  "2679": "澜沧拉祜族自治县",
  "1232": " 桐乡市 ",
  "2899": "兴安县",
  "3045": "青铜峡市",
  "2941": "钦南区",
  "379": "巴音郭楞蒙古自治州",
  "1607": "张店区",
  "1386": "郎溪县",
  "3404": "信义区",
  "1639": "坊子区",
  "1536": "青原区",
  "1035": "东山区",
  "3367": "丰原区",
  "2617": "个旧市",
  "452": "东丽区",
  "579": "蠡县",
  "295": "万宁市",
  "1894": "宜城市",
  "535": "馆陶县",
  "1618": "临邑县",
  "77": "延边朝鲜族自治州",
  "3301": "永安区",
  "3138": "伊宁市",
  "3136": "巴楚县",
  "683": "南宫市",
  "541": "桥西区",
  "2260": "庆城县",
  "1215": "桐庐县",
  "2995": "隆子县",
  "1712": "冠县",
  "2344": "仪陇县",
  "765": "襄汾县",
  "2552": "织金县",
  "897": "大洼县",
  "312": "红河哈尼族彝族自治州",
  "1628": "莱山区",
  "2521": "三都水族自治县",
  "3219": "乌审旗",
  "3671": "常平镇",
  "1002": "梨树区",
  "237": "肇庆市",
  "2435": "宝兴县",
  "2584": "大关县",
  "370": "阿勒泰地区",
  "2722": "共和县",
  "2371": "泸县",
  "2519": "龙里县",
  "3398": "水里乡",
  "2923": "玉州区",
  "567": "涞水县",
  "2610": "南涧彝族自治县",
  "416": "台东县",
  "3749": "宿豫县",
  "2950": "罗城仫佬族自治县",
  "3212": "敖汉旗",
  "3115": "和硕县",
  "914": "德惠市",
  "380": "阿克苏地区",
  "100": "苏州市",
  "965": "道里区",
  "3206": "巴林右旗",
  "300": "临高县",
  "1279": "椒江区",
  "1439": "漳浦县",
  "2974": "昂仁县",
  "2079": "靖州苗族侗族自治县",
  "286": "毕节地区",
  "1395": "马尾区",
  "3654": "麻涌镇",
  "2405": "东坡区",
  "1075": "乌马河区",
  "800": "夏县",
  "2426": "美姑县",
  "2232": "甘谷县",
  "3642": "颖上县",
  "3125": "柯坪县",
  "1365": "居巢区",
  "1407": "湖里区",
  "2432": "石棉县",
  "496": "合川区",
  "3613": "大武乡",
  "2829": "勉县",
  "605": "双滦区",
  "2987": "扎囊县",
  "1779": "固始县",
  "1568": "浮梁县",
  "2581": "鲁甸县",
  "607": "承德县",
  "1807": "西工区",
  "2902": "龙胜各族自治县",
  "1699": "山亭区",
  "42": "张家口市",
  "759": "陵川县",
  "3093": "水磨沟区",
  "1228": " 嘉善县",
  "2508": "关岭布依族苗族自治县",
  "1073": "金山屯区",
  "235": "珠海市",
  "2291": "合作市",
  "1931": "江陵县",
  "2187": "徐闻县",
  "2591": "五华区",
  "694": "山阴县",
  "3399": "鱼池乡",
  "2844": "麟游县",
  "3575": "长治乡",
  "816": "法库县",
  "1103": "溧水县",
  "3031": "改则县",
  "3788": "赤岸镇",
  "3148": "海拉尔区",
  "2244": "山丹县",
  "3159": "额尔古纳市",
  "296": "东方市",
  "1062": "五大连池市",
  "265": "遂宁市",
  "3112": "且末县",
  "3169": "武川县",
  "171": "枣庄市",
  "1700": "滕州市",
  "2609": "弥渡县",
  "445": "河西区",
  "3261": "西贡区",
  "2131": "台山市",
  "1339": "徽州区",
  "2687": "耿马傣族佤族自治县",
  "2012": "祁东县",
  "2338": "顺庆区",
  "582": "雄县",
  "3781": "桐乡市",
  "3201": "红山区",
  "3257": "观塘区",
  "1884": "黄陂区",
  "2120": "高州市",
  "1858": "西平县",
  "557": "辛集市",
  "718": "清徐县",
  "1581": "鄄城县",
  "2147": "大埔县",
  "3621": "凤林镇",
  "1604": "胶南市",
  "1507": "横峰县",
  "2726": "贵南县",
  "441": "密云县",
  "868": "站前区",
  "3325": "归仁区",
  "672": "隆尧县",
  "1140": "邗江区",
  "3417": "板桥区",
  "983": "龙沙区",
  "275": "雅安市",
  "2035": "资阳区",
  "3806": "台东县",
  "3689": "五桂山街道",
  "197": "黄冈市",
  "3626": "玉里镇",
  "3314": "桃源区",
  "2208": "云安县",
  "1731": "巩义市",
  "3496": "泰安乡",
  "853": "本溪满族自治县",
  "751": "壶关县",
  "1500": "彭泽县",
  "1746": "卫滨区",
  "3356": "东区",
  "2167": "斗门区",
  "1980": "芙蓉区",
  "2136": "浈江区",
  "2275": "成县",
  "2685": "镇康县",
  "3517": "大村乡",
  "3410": "东区",
  "3028": "噶尔县",
  "1295": "镜湖区",
  "2832": "镇巴县",
  "677": "新河县",
  "1111": "江阴市",
  "3281": "芩雅区",
  "907": "朝阳区",
  "3249": "中西区",
  "3271": "大安区",
  "1868": "渑池县",
  "2238": "天祝藏族自治县",
  "3480": "复兴乡",
  "590": "下花园区",
  "3154": "新巴尔虎左旗",
  "1210": "江干区",
  "664": "冀州市",
  "1878": "青山区",
  "1790": "淅川县",
  "2388": "简阳市",
  "2938": "田林县",
  "2264": "正宁县",
  "2964": "曲水县",
  "1690": "广饶县",
  "79": "通化市",
  "617": "古冶区",
  "1420": "城厢区",
  "3295": "阿莲区",
  "3801": "苗栗县",
  "352": "钦州市",
  "3437": "林口区",
  "2502": "赤水市",
  "2918": "港北区",
  "126": "淮北市",
  "1594": "市南区",
  "1034": "兴安区",
  "251": "张掖市",
  "2803": "白水县",
  "369": "和田地区",
  "2875": "忻城县",
  "1533": "樟树市",
  "3679": "高埗镇",
  "1548": "章贡区",
  "651": "泊头市",
  "176": "郑州市",
  "3145": "昭苏县",
  "947": "通榆县",
  "1823": "马村区",
  "256": "陇南市",
  "2267": "安定区",
  "2537": "丹寨县",
  "2810": "商南县",
  "920": "蛟河市",
  "428": "宣武区",
  "2305": "青白江区",
  "887": "灯塔市",
  "3758": "陶乐县",
  "3545": "义竹乡",
  "72": "朝阳市",
  "500": "潼南县",
  "3371": "和平区",
  "1496": "德安县",
  "1221": "吴兴区",
  "1757": "魏都区",
  "1200": "岱山县",
  "918": "丰满区",
  "1682": "无棣县",
  "2781": "宜川县",
  "1413": "古田县",
  "1275": "兰溪市",
  "1108": "锡山区",
  "2107": "陆丰市",
  "1598": "崂山区",
  "2211": "潮安县",
  "3453": "冬山乡",
  "1014": "绥芬河市",
  "2282": "两当县",
  "843": "东洲区",
  "1856": "临颍县",
  "2760": "三原县",
  "1491": "浔阳区",
  "2529": "锦屏县",
  "1362": "萧县",
  "1804": "开封县",
  "2315": "彭州市",
  "632": "永清县",
  "394": "锡林郭勒盟",
  "1371": "裕安区",
  "2357": "射洪县",
  "2257": "玉门市",
  "2484": "白云区",
  "610": "滦平县",
  "514": "巫山县",
  "2444": "新龙县",
  "2659": "新平彝族傣族自治县",
  "725": "阳高县",
  "513": "奉节县",
  "50": "朔州市",
  "2645": "砚山县",
  "1519": "乐安县",
  "1994": "荷塘区",
  "3252": "新界",
  "2633": "师宗县",
  "3173": "石拐区",
  "797": "新绛县",
  "2197": "清城区",
  "2459": "金川县",
  "3543": "大林镇",
  "1136": "通州市",
  "1175": "海州区",
  "1236": "北仑区",
  "1683": "沾化县",
  "645": "盐山县",
  "1326": "迎江区",
  "2413": "盐源县",
  "2566": "册亨县",
  "3714": "三都镇",
  "1382": "东至县",
  "1452": "连城县",
  "1176": "赣榆县",
  "2881": "鱼峰区",
  "1815": "嵩县",
  "1039": "尖山区",
  "2384": "屏山县",
  "2637": "沾益县",
  "3662": "大岭山镇",
  "1005": "鸡东县",
  "28": "四川省",
  "2089": "宁远县",
  "589": "宣化区",
  "1337": "屯溪区",
  "2087": "道县",
  "3474": "新屋乡",
  "215": "郴州市",
  "687": "北戴河区",
  "3320": "南区",
  "3101": "玛纳斯县",
  "2098": "白云区",
  "150": "九江市",
  "2184": "坡头区",
  "3161": "新城区",
  "3018": "比如县",
  "2298": "夏河县",
  "2336": "平武县",
  "245": "兰州市",
  "2511": "福泉市",
  "2604": "安宁市",
  "2190": "吴川市",
  "826": "旅顺口区",
  "2546": "松桃苗族自治县",
  "1344": "琅琊区",
  "2494": "绥阳县",
  "3012": "左贡县",
  "2666": "大姚县",
  "332": "咸阳市",
  "3338": "七股区",
  "2329": "涪城区",
  "3599": "满州乡",
  "1099": "下关区",
  "1965": "广水市",
  "745": "介休市",
  "34": "香港特别行政区",
  "2980": "仲巴县",
  "3691": "蝶山区",
  "2653": "江川县",
  "3650": "万江区",
  "2548": "毕节市",
  "2656": "华宁县",
  "2082": "零陵区",
  "620": "丰润区",
  "3056": "额敏县",
  "1410": "翔安区",
  "2613": "云龙县",
  "3789": "衢州市",
  "2693": "香格里拉县",
  "1434": "晋江市",
  "2625": "元阳县",
  "2713": "民和回族土族自治县",
  "3400": "信义乡",
  "3457": "竹北市",
  "1547": "井冈山市",
  "2471": "什邡市",
  "937": "双辽市",
  "1045": "宝清县",
  "1619": "齐河县",
  "730": "左云县",
  "3266": "离岛区",
  "16": "河南省",
  "921": "桦甸市",
  "2880": "城中区",
  "1069": "西林区",
  "2311": "大邑县",
  "3631": "望安乡",
  "1224": "长兴县",
  "368": "哈密地区",
  "3078": "吉木乃县",
  "2556": "钟山区",
  "994": "富裕县",
  "611": "隆化县",
  "1786": "方城县",
  "1849": "太康县",
  "849": "平山区",
  "2320": "仁和区",
  "492": "巴南区",
  "2740": "德令哈市",
  "208": "天门市",
  "2140": "翁源县",
  "2440": "雅江县",
  "2788": "靖边县",
  "1523": "东乡县",
  "2271": "临洮县",
  "3225": "乌拉特中旗",
  "3578": "内埔乡",
  "93": "黑河市",
  "3055": "乌苏市",
  "292": "琼海市",
  "2773": "延川县",
  "2445": "德格县",
  "291": "五指山市",
  "374": "乌鲁木齐市",
  "3703": "峨蔓镇",
  "3071": "民丰县",
  "3040": "惠农区",
  "2429": "名山县",
  "3272": "万华区",
  "114": "嘉兴市",
  "2790": "绥德县",
  "429": "朝阳区",
  "1306": "怀远县",
  "1939": "夷陵区",
  "3688": "中山港街道",
  "3767": "西 区",
  "3097": "乌鲁木齐县",
  "1328": "宜秀区",
  "73": "盘锦市",
  "409": "新竹县",
  "1091": "杜尔伯特蒙古族自治县",
  "67": "丹东市",
  "3335": "麻豆区",
  "3636": "北竿乡",
  "812": "沈北新区",
  "1958": "郧县",
  "1962": "房县",
  "241": "清远市",
  "489": "万盛区",
  "3133": "麦盖提县",
  "2561": "兴仁县",
  "585": "安国市",
  "3711": "光村镇",
  "327": "海南藏族自治州",
  "1392": "鼓楼区",
  "1970": "钟祥市",
  "2391": "威远县",
  "1080": "上甘岭区",
  "1281": "路桥区",
  "732": "矿区",
  "2819": "岚皋县",
  "1864": "汝南县",
  "3214": "达拉特旗",
  "3675": "企石镇",
  "3491": "苗栗市",
  "1603": "平度市",
  "2233": "武山县",
  "622": "滦南县",
  "1881": "汉南区",
  "970": "香坊区",
  "2381": "珙县",
  "1416": "周宁县",
  "2375": "翠屏区",
  "24": "新疆维吾尔自治区",
  "2771": "宝塔区",
  "2256": "阿克塞哈萨克族自治县",
  "2759": "渭城区",
  "3321": "北区",
  "1658": "曲阜市",
  "2049": "邵东县",
  "3197": "库伦旗",
  "104": "徐州市",
  "1558": "宁都县",
  "2057": "武冈市",
  "3370": "东势区",
  "3493": "头屋乡",
  "1635": "栖霞市",
  "1237": "镇海区",
  "2361": "武胜县",
  "1513": "德兴市",
  "2175": "鼎湖区",
  "1264": "遂昌县",
  "747": "襄垣县",
  "159": "济南市",
  "2490": "红花岗区",
  "2563": "晴隆县",
  "3086": "独山子区",
  "1633": "蓬莱市",
  "47": "衡水市",
  "1427": "洛江区",
  "1942": "秭归县",
  "1484": "湾里区",
  "3619": "秀林乡",
  "1017": "穆棱市",
  "270": "资阳市",
  "1057": "爱辉区",
  "2042": "双峰县",
  "538": "武安市",
  "3748": "锦溪镇",
  "2840": "扶风县",
  "1602": "即墨市",
  "521": "丛台区",
  "2007": "南岳区",
  "1332": "太湖县",
  "162": "德州市",
  "1923": "通城县",
  "880": "彰武县",
  "433": "门头沟区",
  "3461": "关西镇",
  "1912": "黄梅县",
  "1399": "罗源县",
  "2164": "龙岗区",
  "986": "昂昂溪区",
  "786": "岚县",
  "3293": "冈山区",
  "740": "寿阳县",
  "1117": "扬中市",
  "1008": "东安区",
  "3022": "索县",
  "103": "盐城市",
  "3434": "三重区",
  "201": "宜昌市",
  "871": "老边区",
  "1401": "永泰县",
  "719": "阳曲县",
  "3393": "国姓乡",
  "1529": "宜丰县",
  "902": "绥中县",
  "827": "中山区",
  "2039": "安化县",
  "266": "广安市",
  "1742": "滑县",
  "1353": "颍东区",
  "3128": "疏勒县",
  "2585": "永善县",
  "1624": "禹城市",
  "2892": "象山区",
  "3363": "太平区",
  "1695": "市中区",
  "1219": "临安市",
  "3774": "布克赛尔",
  "2534": "从江县",
  "97": "南京市",
  "2983": "聂拉木县",
  "2378": "江安县",
  "3645": "嘉峪关市",
  "1704": "莒县",
  "668": "邢台县",
  "750": "黎城县",
  "688": "青龙满族自治县",
  "1749": "新乡县",
  "774": "永和县",
  "1126": "吴江市",
  "910": "双阳区",
  "3463": "宝山乡",
  "2128": "蓬江区",
  "693": "平鲁区",
  "1341": "休宁县",
  "2701": "门源回族自治县",
  "2684": "永德县",
  "3424": "贡寮区",
  "1534": "高安市",
  "2570": "琼山区",
  "893": "北票市",
  "1915": "黄石港区",
  "2309": "双流县",
  "3729": "仙桃市",
  "2737": "囊谦县",
  "83": "白山市",
  "804": "河津市",
  "3375": "神冈区",
  "1385": "宣州区",
  "2558": "水城县",
  "2672": "宁洱哈尼族彝族自治县",
  "1818": "洛宁县",
  "962": "靖宇县",
  "2094": "荔湾区",
  "755": "沁源县",
  "1085": "让胡路区",
  "1837": "清丰县",
  "1714": "临清市",
  "3778": "海宁市",
  "143": "漳州市",
  "3090": "天山区",
  "1403": "福清市",
  "2323": "自流井区",
  "3049": "泾源县",
  "2822": "旬阳县",
  "1051": "庆安县",
  "2268": "通渭县",
  "3033": "兴庆区",
  "1497": "星子县",
  "518": "酉阳土家族苗族自治县",
  "497": "永川区",
  "2914": "八步区",
  "2906": "恭城瑶族自治县",
  "1211": "拱墅区",
  "3221": "临河区",
  "2852": "防城区",
  "2732": "玛多县",
  "411": "苗栗县",
  "169": "东营市",
  "2155": "濠江区",
  "2991": "曲松县",
  "1711": "东阿县",
  "1542": "泰和县",
  "2399": "井研县",
  "2102": "南沙区",
  "2836": "金台区",
  "478": "奉贤区",
  "3720": "郑东新区",
  "2579": "陇川县",
  "398": "台北市",
  "384": "伊犁哈萨克自治州",
  "3242": "科尔沁右翼前旗",
  "836": "铁西区",
  "2016": "苏仙区",
  "3182": "集宁区",
  "3068": "洛浦县",
  "955": "前郭尔罗斯蒙古族自治县",
  "942": "柳河县",
  "1735": "登封市",
  "1376": "霍山县",
  "1888": "襄阳区",
  "3512": "员林镇",
  "3267": "中正区",
  "2030": "澧县",
  "2286": "永靖县",
  "2369": "纳溪区",
  "2647": "麻栗坡县",
  "1595": "市北区",
  "190": "漯河市",
  "2816": "石泉县",
  "1808": "瀍河回族区",
  "1750": "获嘉县",
  "822": "昌图县",
  "601": "涿鹿县",
  "1739": "龙安区",
  "2802": "蒲城县",
  "231": "韶关市",
  "1610": "周村区",
  "779": "离石区",
  "551": "深泽县",
  "504": "璧山县",
  "343": "崇左市",
  "981": "尚志市",
  "697": "怀仁县",
  "3753": "波阳县",
  "2823": "白河县",
  "3001": "墨脱县",
  "3177": "固阳县",
  "3387": "金城镇",
  "857": "振安区",
  "707": "岢岚县",
  "1010": "爱民区",
  "1966": "东宝区",
  "1665": "新泰市",
  "3310": "六龟区",
  "261": "自贡市",
  "1782": "息县",
  "2439": "九龙县",
  "2698": "永胜县",
  "2252": "肃州区",
  "3739": "玉山镇",
  "2506": "普定县",
  "3403": "仁爱区",
  "321": "迪庆藏族自治州",
  "792": "盐湖区",
  "3209": "翁牛特旗",
  "3122": "拜城县",
  "2896": "临桂县",
  "1079": "红星区",
  "1248": "上虞市",
  "2422": "喜德县",
  "3407": "安乐区",
  "3368": "后里区",
  "1590": "平阴县",
  "1652": "鱼台县",
  "2401": "沐川县",
  "3733": "开发区",
  "1516": "黎川县",
  "924": "延吉市",
  "2053": "洞口县",
  "2462": "马尔康县",
  "2933": "德保县",
  "2301": "金牛区",
  "760": "泽州县",
  "863": "太和区",
  "531": "永年县",
  "2027": "鼎城区",
  "2481": "云岩区",
  "2469": "罗江县",
  "3317": "茄萣区",
  "1745": "红旗区",
  "172": "日照市",
  "2594": "西山区",
  "2111": "阳春市",
  "1366": "庐江县",
  "3702": "中和镇",
  "223": "永州市",
  "721": "古交市",
  "1897": "鄂城区",
  "2124": "惠阳区",
  "3482": "芦竹乡",
  "1043": "集贤县",
  "1255": "平阳县",
  "669": "临城县",
  "2660": "元江哈尼族彝族傣族自治县",
  "282": "安顺市",
  "420": "香港岛",
  "3622": "光复乡",
  "1852": "源汇区",
  "3548": "大埤乡",
  "639": "新华区",
  "3449": "罗东镇",
  "989": "梅里斯达翰尔族区",
  "1505": "玉山县",
  "1348": "定远县",
  "2372": "合江县",
  "2945": "金城江区",
  "2248": "崇信县",
  "577": "易县",
  "1137": "海门市",
  "3511": "头屋乡",
  "2809": "丹凤县",
  "1227": " 秀洲区",
  "3504": "秀水乡",
  "1417": "柘荣县",
  "216": "常德市",
  "852": "南芬区",
  "3381": "大甲区",
  "643": "东光县",
  "3351": "大内区",
  "3478": "八德市",
  "3600": "台东市",
  "1951": "巴东县",
  "2766": "长武县",
  "3661": "寮步镇",
  "1120": "常熟市",
  "2928": "北流市",
  "1475": "建阳市",
  "1794": "桐柏县",
  "1187": "海陵区",
  "2193": "龙川县",
  "3522": "埤头乡",
  "2636": "会泽县",
  "676": "巨鹿县",
  "2968": "日喀则市",
  "2092": "江华瑶族自治县",
  "1251": "龙湾区",
  "277": "阿坝藏族羌族自治州",
  "2456": "茂县",
  "3191": "四子王旗",
  "1192": "姜堰市",
  "879": "阜新蒙古族自治县",
  "3306": "鸟松区",
  "3017": "嘉黎县",
  "2640": "施甸县",
  "1095": "白下区",
  "2700": "宁蒗彝族自治县",
  "3104": "木垒哈萨克自治县",
  "1183": "新北区",
  "2975": "谢通门县",
  "1444": "平和县",
  "2747": "灞桥区",
  "1883": "江夏区",
  "1846": "沈丘县",
  "2215": "西固区",
  "2671": "思茅区",
  "133": "巢湖市",
  "123": "蚌埠市",
  "304": "陵水黎族自治县",
  "2515": "独山县",
  "2600": "石林彝族自治县",
  "2417": "宁南县",
  "1631": "莱阳市",
  "1828": "温县",
  "2294": "舟曲县",
  "2605": "大理市",
  "56": "长治市",
  "1369": "和县 ",
  "3006": "江达县",
  "54": "阳泉市",
  "1151": "建湖县",
  "3347": "下营区",
  "306": "琼中黎族苗族自治县",
  "1204": "常山县",
  "70": "阜新市",
  "839": "台安县",
  "2520": "惠水县",
  "166": "泰安市",
  "88": "七台河市",
  "1578": "成武县",
  "2225": "靖远县",
  "1009": "阳明区",
  "30": "云南省",
  "403": "南投县",
  "466": "普陀区",
  "134": "六安市",
  "618": "开平区",
  "3438": "芦洲区",
  "3038": "灵武市",
  "2151": "蕉岭县",
  "848": "清原满族自治县",
  "3290": "苓雅区",
  "1829": "沁阳市",
  "3698": "那大镇",
  "3717": "从台区",
  "1904": "汉川市",
  "1761": "禹州市",
  "1629": "长岛县",
  "1918": "铁山区",
  "2196": "东源县",
  "2755": "户县",
  "1323": "铜官山区",
  "3237": "正镶白旗",
  "1455": "三元区",
  "3150": "莫力达瓦达斡尔族自治旗",
  "1492": "九江县",
  "2662": "双柏县",
  "703": "宁武县",
  "3164": "赛罕区",
  "2729": "甘德县",
  "3560": "西螺镇",
  "3454": "苏澳镇",
  "1134": "启东市",
  "3304": "大寮区",
  "1100": "栖霞区",
  "2885": "柳城县",
  "2861": "武鸣县",
  "1377": "谯城区",
  "3106": "鄯善县",
  "1461": "沙县",
  "2488": "修文县",
  "185": "济源市",
  "2487": "息烽县",
  "3188": "察哈尔右翼前旗",
  "1719": "宁陵县",
  "4": "山西省",
  "2716": "化隆回族自治县",
  "1985": "长沙县",
  "2669": "武定县",
  "1691": "环翠区",
  "3567": "屏东市",
  "3666": "凤岗镇",
  "2003": "珠晖区"
};